// (function() {

// })();


(function() {

      function rv(s) {
        return s &&
          s.__esModule &&
          Object.prototype.hasOwnProperty.call(s, 'default')
          ? s.default
          : s;
      }
      var Qo = { exports: {} },
        Fa = {};
      /**
       * @license React
       * react-jsx-runtime.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Eh;
      function ov() {
        if (Eh) return Fa;
        Eh = 1;
        var s = Symbol.for('react.transitional.element'),
          a = Symbol.for('react.fragment');
        function l(r, u, f) {
          var h = null;
          if (
            (f !== void 0 && (h = '' + f),
            u.key !== void 0 && (h = '' + u.key),
            'key' in u)
          ) {
            f = {};
            for (var g in u) g !== 'key' && (f[g] = u[g]);
          } else f = u;
          return (
            (u = f.ref),
            {
              $$typeof: s,
              type: r,
              key: h,
              ref: u !== void 0 ? u : null,
              props: f,
            }
          );
        }
        return ((Fa.Fragment = a), (Fa.jsx = l), (Fa.jsxs = l), Fa);
      }
      var wh;
      function uv() {
        return (wh || ((wh = 1), (Qo.exports = ov())), Qo.exports);
      }
      var A = uv(),
        Zo = { exports: {} },
        Ia = {},
        Jo = { exports: {} },
        Fo = {};
      /**
       * @license React
       * scheduler.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Ah;
      function cv() {
        return (
          Ah ||
            ((Ah = 1),
            (function (s) {
              function a(D, X) {
                var q = D.length;
                D.push(X);
                e: for (; 0 < q; ) {
                  var ne = (q - 1) >>> 1,
                    T = D[ne];
                  if (0 < u(T, X)) ((D[ne] = X), (D[q] = T), (q = ne));
                  else break e;
                }
              }
              function l(D) {
                return D.length === 0 ? null : D[0];
              }
              function r(D) {
                if (D.length === 0) return null;
                var X = D[0],
                  q = D.pop();
                if (q !== X) {
                  D[0] = q;
                  e: for (var ne = 0, T = D.length, j = T >>> 1; ne < j; ) {
                    var W = 2 * (ne + 1) - 1,
                      P = D[W],
                      le = W + 1,
                      Se = D[le];
                    if (0 > u(P, q))
                      le < T && 0 > u(Se, P)
                        ? ((D[ne] = Se), (D[le] = q), (ne = le))
                        : ((D[ne] = P), (D[W] = q), (ne = W));
                    else if (le < T && 0 > u(Se, q))
                      ((D[ne] = Se), (D[le] = q), (ne = le));
                    else break e;
                  }
                }
                return X;
              }
              function u(D, X) {
                var q = D.sortIndex - X.sortIndex;
                return q !== 0 ? q : D.id - X.id;
              }
              if (
                ((s.unstable_now = void 0),
                typeof performance == 'object' &&
                  typeof performance.now == 'function')
              ) {
                var f = performance;
                s.unstable_now = function () {
                  return f.now();
                };
              } else {
                var h = Date,
                  g = h.now();
                s.unstable_now = function () {
                  return h.now() - g;
                };
              }
              var d = [],
                p = [],
                b = 1,
                y = null,
                w = 3,
                x = !1,
                O = !1,
                _ = !1,
                L = !1,
                $ = typeof setTimeout == 'function' ? setTimeout : null,
                B = typeof clearTimeout == 'function' ? clearTimeout : null,
                K = typeof setImmediate < 'u' ? setImmediate : null;
              function k(D) {
                for (var X = l(p); X !== null; ) {
                  if (X.callback === null) r(p);
                  else if (X.startTime <= D)
                    (r(p), (X.sortIndex = X.expirationTime), a(d, X));
                  else break;
                  X = l(p);
                }
              }
              function H(D) {
                if (((_ = !1), k(D), !O))
                  if (l(d) !== null) ((O = !0), J || ((J = !0), ie()));
                  else {
                    var X = l(p);
                    X !== null && he(H, X.startTime - D);
                  }
              }
              var J = !1,
                Z = -1,
                G = 5,
                ee = -1;
              function Q() {
                return L ? !0 : !(s.unstable_now() - ee < G);
              }
              function I() {
                if (((L = !1), J)) {
                  var D = s.unstable_now();
                  ee = D;
                  var X = !0;
                  try {
                    e: {
                      ((O = !1), _ && ((_ = !1), B(Z), (Z = -1)), (x = !0));
                      var q = w;
                      try {
                        t: {
                          for (
                            k(D), y = l(d);
                            y !== null && !(y.expirationTime > D && Q());
                          ) {
                            var ne = y.callback;
                            if (typeof ne == 'function') {
                              ((y.callback = null), (w = y.priorityLevel));
                              var T = ne(y.expirationTime <= D);
                              if (
                                ((D = s.unstable_now()), typeof T == 'function')
                              ) {
                                ((y.callback = T), k(D), (X = !0));
                                break t;
                              }
                              (y === l(d) && r(d), k(D));
                            } else r(d);
                            y = l(d);
                          }
                          if (y !== null) X = !0;
                          else {
                            var j = l(p);
                            (j !== null && he(H, j.startTime - D), (X = !1));
                          }
                        }
                        break e;
                      } finally {
                        ((y = null), (w = q), (x = !1));
                      }
                      X = void 0;
                    }
                  } finally {
                    X ? ie() : (J = !1);
                  }
                }
              }
              var ie;
              if (typeof K == 'function')
                ie = function () {
                  K(I);
                };
              else if (typeof MessageChannel < 'u') {
                var oe = new MessageChannel(),
                  ue = oe.port2;
                ((oe.port1.onmessage = I),
                  (ie = function () {
                    ue.postMessage(null);
                  }));
              } else
                ie = function () {
                  $(I, 0);
                };
              function he(D, X) {
                Z = $(function () {
                  D(s.unstable_now());
                }, X);
              }
              ((s.unstable_IdlePriority = 5),
                (s.unstable_ImmediatePriority = 1),
                (s.unstable_LowPriority = 4),
                (s.unstable_NormalPriority = 3),
                (s.unstable_Profiling = null),
                (s.unstable_UserBlockingPriority = 2),
                (s.unstable_cancelCallback = function (D) {
                  D.callback = null;
                }),
                (s.unstable_forceFrameRate = function (D) {
                  0 > D || 125 < D
                    ? console.error(
                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                      )
                    : (G = 0 < D ? Math.floor(1e3 / D) : 5);
                }),
                (s.unstable_getCurrentPriorityLevel = function () {
                  return w;
                }),
                (s.unstable_next = function (D) {
                  switch (w) {
                    case 1:
                    case 2:
                    case 3:
                      var X = 3;
                      break;
                    default:
                      X = w;
                  }
                  var q = w;
                  w = X;
                  try {
                    return D();
                  } finally {
                    w = q;
                  }
                }),
                (s.unstable_requestPaint = function () {
                  L = !0;
                }),
                (s.unstable_runWithPriority = function (D, X) {
                  switch (D) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                      break;
                    default:
                      D = 3;
                  }
                  var q = w;
                  w = D;
                  try {
                    return X();
                  } finally {
                    w = q;
                  }
                }),
                (s.unstable_scheduleCallback = function (D, X, q) {
                  var ne = s.unstable_now();
                  switch (
                    (typeof q == 'object' && q !== null
                      ? ((q = q.delay),
                        (q = typeof q == 'number' && 0 < q ? ne + q : ne))
                      : (q = ne),
                    D)
                  ) {
                    case 1:
                      var T = -1;
                      break;
                    case 2:
                      T = 250;
                      break;
                    case 5:
                      T = 1073741823;
                      break;
                    case 4:
                      T = 1e4;
                      break;
                    default:
                      T = 5e3;
                  }
                  return (
                    (T = q + T),
                    (D = {
                      id: b++,
                      callback: X,
                      priorityLevel: D,
                      startTime: q,
                      expirationTime: T,
                      sortIndex: -1,
                    }),
                    q > ne
                      ? ((D.sortIndex = q),
                        a(p, D),
                        l(d) === null &&
                          D === l(p) &&
                          (_ ? (B(Z), (Z = -1)) : (_ = !0), he(H, q - ne)))
                      : ((D.sortIndex = T),
                        a(d, D),
                        O || x || ((O = !0), J || ((J = !0), ie()))),
                    D
                  );
                }),
                (s.unstable_shouldYield = Q),
                (s.unstable_wrapCallback = function (D) {
                  var X = w;
                  return function () {
                    var q = w;
                    w = X;
                    try {
                      return D.apply(this, arguments);
                    } finally {
                      w = q;
                    }
                  };
                }));
            })(Fo)),
          Fo
        );
      }
      var Mh;
      function fv() {
        return (Mh || ((Mh = 1), (Jo.exports = cv())), Jo.exports);
      }
      var Io = { exports: {} },
        pe = {};
      /**
       * @license React
       * react.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Oh;
      function dv() {
        if (Oh) return pe;
        Oh = 1;
        var s = Symbol.for('react.transitional.element'),
          a = Symbol.for('react.portal'),
          l = Symbol.for('react.fragment'),
          r = Symbol.for('react.strict_mode'),
          u = Symbol.for('react.profiler'),
          f = Symbol.for('react.consumer'),
          h = Symbol.for('react.context'),
          g = Symbol.for('react.forward_ref'),
          d = Symbol.for('react.suspense'),
          p = Symbol.for('react.memo'),
          b = Symbol.for('react.lazy'),
          y = Symbol.iterator;
        function w(T) {
          return T === null || typeof T != 'object'
            ? null
            : ((T = (y && T[y]) || T['@@iterator']),
              typeof T == 'function' ? T : null);
        }
        var x = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          O = Object.assign,
          _ = {};
        function L(T, j, W) {
          ((this.props = T),
            (this.context = j),
            (this.refs = _),
            (this.updater = W || x));
        }
        ((L.prototype.isReactComponent = {}),
          (L.prototype.setState = function (T, j) {
            if (typeof T != 'object' && typeof T != 'function' && T != null)
              throw Error(
                'takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, T, j, 'setState');
          }),
          (L.prototype.forceUpdate = function (T) {
            this.updater.enqueueForceUpdate(this, T, 'forceUpdate');
          }));
        function $() {}
        $.prototype = L.prototype;
        function B(T, j, W) {
          ((this.props = T),
            (this.context = j),
            (this.refs = _),
            (this.updater = W || x));
        }
        var K = (B.prototype = new $());
        ((K.constructor = B), O(K, L.prototype), (K.isPureReactComponent = !0));
        var k = Array.isArray,
          H = { H: null, A: null, T: null, S: null, V: null },
          J = Object.prototype.hasOwnProperty;
        function Z(T, j, W, P, le, Se) {
          return (
            (W = Se.ref),
            {
              $$typeof: s,
              type: T,
              key: j,
              ref: W !== void 0 ? W : null,
              props: Se,
            }
          );
        }
        function G(T, j) {
          return Z(T.type, j, void 0, void 0, void 0, T.props);
        }
        function ee(T) {
          return typeof T == 'object' && T !== null && T.$$typeof === s;
        }
        function Q(T) {
          var j = { '=': '=0', ':': '=2' };
          return (
            '$' +
            T.replace(/[=:]/g, function (W) {
              return j[W];
            })
          );
        }
        var I = /\/+/g;
        function ie(T, j) {
          return typeof T == 'object' && T !== null && T.key != null
            ? Q('' + T.key)
            : j.toString(36);
        }
        function oe() {}
        function ue(T) {
          switch (T.status) {
            case 'fulfilled':
              return T.value;
            case 'rejected':
              throw T.reason;
            default:
              switch (
                (typeof T.status == 'string'
                  ? T.then(oe, oe)
                  : ((T.status = 'pending'),
                    T.then(
                      function (j) {
                        T.status === 'pending' &&
                          ((T.status = 'fulfilled'), (T.value = j));
                      },
                      function (j) {
                        T.status === 'pending' &&
                          ((T.status = 'rejected'), (T.reason = j));
                      }
                    )),
                T.status)
              ) {
                case 'fulfilled':
                  return T.value;
                case 'rejected':
                  throw T.reason;
              }
          }
          throw T;
        }
        function he(T, j, W, P, le) {
          var Se = typeof T;
          (Se === 'undefined' || Se === 'boolean') && (T = null);
          var de = !1;
          if (T === null) de = !0;
          else
            switch (Se) {
              case 'bigint':
              case 'string':
              case 'number':
                de = !0;
                break;
              case 'object':
                switch (T.$$typeof) {
                  case s:
                  case a:
                    de = !0;
                    break;
                  case b:
                    return ((de = T._init), he(de(T._payload), j, W, P, le));
                }
            }
          if (de)
            return (
              (le = le(T)),
              (de = P === '' ? '.' + ie(T, 0) : P),
              k(le)
                ? ((W = ''),
                  de != null && (W = de.replace(I, '$&/') + '/'),
                  he(le, j, W, '', function (ui) {
                    return ui;
                  }))
                : le != null &&
                  (ee(le) &&
                    (le = G(
                      le,
                      W +
                        (le.key == null || (T && T.key === le.key)
                          ? ''
                          : ('' + le.key).replace(I, '$&/') + '/') +
                        de
                    )),
                  j.push(le)),
              1
            );
          de = 0;
          var ht = P === '' ? '.' : P + ':';
          if (k(T))
            for (var Ce = 0; Ce < T.length; Ce++)
              ((P = T[Ce]), (Se = ht + ie(P, Ce)), (de += he(P, j, W, Se, le)));
          else if (((Ce = w(T)), typeof Ce == 'function'))
            for (T = Ce.call(T), Ce = 0; !(P = T.next()).done; )
              ((P = P.value),
                (Se = ht + ie(P, Ce++)),
                (de += he(P, j, W, Se, le)));
          else if (Se === 'object') {
            if (typeof T.then == 'function') return he(ue(T), j, W, P, le);
            throw (
              (j = String(T)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  (j === '[object Object]'
                    ? 'object with keys {' + Object.keys(T).join(', ') + '}'
                    : j) +
                  '). If you meant to render a collection of children, use an array instead.'
              )
            );
          }
          return de;
        }
        function D(T, j, W) {
          if (T == null) return T;
          var P = [],
            le = 0;
          return (
            he(T, P, '', '', function (Se) {
              return j.call(W, Se, le++);
            }),
            P
          );
        }
        function X(T) {
          if (T._status === -1) {
            var j = T._result;
            ((j = j()),
              j.then(
                function (W) {
                  (T._status === 0 || T._status === -1) &&
                    ((T._status = 1), (T._result = W));
                },
                function (W) {
                  (T._status === 0 || T._status === -1) &&
                    ((T._status = 2), (T._result = W));
                }
              ),
              T._status === -1 && ((T._status = 0), (T._result = j)));
          }
          if (T._status === 1) return T._result.default;
          throw T._result;
        }
        var q =
          typeof reportError == 'function'
            ? reportError
            : function (T) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var j = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof T == 'object' &&
                      T !== null &&
                      typeof T.message == 'string'
                        ? String(T.message)
                        : String(T),
                    error: T,
                  });
                  if (!window.dispatchEvent(j)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', T);
                  return;
                }
                console.error(T);
              };
        function ne() {}
        return (
          (pe.Children = {
            map: D,
            forEach: function (T, j, W) {
              D(
                T,
                function () {
                  j.apply(this, arguments);
                },
                W
              );
            },
            count: function (T) {
              var j = 0;
              return (
                D(T, function () {
                  j++;
                }),
                j
              );
            },
            toArray: function (T) {
              return (
                D(T, function (j) {
                  return j;
                }) || []
              );
            },
            only: function (T) {
              if (!ee(T))
                throw Error(
                  'React.Children.only expected to receive a single React element child.'
                );
              return T;
            },
          }),
          (pe.Component = L),
          (pe.Fragment = l),
          (pe.Profiler = u),
          (pe.PureComponent = B),
          (pe.StrictMode = r),
          (pe.Suspense = d),
          (pe.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            H),
          (pe.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (T) {
              return H.H.useMemoCache(T);
            },
          }),
          (pe.cache = function (T) {
            return function () {
              return T.apply(null, arguments);
            };
          }),
          (pe.cloneElement = function (T, j, W) {
            if (T == null)
              throw Error(
                'The argument must be a React element, but you passed ' +
                  T +
                  '.'
              );
            var P = O({}, T.props),
              le = T.key,
              Se = void 0;
            if (j != null)
              for (de in (j.ref !== void 0 && (Se = void 0),
              j.key !== void 0 && (le = '' + j.key),
              j))
                !J.call(j, de) ||
                  de === 'key' ||
                  de === '__self' ||
                  de === '__source' ||
                  (de === 'ref' && j.ref === void 0) ||
                  (P[de] = j[de]);
            var de = arguments.length - 2;
            if (de === 1) P.children = W;
            else if (1 < de) {
              for (var ht = Array(de), Ce = 0; Ce < de; Ce++)
                ht[Ce] = arguments[Ce + 2];
              P.children = ht;
            }
            return Z(T.type, le, void 0, void 0, Se, P);
          }),
          (pe.createContext = function (T) {
            return (
              (T = {
                $$typeof: h,
                _currentValue: T,
                _currentValue2: T,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }),
              (T.Provider = T),
              (T.Consumer = { $$typeof: f, _context: T }),
              T
            );
          }),
          (pe.createElement = function (T, j, W) {
            var P,
              le = {},
              Se = null;
            if (j != null)
              for (P in (j.key !== void 0 && (Se = '' + j.key), j))
                J.call(j, P) &&
                  P !== 'key' &&
                  P !== '__self' &&
                  P !== '__source' &&
                  (le[P] = j[P]);
            var de = arguments.length - 2;
            if (de === 1) le.children = W;
            else if (1 < de) {
              for (var ht = Array(de), Ce = 0; Ce < de; Ce++)
                ht[Ce] = arguments[Ce + 2];
              le.children = ht;
            }
            if (T && T.defaultProps)
              for (P in ((de = T.defaultProps), de))
                le[P] === void 0 && (le[P] = de[P]);
            return Z(T, Se, void 0, void 0, null, le);
          }),
          (pe.createRef = function () {
            return { current: null };
          }),
          (pe.forwardRef = function (T) {
            return { $$typeof: g, render: T };
          }),
          (pe.isValidElement = ee),
          (pe.lazy = function (T) {
            return {
              $$typeof: b,
              _payload: { _status: -1, _result: T },
              _init: X,
            };
          }),
          (pe.memo = function (T, j) {
            return { $$typeof: p, type: T, compare: j === void 0 ? null : j };
          }),
          (pe.startTransition = function (T) {
            var j = H.T,
              W = {};
            H.T = W;
            try {
              var P = T(),
                le = H.S;
              (le !== null && le(W, P),
                typeof P == 'object' &&
                  P !== null &&
                  typeof P.then == 'function' &&
                  P.then(ne, q));
            } catch (Se) {
              q(Se);
            } finally {
              H.T = j;
            }
          }),
          (pe.unstable_useCacheRefresh = function () {
            return H.H.useCacheRefresh();
          }),
          (pe.use = function (T) {
            return H.H.use(T);
          }),
          (pe.useActionState = function (T, j, W) {
            return H.H.useActionState(T, j, W);
          }),
          (pe.useCallback = function (T, j) {
            return H.H.useCallback(T, j);
          }),
          (pe.useContext = function (T) {
            return H.H.useContext(T);
          }),
          (pe.useDebugValue = function () {}),
          (pe.useDeferredValue = function (T, j) {
            return H.H.useDeferredValue(T, j);
          }),
          (pe.useEffect = function (T, j, W) {
            var P = H.H;
            if (typeof W == 'function')
              throw Error(
                'useEffect CRUD overload is not enabled in this build of React.'
              );
            return P.useEffect(T, j);
          }),
          (pe.useId = function () {
            return H.H.useId();
          }),
          (pe.useImperativeHandle = function (T, j, W) {
            return H.H.useImperativeHandle(T, j, W);
          }),
          (pe.useInsertionEffect = function (T, j) {
            return H.H.useInsertionEffect(T, j);
          }),
          (pe.useLayoutEffect = function (T, j) {
            return H.H.useLayoutEffect(T, j);
          }),
          (pe.useMemo = function (T, j) {
            return H.H.useMemo(T, j);
          }),
          (pe.useOptimistic = function (T, j) {
            return H.H.useOptimistic(T, j);
          }),
          (pe.useReducer = function (T, j, W) {
            return H.H.useReducer(T, j, W);
          }),
          (pe.useRef = function (T) {
            return H.H.useRef(T);
          }),
          (pe.useState = function (T) {
            return H.H.useState(T);
          }),
          (pe.useSyncExternalStore = function (T, j, W) {
            return H.H.useSyncExternalStore(T, j, W);
          }),
          (pe.useTransition = function () {
            return H.H.useTransition();
          }),
          (pe.version = '19.1.1'),
          pe
        );
      }
      var _h;
      function Tu() {
        return (_h || ((_h = 1), (Io.exports = dv())), Io.exports);
      }
      var Po = { exports: {} },
        it = {};
      /**
       * @license React
       * react-dom.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var zh;
      function hv() {
        if (zh) return it;
        zh = 1;
        var s = Tu();
        function a(d) {
          var p = 'https://react.dev/errors/' + d;
          if (1 < arguments.length) {
            p += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var b = 2; b < arguments.length; b++)
              p += '&args[]=' + encodeURIComponent(arguments[b]);
          }
          return (
            'Minified React error #' +
            d +
            '; visit ' +
            p +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function l() {}
        var r = {
            d: {
              f: l,
              r: function () {
                throw Error(a(522));
              },
              D: l,
              C: l,
              L: l,
              m: l,
              X: l,
              S: l,
              M: l,
            },
            p: 0,
            findDOMNode: null,
          },
          u = Symbol.for('react.portal');
        function f(d, p, b) {
          var y =
            3 < arguments.length && arguments[3] !== void 0
              ? arguments[3]
              : null;
          return {
            $$typeof: u,
            key: y == null ? null : '' + y,
            children: d,
            containerInfo: p,
            implementation: b,
          };
        }
        var h =
          s.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function g(d, p) {
          if (d === 'font') return '';
          if (typeof p == 'string') return p === 'use-credentials' ? p : '';
        }
        return (
          (it.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r),
          (it.createPortal = function (d, p) {
            var b =
              2 < arguments.length && arguments[2] !== void 0
                ? arguments[2]
                : null;
            if (
              !p ||
              (p.nodeType !== 1 && p.nodeType !== 9 && p.nodeType !== 11)
            )
              throw Error(a(299));
            return f(d, p, null, b);
          }),
          (it.flushSync = function (d) {
            var p = h.T,
              b = r.p;
            try {
              if (((h.T = null), (r.p = 2), d)) return d();
            } finally {
              ((h.T = p), (r.p = b), r.d.f());
            }
          }),
          (it.preconnect = function (d, p) {
            typeof d == 'string' &&
              (p
                ? ((p = p.crossOrigin),
                  (p =
                    typeof p == 'string'
                      ? p === 'use-credentials'
                        ? p
                        : ''
                      : void 0))
                : (p = null),
              r.d.C(d, p));
          }),
          (it.prefetchDNS = function (d) {
            typeof d == 'string' && r.d.D(d);
          }),
          (it.preinit = function (d, p) {
            if (typeof d == 'string' && p && typeof p.as == 'string') {
              var b = p.as,
                y = g(b, p.crossOrigin),
                w = typeof p.integrity == 'string' ? p.integrity : void 0,
                x =
                  typeof p.fetchPriority == 'string' ? p.fetchPriority : void 0;
              b === 'style'
                ? r.d.S(
                    d,
                    typeof p.precedence == 'string' ? p.precedence : void 0,
                    { crossOrigin: y, integrity: w, fetchPriority: x }
                  )
                : b === 'script' &&
                  r.d.X(d, {
                    crossOrigin: y,
                    integrity: w,
                    fetchPriority: x,
                    nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                  });
            }
          }),
          (it.preinitModule = function (d, p) {
            if (typeof d == 'string')
              if (typeof p == 'object' && p !== null) {
                if (p.as == null || p.as === 'script') {
                  var b = g(p.as, p.crossOrigin);
                  r.d.M(d, {
                    crossOrigin: b,
                    integrity:
                      typeof p.integrity == 'string' ? p.integrity : void 0,
                    nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                  });
                }
              } else p == null && r.d.M(d);
          }),
          (it.preload = function (d, p) {
            if (
              typeof d == 'string' &&
              typeof p == 'object' &&
              p !== null &&
              typeof p.as == 'string'
            ) {
              var b = p.as,
                y = g(b, p.crossOrigin);
              r.d.L(d, b, {
                crossOrigin: y,
                integrity:
                  typeof p.integrity == 'string' ? p.integrity : void 0,
                nonce: typeof p.nonce == 'string' ? p.nonce : void 0,
                type: typeof p.type == 'string' ? p.type : void 0,
                fetchPriority:
                  typeof p.fetchPriority == 'string' ? p.fetchPriority : void 0,
                referrerPolicy:
                  typeof p.referrerPolicy == 'string'
                    ? p.referrerPolicy
                    : void 0,
                imageSrcSet:
                  typeof p.imageSrcSet == 'string' ? p.imageSrcSet : void 0,
                imageSizes:
                  typeof p.imageSizes == 'string' ? p.imageSizes : void 0,
                media: typeof p.media == 'string' ? p.media : void 0,
              });
            }
          }),
          (it.preloadModule = function (d, p) {
            if (typeof d == 'string')
              if (p) {
                var b = g(p.as, p.crossOrigin);
                r.d.m(d, {
                  as:
                    typeof p.as == 'string' && p.as !== 'script'
                      ? p.as
                      : void 0,
                  crossOrigin: b,
                  integrity:
                    typeof p.integrity == 'string' ? p.integrity : void 0,
                });
              } else r.d.m(d);
          }),
          (it.requestFormReset = function (d) {
            r.d.r(d);
          }),
          (it.unstable_batchedUpdates = function (d, p) {
            return d(p);
          }),
          (it.useFormState = function (d, p, b) {
            return h.H.useFormState(d, p, b);
          }),
          (it.useFormStatus = function () {
            return h.H.useHostTransitionStatus();
          }),
          (it.version = '19.1.1'),
          it
        );
      }
      var Nh;
      function pv() {
        if (Nh) return Po.exports;
        Nh = 1;
        function s() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
            } catch (a) {
              console.error(a);
            }
        }
        return (s(), (Po.exports = hv()), Po.exports);
      }
      /**
       * @license React
       * react-dom-client.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Ch;
      function mv() {
        if (Ch) return Ia;
        Ch = 1;
        var s = fv(),
          a = Tu(),
          l = pv();
        function r(e) {
          var t = 'https://react.dev/errors/' + e;
          if (1 < arguments.length) {
            t += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var i = 2; i < arguments.length; i++)
              t += '&args[]=' + encodeURIComponent(arguments[i]);
          }
          return (
            'Minified React error #' +
            e +
            '; visit ' +
            t +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function u(e) {
          return !(
            !e ||
            (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
          );
        }
        function f(e) {
          var t = e,
            i = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do
              ((t = e),
                (t.flags & 4098) !== 0 && (i = t.return),
                (e = t.return));
            while (e);
          }
          return t.tag === 3 ? i : null;
        }
        function h(e) {
          if (e.tag === 13) {
            var t = e.memoizedState;
            if (
              (t === null &&
                ((e = e.alternate), e !== null && (t = e.memoizedState)),
              t !== null)
            )
              return t.dehydrated;
          }
          return null;
        }
        function g(e) {
          if (f(e) !== e) throw Error(r(188));
        }
        function d(e) {
          var t = e.alternate;
          if (!t) {
            if (((t = f(e)), t === null)) throw Error(r(188));
            return t !== e ? null : e;
          }
          for (var i = e, n = t; ; ) {
            var o = i.return;
            if (o === null) break;
            var c = o.alternate;
            if (c === null) {
              if (((n = o.return), n !== null)) {
                i = n;
                continue;
              }
              break;
            }
            if (o.child === c.child) {
              for (c = o.child; c; ) {
                if (c === i) return (g(o), e);
                if (c === n) return (g(o), t);
                c = c.sibling;
              }
              throw Error(r(188));
            }
            if (i.return !== n.return) ((i = o), (n = c));
            else {
              for (var m = !1, v = o.child; v; ) {
                if (v === i) {
                  ((m = !0), (i = o), (n = c));
                  break;
                }
                if (v === n) {
                  ((m = !0), (n = o), (i = c));
                  break;
                }
                v = v.sibling;
              }
              if (!m) {
                for (v = c.child; v; ) {
                  if (v === i) {
                    ((m = !0), (i = c), (n = o));
                    break;
                  }
                  if (v === n) {
                    ((m = !0), (n = c), (i = o));
                    break;
                  }
                  v = v.sibling;
                }
                if (!m) throw Error(r(189));
              }
            }
            if (i.alternate !== n) throw Error(r(190));
          }
          if (i.tag !== 3) throw Error(r(188));
          return i.stateNode.current === i ? e : t;
        }
        function p(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e;
          for (e = e.child; e !== null; ) {
            if (((t = p(e)), t !== null)) return t;
            e = e.sibling;
          }
          return null;
        }
        var b = Object.assign,
          y = Symbol.for('react.element'),
          w = Symbol.for('react.transitional.element'),
          x = Symbol.for('react.portal'),
          O = Symbol.for('react.fragment'),
          _ = Symbol.for('react.strict_mode'),
          L = Symbol.for('react.profiler'),
          $ = Symbol.for('react.provider'),
          B = Symbol.for('react.consumer'),
          K = Symbol.for('react.context'),
          k = Symbol.for('react.forward_ref'),
          H = Symbol.for('react.suspense'),
          J = Symbol.for('react.suspense_list'),
          Z = Symbol.for('react.memo'),
          G = Symbol.for('react.lazy'),
          ee = Symbol.for('react.activity'),
          Q = Symbol.for('react.memo_cache_sentinel'),
          I = Symbol.iterator;
        function ie(e) {
          return e === null || typeof e != 'object'
            ? null
            : ((e = (I && e[I]) || e['@@iterator']),
              typeof e == 'function' ? e : null);
        }
        var oe = Symbol.for('react.client.reference');
        function ue(e) {
          if (e == null) return null;
          if (typeof e == 'function')
            return e.$$typeof === oe ? null : e.displayName || e.name || null;
          if (typeof e == 'string') return e;
          switch (e) {
            case O:
              return 'Fragment';
            case L:
              return 'Profiler';
            case _:
              return 'StrictMode';
            case H:
              return 'Suspense';
            case J:
              return 'SuspenseList';
            case ee:
              return 'Activity';
          }
          if (typeof e == 'object')
            switch (e.$$typeof) {
              case x:
                return 'Portal';
              case K:
                return (e.displayName || 'Context') + '.Provider';
              case B:
                return (e._context.displayName || 'Context') + '.Consumer';
              case k:
                var t = e.render;
                return (
                  (e = e.displayName),
                  e ||
                    ((e = t.displayName || t.name || ''),
                    (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                  e
                );
              case Z:
                return (
                  (t = e.displayName || null),
                  t !== null ? t : ue(e.type) || 'Memo'
                );
              case G:
                ((t = e._payload), (e = e._init));
                try {
                  return ue(e(t));
                } catch {}
            }
          return null;
        }
        var he = Array.isArray,
          D = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          X = l.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          q = { pending: !1, data: null, method: null, action: null },
          ne = [],
          T = -1;
        function j(e) {
          return { current: e };
        }
        function W(e) {
          0 > T || ((e.current = ne[T]), (ne[T] = null), T--);
        }
        function P(e, t) {
          (T++, (ne[T] = e.current), (e.current = t));
        }
        var le = j(null),
          Se = j(null),
          de = j(null),
          ht = j(null);
        function Ce(e, t) {
          switch ((P(de, t), P(Se, e), P(le, null), t.nodeType)) {
            case 9:
            case 11:
              e = (e = t.documentElement) && (e = e.namespaceURI) ? Id(e) : 0;
              break;
            default:
              if (((e = t.tagName), (t = t.namespaceURI)))
                ((t = Id(t)), (e = Pd(t, e)));
              else
                switch (e) {
                  case 'svg':
                    e = 1;
                    break;
                  case 'math':
                    e = 2;
                    break;
                  default:
                    e = 0;
                }
          }
          (W(le), P(le, e));
        }
        function ui() {
          (W(le), W(Se), W(de));
        }
        function Cs(e) {
          e.memoizedState !== null && P(ht, e);
          var t = le.current,
            i = Pd(t, e.type);
          t !== i && (P(Se, e), P(le, i));
        }
        function nl(e) {
          (Se.current === e && (W(le), W(Se)),
            ht.current === e && (W(ht), (ka._currentValue = q)));
        }
        var Rs = Object.prototype.hasOwnProperty,
          Ds = s.unstable_scheduleCallback,
          Ls = s.unstable_cancelCallback,
          Gp = s.unstable_shouldYield,
          Vp = s.unstable_requestPaint,
          Bt = s.unstable_now,
          Yp = s.unstable_getCurrentPriorityLevel,
          Nu = s.unstable_ImmediatePriority,
          Cu = s.unstable_UserBlockingPriority,
          al = s.unstable_NormalPriority,
          qp = s.unstable_LowPriority,
          Ru = s.unstable_IdlePriority,
          $p = s.log,
          Kp = s.unstable_setDisableYieldValue,
          Wn = null,
          pt = null;
        function ci(e) {
          if (
            (typeof $p == 'function' && Kp(e),
            pt && typeof pt.setStrictMode == 'function')
          )
            try {
              pt.setStrictMode(Wn, e);
            } catch {}
        }
        var mt = Math.clz32 ? Math.clz32 : Qp,
          kp = Math.log,
          Xp = Math.LN2;
        function Qp(e) {
          return ((e >>>= 0), e === 0 ? 32 : (31 - ((kp(e) / Xp) | 0)) | 0);
        }
        var ll = 256,
          sl = 4194304;
        function Bi(e) {
          var t = e & 42;
          if (t !== 0) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return e & 4194048;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return e & 62914560;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function rl(e, t, i) {
          var n = e.pendingLanes;
          if (n === 0) return 0;
          var o = 0,
            c = e.suspendedLanes,
            m = e.pingedLanes;
          e = e.warmLanes;
          var v = n & 134217727;
          return (
            v !== 0
              ? ((n = v & ~c),
                n !== 0
                  ? (o = Bi(n))
                  : ((m &= v),
                    m !== 0
                      ? (o = Bi(m))
                      : i || ((i = v & ~e), i !== 0 && (o = Bi(i)))))
              : ((v = n & ~c),
                v !== 0
                  ? (o = Bi(v))
                  : m !== 0
                    ? (o = Bi(m))
                    : i || ((i = n & ~e), i !== 0 && (o = Bi(i)))),
            o === 0
              ? 0
              : t !== 0 &&
                  t !== o &&
                  (t & c) === 0 &&
                  ((c = o & -o),
                  (i = t & -t),
                  c >= i || (c === 32 && (i & 4194048) !== 0))
                ? t
                : o
          );
        }
        function ea(e, t) {
          return (
            (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0
          );
        }
        function Zp(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function Du() {
          var e = ll;
          return ((ll <<= 1), (ll & 4194048) === 0 && (ll = 256), e);
        }
        function Lu() {
          var e = sl;
          return ((sl <<= 1), (sl & 62914560) === 0 && (sl = 4194304), e);
        }
        function js(e) {
          for (var t = [], i = 0; 31 > i; i++) t.push(e);
          return t;
        }
        function ta(e, t) {
          ((e.pendingLanes |= t),
            t !== 268435456 &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0)));
        }
        function Jp(e, t, i, n, o, c) {
          var m = e.pendingLanes;
          ((e.pendingLanes = i),
            (e.suspendedLanes = 0),
            (e.pingedLanes = 0),
            (e.warmLanes = 0),
            (e.expiredLanes &= i),
            (e.entangledLanes &= i),
            (e.errorRecoveryDisabledLanes &= i),
            (e.shellSuspendCounter = 0));
          var v = e.entanglements,
            S = e.expirationTimes,
            N = e.hiddenUpdates;
          for (i = m & ~i; 0 < i; ) {
            var U = 31 - mt(i),
              Y = 1 << U;
            ((v[U] = 0), (S[U] = -1));
            var C = N[U];
            if (C !== null)
              for (N[U] = null, U = 0; U < C.length; U++) {
                var R = C[U];
                R !== null && (R.lane &= -536870913);
              }
            i &= ~Y;
          }
          (n !== 0 && ju(e, n, 0),
            c !== 0 &&
              o === 0 &&
              e.tag !== 0 &&
              (e.suspendedLanes |= c & ~(m & ~t)));
        }
        function ju(e, t, i) {
          ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
          var n = 31 - mt(t);
          ((e.entangledLanes |= t),
            (e.entanglements[n] =
              e.entanglements[n] | 1073741824 | (i & 4194090)));
        }
        function Bu(e, t) {
          var i = (e.entangledLanes |= t);
          for (e = e.entanglements; i; ) {
            var n = 31 - mt(i),
              o = 1 << n;
            ((o & t) | (e[n] & t) && (e[n] |= t), (i &= ~o));
          }
        }
        function Bs(e) {
          switch (e) {
            case 2:
              e = 1;
              break;
            case 8:
              e = 4;
              break;
            case 32:
              e = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              e = 128;
              break;
            case 268435456:
              e = 134217728;
              break;
            default:
              e = 0;
          }
          return e;
        }
        function Hs(e) {
          return (
            (e &= -e),
            2 < e ? (8 < e ? ((e & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
          );
        }
        function Hu() {
          var e = X.p;
          return e !== 0
            ? e
            : ((e = window.event), e === void 0 ? 32 : vh(e.type));
        }
        function Fp(e, t) {
          var i = X.p;
          try {
            return ((X.p = e), t());
          } finally {
            X.p = i;
          }
        }
        var fi = Math.random().toString(36).slice(2),
          et = '__reactFiber$' + fi,
          st = '__reactProps$' + fi,
          un = '__reactContainer$' + fi,
          Us = '__reactEvents$' + fi,
          Ip = '__reactListeners$' + fi,
          Pp = '__reactHandles$' + fi,
          Uu = '__reactResources$' + fi,
          ia = '__reactMarker$' + fi;
        function Gs(e) {
          (delete e[et],
            delete e[st],
            delete e[Us],
            delete e[Ip],
            delete e[Pp]);
        }
        function cn(e) {
          var t = e[et];
          if (t) return t;
          for (var i = e.parentNode; i; ) {
            if ((t = i[un] || i[et])) {
              if (
                ((i = t.alternate),
                t.child !== null || (i !== null && i.child !== null))
              )
                for (e = ih(e); e !== null; ) {
                  if ((i = e[et])) return i;
                  e = ih(e);
                }
              return t;
            }
            ((e = i), (i = e.parentNode));
          }
          return null;
        }
        function fn(e) {
          if ((e = e[et] || e[un])) {
            var t = e.tag;
            if (
              t === 5 ||
              t === 6 ||
              t === 13 ||
              t === 26 ||
              t === 27 ||
              t === 3
            )
              return e;
          }
          return null;
        }
        function na(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
          throw Error(r(33));
        }
        function dn(e) {
          var t = e[Uu];
          return (
            t ||
              (t = e[Uu] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function ke(e) {
          e[ia] = !0;
        }
        var Gu = new Set(),
          Vu = {};
        function Hi(e, t) {
          (hn(e, t), hn(e + 'Capture', t));
        }
        function hn(e, t) {
          for (Vu[e] = t, e = 0; e < t.length; e++) Gu.add(t[e]);
        }
        var Wp = RegExp(
            '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
          ),
          Yu = {},
          qu = {};
        function em(e) {
          return Rs.call(qu, e)
            ? !0
            : Rs.call(Yu, e)
              ? !1
              : Wp.test(e)
                ? (qu[e] = !0)
                : ((Yu[e] = !0), !1);
        }
        function ol(e, t, i) {
          if (em(t))
            if (i === null) e.removeAttribute(t);
            else {
              switch (typeof i) {
                case 'undefined':
                case 'function':
                case 'symbol':
                  e.removeAttribute(t);
                  return;
                case 'boolean':
                  var n = t.toLowerCase().slice(0, 5);
                  if (n !== 'data-' && n !== 'aria-') {
                    e.removeAttribute(t);
                    return;
                  }
              }
              e.setAttribute(t, '' + i);
            }
        }
        function ul(e, t, i) {
          if (i === null) e.removeAttribute(t);
          else {
            switch (typeof i) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(t);
                return;
            }
            e.setAttribute(t, '' + i);
          }
        }
        function $t(e, t, i, n) {
          if (n === null) e.removeAttribute(i);
          else {
            switch (typeof n) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(i);
                return;
            }
            e.setAttributeNS(t, i, '' + n);
          }
        }
        var Vs, $u;
        function pn(e) {
          if (Vs === void 0)
            try {
              throw Error();
            } catch (i) {
              var t = i.stack.trim().match(/\n( *(at )?)/);
              ((Vs = (t && t[1]) || ''),
                ($u =
                  -1 <
                  i.stack.indexOf(`
    at`)
                    ? ' (<anonymous>)'
                    : -1 < i.stack.indexOf('@')
                      ? '@unknown:0:0'
                      : ''));
            }
          return (
            `
` +
            Vs +
            e +
            $u
          );
        }
        var Ys = !1;
        function qs(e, t) {
          if (!e || Ys) return '';
          Ys = !0;
          var i = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var n = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var Y = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(Y.prototype, 'props', {
                        set: function () {
                          throw Error();
                        },
                      }),
                      typeof Reflect == 'object' && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(Y, []);
                      } catch (R) {
                        var C = R;
                      }
                      Reflect.construct(e, [], Y);
                    } else {
                      try {
                        Y.call();
                      } catch (R) {
                        C = R;
                      }
                      e.call(Y.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (R) {
                      C = R;
                    }
                    (Y = e()) &&
                      typeof Y.catch == 'function' &&
                      Y.catch(function () {});
                  }
                } catch (R) {
                  if (R && C && typeof R.stack == 'string')
                    return [R.stack, C.stack];
                }
                return [null, null];
              },
            };
            n.DetermineComponentFrameRoot.displayName =
              'DetermineComponentFrameRoot';
            var o = Object.getOwnPropertyDescriptor(
              n.DetermineComponentFrameRoot,
              'name'
            );
            o &&
              o.configurable &&
              Object.defineProperty(n.DetermineComponentFrameRoot, 'name', {
                value: 'DetermineComponentFrameRoot',
              });
            var c = n.DetermineComponentFrameRoot(),
              m = c[0],
              v = c[1];
            if (m && v) {
              var S = m.split(`
`),
                N = v.split(`
`);
              for (
                o = n = 0;
                n < S.length && !S[n].includes('DetermineComponentFrameRoot');
              )
                n++;
              for (
                ;
                o < N.length && !N[o].includes('DetermineComponentFrameRoot');
              )
                o++;
              if (n === S.length || o === N.length)
                for (
                  n = S.length - 1, o = N.length - 1;
                  1 <= n && 0 <= o && S[n] !== N[o];
                )
                  o--;
              for (; 1 <= n && 0 <= o; n--, o--)
                if (S[n] !== N[o]) {
                  if (n !== 1 || o !== 1)
                    do
                      if ((n--, o--, 0 > o || S[n] !== N[o])) {
                        var U =
                          `
` + S[n].replace(' at new ', ' at ');
                        return (
                          e.displayName &&
                            U.includes('<anonymous>') &&
                            (U = U.replace('<anonymous>', e.displayName)),
                          U
                        );
                      }
                    while (1 <= n && 0 <= o);
                  break;
                }
            }
          } finally {
            ((Ys = !1), (Error.prepareStackTrace = i));
          }
          return (i = e ? e.displayName || e.name : '') ? pn(i) : '';
        }
        function tm(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return pn(e.type);
            case 16:
              return pn('Lazy');
            case 13:
              return pn('Suspense');
            case 19:
              return pn('SuspenseList');
            case 0:
            case 15:
              return qs(e.type, !1);
            case 11:
              return qs(e.type.render, !1);
            case 1:
              return qs(e.type, !0);
            case 31:
              return pn('Activity');
            default:
              return '';
          }
        }
        function Ku(e) {
          try {
            var t = '';
            do ((t += tm(e)), (e = e.return));
            while (e);
            return t;
          } catch (i) {
            return (
              `
Error generating stack: ` +
              i.message +
              `
` +
              i.stack
            );
          }
        }
        function wt(e) {
          switch (typeof e) {
            case 'bigint':
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
              return e;
            case 'object':
              return e;
            default:
              return '';
          }
        }
        function ku(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            e.toLowerCase() === 'input' &&
            (t === 'checkbox' || t === 'radio')
          );
        }
        function im(e) {
          var t = ku(e) ? 'checked' : 'value',
            i = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
            n = '' + e[t];
          if (
            !e.hasOwnProperty(t) &&
            typeof i < 'u' &&
            typeof i.get == 'function' &&
            typeof i.set == 'function'
          ) {
            var o = i.get,
              c = i.set;
            return (
              Object.defineProperty(e, t, {
                configurable: !0,
                get: function () {
                  return o.call(this);
                },
                set: function (m) {
                  ((n = '' + m), c.call(this, m));
                },
              }),
              Object.defineProperty(e, t, { enumerable: i.enumerable }),
              {
                getValue: function () {
                  return n;
                },
                setValue: function (m) {
                  n = '' + m;
                },
                stopTracking: function () {
                  ((e._valueTracker = null), delete e[t]);
                },
              }
            );
          }
        }
        function cl(e) {
          e._valueTracker || (e._valueTracker = im(e));
        }
        function Xu(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var i = t.getValue(),
            n = '';
          return (
            e && (n = ku(e) ? (e.checked ? 'true' : 'false') : e.value),
            (e = n),
            e !== i ? (t.setValue(e), !0) : !1
          );
        }
        function fl(e) {
          if (
            ((e = e || (typeof document < 'u' ? document : void 0)),
            typeof e > 'u')
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch {
            return e.body;
          }
        }
        var nm = /[\n"\\]/g;
        function At(e) {
          return e.replace(nm, function (t) {
            return '\\' + t.charCodeAt(0).toString(16) + ' ';
          });
        }
        function $s(e, t, i, n, o, c, m, v) {
          ((e.name = ''),
            m != null &&
            typeof m != 'function' &&
            typeof m != 'symbol' &&
            typeof m != 'boolean'
              ? (e.type = m)
              : e.removeAttribute('type'),
            t != null
              ? m === 'number'
                ? ((t === 0 && e.value === '') || e.value != t) &&
                  (e.value = '' + wt(t))
                : e.value !== '' + wt(t) && (e.value = '' + wt(t))
              : (m !== 'submit' && m !== 'reset') || e.removeAttribute('value'),
            t != null
              ? Ks(e, m, wt(t))
              : i != null
                ? Ks(e, m, wt(i))
                : n != null && e.removeAttribute('value'),
            o == null && c != null && (e.defaultChecked = !!c),
            o != null &&
              (e.checked = o && typeof o != 'function' && typeof o != 'symbol'),
            v != null &&
            typeof v != 'function' &&
            typeof v != 'symbol' &&
            typeof v != 'boolean'
              ? (e.name = '' + wt(v))
              : e.removeAttribute('name'));
        }
        function Qu(e, t, i, n, o, c, m, v) {
          if (
            (c != null &&
              typeof c != 'function' &&
              typeof c != 'symbol' &&
              typeof c != 'boolean' &&
              (e.type = c),
            t != null || i != null)
          ) {
            if (!((c !== 'submit' && c !== 'reset') || t != null)) return;
            ((i = i != null ? '' + wt(i) : ''),
              (t = t != null ? '' + wt(t) : i),
              v || t === e.value || (e.value = t),
              (e.defaultValue = t));
          }
          ((n = n ?? o),
            (n = typeof n != 'function' && typeof n != 'symbol' && !!n),
            (e.checked = v ? e.checked : !!n),
            (e.defaultChecked = !!n),
            m != null &&
              typeof m != 'function' &&
              typeof m != 'symbol' &&
              typeof m != 'boolean' &&
              (e.name = m));
        }
        function Ks(e, t, i) {
          (t === 'number' && fl(e.ownerDocument) === e) ||
            e.defaultValue === '' + i ||
            (e.defaultValue = '' + i);
        }
        function mn(e, t, i, n) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < i.length; o++) t['$' + i[o]] = !0;
            for (i = 0; i < e.length; i++)
              ((o = t.hasOwnProperty('$' + e[i].value)),
                e[i].selected !== o && (e[i].selected = o),
                o && n && (e[i].defaultSelected = !0));
          } else {
            for (i = '' + wt(i), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === i) {
                ((e[o].selected = !0), n && (e[o].defaultSelected = !0));
                return;
              }
              t !== null || e[o].disabled || (t = e[o]);
            }
            t !== null && (t.selected = !0);
          }
        }
        function Zu(e, t, i) {
          if (
            t != null &&
            ((t = '' + wt(t)), t !== e.value && (e.value = t), i == null)
          ) {
            e.defaultValue !== t && (e.defaultValue = t);
            return;
          }
          e.defaultValue = i != null ? '' + wt(i) : '';
        }
        function Ju(e, t, i, n) {
          if (t == null) {
            if (n != null) {
              if (i != null) throw Error(r(92));
              if (he(n)) {
                if (1 < n.length) throw Error(r(93));
                n = n[0];
              }
              i = n;
            }
            (i == null && (i = ''), (t = i));
          }
          ((i = wt(t)),
            (e.defaultValue = i),
            (n = e.textContent),
            n === i && n !== '' && n !== null && (e.value = n));
        }
        function gn(e, t) {
          if (t) {
            var i = e.firstChild;
            if (i && i === e.lastChild && i.nodeType === 3) {
              i.nodeValue = t;
              return;
            }
          }
          e.textContent = t;
        }
        var am = new Set(
          'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
            ' '
          )
        );
        function Fu(e, t, i) {
          var n = t.indexOf('--') === 0;
          i == null || typeof i == 'boolean' || i === ''
            ? n
              ? e.setProperty(t, '')
              : t === 'float'
                ? (e.cssFloat = '')
                : (e[t] = '')
            : n
              ? e.setProperty(t, i)
              : typeof i != 'number' || i === 0 || am.has(t)
                ? t === 'float'
                  ? (e.cssFloat = i)
                  : (e[t] = ('' + i).trim())
                : (e[t] = i + 'px');
        }
        function Iu(e, t, i) {
          if (t != null && typeof t != 'object') throw Error(r(62));
          if (((e = e.style), i != null)) {
            for (var n in i)
              !i.hasOwnProperty(n) ||
                (t != null && t.hasOwnProperty(n)) ||
                (n.indexOf('--') === 0
                  ? e.setProperty(n, '')
                  : n === 'float'
                    ? (e.cssFloat = '')
                    : (e[n] = ''));
            for (var o in t)
              ((n = t[o]), t.hasOwnProperty(o) && i[o] !== n && Fu(e, o, n));
          } else for (var c in t) t.hasOwnProperty(c) && Fu(e, c, t[c]);
        }
        function ks(e) {
          if (e.indexOf('-') === -1) return !1;
          switch (e) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var lm = new Map([
            ['acceptCharset', 'accept-charset'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
            ['crossOrigin', 'crossorigin'],
            ['accentHeight', 'accent-height'],
            ['alignmentBaseline', 'alignment-baseline'],
            ['arabicForm', 'arabic-form'],
            ['baselineShift', 'baseline-shift'],
            ['capHeight', 'cap-height'],
            ['clipPath', 'clip-path'],
            ['clipRule', 'clip-rule'],
            ['colorInterpolation', 'color-interpolation'],
            ['colorInterpolationFilters', 'color-interpolation-filters'],
            ['colorProfile', 'color-profile'],
            ['colorRendering', 'color-rendering'],
            ['dominantBaseline', 'dominant-baseline'],
            ['enableBackground', 'enable-background'],
            ['fillOpacity', 'fill-opacity'],
            ['fillRule', 'fill-rule'],
            ['floodColor', 'flood-color'],
            ['floodOpacity', 'flood-opacity'],
            ['fontFamily', 'font-family'],
            ['fontSize', 'font-size'],
            ['fontSizeAdjust', 'font-size-adjust'],
            ['fontStretch', 'font-stretch'],
            ['fontStyle', 'font-style'],
            ['fontVariant', 'font-variant'],
            ['fontWeight', 'font-weight'],
            ['glyphName', 'glyph-name'],
            ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
            ['glyphOrientationVertical', 'glyph-orientation-vertical'],
            ['horizAdvX', 'horiz-adv-x'],
            ['horizOriginX', 'horiz-origin-x'],
            ['imageRendering', 'image-rendering'],
            ['letterSpacing', 'letter-spacing'],
            ['lightingColor', 'lighting-color'],
            ['markerEnd', 'marker-end'],
            ['markerMid', 'marker-mid'],
            ['markerStart', 'marker-start'],
            ['overlinePosition', 'overline-position'],
            ['overlineThickness', 'overline-thickness'],
            ['paintOrder', 'paint-order'],
            ['panose-1', 'panose-1'],
            ['pointerEvents', 'pointer-events'],
            ['renderingIntent', 'rendering-intent'],
            ['shapeRendering', 'shape-rendering'],
            ['stopColor', 'stop-color'],
            ['stopOpacity', 'stop-opacity'],
            ['strikethroughPosition', 'strikethrough-position'],
            ['strikethroughThickness', 'strikethrough-thickness'],
            ['strokeDasharray', 'stroke-dasharray'],
            ['strokeDashoffset', 'stroke-dashoffset'],
            ['strokeLinecap', 'stroke-linecap'],
            ['strokeLinejoin', 'stroke-linejoin'],
            ['strokeMiterlimit', 'stroke-miterlimit'],
            ['strokeOpacity', 'stroke-opacity'],
            ['strokeWidth', 'stroke-width'],
            ['textAnchor', 'text-anchor'],
            ['textDecoration', 'text-decoration'],
            ['textRendering', 'text-rendering'],
            ['transformOrigin', 'transform-origin'],
            ['underlinePosition', 'underline-position'],
            ['underlineThickness', 'underline-thickness'],
            ['unicodeBidi', 'unicode-bidi'],
            ['unicodeRange', 'unicode-range'],
            ['unitsPerEm', 'units-per-em'],
            ['vAlphabetic', 'v-alphabetic'],
            ['vHanging', 'v-hanging'],
            ['vIdeographic', 'v-ideographic'],
            ['vMathematical', 'v-mathematical'],
            ['vectorEffect', 'vector-effect'],
            ['vertAdvY', 'vert-adv-y'],
            ['vertOriginX', 'vert-origin-x'],
            ['vertOriginY', 'vert-origin-y'],
            ['wordSpacing', 'word-spacing'],
            ['writingMode', 'writing-mode'],
            ['xmlnsXlink', 'xmlns:xlink'],
            ['xHeight', 'x-height'],
          ]),
          sm =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function dl(e) {
          return sm.test('' + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var Xs = null;
        function Qs(e) {
          return (
            (e = e.target || e.srcElement || window),
            e.correspondingUseElement && (e = e.correspondingUseElement),
            e.nodeType === 3 ? e.parentNode : e
          );
        }
        var vn = null,
          yn = null;
        function Pu(e) {
          var t = fn(e);
          if (t && (e = t.stateNode)) {
            var i = e[st] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case 'input':
                if (
                  ($s(
                    e,
                    i.value,
                    i.defaultValue,
                    i.defaultValue,
                    i.checked,
                    i.defaultChecked,
                    i.type,
                    i.name
                  ),
                  (t = i.name),
                  i.type === 'radio' && t != null)
                ) {
                  for (i = e; i.parentNode; ) i = i.parentNode;
                  for (
                    i = i.querySelectorAll(
                      'input[name="' + At('' + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < i.length;
                    t++
                  ) {
                    var n = i[t];
                    if (n !== e && n.form === e.form) {
                      var o = n[st] || null;
                      if (!o) throw Error(r(90));
                      $s(
                        n,
                        o.value,
                        o.defaultValue,
                        o.defaultValue,
                        o.checked,
                        o.defaultChecked,
                        o.type,
                        o.name
                      );
                    }
                  }
                  for (t = 0; t < i.length; t++)
                    ((n = i[t]), n.form === e.form && Xu(n));
                }
                break e;
              case 'textarea':
                Zu(e, i.value, i.defaultValue);
                break e;
              case 'select':
                ((t = i.value), t != null && mn(e, !!i.multiple, t, !1));
            }
          }
        }
        var Zs = !1;
        function Wu(e, t, i) {
          if (Zs) return e(t, i);
          Zs = !0;
          try {
            var n = e(t);
            return n;
          } finally {
            if (
              ((Zs = !1),
              (vn !== null || yn !== null) &&
                (Il(), vn && ((t = vn), (e = yn), (yn = vn = null), Pu(t), e)))
            )
              for (t = 0; t < e.length; t++) Pu(e[t]);
          }
        }
        function aa(e, t) {
          var i = e.stateNode;
          if (i === null) return null;
          var n = i[st] || null;
          if (n === null) return null;
          i = n[t];
          e: switch (t) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              ((n = !n.disabled) ||
                ((e = e.type),
                (n = !(
                  e === 'button' ||
                  e === 'input' ||
                  e === 'select' ||
                  e === 'textarea'
                ))),
                (e = !n));
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (i && typeof i != 'function') throw Error(r(231, t, typeof i));
          return i;
        }
        var Kt = !(
            typeof window > 'u' ||
            typeof window.document > 'u' ||
            typeof window.document.createElement > 'u'
          ),
          Js = !1;
        if (Kt)
          try {
            var la = {};
            (Object.defineProperty(la, 'passive', {
              get: function () {
                Js = !0;
              },
            }),
              window.addEventListener('test', la, la),
              window.removeEventListener('test', la, la));
          } catch {
            Js = !1;
          }
        var di = null,
          Fs = null,
          hl = null;
        function ec() {
          if (hl) return hl;
          var e,
            t = Fs,
            i = t.length,
            n,
            o = 'value' in di ? di.value : di.textContent,
            c = o.length;
          for (e = 0; e < i && t[e] === o[e]; e++);
          var m = i - e;
          for (n = 1; n <= m && t[i - n] === o[c - n]; n++);
          return (hl = o.slice(e, 1 < n ? 1 - n : void 0));
        }
        function pl(e) {
          var t = e.keyCode;
          return (
            'charCode' in e
              ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
              : (e = t),
            e === 10 && (e = 13),
            32 <= e || e === 13 ? e : 0
          );
        }
        function ml() {
          return !0;
        }
        function tc() {
          return !1;
        }
        function rt(e) {
          function t(i, n, o, c, m) {
            ((this._reactName = i),
              (this._targetInst = o),
              (this.type = n),
              (this.nativeEvent = c),
              (this.target = m),
              (this.currentTarget = null));
            for (var v in e)
              e.hasOwnProperty(v) && ((i = e[v]), (this[v] = i ? i(c) : c[v]));
            return (
              (this.isDefaultPrevented = (
                c.defaultPrevented != null
                  ? c.defaultPrevented
                  : c.returnValue === !1
              )
                ? ml
                : tc),
              (this.isPropagationStopped = tc),
              this
            );
          }
          return (
            b(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var i = this.nativeEvent;
                i &&
                  (i.preventDefault
                    ? i.preventDefault()
                    : typeof i.returnValue != 'unknown' && (i.returnValue = !1),
                  (this.isDefaultPrevented = ml));
              },
              stopPropagation: function () {
                var i = this.nativeEvent;
                i &&
                  (i.stopPropagation
                    ? i.stopPropagation()
                    : typeof i.cancelBubble != 'unknown' &&
                      (i.cancelBubble = !0),
                  (this.isPropagationStopped = ml));
              },
              persist: function () {},
              isPersistent: ml,
            }),
            t
          );
        }
        var Ui = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          gl = rt(Ui),
          sa = b({}, Ui, { view: 0, detail: 0 }),
          rm = rt(sa),
          Is,
          Ps,
          ra,
          vl = b({}, sa, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: er,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return e.relatedTarget === void 0
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return 'movementX' in e
                ? e.movementX
                : (e !== ra &&
                    (ra && e.type === 'mousemove'
                      ? ((Is = e.screenX - ra.screenX),
                        (Ps = e.screenY - ra.screenY))
                      : (Ps = Is = 0),
                    (ra = e)),
                  Is);
            },
            movementY: function (e) {
              return 'movementY' in e ? e.movementY : Ps;
            },
          }),
          ic = rt(vl),
          om = b({}, vl, { dataTransfer: 0 }),
          um = rt(om),
          cm = b({}, sa, { relatedTarget: 0 }),
          Ws = rt(cm),
          fm = b({}, Ui, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0,
          }),
          dm = rt(fm),
          hm = b({}, Ui, {
            clipboardData: function (e) {
              return 'clipboardData' in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          pm = rt(hm),
          mm = b({}, Ui, { data: 0 }),
          nc = rt(mm),
          gm = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          vm = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          ym = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey',
          };
        function bm(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : (e = ym[e])
              ? !!t[e]
              : !1;
        }
        function er() {
          return bm;
        }
        var Sm = b({}, sa, {
            key: function (e) {
              if (e.key) {
                var t = gm[e.key] || e.key;
                if (t !== 'Unidentified') return t;
              }
              return e.type === 'keypress'
                ? ((e = pl(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                : e.type === 'keydown' || e.type === 'keyup'
                  ? vm[e.keyCode] || 'Unidentified'
                  : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: er,
            charCode: function (e) {
              return e.type === 'keypress' ? pl(e) : 0;
            },
            keyCode: function (e) {
              return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
            },
            which: function (e) {
              return e.type === 'keypress'
                ? pl(e)
                : e.type === 'keydown' || e.type === 'keyup'
                  ? e.keyCode
                  : 0;
            },
          }),
          xm = rt(Sm),
          Tm = b({}, vl, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0,
          }),
          ac = rt(Tm),
          Em = b({}, sa, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: er,
          }),
          wm = rt(Em),
          Am = b({}, Ui, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          Mm = rt(Am),
          Om = b({}, vl, {
            deltaX: function (e) {
              return 'deltaX' in e
                ? e.deltaX
                : 'wheelDeltaX' in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return 'deltaY' in e
                ? e.deltaY
                : 'wheelDeltaY' in e
                  ? -e.wheelDeltaY
                  : 'wheelDelta' in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          _m = rt(Om),
          zm = b({}, Ui, { newState: 0, oldState: 0 }),
          Nm = rt(zm),
          Cm = [9, 13, 27, 32],
          tr = Kt && 'CompositionEvent' in window,
          oa = null;
        Kt && 'documentMode' in document && (oa = document.documentMode);
        var Rm = Kt && 'TextEvent' in window && !oa,
          lc = Kt && (!tr || (oa && 8 < oa && 11 >= oa)),
          sc = ' ',
          rc = !1;
        function oc(e, t) {
          switch (e) {
            case 'keyup':
              return Cm.indexOf(t.keyCode) !== -1;
            case 'keydown':
              return t.keyCode !== 229;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function uc(e) {
          return (
            (e = e.detail),
            typeof e == 'object' && 'data' in e ? e.data : null
          );
        }
        var bn = !1;
        function Dm(e, t) {
          switch (e) {
            case 'compositionend':
              return uc(t);
            case 'keypress':
              return t.which !== 32 ? null : ((rc = !0), sc);
            case 'textInput':
              return ((e = t.data), e === sc && rc ? null : e);
            default:
              return null;
          }
        }
        function Lm(e, t) {
          if (bn)
            return e === 'compositionend' || (!tr && oc(e, t))
              ? ((e = ec()), (hl = Fs = di = null), (bn = !1), e)
              : null;
          switch (e) {
            case 'paste':
              return null;
            case 'keypress':
              if (
                !(t.ctrlKey || t.altKey || t.metaKey) ||
                (t.ctrlKey && t.altKey)
              ) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
              }
              return null;
            case 'compositionend':
              return lc && t.locale !== 'ko' ? null : t.data;
            default:
              return null;
          }
        }
        var jm = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function cc(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return t === 'input' ? !!jm[e.type] : t === 'textarea';
        }
        function fc(e, t, i, n) {
          (vn ? (yn ? yn.push(n) : (yn = [n])) : (vn = n),
            (t = ns(t, 'onChange')),
            0 < t.length &&
              ((i = new gl('onChange', 'change', null, i, n)),
              e.push({ event: i, listeners: t })));
        }
        var ua = null,
          ca = null;
        function Bm(e) {
          Xd(e, 0);
        }
        function yl(e) {
          var t = na(e);
          if (Xu(t)) return e;
        }
        function dc(e, t) {
          if (e === 'change') return t;
        }
        var hc = !1;
        if (Kt) {
          var ir;
          if (Kt) {
            var nr = 'oninput' in document;
            if (!nr) {
              var pc = document.createElement('div');
              (pc.setAttribute('oninput', 'return;'),
                (nr = typeof pc.oninput == 'function'));
            }
            ir = nr;
          } else ir = !1;
          hc = ir && (!document.documentMode || 9 < document.documentMode);
        }
        function mc() {
          ua && (ua.detachEvent('onpropertychange', gc), (ca = ua = null));
        }
        function gc(e) {
          if (e.propertyName === 'value' && yl(ca)) {
            var t = [];
            (fc(t, ca, e, Qs(e)), Wu(Bm, t));
          }
        }
        function Hm(e, t, i) {
          e === 'focusin'
            ? (mc(), (ua = t), (ca = i), ua.attachEvent('onpropertychange', gc))
            : e === 'focusout' && mc();
        }
        function Um(e) {
          if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
            return yl(ca);
        }
        function Gm(e, t) {
          if (e === 'click') return yl(t);
        }
        function Vm(e, t) {
          if (e === 'input' || e === 'change') return yl(t);
        }
        function Ym(e, t) {
          return (
            (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t)
          );
        }
        var gt = typeof Object.is == 'function' ? Object.is : Ym;
        function fa(e, t) {
          if (gt(e, t)) return !0;
          if (
            typeof e != 'object' ||
            e === null ||
            typeof t != 'object' ||
            t === null
          )
            return !1;
          var i = Object.keys(e),
            n = Object.keys(t);
          if (i.length !== n.length) return !1;
          for (n = 0; n < i.length; n++) {
            var o = i[n];
            if (!Rs.call(t, o) || !gt(e[o], t[o])) return !1;
          }
          return !0;
        }
        function vc(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function yc(e, t) {
          var i = vc(e);
          e = 0;
          for (var n; i; ) {
            if (i.nodeType === 3) {
              if (((n = e + i.textContent.length), e <= t && n >= t))
                return { node: i, offset: t - e };
              e = n;
            }
            e: {
              for (; i; ) {
                if (i.nextSibling) {
                  i = i.nextSibling;
                  break e;
                }
                i = i.parentNode;
              }
              i = void 0;
            }
            i = vc(i);
          }
        }
        function bc(e, t) {
          return e && t
            ? e === t
              ? !0
              : e && e.nodeType === 3
                ? !1
                : t && t.nodeType === 3
                  ? bc(e, t.parentNode)
                  : 'contains' in e
                    ? e.contains(t)
                    : e.compareDocumentPosition
                      ? !!(e.compareDocumentPosition(t) & 16)
                      : !1
            : !1;
        }
        function Sc(e) {
          e =
            e != null &&
            e.ownerDocument != null &&
            e.ownerDocument.defaultView != null
              ? e.ownerDocument.defaultView
              : window;
          for (var t = fl(e.document); t instanceof e.HTMLIFrameElement; ) {
            try {
              var i = typeof t.contentWindow.location.href == 'string';
            } catch {
              i = !1;
            }
            if (i) e = t.contentWindow;
            else break;
            t = fl(e.document);
          }
          return t;
        }
        function ar(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            ((t === 'input' &&
              (e.type === 'text' ||
                e.type === 'search' ||
                e.type === 'tel' ||
                e.type === 'url' ||
                e.type === 'password')) ||
              t === 'textarea' ||
              e.contentEditable === 'true')
          );
        }
        var qm =
            Kt && 'documentMode' in document && 11 >= document.documentMode,
          Sn = null,
          lr = null,
          da = null,
          sr = !1;
        function xc(e, t, i) {
          var n =
            i.window === i
              ? i.document
              : i.nodeType === 9
                ? i
                : i.ownerDocument;
          sr ||
            Sn == null ||
            Sn !== fl(n) ||
            ((n = Sn),
            'selectionStart' in n && ar(n)
              ? (n = { start: n.selectionStart, end: n.selectionEnd })
              : ((n = (
                  (n.ownerDocument && n.ownerDocument.defaultView) ||
                  window
                ).getSelection()),
                (n = {
                  anchorNode: n.anchorNode,
                  anchorOffset: n.anchorOffset,
                  focusNode: n.focusNode,
                  focusOffset: n.focusOffset,
                })),
            (da && fa(da, n)) ||
              ((da = n),
              (n = ns(lr, 'onSelect')),
              0 < n.length &&
                ((t = new gl('onSelect', 'select', null, t, i)),
                e.push({ event: t, listeners: n }),
                (t.target = Sn))));
        }
        function Gi(e, t) {
          var i = {};
          return (
            (i[e.toLowerCase()] = t.toLowerCase()),
            (i['Webkit' + e] = 'webkit' + t),
            (i['Moz' + e] = 'moz' + t),
            i
          );
        }
        var xn = {
            animationend: Gi('Animation', 'AnimationEnd'),
            animationiteration: Gi('Animation', 'AnimationIteration'),
            animationstart: Gi('Animation', 'AnimationStart'),
            transitionrun: Gi('Transition', 'TransitionRun'),
            transitionstart: Gi('Transition', 'TransitionStart'),
            transitioncancel: Gi('Transition', 'TransitionCancel'),
            transitionend: Gi('Transition', 'TransitionEnd'),
          },
          rr = {},
          Tc = {};
        Kt &&
          ((Tc = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete xn.animationend.animation,
            delete xn.animationiteration.animation,
            delete xn.animationstart.animation),
          'TransitionEvent' in window || delete xn.transitionend.transition);
        function Vi(e) {
          if (rr[e]) return rr[e];
          if (!xn[e]) return e;
          var t = xn[e],
            i;
          for (i in t)
            if (t.hasOwnProperty(i) && i in Tc) return (rr[e] = t[i]);
          return e;
        }
        var Ec = Vi('animationend'),
          wc = Vi('animationiteration'),
          Ac = Vi('animationstart'),
          $m = Vi('transitionrun'),
          Km = Vi('transitionstart'),
          km = Vi('transitioncancel'),
          Mc = Vi('transitionend'),
          Oc = new Map(),
          or =
            'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        or.push('scrollEnd');
        function Dt(e, t) {
          (Oc.set(e, t), Hi(t, [e]));
        }
        var _c = new WeakMap();
        function Mt(e, t) {
          if (typeof e == 'object' && e !== null) {
            var i = _c.get(e);
            return i !== void 0
              ? i
              : ((t = { value: e, source: t, stack: Ku(t) }), _c.set(e, t), t);
          }
          return { value: e, source: t, stack: Ku(t) };
        }
        var Ot = [],
          Tn = 0,
          ur = 0;
        function bl() {
          for (var e = Tn, t = (ur = Tn = 0); t < e; ) {
            var i = Ot[t];
            Ot[t++] = null;
            var n = Ot[t];
            Ot[t++] = null;
            var o = Ot[t];
            Ot[t++] = null;
            var c = Ot[t];
            if (((Ot[t++] = null), n !== null && o !== null)) {
              var m = n.pending;
              (m === null ? (o.next = o) : ((o.next = m.next), (m.next = o)),
                (n.pending = o));
            }
            c !== 0 && zc(i, o, c);
          }
        }
        function Sl(e, t, i, n) {
          ((Ot[Tn++] = e),
            (Ot[Tn++] = t),
            (Ot[Tn++] = i),
            (Ot[Tn++] = n),
            (ur |= n),
            (e.lanes |= n),
            (e = e.alternate),
            e !== null && (e.lanes |= n));
        }
        function cr(e, t, i, n) {
          return (Sl(e, t, i, n), xl(e));
        }
        function En(e, t) {
          return (Sl(e, null, null, t), xl(e));
        }
        function zc(e, t, i) {
          e.lanes |= i;
          var n = e.alternate;
          n !== null && (n.lanes |= i);
          for (var o = !1, c = e.return; c !== null; )
            ((c.childLanes |= i),
              (n = c.alternate),
              n !== null && (n.childLanes |= i),
              c.tag === 22 &&
                ((e = c.stateNode),
                e === null || e._visibility & 1 || (o = !0)),
              (e = c),
              (c = c.return));
          return e.tag === 3
            ? ((c = e.stateNode),
              o &&
                t !== null &&
                ((o = 31 - mt(i)),
                (e = c.hiddenUpdates),
                (n = e[o]),
                n === null ? (e[o] = [t]) : n.push(t),
                (t.lane = i | 536870912)),
              c)
            : null;
        }
        function xl(e) {
          if (50 < Ha) throw ((Ha = 0), (vo = null), Error(r(185)));
          for (var t = e.return; t !== null; ) ((e = t), (t = e.return));
          return e.tag === 3 ? e.stateNode : null;
        }
        var wn = {};
        function Xm(e, t, i, n) {
          ((this.tag = e),
            (this.key = i),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = n),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function vt(e, t, i, n) {
          return new Xm(e, t, i, n);
        }
        function fr(e) {
          return ((e = e.prototype), !(!e || !e.isReactComponent));
        }
        function kt(e, t) {
          var i = e.alternate;
          return (
            i === null
              ? ((i = vt(e.tag, t, e.key, e.mode)),
                (i.elementType = e.elementType),
                (i.type = e.type),
                (i.stateNode = e.stateNode),
                (i.alternate = e),
                (e.alternate = i))
              : ((i.pendingProps = t),
                (i.type = e.type),
                (i.flags = 0),
                (i.subtreeFlags = 0),
                (i.deletions = null)),
            (i.flags = e.flags & 65011712),
            (i.childLanes = e.childLanes),
            (i.lanes = e.lanes),
            (i.child = e.child),
            (i.memoizedProps = e.memoizedProps),
            (i.memoizedState = e.memoizedState),
            (i.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (i.dependencies =
              t === null
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (i.sibling = e.sibling),
            (i.index = e.index),
            (i.ref = e.ref),
            (i.refCleanup = e.refCleanup),
            i
          );
        }
        function Nc(e, t) {
          e.flags &= 65011714;
          var i = e.alternate;
          return (
            i === null
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = i.childLanes),
                (e.lanes = i.lanes),
                (e.child = i.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = i.memoizedProps),
                (e.memoizedState = i.memoizedState),
                (e.updateQueue = i.updateQueue),
                (e.type = i.type),
                (t = i.dependencies),
                (e.dependencies =
                  t === null
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Tl(e, t, i, n, o, c) {
          var m = 0;
          if (((n = e), typeof e == 'function')) fr(e) && (m = 1);
          else if (typeof e == 'string')
            m = Zg(e, i, le.current)
              ? 26
              : e === 'html' || e === 'head' || e === 'body'
                ? 27
                : 5;
          else
            e: switch (e) {
              case ee:
                return (
                  (e = vt(31, i, t, o)),
                  (e.elementType = ee),
                  (e.lanes = c),
                  e
                );
              case O:
                return Yi(i.children, o, c, t);
              case _:
                ((m = 8), (o |= 24));
                break;
              case L:
                return (
                  (e = vt(12, i, t, o | 2)),
                  (e.elementType = L),
                  (e.lanes = c),
                  e
                );
              case H:
                return (
                  (e = vt(13, i, t, o)),
                  (e.elementType = H),
                  (e.lanes = c),
                  e
                );
              case J:
                return (
                  (e = vt(19, i, t, o)),
                  (e.elementType = J),
                  (e.lanes = c),
                  e
                );
              default:
                if (typeof e == 'object' && e !== null)
                  switch (e.$$typeof) {
                    case $:
                    case K:
                      m = 10;
                      break e;
                    case B:
                      m = 9;
                      break e;
                    case k:
                      m = 11;
                      break e;
                    case Z:
                      m = 14;
                      break e;
                    case G:
                      ((m = 16), (n = null));
                      break e;
                  }
                ((m = 29),
                  (i = Error(r(130, e === null ? 'null' : typeof e, ''))),
                  (n = null));
            }
          return (
            (t = vt(m, i, t, o)),
            (t.elementType = e),
            (t.type = n),
            (t.lanes = c),
            t
          );
        }
        function Yi(e, t, i, n) {
          return ((e = vt(7, e, n, t)), (e.lanes = i), e);
        }
        function dr(e, t, i) {
          return ((e = vt(6, e, null, t)), (e.lanes = i), e);
        }
        function hr(e, t, i) {
          return (
            (t = vt(4, e.children !== null ? e.children : [], e.key, t)),
            (t.lanes = i),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        var An = [],
          Mn = 0,
          El = null,
          wl = 0,
          _t = [],
          zt = 0,
          qi = null,
          Xt = 1,
          Qt = '';
        function $i(e, t) {
          ((An[Mn++] = wl), (An[Mn++] = El), (El = e), (wl = t));
        }
        function Cc(e, t, i) {
          ((_t[zt++] = Xt), (_t[zt++] = Qt), (_t[zt++] = qi), (qi = e));
          var n = Xt;
          e = Qt;
          var o = 32 - mt(n) - 1;
          ((n &= ~(1 << o)), (i += 1));
          var c = 32 - mt(t) + o;
          if (30 < c) {
            var m = o - (o % 5);
            ((c = (n & ((1 << m) - 1)).toString(32)),
              (n >>= m),
              (o -= m),
              (Xt = (1 << (32 - mt(t) + o)) | (i << o) | n),
              (Qt = c + e));
          } else ((Xt = (1 << c) | (i << o) | n), (Qt = e));
        }
        function pr(e) {
          e.return !== null && ($i(e, 1), Cc(e, 1, 0));
        }
        function mr(e) {
          for (; e === El; )
            ((El = An[--Mn]),
              (An[Mn] = null),
              (wl = An[--Mn]),
              (An[Mn] = null));
          for (; e === qi; )
            ((qi = _t[--zt]),
              (_t[zt] = null),
              (Qt = _t[--zt]),
              (_t[zt] = null),
              (Xt = _t[--zt]),
              (_t[zt] = null));
        }
        var nt = null,
          Le = null,
          Te = !1,
          Ki = null,
          Ht = !1,
          gr = Error(r(519));
        function ki(e) {
          var t = Error(r(418, ''));
          throw (ma(Mt(t, e)), gr);
        }
        function Rc(e) {
          var t = e.stateNode,
            i = e.type,
            n = e.memoizedProps;
          switch (((t[et] = e), (t[st] = n), i)) {
            case 'dialog':
              (ye('cancel', t), ye('close', t));
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              ye('load', t);
              break;
            case 'video':
            case 'audio':
              for (i = 0; i < Ga.length; i++) ye(Ga[i], t);
              break;
            case 'source':
              ye('error', t);
              break;
            case 'img':
            case 'image':
            case 'link':
              (ye('error', t), ye('load', t));
              break;
            case 'details':
              ye('toggle', t);
              break;
            case 'input':
              (ye('invalid', t),
                Qu(
                  t,
                  n.value,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name,
                  !0
                ),
                cl(t));
              break;
            case 'select':
              ye('invalid', t);
              break;
            case 'textarea':
              (ye('invalid', t),
                Ju(t, n.value, n.defaultValue, n.children),
                cl(t));
          }
          ((i = n.children),
            (typeof i != 'string' &&
              typeof i != 'number' &&
              typeof i != 'bigint') ||
            t.textContent === '' + i ||
            n.suppressHydrationWarning === !0 ||
            Fd(t.textContent, i)
              ? (n.popover != null && (ye('beforetoggle', t), ye('toggle', t)),
                n.onScroll != null && ye('scroll', t),
                n.onScrollEnd != null && ye('scrollend', t),
                n.onClick != null && (t.onclick = as),
                (t = !0))
              : (t = !1),
            t || ki(e));
        }
        function Dc(e) {
          for (nt = e.return; nt; )
            switch (nt.tag) {
              case 5:
              case 13:
                Ht = !1;
                return;
              case 27:
              case 3:
                Ht = !0;
                return;
              default:
                nt = nt.return;
            }
        }
        function ha(e) {
          if (e !== nt) return !1;
          if (!Te) return (Dc(e), (Te = !0), !1);
          var t = e.tag,
            i;
          if (
            ((i = t !== 3 && t !== 27) &&
              ((i = t === 5) &&
                ((i = e.type),
                (i =
                  !(i !== 'form' && i !== 'button') ||
                  Do(e.type, e.memoizedProps))),
              (i = !i)),
            i && Le && ki(e),
            Dc(e),
            t === 13)
          ) {
            if (
              ((e = e.memoizedState),
              (e = e !== null ? e.dehydrated : null),
              !e)
            )
              throw Error(r(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (e.nodeType === 8)
                  if (((i = e.data), i === '/$')) {
                    if (t === 0) {
                      Le = jt(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else (i !== '$' && i !== '$!' && i !== '$?') || t++;
                e = e.nextSibling;
              }
              Le = null;
            }
          } else
            t === 27
              ? ((t = Le),
                _i(e.type) ? ((e = Ho), (Ho = null), (Le = e)) : (Le = t))
              : (Le = nt ? jt(e.stateNode.nextSibling) : null);
          return !0;
        }
        function pa() {
          ((Le = nt = null), (Te = !1));
        }
        function Lc() {
          var e = Ki;
          return (
            e !== null &&
              (ct === null ? (ct = e) : ct.push.apply(ct, e), (Ki = null)),
            e
          );
        }
        function ma(e) {
          Ki === null ? (Ki = [e]) : Ki.push(e);
        }
        var vr = j(null),
          Xi = null,
          Zt = null;
        function hi(e, t, i) {
          (P(vr, t._currentValue), (t._currentValue = i));
        }
        function Jt(e) {
          ((e._currentValue = vr.current), W(vr));
        }
        function yr(e, t, i) {
          for (; e !== null; ) {
            var n = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), n !== null && (n.childLanes |= t))
                : n !== null && (n.childLanes & t) !== t && (n.childLanes |= t),
              e === i)
            )
              break;
            e = e.return;
          }
        }
        function br(e, t, i, n) {
          var o = e.child;
          for (o !== null && (o.return = e); o !== null; ) {
            var c = o.dependencies;
            if (c !== null) {
              var m = o.child;
              c = c.firstContext;
              e: for (; c !== null; ) {
                var v = c;
                c = o;
                for (var S = 0; S < t.length; S++)
                  if (v.context === t[S]) {
                    ((c.lanes |= i),
                      (v = c.alternate),
                      v !== null && (v.lanes |= i),
                      yr(c.return, i, e),
                      n || (m = null));
                    break e;
                  }
                c = v.next;
              }
            } else if (o.tag === 18) {
              if (((m = o.return), m === null)) throw Error(r(341));
              ((m.lanes |= i),
                (c = m.alternate),
                c !== null && (c.lanes |= i),
                yr(m, i, e),
                (m = null));
            } else m = o.child;
            if (m !== null) m.return = o;
            else
              for (m = o; m !== null; ) {
                if (m === e) {
                  m = null;
                  break;
                }
                if (((o = m.sibling), o !== null)) {
                  ((o.return = m.return), (m = o));
                  break;
                }
                m = m.return;
              }
            o = m;
          }
        }
        function ga(e, t, i, n) {
          e = null;
          for (var o = t, c = !1; o !== null; ) {
            if (!c) {
              if ((o.flags & 524288) !== 0) c = !0;
              else if ((o.flags & 262144) !== 0) break;
            }
            if (o.tag === 10) {
              var m = o.alternate;
              if (m === null) throw Error(r(387));
              if (((m = m.memoizedProps), m !== null)) {
                var v = o.type;
                gt(o.pendingProps.value, m.value) ||
                  (e !== null ? e.push(v) : (e = [v]));
              }
            } else if (o === ht.current) {
              if (((m = o.alternate), m === null)) throw Error(r(387));
              m.memoizedState.memoizedState !== o.memoizedState.memoizedState &&
                (e !== null ? e.push(ka) : (e = [ka]));
            }
            o = o.return;
          }
          (e !== null && br(t, e, i, n), (t.flags |= 262144));
        }
        function Al(e) {
          for (e = e.firstContext; e !== null; ) {
            if (!gt(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function Qi(e) {
          ((Xi = e),
            (Zt = null),
            (e = e.dependencies),
            e !== null && (e.firstContext = null));
        }
        function tt(e) {
          return jc(Xi, e);
        }
        function Ml(e, t) {
          return (Xi === null && Qi(e), jc(e, t));
        }
        function jc(e, t) {
          var i = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: i, next: null }), Zt === null)
          ) {
            if (e === null) throw Error(r(308));
            ((Zt = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288));
          } else Zt = Zt.next = t;
          return i;
        }
        var Qm =
            typeof AbortController < 'u'
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (i, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    ((t.aborted = !0),
                      e.forEach(function (i) {
                        return i();
                      }));
                  };
                },
          Zm = s.unstable_scheduleCallback,
          Jm = s.unstable_NormalPriority,
          Ye = {
            $$typeof: K,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Sr() {
          return { controller: new Qm(), data: new Map(), refCount: 0 };
        }
        function va(e) {
          (e.refCount--,
            e.refCount === 0 &&
              Zm(Jm, function () {
                e.controller.abort();
              }));
        }
        var ya = null,
          xr = 0,
          On = 0,
          _n = null;
        function Fm(e, t) {
          if (ya === null) {
            var i = (ya = []);
            ((xr = 0),
              (On = wo()),
              (_n = {
                status: 'pending',
                value: void 0,
                then: function (n) {
                  i.push(n);
                },
              }));
          }
          return (xr++, t.then(Bc, Bc), t);
        }
        function Bc() {
          if (--xr === 0 && ya !== null) {
            _n !== null && (_n.status = 'fulfilled');
            var e = ya;
            ((ya = null), (On = 0), (_n = null));
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        function Im(e, t) {
          var i = [],
            n = {
              status: 'pending',
              value: null,
              reason: null,
              then: function (o) {
                i.push(o);
              },
            };
          return (
            e.then(
              function () {
                ((n.status = 'fulfilled'), (n.value = t));
                for (var o = 0; o < i.length; o++) (0, i[o])(t);
              },
              function (o) {
                for (
                  n.status = 'rejected', n.reason = o, o = 0;
                  o < i.length;
                  o++
                )
                  (0, i[o])(void 0);
              }
            ),
            n
          );
        }
        var Hc = D.S;
        D.S = function (e, t) {
          (typeof t == 'object' &&
            t !== null &&
            typeof t.then == 'function' &&
            Fm(e, t),
            Hc !== null && Hc(e, t));
        };
        var Zi = j(null);
        function Tr() {
          var e = Zi.current;
          return e !== null ? e : Ne.pooledCache;
        }
        function Ol(e, t) {
          t === null ? P(Zi, Zi.current) : P(Zi, t.pool);
        }
        function Uc() {
          var e = Tr();
          return e === null ? null : { parent: Ye._currentValue, pool: e };
        }
        var ba = Error(r(460)),
          Gc = Error(r(474)),
          _l = Error(r(542)),
          Er = { then: function () {} };
        function Vc(e) {
          return ((e = e.status), e === 'fulfilled' || e === 'rejected');
        }
        function zl() {}
        function Yc(e, t, i) {
          switch (
            ((i = e[i]),
            i === void 0 ? e.push(t) : i !== t && (t.then(zl, zl), (t = i)),
            t.status)
          ) {
            case 'fulfilled':
              return t.value;
            case 'rejected':
              throw ((e = t.reason), $c(e), e);
            default:
              if (typeof t.status == 'string') t.then(zl, zl);
              else {
                if (((e = Ne), e !== null && 100 < e.shellSuspendCounter))
                  throw Error(r(482));
                ((e = t),
                  (e.status = 'pending'),
                  e.then(
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'fulfilled'), (o.value = n));
                      }
                    },
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'rejected'), (o.reason = n));
                      }
                    }
                  ));
              }
              switch (t.status) {
                case 'fulfilled':
                  return t.value;
                case 'rejected':
                  throw ((e = t.reason), $c(e), e);
              }
              throw ((Sa = t), ba);
          }
        }
        var Sa = null;
        function qc() {
          if (Sa === null) throw Error(r(459));
          var e = Sa;
          return ((Sa = null), e);
        }
        function $c(e) {
          if (e === ba || e === _l) throw Error(r(483));
        }
        var pi = !1;
        function wr(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function Ar(e, t) {
          ((e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              }));
        }
        function mi(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function gi(e, t, i) {
          var n = e.updateQueue;
          if (n === null) return null;
          if (((n = n.shared), (we & 2) !== 0)) {
            var o = n.pending;
            return (
              o === null ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (n.pending = t),
              (t = xl(e)),
              zc(e, null, i),
              t
            );
          }
          return (Sl(e, n, t, i), xl(e));
        }
        function xa(e, t, i) {
          if (
            ((t = t.updateQueue),
            t !== null && ((t = t.shared), (i & 4194048) !== 0))
          ) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (i |= n), (t.lanes = i), Bu(e, i));
          }
        }
        function Mr(e, t) {
          var i = e.updateQueue,
            n = e.alternate;
          if (n !== null && ((n = n.updateQueue), i === n)) {
            var o = null,
              c = null;
            if (((i = i.firstBaseUpdate), i !== null)) {
              do {
                var m = {
                  lane: i.lane,
                  tag: i.tag,
                  payload: i.payload,
                  callback: null,
                  next: null,
                };
                (c === null ? (o = c = m) : (c = c.next = m), (i = i.next));
              } while (i !== null);
              c === null ? (o = c = t) : (c = c.next = t);
            } else o = c = t;
            ((i = {
              baseState: n.baseState,
              firstBaseUpdate: o,
              lastBaseUpdate: c,
              shared: n.shared,
              callbacks: n.callbacks,
            }),
              (e.updateQueue = i));
            return;
          }
          ((e = i.lastBaseUpdate),
            e === null ? (i.firstBaseUpdate = t) : (e.next = t),
            (i.lastBaseUpdate = t));
        }
        var Or = !1;
        function Ta() {
          if (Or) {
            var e = _n;
            if (e !== null) throw e;
          }
        }
        function Ea(e, t, i, n) {
          Or = !1;
          var o = e.updateQueue;
          pi = !1;
          var c = o.firstBaseUpdate,
            m = o.lastBaseUpdate,
            v = o.shared.pending;
          if (v !== null) {
            o.shared.pending = null;
            var S = v,
              N = S.next;
            ((S.next = null), m === null ? (c = N) : (m.next = N), (m = S));
            var U = e.alternate;
            U !== null &&
              ((U = U.updateQueue),
              (v = U.lastBaseUpdate),
              v !== m &&
                (v === null ? (U.firstBaseUpdate = N) : (v.next = N),
                (U.lastBaseUpdate = S)));
          }
          if (c !== null) {
            var Y = o.baseState;
            ((m = 0), (U = N = S = null), (v = c));
            do {
              var C = v.lane & -536870913,
                R = C !== v.lane;
              if (R ? (be & C) === C : (n & C) === C) {
                (C !== 0 && C === On && (Or = !0),
                  U !== null &&
                    (U = U.next =
                      {
                        lane: 0,
                        tag: v.tag,
                        payload: v.payload,
                        callback: null,
                        next: null,
                      }));
                e: {
                  var ce = e,
                    se = v;
                  C = t;
                  var _e = i;
                  switch (se.tag) {
                    case 1:
                      if (((ce = se.payload), typeof ce == 'function')) {
                        Y = ce.call(_e, Y, C);
                        break e;
                      }
                      Y = ce;
                      break e;
                    case 3:
                      ce.flags = (ce.flags & -65537) | 128;
                    case 0:
                      if (
                        ((ce = se.payload),
                        (C = typeof ce == 'function' ? ce.call(_e, Y, C) : ce),
                        C == null)
                      )
                        break e;
                      Y = b({}, Y, C);
                      break e;
                    case 2:
                      pi = !0;
                  }
                }
                ((C = v.callback),
                  C !== null &&
                    ((e.flags |= 64),
                    R && (e.flags |= 8192),
                    (R = o.callbacks),
                    R === null ? (o.callbacks = [C]) : R.push(C)));
              } else
                ((R = {
                  lane: C,
                  tag: v.tag,
                  payload: v.payload,
                  callback: v.callback,
                  next: null,
                }),
                  U === null ? ((N = U = R), (S = Y)) : (U = U.next = R),
                  (m |= C));
              if (((v = v.next), v === null)) {
                if (((v = o.shared.pending), v === null)) break;
                ((R = v),
                  (v = R.next),
                  (R.next = null),
                  (o.lastBaseUpdate = R),
                  (o.shared.pending = null));
              }
            } while (!0);
            (U === null && (S = Y),
              (o.baseState = S),
              (o.firstBaseUpdate = N),
              (o.lastBaseUpdate = U),
              c === null && (o.shared.lanes = 0),
              (wi |= m),
              (e.lanes = m),
              (e.memoizedState = Y));
          }
        }
        function Kc(e, t) {
          if (typeof e != 'function') throw Error(r(191, e));
          e.call(t);
        }
        function kc(e, t) {
          var i = e.callbacks;
          if (i !== null)
            for (e.callbacks = null, e = 0; e < i.length; e++) Kc(i[e], t);
        }
        var zn = j(null),
          Nl = j(0);
        function Xc(e, t) {
          ((e = ii), P(Nl, e), P(zn, t), (ii = e | t.baseLanes));
        }
        function _r() {
          (P(Nl, ii), P(zn, zn.current));
        }
        function zr() {
          ((ii = Nl.current), W(zn), W(Nl));
        }
        var vi = 0,
          me = null,
          Me = null,
          Ge = null,
          Cl = !1,
          Nn = !1,
          Ji = !1,
          Rl = 0,
          wa = 0,
          Cn = null,
          Pm = 0;
        function He() {
          throw Error(r(321));
        }
        function Nr(e, t) {
          if (t === null) return !1;
          for (var i = 0; i < t.length && i < e.length; i++)
            if (!gt(e[i], t[i])) return !1;
          return !0;
        }
        function Cr(e, t, i, n, o, c) {
          return (
            (vi = c),
            (me = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (D.H = e === null || e.memoizedState === null ? Nf : Cf),
            (Ji = !1),
            (c = i(n, o)),
            (Ji = !1),
            Nn && (c = Zc(t, i, n, o)),
            Qc(e),
            c
          );
        }
        function Qc(e) {
          D.H = Ul;
          var t = Me !== null && Me.next !== null;
          if (
            ((vi = 0),
            (Ge = Me = me = null),
            (Cl = !1),
            (wa = 0),
            (Cn = null),
            t)
          )
            throw Error(r(300));
          e === null ||
            Xe ||
            ((e = e.dependencies), e !== null && Al(e) && (Xe = !0));
        }
        function Zc(e, t, i, n) {
          me = e;
          var o = 0;
          do {
            if ((Nn && (Cn = null), (wa = 0), (Nn = !1), 25 <= o))
              throw Error(r(301));
            if (((o += 1), (Ge = Me = null), e.updateQueue != null)) {
              var c = e.updateQueue;
              ((c.lastEffect = null),
                (c.events = null),
                (c.stores = null),
                c.memoCache != null && (c.memoCache.index = 0));
            }
            ((D.H = lg), (c = t(i, n)));
          } while (Nn);
          return c;
        }
        function Wm() {
          var e = D.H,
            t = e.useState()[0];
          return (
            (t = typeof t.then == 'function' ? Aa(t) : t),
            (e = e.useState()[0]),
            (Me !== null ? Me.memoizedState : null) !== e && (me.flags |= 1024),
            t
          );
        }
        function Rr() {
          var e = Rl !== 0;
          return ((Rl = 0), e);
        }
        function Dr(e, t, i) {
          ((t.updateQueue = e.updateQueue),
            (t.flags &= -2053),
            (e.lanes &= ~i));
        }
        function Lr(e) {
          if (Cl) {
            for (e = e.memoizedState; e !== null; ) {
              var t = e.queue;
              (t !== null && (t.pending = null), (e = e.next));
            }
            Cl = !1;
          }
          ((vi = 0),
            (Ge = Me = me = null),
            (Nn = !1),
            (wa = Rl = 0),
            (Cn = null));
        }
        function ot() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            Ge === null ? (me.memoizedState = Ge = e) : (Ge = Ge.next = e),
            Ge
          );
        }
        function Ve() {
          if (Me === null) {
            var e = me.alternate;
            e = e !== null ? e.memoizedState : null;
          } else e = Me.next;
          var t = Ge === null ? me.memoizedState : Ge.next;
          if (t !== null) ((Ge = t), (Me = e));
          else {
            if (e === null)
              throw me.alternate === null ? Error(r(467)) : Error(r(310));
            ((Me = e),
              (e = {
                memoizedState: Me.memoizedState,
                baseState: Me.baseState,
                baseQueue: Me.baseQueue,
                queue: Me.queue,
                next: null,
              }),
              Ge === null ? (me.memoizedState = Ge = e) : (Ge = Ge.next = e));
          }
          return Ge;
        }
        function jr() {
          return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null,
          };
        }
        function Aa(e) {
          var t = wa;
          return (
            (wa += 1),
            Cn === null && (Cn = []),
            (e = Yc(Cn, e, t)),
            (t = me),
            (Ge === null ? t.memoizedState : Ge.next) === null &&
              ((t = t.alternate),
              (D.H = t === null || t.memoizedState === null ? Nf : Cf)),
            e
          );
        }
        function Dl(e) {
          if (e !== null && typeof e == 'object') {
            if (typeof e.then == 'function') return Aa(e);
            if (e.$$typeof === K) return tt(e);
          }
          throw Error(r(438, String(e)));
        }
        function Br(e) {
          var t = null,
            i = me.updateQueue;
          if ((i !== null && (t = i.memoCache), t == null)) {
            var n = me.alternate;
            n !== null &&
              ((n = n.updateQueue),
              n !== null &&
                ((n = n.memoCache),
                n != null &&
                  (t = {
                    data: n.data.map(function (o) {
                      return o.slice();
                    }),
                    index: 0,
                  })));
          }
          if (
            (t == null && (t = { data: [], index: 0 }),
            i === null && ((i = jr()), (me.updateQueue = i)),
            (i.memoCache = t),
            (i = t.data[t.index]),
            i === void 0)
          )
            for (i = t.data[t.index] = Array(e), n = 0; n < e; n++) i[n] = Q;
          return (t.index++, i);
        }
        function Ft(e, t) {
          return typeof t == 'function' ? t(e) : t;
        }
        function Ll(e) {
          var t = Ve();
          return Hr(t, Me, e);
        }
        function Hr(e, t, i) {
          var n = e.queue;
          if (n === null) throw Error(r(311));
          n.lastRenderedReducer = i;
          var o = e.baseQueue,
            c = n.pending;
          if (c !== null) {
            if (o !== null) {
              var m = o.next;
              ((o.next = c.next), (c.next = m));
            }
            ((t.baseQueue = o = c), (n.pending = null));
          }
          if (((c = e.baseState), o === null)) e.memoizedState = c;
          else {
            t = o.next;
            var v = (m = null),
              S = null,
              N = t,
              U = !1;
            do {
              var Y = N.lane & -536870913;
              if (Y !== N.lane ? (be & Y) === Y : (vi & Y) === Y) {
                var C = N.revertLane;
                if (C === 0)
                  (S !== null &&
                    (S = S.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: N.action,
                        hasEagerState: N.hasEagerState,
                        eagerState: N.eagerState,
                        next: null,
                      }),
                    Y === On && (U = !0));
                else if ((vi & C) === C) {
                  ((N = N.next), C === On && (U = !0));
                  continue;
                } else
                  ((Y = {
                    lane: 0,
                    revertLane: N.revertLane,
                    action: N.action,
                    hasEagerState: N.hasEagerState,
                    eagerState: N.eagerState,
                    next: null,
                  }),
                    S === null ? ((v = S = Y), (m = c)) : (S = S.next = Y),
                    (me.lanes |= C),
                    (wi |= C));
                ((Y = N.action),
                  Ji && i(c, Y),
                  (c = N.hasEagerState ? N.eagerState : i(c, Y)));
              } else
                ((C = {
                  lane: Y,
                  revertLane: N.revertLane,
                  action: N.action,
                  hasEagerState: N.hasEagerState,
                  eagerState: N.eagerState,
                  next: null,
                }),
                  S === null ? ((v = S = C), (m = c)) : (S = S.next = C),
                  (me.lanes |= Y),
                  (wi |= Y));
              N = N.next;
            } while (N !== null && N !== t);
            if (
              (S === null ? (m = c) : (S.next = v),
              !gt(c, e.memoizedState) &&
                ((Xe = !0), U && ((i = _n), i !== null)))
            )
              throw i;
            ((e.memoizedState = c),
              (e.baseState = m),
              (e.baseQueue = S),
              (n.lastRenderedState = c));
          }
          return (o === null && (n.lanes = 0), [e.memoizedState, n.dispatch]);
        }
        function Ur(e) {
          var t = Ve(),
            i = t.queue;
          if (i === null) throw Error(r(311));
          i.lastRenderedReducer = e;
          var n = i.dispatch,
            o = i.pending,
            c = t.memoizedState;
          if (o !== null) {
            i.pending = null;
            var m = (o = o.next);
            do ((c = e(c, m.action)), (m = m.next));
            while (m !== o);
            (gt(c, t.memoizedState) || (Xe = !0),
              (t.memoizedState = c),
              t.baseQueue === null && (t.baseState = c),
              (i.lastRenderedState = c));
          }
          return [c, n];
        }
        function Jc(e, t, i) {
          var n = me,
            o = Ve(),
            c = Te;
          if (c) {
            if (i === void 0) throw Error(r(407));
            i = i();
          } else i = t();
          var m = !gt((Me || o).memoizedState, i);
          (m && ((o.memoizedState = i), (Xe = !0)), (o = o.queue));
          var v = Pc.bind(null, n, o, e);
          if (
            (Ma(2048, 8, v, [e]),
            o.getSnapshot !== t ||
              m ||
              (Ge !== null && Ge.memoizedState.tag & 1))
          ) {
            if (
              ((n.flags |= 2048),
              Rn(9, jl(), Ic.bind(null, n, o, i, t), null),
              Ne === null)
            )
              throw Error(r(349));
            c || (vi & 124) !== 0 || Fc(n, t, i);
          }
          return i;
        }
        function Fc(e, t, i) {
          ((e.flags |= 16384),
            (e = { getSnapshot: t, value: i }),
            (t = me.updateQueue),
            t === null
              ? ((t = jr()), (me.updateQueue = t), (t.stores = [e]))
              : ((i = t.stores), i === null ? (t.stores = [e]) : i.push(e)));
        }
        function Ic(e, t, i, n) {
          ((t.value = i), (t.getSnapshot = n), Wc(t) && ef(e));
        }
        function Pc(e, t, i) {
          return i(function () {
            Wc(t) && ef(e);
          });
        }
        function Wc(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var i = t();
            return !gt(e, i);
          } catch {
            return !0;
          }
        }
        function ef(e) {
          var t = En(e, 2);
          t !== null && Tt(t, e, 2);
        }
        function Gr(e) {
          var t = ot();
          if (typeof e == 'function') {
            var i = e;
            if (((e = i()), Ji)) {
              ci(!0);
              try {
                i();
              } finally {
                ci(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ft,
              lastRenderedState: e,
            }),
            t
          );
        }
        function tf(e, t, i, n) {
          return (
            (e.baseState = i),
            Hr(e, Me, typeof n == 'function' ? n : Ft)
          );
        }
        function eg(e, t, i, n, o) {
          if (Hl(e)) throw Error(r(485));
          if (((e = t.action), e !== null)) {
            var c = {
              payload: o,
              action: e,
              next: null,
              isTransition: !0,
              status: 'pending',
              value: null,
              reason: null,
              listeners: [],
              then: function (m) {
                c.listeners.push(m);
              },
            };
            (D.T !== null ? i(!0) : (c.isTransition = !1),
              n(c),
              (i = t.pending),
              i === null
                ? ((c.next = t.pending = c), nf(t, c))
                : ((c.next = i.next), (t.pending = i.next = c)));
          }
        }
        function nf(e, t) {
          var i = t.action,
            n = t.payload,
            o = e.state;
          if (t.isTransition) {
            var c = D.T,
              m = {};
            D.T = m;
            try {
              var v = i(o, n),
                S = D.S;
              (S !== null && S(m, v), af(e, t, v));
            } catch (N) {
              Vr(e, t, N);
            } finally {
              D.T = c;
            }
          } else
            try {
              ((c = i(o, n)), af(e, t, c));
            } catch (N) {
              Vr(e, t, N);
            }
        }
        function af(e, t, i) {
          i !== null && typeof i == 'object' && typeof i.then == 'function'
            ? i.then(
                function (n) {
                  lf(e, t, n);
                },
                function (n) {
                  return Vr(e, t, n);
                }
              )
            : lf(e, t, i);
        }
        function lf(e, t, i) {
          ((t.status = 'fulfilled'),
            (t.value = i),
            sf(t),
            (e.state = i),
            (t = e.pending),
            t !== null &&
              ((i = t.next),
              i === t
                ? (e.pending = null)
                : ((i = i.next), (t.next = i), nf(e, i))));
        }
        function Vr(e, t, i) {
          var n = e.pending;
          if (((e.pending = null), n !== null)) {
            n = n.next;
            do ((t.status = 'rejected'), (t.reason = i), sf(t), (t = t.next));
            while (t !== n);
          }
          e.action = null;
        }
        function sf(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function rf(e, t) {
          return t;
        }
        function of(e, t) {
          if (Te) {
            var i = Ne.formState;
            if (i !== null) {
              e: {
                var n = me;
                if (Te) {
                  if (Le) {
                    t: {
                      for (var o = Le, c = Ht; o.nodeType !== 8; ) {
                        if (!c) {
                          o = null;
                          break t;
                        }
                        if (((o = jt(o.nextSibling)), o === null)) {
                          o = null;
                          break t;
                        }
                      }
                      ((c = o.data), (o = c === 'F!' || c === 'F' ? o : null));
                    }
                    if (o) {
                      ((Le = jt(o.nextSibling)), (n = o.data === 'F!'));
                      break e;
                    }
                  }
                  ki(n);
                }
                n = !1;
              }
              n && (t = i[0]);
            }
          }
          return (
            (i = ot()),
            (i.memoizedState = i.baseState = t),
            (n = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: rf,
              lastRenderedState: t,
            }),
            (i.queue = n),
            (i = Of.bind(null, me, n)),
            (n.dispatch = i),
            (n = Gr(!1)),
            (c = kr.bind(null, me, !1, n.queue)),
            (n = ot()),
            (o = { state: t, dispatch: null, action: e, pending: null }),
            (n.queue = o),
            (i = eg.bind(null, me, o, c, i)),
            (o.dispatch = i),
            (n.memoizedState = e),
            [t, i, !1]
          );
        }
        function uf(e) {
          var t = Ve();
          return cf(t, Me, e);
        }
        function cf(e, t, i) {
          if (
            ((t = Hr(e, t, rf)[0]),
            (e = Ll(Ft)[0]),
            typeof t == 'object' && t !== null && typeof t.then == 'function')
          )
            try {
              var n = Aa(t);
            } catch (m) {
              throw m === ba ? _l : m;
            }
          else n = t;
          t = Ve();
          var o = t.queue,
            c = o.dispatch;
          return (
            i !== t.memoizedState &&
              ((me.flags |= 2048), Rn(9, jl(), tg.bind(null, o, i), null)),
            [n, c, e]
          );
        }
        function tg(e, t) {
          e.action = t;
        }
        function ff(e) {
          var t = Ve(),
            i = Me;
          if (i !== null) return cf(t, i, e);
          (Ve(), (t = t.memoizedState), (i = Ve()));
          var n = i.queue.dispatch;
          return ((i.memoizedState = e), [t, n, !1]);
        }
        function Rn(e, t, i, n) {
          return (
            (e = { tag: e, create: i, deps: n, inst: t, next: null }),
            (t = me.updateQueue),
            t === null && ((t = jr()), (me.updateQueue = t)),
            (i = t.lastEffect),
            i === null
              ? (t.lastEffect = e.next = e)
              : ((n = i.next), (i.next = e), (e.next = n), (t.lastEffect = e)),
            e
          );
        }
        function jl() {
          return { destroy: void 0, resource: void 0 };
        }
        function df() {
          return Ve().memoizedState;
        }
        function Bl(e, t, i, n) {
          var o = ot();
          ((n = n === void 0 ? null : n),
            (me.flags |= e),
            (o.memoizedState = Rn(1 | t, jl(), i, n)));
        }
        function Ma(e, t, i, n) {
          var o = Ve();
          n = n === void 0 ? null : n;
          var c = o.memoizedState.inst;
          Me !== null && n !== null && Nr(n, Me.memoizedState.deps)
            ? (o.memoizedState = Rn(t, c, i, n))
            : ((me.flags |= e), (o.memoizedState = Rn(1 | t, c, i, n)));
        }
        function hf(e, t) {
          Bl(8390656, 8, e, t);
        }
        function pf(e, t) {
          Ma(2048, 8, e, t);
        }
        function mf(e, t) {
          return Ma(4, 2, e, t);
        }
        function gf(e, t) {
          return Ma(4, 4, e, t);
        }
        function vf(e, t) {
          if (typeof t == 'function') {
            e = e();
            var i = t(e);
            return function () {
              typeof i == 'function' ? i() : t(null);
            };
          }
          if (t != null)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function yf(e, t, i) {
          ((i = i != null ? i.concat([e]) : null),
            Ma(4, 4, vf.bind(null, t, e), i));
        }
        function Yr() {}
        function bf(e, t) {
          var i = Ve();
          t = t === void 0 ? null : t;
          var n = i.memoizedState;
          return t !== null && Nr(t, n[1])
            ? n[0]
            : ((i.memoizedState = [e, t]), e);
        }
        function Sf(e, t) {
          var i = Ve();
          t = t === void 0 ? null : t;
          var n = i.memoizedState;
          if (t !== null && Nr(t, n[1])) return n[0];
          if (((n = e()), Ji)) {
            ci(!0);
            try {
              e();
            } finally {
              ci(!1);
            }
          }
          return ((i.memoizedState = [n, t]), n);
        }
        function qr(e, t, i) {
          return i === void 0 || (vi & 1073741824) !== 0
            ? (e.memoizedState = t)
            : ((e.memoizedState = i),
              (e = Ed()),
              (me.lanes |= e),
              (wi |= e),
              i);
        }
        function xf(e, t, i, n) {
          return gt(i, t)
            ? i
            : zn.current !== null
              ? ((e = qr(e, i, n)), gt(e, t) || (Xe = !0), e)
              : (vi & 42) === 0
                ? ((Xe = !0), (e.memoizedState = i))
                : ((e = Ed()), (me.lanes |= e), (wi |= e), t);
        }
        function Tf(e, t, i, n, o) {
          var c = X.p;
          X.p = c !== 0 && 8 > c ? c : 8;
          var m = D.T,
            v = {};
          ((D.T = v), kr(e, !1, t, i));
          try {
            var S = o(),
              N = D.S;
            if (
              (N !== null && N(v, S),
              S !== null && typeof S == 'object' && typeof S.then == 'function')
            ) {
              var U = Im(S, n);
              Oa(e, t, U, xt());
            } else Oa(e, t, n, xt());
          } catch (Y) {
            Oa(
              e,
              t,
              { then: function () {}, status: 'rejected', reason: Y },
              xt()
            );
          } finally {
            ((X.p = c), (D.T = m));
          }
        }
        function ig() {}
        function $r(e, t, i, n) {
          if (e.tag !== 5) throw Error(r(476));
          var o = Ef(e).queue;
          Tf(
            e,
            o,
            t,
            q,
            i === null
              ? ig
              : function () {
                  return (wf(e), i(n));
                }
          );
        }
        function Ef(e) {
          var t = e.memoizedState;
          if (t !== null) return t;
          t = {
            memoizedState: q,
            baseState: q,
            baseQueue: null,
            queue: {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ft,
              lastRenderedState: q,
            },
            next: null,
          };
          var i = {};
          return (
            (t.next = {
              memoizedState: i,
              baseState: i,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ft,
                lastRenderedState: i,
              },
              next: null,
            }),
            (e.memoizedState = t),
            (e = e.alternate),
            e !== null && (e.memoizedState = t),
            t
          );
        }
        function wf(e) {
          var t = Ef(e).next.queue;
          Oa(e, t, {}, xt());
        }
        function Kr() {
          return tt(ka);
        }
        function Af() {
          return Ve().memoizedState;
        }
        function Mf() {
          return Ve().memoizedState;
        }
        function ng(e) {
          for (var t = e.return; t !== null; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var i = xt();
                e = mi(i);
                var n = gi(t, e, i);
                (n !== null && (Tt(n, t, i), xa(n, t, i)),
                  (t = { cache: Sr() }),
                  (e.payload = t));
                return;
            }
            t = t.return;
          }
        }
        function ag(e, t, i) {
          var n = xt();
          ((i = {
            lane: n,
            revertLane: 0,
            action: i,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Hl(e)
              ? _f(t, i)
              : ((i = cr(e, t, i, n)),
                i !== null && (Tt(i, e, n), zf(i, t, n))));
        }
        function Of(e, t, i) {
          var n = xt();
          Oa(e, t, i, n);
        }
        function Oa(e, t, i, n) {
          var o = {
            lane: n,
            revertLane: 0,
            action: i,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (Hl(e)) _f(t, o);
          else {
            var c = e.alternate;
            if (
              e.lanes === 0 &&
              (c === null || c.lanes === 0) &&
              ((c = t.lastRenderedReducer), c !== null)
            )
              try {
                var m = t.lastRenderedState,
                  v = c(m, i);
                if (((o.hasEagerState = !0), (o.eagerState = v), gt(v, m)))
                  return (Sl(e, t, o, 0), Ne === null && bl(), !1);
              } catch {
              } finally {
              }
            if (((i = cr(e, t, o, n)), i !== null))
              return (Tt(i, e, n), zf(i, t, n), !0);
          }
          return !1;
        }
        function kr(e, t, i, n) {
          if (
            ((n = {
              lane: 2,
              revertLane: wo(),
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Hl(e))
          ) {
            if (t) throw Error(r(479));
          } else ((t = cr(e, i, n, 2)), t !== null && Tt(t, e, 2));
        }
        function Hl(e) {
          var t = e.alternate;
          return e === me || (t !== null && t === me);
        }
        function _f(e, t) {
          Nn = Cl = !0;
          var i = e.pending;
          (i === null ? (t.next = t) : ((t.next = i.next), (i.next = t)),
            (e.pending = t));
        }
        function zf(e, t, i) {
          if ((i & 4194048) !== 0) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (i |= n), (t.lanes = i), Bu(e, i));
          }
        }
        var Ul = {
            readContext: tt,
            use: Dl,
            useCallback: He,
            useContext: He,
            useEffect: He,
            useImperativeHandle: He,
            useLayoutEffect: He,
            useInsertionEffect: He,
            useMemo: He,
            useReducer: He,
            useRef: He,
            useState: He,
            useDebugValue: He,
            useDeferredValue: He,
            useTransition: He,
            useSyncExternalStore: He,
            useId: He,
            useHostTransitionStatus: He,
            useFormState: He,
            useActionState: He,
            useOptimistic: He,
            useMemoCache: He,
            useCacheRefresh: He,
          },
          Nf = {
            readContext: tt,
            use: Dl,
            useCallback: function (e, t) {
              return ((ot().memoizedState = [e, t === void 0 ? null : t]), e);
            },
            useContext: tt,
            useEffect: hf,
            useImperativeHandle: function (e, t, i) {
              ((i = i != null ? i.concat([e]) : null),
                Bl(4194308, 4, vf.bind(null, t, e), i));
            },
            useLayoutEffect: function (e, t) {
              return Bl(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              Bl(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var i = ot();
              t = t === void 0 ? null : t;
              var n = e();
              if (Ji) {
                ci(!0);
                try {
                  e();
                } finally {
                  ci(!1);
                }
              }
              return ((i.memoizedState = [n, t]), n);
            },
            useReducer: function (e, t, i) {
              var n = ot();
              if (i !== void 0) {
                var o = i(t);
                if (Ji) {
                  ci(!0);
                  try {
                    i(t);
                  } finally {
                    ci(!1);
                  }
                }
              } else o = t;
              return (
                (n.memoizedState = n.baseState = o),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: o,
                }),
                (n.queue = e),
                (e = e.dispatch = ag.bind(null, me, e)),
                [n.memoizedState, e]
              );
            },
            useRef: function (e) {
              var t = ot();
              return ((e = { current: e }), (t.memoizedState = e));
            },
            useState: function (e) {
              e = Gr(e);
              var t = e.queue,
                i = Of.bind(null, me, t);
              return ((t.dispatch = i), [e.memoizedState, i]);
            },
            useDebugValue: Yr,
            useDeferredValue: function (e, t) {
              var i = ot();
              return qr(i, e, t);
            },
            useTransition: function () {
              var e = Gr(!1);
              return (
                (e = Tf.bind(null, me, e.queue, !0, !1)),
                (ot().memoizedState = e),
                [!1, e]
              );
            },
            useSyncExternalStore: function (e, t, i) {
              var n = me,
                o = ot();
              if (Te) {
                if (i === void 0) throw Error(r(407));
                i = i();
              } else {
                if (((i = t()), Ne === null)) throw Error(r(349));
                (be & 124) !== 0 || Fc(n, t, i);
              }
              o.memoizedState = i;
              var c = { value: i, getSnapshot: t };
              return (
                (o.queue = c),
                hf(Pc.bind(null, n, c, e), [e]),
                (n.flags |= 2048),
                Rn(9, jl(), Ic.bind(null, n, c, i, t), null),
                i
              );
            },
            useId: function () {
              var e = ot(),
                t = Ne.identifierPrefix;
              if (Te) {
                var i = Qt,
                  n = Xt;
                ((i = (n & ~(1 << (32 - mt(n) - 1))).toString(32) + i),
                  (t = '«' + t + 'R' + i),
                  (i = Rl++),
                  0 < i && (t += 'H' + i.toString(32)),
                  (t += '»'));
              } else ((i = Pm++), (t = '«' + t + 'r' + i.toString(32) + '»'));
              return (e.memoizedState = t);
            },
            useHostTransitionStatus: Kr,
            useFormState: of,
            useActionState: of,
            useOptimistic: function (e) {
              var t = ot();
              t.memoizedState = t.baseState = e;
              var i = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = i),
                (t = kr.bind(null, me, !0, i)),
                (i.dispatch = t),
                [e, t]
              );
            },
            useMemoCache: Br,
            useCacheRefresh: function () {
              return (ot().memoizedState = ng.bind(null, me));
            },
          },
          Cf = {
            readContext: tt,
            use: Dl,
            useCallback: bf,
            useContext: tt,
            useEffect: pf,
            useImperativeHandle: yf,
            useInsertionEffect: mf,
            useLayoutEffect: gf,
            useMemo: Sf,
            useReducer: Ll,
            useRef: df,
            useState: function () {
              return Ll(Ft);
            },
            useDebugValue: Yr,
            useDeferredValue: function (e, t) {
              var i = Ve();
              return xf(i, Me.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Ll(Ft)[0],
                t = Ve().memoizedState;
              return [typeof e == 'boolean' ? e : Aa(e), t];
            },
            useSyncExternalStore: Jc,
            useId: Af,
            useHostTransitionStatus: Kr,
            useFormState: uf,
            useActionState: uf,
            useOptimistic: function (e, t) {
              var i = Ve();
              return tf(i, Me, e, t);
            },
            useMemoCache: Br,
            useCacheRefresh: Mf,
          },
          lg = {
            readContext: tt,
            use: Dl,
            useCallback: bf,
            useContext: tt,
            useEffect: pf,
            useImperativeHandle: yf,
            useInsertionEffect: mf,
            useLayoutEffect: gf,
            useMemo: Sf,
            useReducer: Ur,
            useRef: df,
            useState: function () {
              return Ur(Ft);
            },
            useDebugValue: Yr,
            useDeferredValue: function (e, t) {
              var i = Ve();
              return Me === null ? qr(i, e, t) : xf(i, Me.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Ur(Ft)[0],
                t = Ve().memoizedState;
              return [typeof e == 'boolean' ? e : Aa(e), t];
            },
            useSyncExternalStore: Jc,
            useId: Af,
            useHostTransitionStatus: Kr,
            useFormState: ff,
            useActionState: ff,
            useOptimistic: function (e, t) {
              var i = Ve();
              return Me !== null
                ? tf(i, Me, e, t)
                : ((i.baseState = e), [e, i.queue.dispatch]);
            },
            useMemoCache: Br,
            useCacheRefresh: Mf,
          },
          Dn = null,
          _a = 0;
        function Gl(e) {
          var t = _a;
          return ((_a += 1), Dn === null && (Dn = []), Yc(Dn, e, t));
        }
        function za(e, t) {
          ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
        }
        function Vl(e, t) {
          throw t.$$typeof === y
            ? Error(r(525))
            : ((e = Object.prototype.toString.call(t)),
              Error(
                r(
                  31,
                  e === '[object Object]'
                    ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                    : e
                )
              ));
        }
        function Rf(e) {
          var t = e._init;
          return t(e._payload);
        }
        function Df(e) {
          function t(M, E) {
            if (e) {
              var z = M.deletions;
              z === null ? ((M.deletions = [E]), (M.flags |= 16)) : z.push(E);
            }
          }
          function i(M, E) {
            if (!e) return null;
            for (; E !== null; ) (t(M, E), (E = E.sibling));
            return null;
          }
          function n(M) {
            for (var E = new Map(); M !== null; )
              (M.key !== null ? E.set(M.key, M) : E.set(M.index, M),
                (M = M.sibling));
            return E;
          }
          function o(M, E) {
            return ((M = kt(M, E)), (M.index = 0), (M.sibling = null), M);
          }
          function c(M, E, z) {
            return (
              (M.index = z),
              e
                ? ((z = M.alternate),
                  z !== null
                    ? ((z = z.index), z < E ? ((M.flags |= 67108866), E) : z)
                    : ((M.flags |= 67108866), E))
                : ((M.flags |= 1048576), E)
            );
          }
          function m(M) {
            return (e && M.alternate === null && (M.flags |= 67108866), M);
          }
          function v(M, E, z, V) {
            return E === null || E.tag !== 6
              ? ((E = dr(z, M.mode, V)), (E.return = M), E)
              : ((E = o(E, z)), (E.return = M), E);
          }
          function S(M, E, z, V) {
            var te = z.type;
            return te === O
              ? U(M, E, z.props.children, V, z.key)
              : E !== null &&
                  (E.elementType === te ||
                    (typeof te == 'object' &&
                      te !== null &&
                      te.$$typeof === G &&
                      Rf(te) === E.type))
                ? ((E = o(E, z.props)), za(E, z), (E.return = M), E)
                : ((E = Tl(z.type, z.key, z.props, null, M.mode, V)),
                  za(E, z),
                  (E.return = M),
                  E);
          }
          function N(M, E, z, V) {
            return E === null ||
              E.tag !== 4 ||
              E.stateNode.containerInfo !== z.containerInfo ||
              E.stateNode.implementation !== z.implementation
              ? ((E = hr(z, M.mode, V)), (E.return = M), E)
              : ((E = o(E, z.children || [])), (E.return = M), E);
          }
          function U(M, E, z, V, te) {
            return E === null || E.tag !== 7
              ? ((E = Yi(z, M.mode, V, te)), (E.return = M), E)
              : ((E = o(E, z)), (E.return = M), E);
          }
          function Y(M, E, z) {
            if (
              (typeof E == 'string' && E !== '') ||
              typeof E == 'number' ||
              typeof E == 'bigint'
            )
              return ((E = dr('' + E, M.mode, z)), (E.return = M), E);
            if (typeof E == 'object' && E !== null) {
              switch (E.$$typeof) {
                case w:
                  return (
                    (z = Tl(E.type, E.key, E.props, null, M.mode, z)),
                    za(z, E),
                    (z.return = M),
                    z
                  );
                case x:
                  return ((E = hr(E, M.mode, z)), (E.return = M), E);
                case G:
                  var V = E._init;
                  return ((E = V(E._payload)), Y(M, E, z));
              }
              if (he(E) || ie(E))
                return ((E = Yi(E, M.mode, z, null)), (E.return = M), E);
              if (typeof E.then == 'function') return Y(M, Gl(E), z);
              if (E.$$typeof === K) return Y(M, Ml(M, E), z);
              Vl(M, E);
            }
            return null;
          }
          function C(M, E, z, V) {
            var te = E !== null ? E.key : null;
            if (
              (typeof z == 'string' && z !== '') ||
              typeof z == 'number' ||
              typeof z == 'bigint'
            )
              return te !== null ? null : v(M, E, '' + z, V);
            if (typeof z == 'object' && z !== null) {
              switch (z.$$typeof) {
                case w:
                  return z.key === te ? S(M, E, z, V) : null;
                case x:
                  return z.key === te ? N(M, E, z, V) : null;
                case G:
                  return ((te = z._init), (z = te(z._payload)), C(M, E, z, V));
              }
              if (he(z) || ie(z))
                return te !== null ? null : U(M, E, z, V, null);
              if (typeof z.then == 'function') return C(M, E, Gl(z), V);
              if (z.$$typeof === K) return C(M, E, Ml(M, z), V);
              Vl(M, z);
            }
            return null;
          }
          function R(M, E, z, V, te) {
            if (
              (typeof V == 'string' && V !== '') ||
              typeof V == 'number' ||
              typeof V == 'bigint'
            )
              return ((M = M.get(z) || null), v(E, M, '' + V, te));
            if (typeof V == 'object' && V !== null) {
              switch (V.$$typeof) {
                case w:
                  return (
                    (M = M.get(V.key === null ? z : V.key) || null),
                    S(E, M, V, te)
                  );
                case x:
                  return (
                    (M = M.get(V.key === null ? z : V.key) || null),
                    N(E, M, V, te)
                  );
                case G:
                  var ge = V._init;
                  return ((V = ge(V._payload)), R(M, E, z, V, te));
              }
              if (he(V) || ie(V))
                return ((M = M.get(z) || null), U(E, M, V, te, null));
              if (typeof V.then == 'function') return R(M, E, z, Gl(V), te);
              if (V.$$typeof === K) return R(M, E, z, Ml(E, V), te);
              Vl(E, V);
            }
            return null;
          }
          function ce(M, E, z, V) {
            for (
              var te = null, ge = null, ae = E, re = (E = 0), Ze = null;
              ae !== null && re < z.length;
              re++
            ) {
              ae.index > re ? ((Ze = ae), (ae = null)) : (Ze = ae.sibling);
              var xe = C(M, ae, z[re], V);
              if (xe === null) {
                ae === null && (ae = Ze);
                break;
              }
              (e && ae && xe.alternate === null && t(M, ae),
                (E = c(xe, E, re)),
                ge === null ? (te = xe) : (ge.sibling = xe),
                (ge = xe),
                (ae = Ze));
            }
            if (re === z.length) return (i(M, ae), Te && $i(M, re), te);
            if (ae === null) {
              for (; re < z.length; re++)
                ((ae = Y(M, z[re], V)),
                  ae !== null &&
                    ((E = c(ae, E, re)),
                    ge === null ? (te = ae) : (ge.sibling = ae),
                    (ge = ae)));
              return (Te && $i(M, re), te);
            }
            for (ae = n(ae); re < z.length; re++)
              ((Ze = R(ae, M, re, z[re], V)),
                Ze !== null &&
                  (e &&
                    Ze.alternate !== null &&
                    ae.delete(Ze.key === null ? re : Ze.key),
                  (E = c(Ze, E, re)),
                  ge === null ? (te = Ze) : (ge.sibling = Ze),
                  (ge = Ze)));
            return (
              e &&
                ae.forEach(function (Di) {
                  return t(M, Di);
                }),
              Te && $i(M, re),
              te
            );
          }
          function se(M, E, z, V) {
            if (z == null) throw Error(r(151));
            for (
              var te = null,
                ge = null,
                ae = E,
                re = (E = 0),
                Ze = null,
                xe = z.next();
              ae !== null && !xe.done;
              re++, xe = z.next()
            ) {
              ae.index > re ? ((Ze = ae), (ae = null)) : (Ze = ae.sibling);
              var Di = C(M, ae, xe.value, V);
              if (Di === null) {
                ae === null && (ae = Ze);
                break;
              }
              (e && ae && Di.alternate === null && t(M, ae),
                (E = c(Di, E, re)),
                ge === null ? (te = Di) : (ge.sibling = Di),
                (ge = Di),
                (ae = Ze));
            }
            if (xe.done) return (i(M, ae), Te && $i(M, re), te);
            if (ae === null) {
              for (; !xe.done; re++, xe = z.next())
                ((xe = Y(M, xe.value, V)),
                  xe !== null &&
                    ((E = c(xe, E, re)),
                    ge === null ? (te = xe) : (ge.sibling = xe),
                    (ge = xe)));
              return (Te && $i(M, re), te);
            }
            for (ae = n(ae); !xe.done; re++, xe = z.next())
              ((xe = R(ae, M, re, xe.value, V)),
                xe !== null &&
                  (e &&
                    xe.alternate !== null &&
                    ae.delete(xe.key === null ? re : xe.key),
                  (E = c(xe, E, re)),
                  ge === null ? (te = xe) : (ge.sibling = xe),
                  (ge = xe)));
            return (
              e &&
                ae.forEach(function (sv) {
                  return t(M, sv);
                }),
              Te && $i(M, re),
              te
            );
          }
          function _e(M, E, z, V) {
            if (
              (typeof z == 'object' &&
                z !== null &&
                z.type === O &&
                z.key === null &&
                (z = z.props.children),
              typeof z == 'object' && z !== null)
            ) {
              switch (z.$$typeof) {
                case w:
                  e: {
                    for (var te = z.key; E !== null; ) {
                      if (E.key === te) {
                        if (((te = z.type), te === O)) {
                          if (E.tag === 7) {
                            (i(M, E.sibling),
                              (V = o(E, z.props.children)),
                              (V.return = M),
                              (M = V));
                            break e;
                          }
                        } else if (
                          E.elementType === te ||
                          (typeof te == 'object' &&
                            te !== null &&
                            te.$$typeof === G &&
                            Rf(te) === E.type)
                        ) {
                          (i(M, E.sibling),
                            (V = o(E, z.props)),
                            za(V, z),
                            (V.return = M),
                            (M = V));
                          break e;
                        }
                        i(M, E);
                        break;
                      } else t(M, E);
                      E = E.sibling;
                    }
                    z.type === O
                      ? ((V = Yi(z.props.children, M.mode, V, z.key)),
                        (V.return = M),
                        (M = V))
                      : ((V = Tl(z.type, z.key, z.props, null, M.mode, V)),
                        za(V, z),
                        (V.return = M),
                        (M = V));
                  }
                  return m(M);
                case x:
                  e: {
                    for (te = z.key; E !== null; ) {
                      if (E.key === te)
                        if (
                          E.tag === 4 &&
                          E.stateNode.containerInfo === z.containerInfo &&
                          E.stateNode.implementation === z.implementation
                        ) {
                          (i(M, E.sibling),
                            (V = o(E, z.children || [])),
                            (V.return = M),
                            (M = V));
                          break e;
                        } else {
                          i(M, E);
                          break;
                        }
                      else t(M, E);
                      E = E.sibling;
                    }
                    ((V = hr(z, M.mode, V)), (V.return = M), (M = V));
                  }
                  return m(M);
                case G:
                  return ((te = z._init), (z = te(z._payload)), _e(M, E, z, V));
              }
              if (he(z)) return ce(M, E, z, V);
              if (ie(z)) {
                if (((te = ie(z)), typeof te != 'function'))
                  throw Error(r(150));
                return ((z = te.call(z)), se(M, E, z, V));
              }
              if (typeof z.then == 'function') return _e(M, E, Gl(z), V);
              if (z.$$typeof === K) return _e(M, E, Ml(M, z), V);
              Vl(M, z);
            }
            return (typeof z == 'string' && z !== '') ||
              typeof z == 'number' ||
              typeof z == 'bigint'
              ? ((z = '' + z),
                E !== null && E.tag === 6
                  ? (i(M, E.sibling), (V = o(E, z)), (V.return = M), (M = V))
                  : (i(M, E), (V = dr(z, M.mode, V)), (V.return = M), (M = V)),
                m(M))
              : i(M, E);
          }
          return function (M, E, z, V) {
            try {
              _a = 0;
              var te = _e(M, E, z, V);
              return ((Dn = null), te);
            } catch (ae) {
              if (ae === ba || ae === _l) throw ae;
              var ge = vt(29, ae, null, M.mode);
              return ((ge.lanes = V), (ge.return = M), ge);
            } finally {
            }
          };
        }
        var Ln = Df(!0),
          Lf = Df(!1),
          Nt = j(null),
          Ut = null;
        function yi(e) {
          var t = e.alternate;
          (P(qe, qe.current & 1),
            P(Nt, e),
            Ut === null &&
              (t === null || zn.current !== null || t.memoizedState !== null) &&
              (Ut = e));
        }
        function jf(e) {
          if (e.tag === 22) {
            if ((P(qe, qe.current), P(Nt, e), Ut === null)) {
              var t = e.alternate;
              t !== null && t.memoizedState !== null && (Ut = e);
            }
          } else bi();
        }
        function bi() {
          (P(qe, qe.current), P(Nt, Nt.current));
        }
        function It(e) {
          (W(Nt), Ut === e && (Ut = null), W(qe));
        }
        var qe = j(0);
        function Yl(e) {
          for (var t = e; t !== null; ) {
            if (t.tag === 13) {
              var i = t.memoizedState;
              if (
                i !== null &&
                ((i = i.dehydrated), i === null || i.data === '$?' || Bo(i))
              )
                return t;
            } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
              if ((t.flags & 128) !== 0) return t;
            } else if (t.child !== null) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) return null;
              t = t.return;
            }
            ((t.sibling.return = t.return), (t = t.sibling));
          }
          return null;
        }
        function Xr(e, t, i, n) {
          ((t = e.memoizedState),
            (i = i(n, t)),
            (i = i == null ? t : b({}, t, i)),
            (e.memoizedState = i),
            e.lanes === 0 && (e.updateQueue.baseState = i));
        }
        var Qr = {
          enqueueSetState: function (e, t, i) {
            e = e._reactInternals;
            var n = xt(),
              o = mi(n);
            ((o.payload = t),
              i != null && (o.callback = i),
              (t = gi(e, o, n)),
              t !== null && (Tt(t, e, n), xa(t, e, n)));
          },
          enqueueReplaceState: function (e, t, i) {
            e = e._reactInternals;
            var n = xt(),
              o = mi(n);
            ((o.tag = 1),
              (o.payload = t),
              i != null && (o.callback = i),
              (t = gi(e, o, n)),
              t !== null && (Tt(t, e, n), xa(t, e, n)));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var i = xt(),
              n = mi(i);
            ((n.tag = 2),
              t != null && (n.callback = t),
              (t = gi(e, n, i)),
              t !== null && (Tt(t, e, i), xa(t, e, i)));
          },
        };
        function Bf(e, t, i, n, o, c, m) {
          return (
            (e = e.stateNode),
            typeof e.shouldComponentUpdate == 'function'
              ? e.shouldComponentUpdate(n, c, m)
              : t.prototype && t.prototype.isPureReactComponent
                ? !fa(i, n) || !fa(o, c)
                : !0
          );
        }
        function Hf(e, t, i, n) {
          ((e = t.state),
            typeof t.componentWillReceiveProps == 'function' &&
              t.componentWillReceiveProps(i, n),
            typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
              t.UNSAFE_componentWillReceiveProps(i, n),
            t.state !== e && Qr.enqueueReplaceState(t, t.state, null));
        }
        function Fi(e, t) {
          var i = t;
          if ('ref' in t) {
            i = {};
            for (var n in t) n !== 'ref' && (i[n] = t[n]);
          }
          if ((e = e.defaultProps)) {
            i === t && (i = b({}, i));
            for (var o in e) i[o] === void 0 && (i[o] = e[o]);
          }
          return i;
        }
        var ql =
          typeof reportError == 'function'
            ? reportError
            : function (e) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var t = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof e == 'object' &&
                      e !== null &&
                      typeof e.message == 'string'
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', e);
                  return;
                }
                console.error(e);
              };
        function Uf(e) {
          ql(e);
        }
        function Gf(e) {
          console.error(e);
        }
        function Vf(e) {
          ql(e);
        }
        function $l(e, t) {
          try {
            var i = e.onUncaughtError;
            i(t.value, { componentStack: t.stack });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Yf(e, t, i) {
          try {
            var n = e.onCaughtError;
            n(i.value, {
              componentStack: i.stack,
              errorBoundary: t.tag === 1 ? t.stateNode : null,
            });
          } catch (o) {
            setTimeout(function () {
              throw o;
            });
          }
        }
        function Zr(e, t, i) {
          return (
            (i = mi(i)),
            (i.tag = 3),
            (i.payload = { element: null }),
            (i.callback = function () {
              $l(e, t);
            }),
            i
          );
        }
        function qf(e) {
          return ((e = mi(e)), (e.tag = 3), e);
        }
        function $f(e, t, i, n) {
          var o = i.type.getDerivedStateFromError;
          if (typeof o == 'function') {
            var c = n.value;
            ((e.payload = function () {
              return o(c);
            }),
              (e.callback = function () {
                Yf(t, i, n);
              }));
          }
          var m = i.stateNode;
          m !== null &&
            typeof m.componentDidCatch == 'function' &&
            (e.callback = function () {
              (Yf(t, i, n),
                typeof o != 'function' &&
                  (Ai === null ? (Ai = new Set([this])) : Ai.add(this)));
              var v = n.stack;
              this.componentDidCatch(n.value, {
                componentStack: v !== null ? v : '',
              });
            });
        }
        function sg(e, t, i, n, o) {
          if (
            ((i.flags |= 32768),
            n !== null && typeof n == 'object' && typeof n.then == 'function')
          ) {
            if (
              ((t = i.alternate),
              t !== null && ga(t, i, o, !0),
              (i = Nt.current),
              i !== null)
            ) {
              switch (i.tag) {
                case 13:
                  return (
                    Ut === null
                      ? bo()
                      : i.alternate === null && je === 0 && (je = 3),
                    (i.flags &= -257),
                    (i.flags |= 65536),
                    (i.lanes = o),
                    n === Er
                      ? (i.flags |= 16384)
                      : ((t = i.updateQueue),
                        t === null ? (i.updateQueue = new Set([n])) : t.add(n),
                        xo(e, n, o)),
                    !1
                  );
                case 22:
                  return (
                    (i.flags |= 65536),
                    n === Er
                      ? (i.flags |= 16384)
                      : ((t = i.updateQueue),
                        t === null
                          ? ((t = {
                              transitions: null,
                              markerInstances: null,
                              retryQueue: new Set([n]),
                            }),
                            (i.updateQueue = t))
                          : ((i = t.retryQueue),
                            i === null
                              ? (t.retryQueue = new Set([n]))
                              : i.add(n)),
                        xo(e, n, o)),
                    !1
                  );
              }
              throw Error(r(435, i.tag));
            }
            return (xo(e, n, o), bo(), !1);
          }
          if (Te)
            return (
              (t = Nt.current),
              t !== null
                ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                  (t.flags |= 65536),
                  (t.lanes = o),
                  n !== gr && ((e = Error(r(422), { cause: n })), ma(Mt(e, i))))
                : (n !== gr &&
                    ((t = Error(r(423), { cause: n })), ma(Mt(t, i))),
                  (e = e.current.alternate),
                  (e.flags |= 65536),
                  (o &= -o),
                  (e.lanes |= o),
                  (n = Mt(n, i)),
                  (o = Zr(e.stateNode, n, o)),
                  Mr(e, o),
                  je !== 4 && (je = 2)),
              !1
            );
          var c = Error(r(520), { cause: n });
          if (
            ((c = Mt(c, i)),
            Ba === null ? (Ba = [c]) : Ba.push(c),
            je !== 4 && (je = 2),
            t === null)
          )
            return !0;
          ((n = Mt(n, i)), (i = t));
          do {
            switch (i.tag) {
              case 3:
                return (
                  (i.flags |= 65536),
                  (e = o & -o),
                  (i.lanes |= e),
                  (e = Zr(i.stateNode, n, e)),
                  Mr(i, e),
                  !1
                );
              case 1:
                if (
                  ((t = i.type),
                  (c = i.stateNode),
                  (i.flags & 128) === 0 &&
                    (typeof t.getDerivedStateFromError == 'function' ||
                      (c !== null &&
                        typeof c.componentDidCatch == 'function' &&
                        (Ai === null || !Ai.has(c)))))
                )
                  return (
                    (i.flags |= 65536),
                    (o &= -o),
                    (i.lanes |= o),
                    (o = qf(o)),
                    $f(o, e, i, n),
                    Mr(i, o),
                    !1
                  );
            }
            i = i.return;
          } while (i !== null);
          return !1;
        }
        var Kf = Error(r(461)),
          Xe = !1;
        function Fe(e, t, i, n) {
          t.child = e === null ? Lf(t, null, i, n) : Ln(t, e.child, i, n);
        }
        function kf(e, t, i, n, o) {
          i = i.render;
          var c = t.ref;
          if ('ref' in n) {
            var m = {};
            for (var v in n) v !== 'ref' && (m[v] = n[v]);
          } else m = n;
          return (
            Qi(t),
            (n = Cr(e, t, i, m, c, o)),
            (v = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, o), Pt(e, t, o))
              : (Te && v && pr(t), (t.flags |= 1), Fe(e, t, n, o), t.child)
          );
        }
        function Xf(e, t, i, n, o) {
          if (e === null) {
            var c = i.type;
            return typeof c == 'function' &&
              !fr(c) &&
              c.defaultProps === void 0 &&
              i.compare === null
              ? ((t.tag = 15), (t.type = c), Qf(e, t, c, n, o))
              : ((e = Tl(i.type, null, n, t, t.mode, o)),
                (e.ref = t.ref),
                (e.return = t),
                (t.child = e));
          }
          if (((c = e.child), !io(e, o))) {
            var m = c.memoizedProps;
            if (
              ((i = i.compare),
              (i = i !== null ? i : fa),
              i(m, n) && e.ref === t.ref)
            )
              return Pt(e, t, o);
          }
          return (
            (t.flags |= 1),
            (e = kt(c, n)),
            (e.ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Qf(e, t, i, n, o) {
          if (e !== null) {
            var c = e.memoizedProps;
            if (fa(c, n) && e.ref === t.ref)
              if (((Xe = !1), (t.pendingProps = n = c), io(e, o)))
                (e.flags & 131072) !== 0 && (Xe = !0);
              else return ((t.lanes = e.lanes), Pt(e, t, o));
          }
          return Jr(e, t, i, n, o);
        }
        function Zf(e, t, i) {
          var n = t.pendingProps,
            o = n.children,
            c = e !== null ? e.memoizedState : null;
          if (n.mode === 'hidden') {
            if ((t.flags & 128) !== 0) {
              if (((n = c !== null ? c.baseLanes | i : i), e !== null)) {
                for (o = t.child = e.child, c = 0; o !== null; )
                  ((c = c | o.lanes | o.childLanes), (o = o.sibling));
                t.childLanes = c & ~n;
              } else ((t.childLanes = 0), (t.child = null));
              return Jf(e, t, n, i);
            }
            if ((i & 536870912) !== 0)
              ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                e !== null && Ol(t, c !== null ? c.cachePool : null),
                c !== null ? Xc(t, c) : _r(),
                jf(t));
            else
              return (
                (t.lanes = t.childLanes = 536870912),
                Jf(e, t, c !== null ? c.baseLanes | i : i, i)
              );
          } else
            c !== null
              ? (Ol(t, c.cachePool), Xc(t, c), bi(), (t.memoizedState = null))
              : (e !== null && Ol(t, null), _r(), bi());
          return (Fe(e, t, o, i), t.child);
        }
        function Jf(e, t, i, n) {
          var o = Tr();
          return (
            (o = o === null ? null : { parent: Ye._currentValue, pool: o }),
            (t.memoizedState = { baseLanes: i, cachePool: o }),
            e !== null && Ol(t, null),
            _r(),
            jf(t),
            e !== null && ga(e, t, n, !0),
            null
          );
        }
        function Kl(e, t) {
          var i = t.ref;
          if (i === null) e !== null && e.ref !== null && (t.flags |= 4194816);
          else {
            if (typeof i != 'function' && typeof i != 'object')
              throw Error(r(284));
            (e === null || e.ref !== i) && (t.flags |= 4194816);
          }
        }
        function Jr(e, t, i, n, o) {
          return (
            Qi(t),
            (i = Cr(e, t, i, n, void 0, o)),
            (n = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, o), Pt(e, t, o))
              : (Te && n && pr(t), (t.flags |= 1), Fe(e, t, i, o), t.child)
          );
        }
        function Ff(e, t, i, n, o, c) {
          return (
            Qi(t),
            (t.updateQueue = null),
            (i = Zc(t, n, i, o)),
            Qc(e),
            (n = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, c), Pt(e, t, c))
              : (Te && n && pr(t), (t.flags |= 1), Fe(e, t, i, c), t.child)
          );
        }
        function If(e, t, i, n, o) {
          if ((Qi(t), t.stateNode === null)) {
            var c = wn,
              m = i.contextType;
            (typeof m == 'object' && m !== null && (c = tt(m)),
              (c = new i(n, c)),
              (t.memoizedState =
                c.state !== null && c.state !== void 0 ? c.state : null),
              (c.updater = Qr),
              (t.stateNode = c),
              (c._reactInternals = t),
              (c = t.stateNode),
              (c.props = n),
              (c.state = t.memoizedState),
              (c.refs = {}),
              wr(t),
              (m = i.contextType),
              (c.context = typeof m == 'object' && m !== null ? tt(m) : wn),
              (c.state = t.memoizedState),
              (m = i.getDerivedStateFromProps),
              typeof m == 'function' &&
                (Xr(t, i, m, n), (c.state = t.memoizedState)),
              typeof i.getDerivedStateFromProps == 'function' ||
                typeof c.getSnapshotBeforeUpdate == 'function' ||
                (typeof c.UNSAFE_componentWillMount != 'function' &&
                  typeof c.componentWillMount != 'function') ||
                ((m = c.state),
                typeof c.componentWillMount == 'function' &&
                  c.componentWillMount(),
                typeof c.UNSAFE_componentWillMount == 'function' &&
                  c.UNSAFE_componentWillMount(),
                m !== c.state && Qr.enqueueReplaceState(c, c.state, null),
                Ea(t, n, c, o),
                Ta(),
                (c.state = t.memoizedState)),
              typeof c.componentDidMount == 'function' && (t.flags |= 4194308),
              (n = !0));
          } else if (e === null) {
            c = t.stateNode;
            var v = t.memoizedProps,
              S = Fi(i, v);
            c.props = S;
            var N = c.context,
              U = i.contextType;
            ((m = wn), typeof U == 'object' && U !== null && (m = tt(U)));
            var Y = i.getDerivedStateFromProps;
            ((U =
              typeof Y == 'function' ||
              typeof c.getSnapshotBeforeUpdate == 'function'),
              (v = t.pendingProps !== v),
              U ||
                (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof c.componentWillReceiveProps != 'function') ||
                ((v || N !== m) && Hf(t, c, n, m)),
              (pi = !1));
            var C = t.memoizedState;
            ((c.state = C),
              Ea(t, n, c, o),
              Ta(),
              (N = t.memoizedState),
              v || C !== N || pi
                ? (typeof Y == 'function' &&
                    (Xr(t, i, Y, n), (N = t.memoizedState)),
                  (S = pi || Bf(t, i, S, n, C, N, m))
                    ? (U ||
                        (typeof c.UNSAFE_componentWillMount != 'function' &&
                          typeof c.componentWillMount != 'function') ||
                        (typeof c.componentWillMount == 'function' &&
                          c.componentWillMount(),
                        typeof c.UNSAFE_componentWillMount == 'function' &&
                          c.UNSAFE_componentWillMount()),
                      typeof c.componentDidMount == 'function' &&
                        (t.flags |= 4194308))
                    : (typeof c.componentDidMount == 'function' &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = n),
                      (t.memoizedState = N)),
                  (c.props = n),
                  (c.state = N),
                  (c.context = m),
                  (n = S))
                : (typeof c.componentDidMount == 'function' &&
                    (t.flags |= 4194308),
                  (n = !1)));
          } else {
            ((c = t.stateNode),
              Ar(e, t),
              (m = t.memoizedProps),
              (U = Fi(i, m)),
              (c.props = U),
              (Y = t.pendingProps),
              (C = c.context),
              (N = i.contextType),
              (S = wn),
              typeof N == 'object' && N !== null && (S = tt(N)),
              (v = i.getDerivedStateFromProps),
              (N =
                typeof v == 'function' ||
                typeof c.getSnapshotBeforeUpdate == 'function') ||
                (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof c.componentWillReceiveProps != 'function') ||
                ((m !== Y || C !== S) && Hf(t, c, n, S)),
              (pi = !1),
              (C = t.memoizedState),
              (c.state = C),
              Ea(t, n, c, o),
              Ta());
            var R = t.memoizedState;
            m !== Y ||
            C !== R ||
            pi ||
            (e !== null && e.dependencies !== null && Al(e.dependencies))
              ? (typeof v == 'function' &&
                  (Xr(t, i, v, n), (R = t.memoizedState)),
                (U =
                  pi ||
                  Bf(t, i, U, n, C, R, S) ||
                  (e !== null && e.dependencies !== null && Al(e.dependencies)))
                  ? (N ||
                      (typeof c.UNSAFE_componentWillUpdate != 'function' &&
                        typeof c.componentWillUpdate != 'function') ||
                      (typeof c.componentWillUpdate == 'function' &&
                        c.componentWillUpdate(n, R, S),
                      typeof c.UNSAFE_componentWillUpdate == 'function' &&
                        c.UNSAFE_componentWillUpdate(n, R, S)),
                    typeof c.componentDidUpdate == 'function' && (t.flags |= 4),
                    typeof c.getSnapshotBeforeUpdate == 'function' &&
                      (t.flags |= 1024))
                  : (typeof c.componentDidUpdate != 'function' ||
                      (m === e.memoizedProps && C === e.memoizedState) ||
                      (t.flags |= 4),
                    typeof c.getSnapshotBeforeUpdate != 'function' ||
                      (m === e.memoizedProps && C === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = n),
                    (t.memoizedState = R)),
                (c.props = n),
                (c.state = R),
                (c.context = S),
                (n = U))
              : (typeof c.componentDidUpdate != 'function' ||
                  (m === e.memoizedProps && C === e.memoizedState) ||
                  (t.flags |= 4),
                typeof c.getSnapshotBeforeUpdate != 'function' ||
                  (m === e.memoizedProps && C === e.memoizedState) ||
                  (t.flags |= 1024),
                (n = !1));
          }
          return (
            (c = n),
            Kl(e, t),
            (n = (t.flags & 128) !== 0),
            c || n
              ? ((c = t.stateNode),
                (i =
                  n && typeof i.getDerivedStateFromError != 'function'
                    ? null
                    : c.render()),
                (t.flags |= 1),
                e !== null && n
                  ? ((t.child = Ln(t, e.child, null, o)),
                    (t.child = Ln(t, null, i, o)))
                  : Fe(e, t, i, o),
                (t.memoizedState = c.state),
                (e = t.child))
              : (e = Pt(e, t, o)),
            e
          );
        }
        function Pf(e, t, i, n) {
          return (pa(), (t.flags |= 256), Fe(e, t, i, n), t.child);
        }
        var Fr = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function Ir(e) {
          return { baseLanes: e, cachePool: Uc() };
        }
        function Pr(e, t, i) {
          return ((e = e !== null ? e.childLanes & ~i : 0), t && (e |= Ct), e);
        }
        function Wf(e, t, i) {
          var n = t.pendingProps,
            o = !1,
            c = (t.flags & 128) !== 0,
            m;
          if (
            ((m = c) ||
              (m =
                e !== null && e.memoizedState === null
                  ? !1
                  : (qe.current & 2) !== 0),
            m && ((o = !0), (t.flags &= -129)),
            (m = (t.flags & 32) !== 0),
            (t.flags &= -33),
            e === null)
          ) {
            if (Te) {
              if ((o ? yi(t) : bi(), Te)) {
                var v = Le,
                  S;
                if ((S = v)) {
                  e: {
                    for (S = v, v = Ht; S.nodeType !== 8; ) {
                      if (!v) {
                        v = null;
                        break e;
                      }
                      if (((S = jt(S.nextSibling)), S === null)) {
                        v = null;
                        break e;
                      }
                    }
                    v = S;
                  }
                  v !== null
                    ? ((t.memoizedState = {
                        dehydrated: v,
                        treeContext:
                          qi !== null ? { id: Xt, overflow: Qt } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (S = vt(18, null, null, 0)),
                      (S.stateNode = v),
                      (S.return = t),
                      (t.child = S),
                      (nt = t),
                      (Le = null),
                      (S = !0))
                    : (S = !1);
                }
                S || ki(t);
              }
              if (
                ((v = t.memoizedState),
                v !== null && ((v = v.dehydrated), v !== null))
              )
                return (Bo(v) ? (t.lanes = 32) : (t.lanes = 536870912), null);
              It(t);
            }
            return (
              (v = n.children),
              (n = n.fallback),
              o
                ? (bi(),
                  (o = t.mode),
                  (v = kl({ mode: 'hidden', children: v }, o)),
                  (n = Yi(n, o, i, null)),
                  (v.return = t),
                  (n.return = t),
                  (v.sibling = n),
                  (t.child = v),
                  (o = t.child),
                  (o.memoizedState = Ir(i)),
                  (o.childLanes = Pr(e, m, i)),
                  (t.memoizedState = Fr),
                  n)
                : (yi(t), Wr(t, v))
            );
          }
          if (
            ((S = e.memoizedState),
            S !== null && ((v = S.dehydrated), v !== null))
          ) {
            if (c)
              t.flags & 256
                ? (yi(t), (t.flags &= -257), (t = eo(e, t, i)))
                : t.memoizedState !== null
                  ? (bi(), (t.child = e.child), (t.flags |= 128), (t = null))
                  : (bi(),
                    (o = n.fallback),
                    (v = t.mode),
                    (n = kl({ mode: 'visible', children: n.children }, v)),
                    (o = Yi(o, v, i, null)),
                    (o.flags |= 2),
                    (n.return = t),
                    (o.return = t),
                    (n.sibling = o),
                    (t.child = n),
                    Ln(t, e.child, null, i),
                    (n = t.child),
                    (n.memoizedState = Ir(i)),
                    (n.childLanes = Pr(e, m, i)),
                    (t.memoizedState = Fr),
                    (t = o));
            else if ((yi(t), Bo(v))) {
              if (((m = v.nextSibling && v.nextSibling.dataset), m))
                var N = m.dgst;
              ((m = N),
                (n = Error(r(419))),
                (n.stack = ''),
                (n.digest = m),
                ma({ value: n, source: null, stack: null }),
                (t = eo(e, t, i)));
            } else if (
              (Xe || ga(e, t, i, !1), (m = (i & e.childLanes) !== 0), Xe || m)
            ) {
              if (
                ((m = Ne),
                m !== null &&
                  ((n = i & -i),
                  (n = (n & 42) !== 0 ? 1 : Bs(n)),
                  (n = (n & (m.suspendedLanes | i)) !== 0 ? 0 : n),
                  n !== 0 && n !== S.retryLane))
              )
                throw ((S.retryLane = n), En(e, n), Tt(m, e, n), Kf);
              (v.data === '$?' || bo(), (t = eo(e, t, i)));
            } else
              v.data === '$?'
                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                : ((e = S.treeContext),
                  (Le = jt(v.nextSibling)),
                  (nt = t),
                  (Te = !0),
                  (Ki = null),
                  (Ht = !1),
                  e !== null &&
                    ((_t[zt++] = Xt),
                    (_t[zt++] = Qt),
                    (_t[zt++] = qi),
                    (Xt = e.id),
                    (Qt = e.overflow),
                    (qi = t)),
                  (t = Wr(t, n.children)),
                  (t.flags |= 4096));
            return t;
          }
          return o
            ? (bi(),
              (o = n.fallback),
              (v = t.mode),
              (S = e.child),
              (N = S.sibling),
              (n = kt(S, { mode: 'hidden', children: n.children })),
              (n.subtreeFlags = S.subtreeFlags & 65011712),
              N !== null
                ? (o = kt(N, o))
                : ((o = Yi(o, v, i, null)), (o.flags |= 2)),
              (o.return = t),
              (n.return = t),
              (n.sibling = o),
              (t.child = n),
              (n = o),
              (o = t.child),
              (v = e.child.memoizedState),
              v === null
                ? (v = Ir(i))
                : ((S = v.cachePool),
                  S !== null
                    ? ((N = Ye._currentValue),
                      (S = S.parent !== N ? { parent: N, pool: N } : S))
                    : (S = Uc()),
                  (v = { baseLanes: v.baseLanes | i, cachePool: S })),
              (o.memoizedState = v),
              (o.childLanes = Pr(e, m, i)),
              (t.memoizedState = Fr),
              n)
            : (yi(t),
              (i = e.child),
              (e = i.sibling),
              (i = kt(i, { mode: 'visible', children: n.children })),
              (i.return = t),
              (i.sibling = null),
              e !== null &&
                ((m = t.deletions),
                m === null
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : m.push(e)),
              (t.child = i),
              (t.memoizedState = null),
              i);
        }
        function Wr(e, t) {
          return (
            (t = kl({ mode: 'visible', children: t }, e.mode)),
            (t.return = e),
            (e.child = t)
          );
        }
        function kl(e, t) {
          return (
            (e = vt(22, e, null, t)),
            (e.lanes = 0),
            (e.stateNode = {
              _visibility: 1,
              _pendingMarkers: null,
              _retryCache: null,
              _transitions: null,
            }),
            e
          );
        }
        function eo(e, t, i) {
          return (
            Ln(t, e.child, null, i),
            (e = Wr(t, t.pendingProps.children)),
            (e.flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function ed(e, t, i) {
          e.lanes |= t;
          var n = e.alternate;
          (n !== null && (n.lanes |= t), yr(e.return, t, i));
        }
        function to(e, t, i, n, o) {
          var c = e.memoizedState;
          c === null
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: n,
                tail: i,
                tailMode: o,
              })
            : ((c.isBackwards = t),
              (c.rendering = null),
              (c.renderingStartTime = 0),
              (c.last = n),
              (c.tail = i),
              (c.tailMode = o));
        }
        function td(e, t, i) {
          var n = t.pendingProps,
            o = n.revealOrder,
            c = n.tail;
          if ((Fe(e, t, n.children, i), (n = qe.current), (n & 2) !== 0))
            ((n = (n & 1) | 2), (t.flags |= 128));
          else {
            if (e !== null && (e.flags & 128) !== 0)
              e: for (e = t.child; e !== null; ) {
                if (e.tag === 13) e.memoizedState !== null && ed(e, i, t);
                else if (e.tag === 19) ed(e, i, t);
                else if (e.child !== null) {
                  ((e.child.return = e), (e = e.child));
                  continue;
                }
                if (e === t) break e;
                for (; e.sibling === null; ) {
                  if (e.return === null || e.return === t) break e;
                  e = e.return;
                }
                ((e.sibling.return = e.return), (e = e.sibling));
              }
            n &= 1;
          }
          switch ((P(qe, n), o)) {
            case 'forwards':
              for (i = t.child, o = null; i !== null; )
                ((e = i.alternate),
                  e !== null && Yl(e) === null && (o = i),
                  (i = i.sibling));
              ((i = o),
                i === null
                  ? ((o = t.child), (t.child = null))
                  : ((o = i.sibling), (i.sibling = null)),
                to(t, !1, o, i, c));
              break;
            case 'backwards':
              for (i = null, o = t.child, t.child = null; o !== null; ) {
                if (((e = o.alternate), e !== null && Yl(e) === null)) {
                  t.child = o;
                  break;
                }
                ((e = o.sibling), (o.sibling = i), (i = o), (o = e));
              }
              to(t, !0, i, null, c);
              break;
            case 'together':
              to(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function Pt(e, t, i) {
          if (
            (e !== null && (t.dependencies = e.dependencies),
            (wi |= t.lanes),
            (i & t.childLanes) === 0)
          )
            if (e !== null) {
              if ((ga(e, t, i, !1), (i & t.childLanes) === 0)) return null;
            } else return null;
          if (e !== null && t.child !== e.child) throw Error(r(153));
          if (t.child !== null) {
            for (
              e = t.child, i = kt(e, e.pendingProps), t.child = i, i.return = t;
              e.sibling !== null;
            )
              ((e = e.sibling),
                (i = i.sibling = kt(e, e.pendingProps)),
                (i.return = t));
            i.sibling = null;
          }
          return t.child;
        }
        function io(e, t) {
          return (e.lanes & t) !== 0
            ? !0
            : ((e = e.dependencies), !!(e !== null && Al(e)));
        }
        function rg(e, t, i) {
          switch (t.tag) {
            case 3:
              (Ce(t, t.stateNode.containerInfo),
                hi(t, Ye, e.memoizedState.cache),
                pa());
              break;
            case 27:
            case 5:
              Cs(t);
              break;
            case 4:
              Ce(t, t.stateNode.containerInfo);
              break;
            case 10:
              hi(t, t.type, t.memoizedProps.value);
              break;
            case 13:
              var n = t.memoizedState;
              if (n !== null)
                return n.dehydrated !== null
                  ? (yi(t), (t.flags |= 128), null)
                  : (i & t.child.childLanes) !== 0
                    ? Wf(e, t, i)
                    : (yi(t), (e = Pt(e, t, i)), e !== null ? e.sibling : null);
              yi(t);
              break;
            case 19:
              var o = (e.flags & 128) !== 0;
              if (
                ((n = (i & t.childLanes) !== 0),
                n || (ga(e, t, i, !1), (n = (i & t.childLanes) !== 0)),
                o)
              ) {
                if (n) return td(e, t, i);
                t.flags |= 128;
              }
              if (
                ((o = t.memoizedState),
                o !== null &&
                  ((o.rendering = null),
                  (o.tail = null),
                  (o.lastEffect = null)),
                P(qe, qe.current),
                n)
              )
                break;
              return null;
            case 22:
            case 23:
              return ((t.lanes = 0), Zf(e, t, i));
            case 24:
              hi(t, Ye, e.memoizedState.cache);
          }
          return Pt(e, t, i);
        }
        function id(e, t, i) {
          if (e !== null)
            if (e.memoizedProps !== t.pendingProps) Xe = !0;
            else {
              if (!io(e, i) && (t.flags & 128) === 0)
                return ((Xe = !1), rg(e, t, i));
              Xe = (e.flags & 131072) !== 0;
            }
          else
            ((Xe = !1), Te && (t.flags & 1048576) !== 0 && Cc(t, wl, t.index));
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var n = t.elementType,
                  o = n._init;
                if (((n = o(n._payload)), (t.type = n), typeof n == 'function'))
                  fr(n)
                    ? ((e = Fi(n, e)), (t.tag = 1), (t = If(null, t, n, e, i)))
                    : ((t.tag = 0), (t = Jr(null, t, n, e, i)));
                else {
                  if (n != null) {
                    if (((o = n.$$typeof), o === k)) {
                      ((t.tag = 11), (t = kf(null, t, n, e, i)));
                      break e;
                    } else if (o === Z) {
                      ((t.tag = 14), (t = Xf(null, t, n, e, i)));
                      break e;
                    }
                  }
                  throw ((t = ue(n) || n), Error(r(306, t, '')));
                }
              }
              return t;
            case 0:
              return Jr(e, t, t.type, t.pendingProps, i);
            case 1:
              return (
                (n = t.type),
                (o = Fi(n, t.pendingProps)),
                If(e, t, n, o, i)
              );
            case 3:
              e: {
                if ((Ce(t, t.stateNode.containerInfo), e === null))
                  throw Error(r(387));
                n = t.pendingProps;
                var c = t.memoizedState;
                ((o = c.element), Ar(e, t), Ea(t, n, null, i));
                var m = t.memoizedState;
                if (
                  ((n = m.cache),
                  hi(t, Ye, n),
                  n !== c.cache && br(t, [Ye], i, !0),
                  Ta(),
                  (n = m.element),
                  c.isDehydrated)
                )
                  if (
                    ((c = { element: n, isDehydrated: !1, cache: m.cache }),
                    (t.updateQueue.baseState = c),
                    (t.memoizedState = c),
                    t.flags & 256)
                  ) {
                    t = Pf(e, t, n, i);
                    break e;
                  } else if (n !== o) {
                    ((o = Mt(Error(r(424)), t)), ma(o), (t = Pf(e, t, n, i)));
                    break e;
                  } else {
                    switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                      case 9:
                        e = e.body;
                        break;
                      default:
                        e = e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                    }
                    for (
                      Le = jt(e.firstChild),
                        nt = t,
                        Te = !0,
                        Ki = null,
                        Ht = !0,
                        i = Lf(t, null, n, i),
                        t.child = i;
                      i;
                    )
                      ((i.flags = (i.flags & -3) | 4096), (i = i.sibling));
                  }
                else {
                  if ((pa(), n === o)) {
                    t = Pt(e, t, i);
                    break e;
                  }
                  Fe(e, t, n, i);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                Kl(e, t),
                e === null
                  ? (i = sh(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = i)
                    : Te ||
                      ((i = t.type),
                      (e = t.pendingProps),
                      (n = ls(de.current).createElement(i)),
                      (n[et] = t),
                      (n[st] = e),
                      Pe(n, i, e),
                      ke(n),
                      (t.stateNode = n))
                  : (t.memoizedState = sh(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                Cs(t),
                e === null &&
                  Te &&
                  ((n = t.stateNode = nh(t.type, t.pendingProps, de.current)),
                  (nt = t),
                  (Ht = !0),
                  (o = Le),
                  _i(t.type) ? ((Ho = o), (Le = jt(n.firstChild))) : (Le = o)),
                Fe(e, t, t.pendingProps.children, i),
                Kl(e, t),
                e === null && (t.flags |= 4194304),
                t.child
              );
            case 5:
              return (
                e === null &&
                  Te &&
                  ((o = n = Le) &&
                    ((n = jg(n, t.type, t.pendingProps, Ht)),
                    n !== null
                      ? ((t.stateNode = n),
                        (nt = t),
                        (Le = jt(n.firstChild)),
                        (Ht = !1),
                        (o = !0))
                      : (o = !1)),
                  o || ki(t)),
                Cs(t),
                (o = t.type),
                (c = t.pendingProps),
                (m = e !== null ? e.memoizedProps : null),
                (n = c.children),
                Do(o, c)
                  ? (n = null)
                  : m !== null && Do(o, m) && (t.flags |= 32),
                t.memoizedState !== null &&
                  ((o = Cr(e, t, Wm, null, null, i)), (ka._currentValue = o)),
                Kl(e, t),
                Fe(e, t, n, i),
                t.child
              );
            case 6:
              return (
                e === null &&
                  Te &&
                  ((e = i = Le) &&
                    ((i = Bg(i, t.pendingProps, Ht)),
                    i !== null
                      ? ((t.stateNode = i), (nt = t), (Le = null), (e = !0))
                      : (e = !1)),
                  e || ki(t)),
                null
              );
            case 13:
              return Wf(e, t, i);
            case 4:
              return (
                Ce(t, t.stateNode.containerInfo),
                (n = t.pendingProps),
                e === null ? (t.child = Ln(t, null, n, i)) : Fe(e, t, n, i),
                t.child
              );
            case 11:
              return kf(e, t, t.type, t.pendingProps, i);
            case 7:
              return (Fe(e, t, t.pendingProps, i), t.child);
            case 8:
              return (Fe(e, t, t.pendingProps.children, i), t.child);
            case 12:
              return (Fe(e, t, t.pendingProps.children, i), t.child);
            case 10:
              return (
                (n = t.pendingProps),
                hi(t, t.type, n.value),
                Fe(e, t, n.children, i),
                t.child
              );
            case 9:
              return (
                (o = t.type._context),
                (n = t.pendingProps.children),
                Qi(t),
                (o = tt(o)),
                (n = n(o)),
                (t.flags |= 1),
                Fe(e, t, n, i),
                t.child
              );
            case 14:
              return Xf(e, t, t.type, t.pendingProps, i);
            case 15:
              return Qf(e, t, t.type, t.pendingProps, i);
            case 19:
              return td(e, t, i);
            case 31:
              return (
                (n = t.pendingProps),
                (i = t.mode),
                (n = { mode: n.mode, children: n.children }),
                e === null
                  ? ((i = kl(n, i)),
                    (i.ref = t.ref),
                    (t.child = i),
                    (i.return = t),
                    (t = i))
                  : ((i = kt(e.child, n)),
                    (i.ref = t.ref),
                    (t.child = i),
                    (i.return = t),
                    (t = i)),
                t
              );
            case 22:
              return Zf(e, t, i);
            case 24:
              return (
                Qi(t),
                (n = tt(Ye)),
                e === null
                  ? ((o = Tr()),
                    o === null &&
                      ((o = Ne),
                      (c = Sr()),
                      (o.pooledCache = c),
                      c.refCount++,
                      c !== null && (o.pooledCacheLanes |= i),
                      (o = c)),
                    (t.memoizedState = { parent: n, cache: o }),
                    wr(t),
                    hi(t, Ye, o))
                  : ((e.lanes & i) !== 0 &&
                      (Ar(e, t), Ea(t, null, null, i), Ta()),
                    (o = e.memoizedState),
                    (c = t.memoizedState),
                    o.parent !== n
                      ? ((o = { parent: n, cache: n }),
                        (t.memoizedState = o),
                        t.lanes === 0 &&
                          (t.memoizedState = t.updateQueue.baseState = o),
                        hi(t, Ye, n))
                      : ((n = c.cache),
                        hi(t, Ye, n),
                        n !== o.cache && br(t, [Ye], i, !0))),
                Fe(e, t, t.pendingProps.children, i),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(r(156, t.tag));
        }
        function Wt(e) {
          e.flags |= 4;
        }
        function nd(e, t) {
          if (t.type !== 'stylesheet' || (t.state.loading & 4) !== 0)
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !fh(t))) {
            if (
              ((t = Nt.current),
              t !== null &&
                ((be & 4194048) === be
                  ? Ut !== null
                  : ((be & 62914560) !== be && (be & 536870912) === 0) ||
                    t !== Ut))
            )
              throw ((Sa = Er), Gc);
            e.flags |= 8192;
          }
        }
        function Xl(e, t) {
          (t !== null && (e.flags |= 4),
            e.flags & 16384 &&
              ((t = e.tag !== 22 ? Lu() : 536870912),
              (e.lanes |= t),
              (Un |= t)));
        }
        function Na(e, t) {
          if (!Te)
            switch (e.tailMode) {
              case 'hidden':
                t = e.tail;
                for (var i = null; t !== null; )
                  (t.alternate !== null && (i = t), (t = t.sibling));
                i === null ? (e.tail = null) : (i.sibling = null);
                break;
              case 'collapsed':
                i = e.tail;
                for (var n = null; i !== null; )
                  (i.alternate !== null && (n = i), (i = i.sibling));
                n === null
                  ? t || e.tail === null
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (n.sibling = null);
            }
        }
        function De(e) {
          var t = e.alternate !== null && e.alternate.child === e.child,
            i = 0,
            n = 0;
          if (t)
            for (var o = e.child; o !== null; )
              ((i |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags & 65011712),
                (n |= o.flags & 65011712),
                (o.return = e),
                (o = o.sibling));
          else
            for (o = e.child; o !== null; )
              ((i |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags),
                (n |= o.flags),
                (o.return = e),
                (o = o.sibling));
          return ((e.subtreeFlags |= n), (e.childLanes = i), t);
        }
        function og(e, t, i) {
          var n = t.pendingProps;
          switch ((mr(t), t.tag)) {
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (De(t), null);
            case 1:
              return (De(t), null);
            case 3:
              return (
                (i = t.stateNode),
                (n = null),
                e !== null && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                Jt(Ye),
                ui(),
                i.pendingContext &&
                  ((i.context = i.pendingContext), (i.pendingContext = null)),
                (e === null || e.child === null) &&
                  (ha(t)
                    ? Wt(t)
                    : e === null ||
                      (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                      ((t.flags |= 1024), Lc())),
                De(t),
                null
              );
            case 26:
              return (
                (i = t.memoizedState),
                e === null
                  ? (Wt(t),
                    i !== null
                      ? (De(t), nd(t, i))
                      : (De(t), (t.flags &= -16777217)))
                  : i
                    ? i !== e.memoizedState
                      ? (Wt(t), De(t), nd(t, i))
                      : (De(t), (t.flags &= -16777217))
                    : (e.memoizedProps !== n && Wt(t),
                      De(t),
                      (t.flags &= -16777217)),
                null
              );
            case 27:
              (nl(t), (i = de.current));
              var o = t.type;
              if (e !== null && t.stateNode != null)
                e.memoizedProps !== n && Wt(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (De(t), null);
                }
                ((e = le.current),
                  ha(t)
                    ? Rc(t)
                    : ((e = nh(o, n, i)), (t.stateNode = e), Wt(t)));
              }
              return (De(t), null);
            case 5:
              if ((nl(t), (i = t.type), e !== null && t.stateNode != null))
                e.memoizedProps !== n && Wt(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (De(t), null);
                }
                if (((e = le.current), ha(t))) Rc(t);
                else {
                  switch (((o = ls(de.current)), e)) {
                    case 1:
                      e = o.createElementNS('http://www.w3.org/2000/svg', i);
                      break;
                    case 2:
                      e = o.createElementNS(
                        'http://www.w3.org/1998/Math/MathML',
                        i
                      );
                      break;
                    default:
                      switch (i) {
                        case 'svg':
                          e = o.createElementNS(
                            'http://www.w3.org/2000/svg',
                            i
                          );
                          break;
                        case 'math':
                          e = o.createElementNS(
                            'http://www.w3.org/1998/Math/MathML',
                            i
                          );
                          break;
                        case 'script':
                          ((e = o.createElement('div')),
                            (e.innerHTML = '<script><\/script>'),
                            (e = e.removeChild(e.firstChild)));
                          break;
                        case 'select':
                          ((e =
                            typeof n.is == 'string'
                              ? o.createElement('select', { is: n.is })
                              : o.createElement('select')),
                            n.multiple
                              ? (e.multiple = !0)
                              : n.size && (e.size = n.size));
                          break;
                        default:
                          e =
                            typeof n.is == 'string'
                              ? o.createElement(i, { is: n.is })
                              : o.createElement(i);
                      }
                  }
                  ((e[et] = t), (e[st] = n));
                  e: for (o = t.child; o !== null; ) {
                    if (o.tag === 5 || o.tag === 6) e.appendChild(o.stateNode);
                    else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                      ((o.child.return = o), (o = o.child));
                      continue;
                    }
                    if (o === t) break e;
                    for (; o.sibling === null; ) {
                      if (o.return === null || o.return === t) break e;
                      o = o.return;
                    }
                    ((o.sibling.return = o.return), (o = o.sibling));
                  }
                  t.stateNode = e;
                  e: switch ((Pe(e, i, n), i)) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      e = !!n.autoFocus;
                      break e;
                    case 'img':
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && Wt(t);
                }
              }
              return (De(t), (t.flags &= -16777217), null);
            case 6:
              if (e && t.stateNode != null) e.memoizedProps !== n && Wt(t);
              else {
                if (typeof n != 'string' && t.stateNode === null)
                  throw Error(r(166));
                if (((e = de.current), ha(t))) {
                  if (
                    ((e = t.stateNode),
                    (i = t.memoizedProps),
                    (n = null),
                    (o = nt),
                    o !== null)
                  )
                    switch (o.tag) {
                      case 27:
                      case 5:
                        n = o.memoizedProps;
                    }
                  ((e[et] = t),
                    (e = !!(
                      e.nodeValue === i ||
                      (n !== null && n.suppressHydrationWarning === !0) ||
                      Fd(e.nodeValue, i)
                    )),
                    e || ki(t));
                } else
                  ((e = ls(e).createTextNode(n)),
                    (e[et] = t),
                    (t.stateNode = e));
              }
              return (De(t), null);
            case 13:
              if (
                ((n = t.memoizedState),
                e === null ||
                  (e.memoizedState !== null &&
                    e.memoizedState.dehydrated !== null))
              ) {
                if (((o = ha(t)), n !== null && n.dehydrated !== null)) {
                  if (e === null) {
                    if (!o) throw Error(r(318));
                    if (
                      ((o = t.memoizedState),
                      (o = o !== null ? o.dehydrated : null),
                      !o)
                    )
                      throw Error(r(317));
                    o[et] = t;
                  } else
                    (pa(),
                      (t.flags & 128) === 0 && (t.memoizedState = null),
                      (t.flags |= 4));
                  (De(t), (o = !1));
                } else
                  ((o = Lc()),
                    e !== null &&
                      e.memoizedState !== null &&
                      (e.memoizedState.hydrationErrors = o),
                    (o = !0));
                if (!o) return t.flags & 256 ? (It(t), t) : (It(t), null);
              }
              if ((It(t), (t.flags & 128) !== 0)) return ((t.lanes = i), t);
              if (
                ((i = n !== null),
                (e = e !== null && e.memoizedState !== null),
                i)
              ) {
                ((n = t.child),
                  (o = null),
                  n.alternate !== null &&
                    n.alternate.memoizedState !== null &&
                    n.alternate.memoizedState.cachePool !== null &&
                    (o = n.alternate.memoizedState.cachePool.pool));
                var c = null;
                (n.memoizedState !== null &&
                  n.memoizedState.cachePool !== null &&
                  (c = n.memoizedState.cachePool.pool),
                  c !== o && (n.flags |= 2048));
              }
              return (
                i !== e && i && (t.child.flags |= 8192),
                Xl(t, t.updateQueue),
                De(t),
                null
              );
            case 4:
              return (
                ui(),
                e === null && _o(t.stateNode.containerInfo),
                De(t),
                null
              );
            case 10:
              return (Jt(t.type), De(t), null);
            case 19:
              if ((W(qe), (o = t.memoizedState), o === null))
                return (De(t), null);
              if (((n = (t.flags & 128) !== 0), (c = o.rendering), c === null))
                if (n) Na(o, !1);
                else {
                  if (je !== 0 || (e !== null && (e.flags & 128) !== 0))
                    for (e = t.child; e !== null; ) {
                      if (((c = Yl(e)), c !== null)) {
                        for (
                          t.flags |= 128,
                            Na(o, !1),
                            e = c.updateQueue,
                            t.updateQueue = e,
                            Xl(t, e),
                            t.subtreeFlags = 0,
                            e = i,
                            i = t.child;
                          i !== null;
                        )
                          (Nc(i, e), (i = i.sibling));
                        return (P(qe, (qe.current & 1) | 2), t.child);
                      }
                      e = e.sibling;
                    }
                  o.tail !== null &&
                    Bt() > Jl &&
                    ((t.flags |= 128),
                    (n = !0),
                    Na(o, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!n)
                  if (((e = Yl(c)), e !== null)) {
                    if (
                      ((t.flags |= 128),
                      (n = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      Xl(t, e),
                      Na(o, !0),
                      o.tail === null &&
                        o.tailMode === 'hidden' &&
                        !c.alternate &&
                        !Te)
                    )
                      return (De(t), null);
                  } else
                    2 * Bt() - o.renderingStartTime > Jl &&
                      i !== 536870912 &&
                      ((t.flags |= 128),
                      (n = !0),
                      Na(o, !1),
                      (t.lanes = 4194304));
                o.isBackwards
                  ? ((c.sibling = t.child), (t.child = c))
                  : ((e = o.last),
                    e !== null ? (e.sibling = c) : (t.child = c),
                    (o.last = c));
              }
              return o.tail !== null
                ? ((t = o.tail),
                  (o.rendering = t),
                  (o.tail = t.sibling),
                  (o.renderingStartTime = Bt()),
                  (t.sibling = null),
                  (e = qe.current),
                  P(qe, n ? (e & 1) | 2 : e & 1),
                  t)
                : (De(t), null);
            case 22:
            case 23:
              return (
                It(t),
                zr(),
                (n = t.memoizedState !== null),
                e !== null
                  ? (e.memoizedState !== null) !== n && (t.flags |= 8192)
                  : n && (t.flags |= 8192),
                n
                  ? (i & 536870912) !== 0 &&
                    (t.flags & 128) === 0 &&
                    (De(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                  : De(t),
                (i = t.updateQueue),
                i !== null && Xl(t, i.retryQueue),
                (i = null),
                e !== null &&
                  e.memoizedState !== null &&
                  e.memoizedState.cachePool !== null &&
                  (i = e.memoizedState.cachePool.pool),
                (n = null),
                t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (n = t.memoizedState.cachePool.pool),
                n !== i && (t.flags |= 2048),
                e !== null && W(Zi),
                null
              );
            case 24:
              return (
                (i = null),
                e !== null && (i = e.memoizedState.cache),
                t.memoizedState.cache !== i && (t.flags |= 2048),
                Jt(Ye),
                De(t),
                null
              );
            case 25:
              return null;
            case 30:
              return null;
          }
          throw Error(r(156, t.tag));
        }
        function ug(e, t) {
          switch ((mr(t), t.tag)) {
            case 1:
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 3:
              return (
                Jt(Ye),
                ui(),
                (e = t.flags),
                (e & 65536) !== 0 && (e & 128) === 0
                  ? ((t.flags = (e & -65537) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return (nl(t), null);
            case 13:
              if (
                (It(t),
                (e = t.memoizedState),
                e !== null && e.dehydrated !== null)
              ) {
                if (t.alternate === null) throw Error(r(340));
                pa();
              }
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 19:
              return (W(qe), null);
            case 4:
              return (ui(), null);
            case 10:
              return (Jt(t.type), null);
            case 22:
            case 23:
              return (
                It(t),
                zr(),
                e !== null && W(Zi),
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 24:
              return (Jt(Ye), null);
            case 25:
              return null;
            default:
              return null;
          }
        }
        function ad(e, t) {
          switch ((mr(t), t.tag)) {
            case 3:
              (Jt(Ye), ui());
              break;
            case 26:
            case 27:
            case 5:
              nl(t);
              break;
            case 4:
              ui();
              break;
            case 13:
              It(t);
              break;
            case 19:
              W(qe);
              break;
            case 10:
              Jt(t.type);
              break;
            case 22:
            case 23:
              (It(t), zr(), e !== null && W(Zi));
              break;
            case 24:
              Jt(Ye);
          }
        }
        function Ca(e, t) {
          try {
            var i = t.updateQueue,
              n = i !== null ? i.lastEffect : null;
            if (n !== null) {
              var o = n.next;
              i = o;
              do {
                if ((i.tag & e) === e) {
                  n = void 0;
                  var c = i.create,
                    m = i.inst;
                  ((n = c()), (m.destroy = n));
                }
                i = i.next;
              } while (i !== o);
            }
          } catch (v) {
            ze(t, t.return, v);
          }
        }
        function Si(e, t, i) {
          try {
            var n = t.updateQueue,
              o = n !== null ? n.lastEffect : null;
            if (o !== null) {
              var c = o.next;
              n = c;
              do {
                if ((n.tag & e) === e) {
                  var m = n.inst,
                    v = m.destroy;
                  if (v !== void 0) {
                    ((m.destroy = void 0), (o = t));
                    var S = i,
                      N = v;
                    try {
                      N();
                    } catch (U) {
                      ze(o, S, U);
                    }
                  }
                }
                n = n.next;
              } while (n !== c);
            }
          } catch (U) {
            ze(t, t.return, U);
          }
        }
        function ld(e) {
          var t = e.updateQueue;
          if (t !== null) {
            var i = e.stateNode;
            try {
              kc(t, i);
            } catch (n) {
              ze(e, e.return, n);
            }
          }
        }
        function sd(e, t, i) {
          ((i.props = Fi(e.type, e.memoizedProps)),
            (i.state = e.memoizedState));
          try {
            i.componentWillUnmount();
          } catch (n) {
            ze(e, t, n);
          }
        }
        function Ra(e, t) {
          try {
            var i = e.ref;
            if (i !== null) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var n = e.stateNode;
                  break;
                case 30:
                  n = e.stateNode;
                  break;
                default:
                  n = e.stateNode;
              }
              typeof i == 'function' ? (e.refCleanup = i(n)) : (i.current = n);
            }
          } catch (o) {
            ze(e, t, o);
          }
        }
        function Gt(e, t) {
          var i = e.ref,
            n = e.refCleanup;
          if (i !== null)
            if (typeof n == 'function')
              try {
                n();
              } catch (o) {
                ze(e, t, o);
              } finally {
                ((e.refCleanup = null),
                  (e = e.alternate),
                  e != null && (e.refCleanup = null));
              }
            else if (typeof i == 'function')
              try {
                i(null);
              } catch (o) {
                ze(e, t, o);
              }
            else i.current = null;
        }
        function rd(e) {
          var t = e.type,
            i = e.memoizedProps,
            n = e.stateNode;
          try {
            e: switch (t) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                i.autoFocus && n.focus();
                break e;
              case 'img':
                i.src ? (n.src = i.src) : i.srcSet && (n.srcset = i.srcSet);
            }
          } catch (o) {
            ze(e, e.return, o);
          }
        }
        function no(e, t, i) {
          try {
            var n = e.stateNode;
            (Ng(n, e.type, i, t), (n[st] = t));
          } catch (o) {
            ze(e, e.return, o);
          }
        }
        function od(e) {
          return (
            e.tag === 5 ||
            e.tag === 3 ||
            e.tag === 26 ||
            (e.tag === 27 && _i(e.type)) ||
            e.tag === 4
          );
        }
        function ao(e) {
          e: for (;;) {
            for (; e.sibling === null; ) {
              if (e.return === null || od(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
            ) {
              if (
                (e.tag === 27 && _i(e.type)) ||
                e.flags & 2 ||
                e.child === null ||
                e.tag === 4
              )
                continue e;
              ((e.child.return = e), (e = e.child));
            }
            if (!(e.flags & 2)) return e.stateNode;
          }
        }
        function lo(e, t, i) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode),
              t
                ? (i.nodeType === 9
                    ? i.body
                    : i.nodeName === 'HTML'
                      ? i.ownerDocument.body
                      : i
                  ).insertBefore(e, t)
                : ((t =
                    i.nodeType === 9
                      ? i.body
                      : i.nodeName === 'HTML'
                        ? i.ownerDocument.body
                        : i),
                  t.appendChild(e),
                  (i = i._reactRootContainer),
                  i != null || t.onclick !== null || (t.onclick = as)));
          else if (
            n !== 4 &&
            (n === 27 && _i(e.type) && ((i = e.stateNode), (t = null)),
            (e = e.child),
            e !== null)
          )
            for (lo(e, t, i), e = e.sibling; e !== null; )
              (lo(e, t, i), (e = e.sibling));
        }
        function Ql(e, t, i) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode), t ? i.insertBefore(e, t) : i.appendChild(e));
          else if (
            n !== 4 &&
            (n === 27 && _i(e.type) && (i = e.stateNode),
            (e = e.child),
            e !== null)
          )
            for (Ql(e, t, i), e = e.sibling; e !== null; )
              (Ql(e, t, i), (e = e.sibling));
        }
        function ud(e) {
          var t = e.stateNode,
            i = e.memoizedProps;
          try {
            for (var n = e.type, o = t.attributes; o.length; )
              t.removeAttributeNode(o[0]);
            (Pe(t, n, i), (t[et] = e), (t[st] = i));
          } catch (c) {
            ze(e, e.return, c);
          }
        }
        var ei = !1,
          Ue = !1,
          so = !1,
          cd = typeof WeakSet == 'function' ? WeakSet : Set,
          Qe = null;
        function cg(e, t) {
          if (((e = e.containerInfo), (Co = fs), (e = Sc(e)), ar(e))) {
            if ('selectionStart' in e)
              var i = { start: e.selectionStart, end: e.selectionEnd };
            else {
              i = ((i = e.ownerDocument) && i.defaultView) || window;
              var n = i.getSelection && i.getSelection();
              if (n && n.rangeCount !== 0) {
                i = n.anchorNode;
                var o = n.anchorOffset,
                  c = n.focusNode;
                n = n.focusOffset;
                var m = 0,
                  v = -1,
                  S = -1,
                  N = 0,
                  U = 0,
                  Y = e,
                  C = null;
                e: for (;;) {
                  for (
                    var R;
                    Y !== i || (o !== 0 && Y.nodeType !== 3) || (v = m + o),
                      Y !== c || (n !== 0 && Y.nodeType !== 3) || (S = m + n),
                      Y.nodeType === 3 && (m += Y.nodeValue.length),
                      (R = Y.firstChild) !== null;
                  )
                    ((C = Y), (Y = R));
                  for (;;) {
                    if (Y === e) break e;
                    if (
                      (C === i && ++N === o && (v = m),
                      C === c && ++U === n && (S = m),
                      (R = Y.nextSibling) !== null)
                    )
                      break;
                    ((Y = C), (C = Y.parentNode));
                  }
                  Y = R;
                }
                i = v === -1 || S === -1 ? null : { start: v, end: S };
              } else i = null;
            }
            i = i || { start: 0, end: 0 };
          } else i = null;
          for (
            Ro = { focusedElem: e, selectionRange: i }, fs = !1, Qe = t;
            Qe !== null;
          )
            if (
              ((t = Qe),
              (e = t.child),
              (t.subtreeFlags & 1024) !== 0 && e !== null)
            )
              ((e.return = t), (Qe = e));
            else
              for (; Qe !== null; ) {
                switch (((t = Qe), (c = t.alternate), (e = t.flags), t.tag)) {
                  case 0:
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if ((e & 1024) !== 0 && c !== null) {
                      ((e = void 0),
                        (i = t),
                        (o = c.memoizedProps),
                        (c = c.memoizedState),
                        (n = i.stateNode));
                      try {
                        var ce = Fi(i.type, o);
                        ((e = n.getSnapshotBeforeUpdate(ce, c)),
                          (n.__reactInternalSnapshotBeforeUpdate = e));
                      } catch (se) {
                        ze(i, i.return, se);
                      }
                    }
                    break;
                  case 3:
                    if ((e & 1024) !== 0) {
                      if (
                        ((e = t.stateNode.containerInfo),
                        (i = e.nodeType),
                        i === 9)
                      )
                        jo(e);
                      else if (i === 1)
                        switch (e.nodeName) {
                          case 'HEAD':
                          case 'HTML':
                          case 'BODY':
                            jo(e);
                            break;
                          default:
                            e.textContent = '';
                        }
                    }
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if ((e & 1024) !== 0) throw Error(r(163));
                }
                if (((e = t.sibling), e !== null)) {
                  ((e.return = t.return), (Qe = e));
                  break;
                }
                Qe = t.return;
              }
        }
        function fd(e, t, i) {
          var n = i.flags;
          switch (i.tag) {
            case 0:
            case 11:
            case 15:
              (xi(e, i), n & 4 && Ca(5, i));
              break;
            case 1:
              if ((xi(e, i), n & 4))
                if (((e = i.stateNode), t === null))
                  try {
                    e.componentDidMount();
                  } catch (m) {
                    ze(i, i.return, m);
                  }
                else {
                  var o = Fi(i.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      o,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (m) {
                    ze(i, i.return, m);
                  }
                }
              (n & 64 && ld(i), n & 512 && Ra(i, i.return));
              break;
            case 3:
              if ((xi(e, i), n & 64 && ((e = i.updateQueue), e !== null))) {
                if (((t = null), i.child !== null))
                  switch (i.child.tag) {
                    case 27:
                    case 5:
                      t = i.child.stateNode;
                      break;
                    case 1:
                      t = i.child.stateNode;
                  }
                try {
                  kc(e, t);
                } catch (m) {
                  ze(i, i.return, m);
                }
              }
              break;
            case 27:
              t === null && n & 4 && ud(i);
            case 26:
            case 5:
              (xi(e, i),
                t === null && n & 4 && rd(i),
                n & 512 && Ra(i, i.return));
              break;
            case 12:
              xi(e, i);
              break;
            case 13:
              (xi(e, i),
                n & 4 && pd(e, i),
                n & 64 &&
                  ((e = i.memoizedState),
                  e !== null &&
                    ((e = e.dehydrated),
                    e !== null && ((i = bg.bind(null, i)), Hg(e, i)))));
              break;
            case 22:
              if (((n = i.memoizedState !== null || ei), !n)) {
                ((t = (t !== null && t.memoizedState !== null) || Ue),
                  (o = ei));
                var c = Ue;
                ((ei = n),
                  (Ue = t) && !c
                    ? Ti(e, i, (i.subtreeFlags & 8772) !== 0)
                    : xi(e, i),
                  (ei = o),
                  (Ue = c));
              }
              break;
            case 30:
              break;
            default:
              xi(e, i);
          }
        }
        function dd(e) {
          var t = e.alternate;
          (t !== null && ((e.alternate = null), dd(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            e.tag === 5 && ((t = e.stateNode), t !== null && Gs(t)),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null));
        }
        var Re = null,
          ut = !1;
        function ti(e, t, i) {
          for (i = i.child; i !== null; ) (hd(e, t, i), (i = i.sibling));
        }
        function hd(e, t, i) {
          if (pt && typeof pt.onCommitFiberUnmount == 'function')
            try {
              pt.onCommitFiberUnmount(Wn, i);
            } catch {}
          switch (i.tag) {
            case 26:
              (Ue || Gt(i, t),
                ti(e, t, i),
                i.memoizedState
                  ? i.memoizedState.count--
                  : i.stateNode &&
                    ((i = i.stateNode), i.parentNode.removeChild(i)));
              break;
            case 27:
              Ue || Gt(i, t);
              var n = Re,
                o = ut;
              (_i(i.type) && ((Re = i.stateNode), (ut = !1)),
                ti(e, t, i),
                Ya(i.stateNode),
                (Re = n),
                (ut = o));
              break;
            case 5:
              Ue || Gt(i, t);
            case 6:
              if (
                ((n = Re),
                (o = ut),
                (Re = null),
                ti(e, t, i),
                (Re = n),
                (ut = o),
                Re !== null)
              )
                if (ut)
                  try {
                    (Re.nodeType === 9
                      ? Re.body
                      : Re.nodeName === 'HTML'
                        ? Re.ownerDocument.body
                        : Re
                    ).removeChild(i.stateNode);
                  } catch (c) {
                    ze(i, t, c);
                  }
                else
                  try {
                    Re.removeChild(i.stateNode);
                  } catch (c) {
                    ze(i, t, c);
                  }
              break;
            case 18:
              Re !== null &&
                (ut
                  ? ((e = Re),
                    th(
                      e.nodeType === 9
                        ? e.body
                        : e.nodeName === 'HTML'
                          ? e.ownerDocument.body
                          : e,
                      i.stateNode
                    ),
                    Ja(e))
                  : th(Re, i.stateNode));
              break;
            case 4:
              ((n = Re),
                (o = ut),
                (Re = i.stateNode.containerInfo),
                (ut = !0),
                ti(e, t, i),
                (Re = n),
                (ut = o));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              (Ue || Si(2, i, t), Ue || Si(4, i, t), ti(e, t, i));
              break;
            case 1:
              (Ue ||
                (Gt(i, t),
                (n = i.stateNode),
                typeof n.componentWillUnmount == 'function' && sd(i, t, n)),
                ti(e, t, i));
              break;
            case 21:
              ti(e, t, i);
              break;
            case 22:
              ((Ue = (n = Ue) || i.memoizedState !== null),
                ti(e, t, i),
                (Ue = n));
              break;
            default:
              ti(e, t, i);
          }
        }
        function pd(e, t) {
          if (
            t.memoizedState === null &&
            ((e = t.alternate),
            e !== null &&
              ((e = e.memoizedState),
              e !== null && ((e = e.dehydrated), e !== null)))
          )
            try {
              Ja(e);
            } catch (i) {
              ze(t, t.return, i);
            }
        }
        function fg(e) {
          switch (e.tag) {
            case 13:
            case 19:
              var t = e.stateNode;
              return (t === null && (t = e.stateNode = new cd()), t);
            case 22:
              return (
                (e = e.stateNode),
                (t = e._retryCache),
                t === null && (t = e._retryCache = new cd()),
                t
              );
            default:
              throw Error(r(435, e.tag));
          }
        }
        function ro(e, t) {
          var i = fg(e);
          t.forEach(function (n) {
            var o = Sg.bind(null, e, n);
            i.has(n) || (i.add(n), n.then(o, o));
          });
        }
        function yt(e, t) {
          var i = t.deletions;
          if (i !== null)
            for (var n = 0; n < i.length; n++) {
              var o = i[n],
                c = e,
                m = t,
                v = m;
              e: for (; v !== null; ) {
                switch (v.tag) {
                  case 27:
                    if (_i(v.type)) {
                      ((Re = v.stateNode), (ut = !1));
                      break e;
                    }
                    break;
                  case 5:
                    ((Re = v.stateNode), (ut = !1));
                    break e;
                  case 3:
                  case 4:
                    ((Re = v.stateNode.containerInfo), (ut = !0));
                    break e;
                }
                v = v.return;
              }
              if (Re === null) throw Error(r(160));
              (hd(c, m, o),
                (Re = null),
                (ut = !1),
                (c = o.alternate),
                c !== null && (c.return = null),
                (o.return = null));
            }
          if (t.subtreeFlags & 13878)
            for (t = t.child; t !== null; ) (md(t, e), (t = t.sibling));
        }
        var Lt = null;
        function md(e, t) {
          var i = e.alternate,
            n = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              (yt(t, e),
                bt(e),
                n & 4 && (Si(3, e, e.return), Ca(3, e), Si(5, e, e.return)));
              break;
            case 1:
              (yt(t, e),
                bt(e),
                n & 512 && (Ue || i === null || Gt(i, i.return)),
                n & 64 &&
                  ei &&
                  ((e = e.updateQueue),
                  e !== null &&
                    ((n = e.callbacks),
                    n !== null &&
                      ((i = e.shared.hiddenCallbacks),
                      (e.shared.hiddenCallbacks =
                        i === null ? n : i.concat(n))))));
              break;
            case 26:
              var o = Lt;
              if (
                (yt(t, e),
                bt(e),
                n & 512 && (Ue || i === null || Gt(i, i.return)),
                n & 4)
              ) {
                var c = i !== null ? i.memoizedState : null;
                if (((n = e.memoizedState), i === null))
                  if (n === null)
                    if (e.stateNode === null) {
                      e: {
                        ((n = e.type),
                          (i = e.memoizedProps),
                          (o = o.ownerDocument || o));
                        t: switch (n) {
                          case 'title':
                            ((c = o.getElementsByTagName('title')[0]),
                              (!c ||
                                c[ia] ||
                                c[et] ||
                                c.namespaceURI ===
                                  'http://www.w3.org/2000/svg' ||
                                c.hasAttribute('itemprop')) &&
                                ((c = o.createElement(n)),
                                o.head.insertBefore(
                                  c,
                                  o.querySelector('head > title')
                                )),
                              Pe(c, n, i),
                              (c[et] = e),
                              ke(c),
                              (n = c));
                            break e;
                          case 'link':
                            var m = uh('link', 'href', o).get(
                              n + (i.href || '')
                            );
                            if (m) {
                              for (var v = 0; v < m.length; v++)
                                if (
                                  ((c = m[v]),
                                  c.getAttribute('href') ===
                                    (i.href == null || i.href === ''
                                      ? null
                                      : i.href) &&
                                    c.getAttribute('rel') ===
                                      (i.rel == null ? null : i.rel) &&
                                    c.getAttribute('title') ===
                                      (i.title == null ? null : i.title) &&
                                    c.getAttribute('crossorigin') ===
                                      (i.crossOrigin == null
                                        ? null
                                        : i.crossOrigin))
                                ) {
                                  m.splice(v, 1);
                                  break t;
                                }
                            }
                            ((c = o.createElement(n)),
                              Pe(c, n, i),
                              o.head.appendChild(c));
                            break;
                          case 'meta':
                            if (
                              (m = uh('meta', 'content', o).get(
                                n + (i.content || '')
                              ))
                            ) {
                              for (v = 0; v < m.length; v++)
                                if (
                                  ((c = m[v]),
                                  c.getAttribute('content') ===
                                    (i.content == null
                                      ? null
                                      : '' + i.content) &&
                                    c.getAttribute('name') ===
                                      (i.name == null ? null : i.name) &&
                                    c.getAttribute('property') ===
                                      (i.property == null
                                        ? null
                                        : i.property) &&
                                    c.getAttribute('http-equiv') ===
                                      (i.httpEquiv == null
                                        ? null
                                        : i.httpEquiv) &&
                                    c.getAttribute('charset') ===
                                      (i.charSet == null ? null : i.charSet))
                                ) {
                                  m.splice(v, 1);
                                  break t;
                                }
                            }
                            ((c = o.createElement(n)),
                              Pe(c, n, i),
                              o.head.appendChild(c));
                            break;
                          default:
                            throw Error(r(468, n));
                        }
                        ((c[et] = e), ke(c), (n = c));
                      }
                      e.stateNode = n;
                    } else ch(o, e.type, e.stateNode);
                  else e.stateNode = oh(o, n, e.memoizedProps);
                else
                  c !== n
                    ? (c === null
                        ? i.stateNode !== null &&
                          ((i = i.stateNode), i.parentNode.removeChild(i))
                        : c.count--,
                      n === null
                        ? ch(o, e.type, e.stateNode)
                        : oh(o, n, e.memoizedProps))
                    : n === null &&
                      e.stateNode !== null &&
                      no(e, e.memoizedProps, i.memoizedProps);
              }
              break;
            case 27:
              (yt(t, e),
                bt(e),
                n & 512 && (Ue || i === null || Gt(i, i.return)),
                i !== null && n & 4 && no(e, e.memoizedProps, i.memoizedProps));
              break;
            case 5:
              if (
                (yt(t, e),
                bt(e),
                n & 512 && (Ue || i === null || Gt(i, i.return)),
                e.flags & 32)
              ) {
                o = e.stateNode;
                try {
                  gn(o, '');
                } catch (R) {
                  ze(e, e.return, R);
                }
              }
              (n & 4 &&
                e.stateNode != null &&
                ((o = e.memoizedProps),
                no(e, o, i !== null ? i.memoizedProps : o)),
                n & 1024 && (so = !0));
              break;
            case 6:
              if ((yt(t, e), bt(e), n & 4)) {
                if (e.stateNode === null) throw Error(r(162));
                ((n = e.memoizedProps), (i = e.stateNode));
                try {
                  i.nodeValue = n;
                } catch (R) {
                  ze(e, e.return, R);
                }
              }
              break;
            case 3:
              if (
                ((os = null),
                (o = Lt),
                (Lt = ss(t.containerInfo)),
                yt(t, e),
                (Lt = o),
                bt(e),
                n & 4 && i !== null && i.memoizedState.isDehydrated)
              )
                try {
                  Ja(t.containerInfo);
                } catch (R) {
                  ze(e, e.return, R);
                }
              so && ((so = !1), gd(e));
              break;
            case 4:
              ((n = Lt),
                (Lt = ss(e.stateNode.containerInfo)),
                yt(t, e),
                bt(e),
                (Lt = n));
              break;
            case 12:
              (yt(t, e), bt(e));
              break;
            case 13:
              (yt(t, e),
                bt(e),
                e.child.flags & 8192 &&
                  (e.memoizedState !== null) !=
                    (i !== null && i.memoizedState !== null) &&
                  (po = Bt()),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), ro(e, n))));
              break;
            case 22:
              o = e.memoizedState !== null;
              var S = i !== null && i.memoizedState !== null,
                N = ei,
                U = Ue;
              if (
                ((ei = N || o),
                (Ue = U || S),
                yt(t, e),
                (Ue = U),
                (ei = N),
                bt(e),
                n & 8192)
              )
                e: for (
                  t = e.stateNode,
                    t._visibility = o ? t._visibility & -2 : t._visibility | 1,
                    o && (i === null || S || ei || Ue || Ii(e)),
                    i = null,
                    t = e;
                  ;
                ) {
                  if (t.tag === 5 || t.tag === 26) {
                    if (i === null) {
                      S = i = t;
                      try {
                        if (((c = S.stateNode), o))
                          ((m = c.style),
                            typeof m.setProperty == 'function'
                              ? m.setProperty('display', 'none', 'important')
                              : (m.display = 'none'));
                        else {
                          v = S.stateNode;
                          var Y = S.memoizedProps.style,
                            C =
                              Y != null && Y.hasOwnProperty('display')
                                ? Y.display
                                : null;
                          v.style.display =
                            C == null || typeof C == 'boolean'
                              ? ''
                              : ('' + C).trim();
                        }
                      } catch (R) {
                        ze(S, S.return, R);
                      }
                    }
                  } else if (t.tag === 6) {
                    if (i === null) {
                      S = t;
                      try {
                        S.stateNode.nodeValue = o ? '' : S.memoizedProps;
                      } catch (R) {
                        ze(S, S.return, R);
                      }
                    }
                  } else if (
                    ((t.tag !== 22 && t.tag !== 23) ||
                      t.memoizedState === null ||
                      t === e) &&
                    t.child !== null
                  ) {
                    ((t.child.return = t), (t = t.child));
                    continue;
                  }
                  if (t === e) break e;
                  for (; t.sibling === null; ) {
                    if (t.return === null || t.return === e) break e;
                    (i === t && (i = null), (t = t.return));
                  }
                  (i === t && (i = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling));
                }
              n & 4 &&
                ((n = e.updateQueue),
                n !== null &&
                  ((i = n.retryQueue),
                  i !== null && ((n.retryQueue = null), ro(e, i))));
              break;
            case 19:
              (yt(t, e),
                bt(e),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), ro(e, n))));
              break;
            case 30:
              break;
            case 21:
              break;
            default:
              (yt(t, e), bt(e));
          }
        }
        function bt(e) {
          var t = e.flags;
          if (t & 2) {
            try {
              for (var i, n = e.return; n !== null; ) {
                if (od(n)) {
                  i = n;
                  break;
                }
                n = n.return;
              }
              if (i == null) throw Error(r(160));
              switch (i.tag) {
                case 27:
                  var o = i.stateNode,
                    c = ao(e);
                  Ql(e, c, o);
                  break;
                case 5:
                  var m = i.stateNode;
                  i.flags & 32 && (gn(m, ''), (i.flags &= -33));
                  var v = ao(e);
                  Ql(e, v, m);
                  break;
                case 3:
                case 4:
                  var S = i.stateNode.containerInfo,
                    N = ao(e);
                  lo(e, N, S);
                  break;
                default:
                  throw Error(r(161));
              }
            } catch (U) {
              ze(e, e.return, U);
            }
            e.flags &= -3;
          }
          t & 4096 && (e.flags &= -4097);
        }
        function gd(e) {
          if (e.subtreeFlags & 1024)
            for (e = e.child; e !== null; ) {
              var t = e;
              (gd(t),
                t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                (e = e.sibling));
            }
        }
        function xi(e, t) {
          if (t.subtreeFlags & 8772)
            for (t = t.child; t !== null; )
              (fd(e, t.alternate, t), (t = t.sibling));
        }
        function Ii(e) {
          for (e = e.child; e !== null; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                (Si(4, t, t.return), Ii(t));
                break;
              case 1:
                Gt(t, t.return);
                var i = t.stateNode;
                (typeof i.componentWillUnmount == 'function' &&
                  sd(t, t.return, i),
                  Ii(t));
                break;
              case 27:
                Ya(t.stateNode);
              case 26:
              case 5:
                (Gt(t, t.return), Ii(t));
                break;
              case 22:
                t.memoizedState === null && Ii(t);
                break;
              case 30:
                Ii(t);
                break;
              default:
                Ii(t);
            }
            e = e.sibling;
          }
        }
        function Ti(e, t, i) {
          for (
            i = i && (t.subtreeFlags & 8772) !== 0, t = t.child;
            t !== null;
          ) {
            var n = t.alternate,
              o = e,
              c = t,
              m = c.flags;
            switch (c.tag) {
              case 0:
              case 11:
              case 15:
                (Ti(o, c, i), Ca(4, c));
                break;
              case 1:
                if (
                  (Ti(o, c, i),
                  (n = c),
                  (o = n.stateNode),
                  typeof o.componentDidMount == 'function')
                )
                  try {
                    o.componentDidMount();
                  } catch (N) {
                    ze(n, n.return, N);
                  }
                if (((n = c), (o = n.updateQueue), o !== null)) {
                  var v = n.stateNode;
                  try {
                    var S = o.shared.hiddenCallbacks;
                    if (S !== null)
                      for (
                        o.shared.hiddenCallbacks = null, o = 0;
                        o < S.length;
                        o++
                      )
                        Kc(S[o], v);
                  } catch (N) {
                    ze(n, n.return, N);
                  }
                }
                (i && m & 64 && ld(c), Ra(c, c.return));
                break;
              case 27:
                ud(c);
              case 26:
              case 5:
                (Ti(o, c, i),
                  i && n === null && m & 4 && rd(c),
                  Ra(c, c.return));
                break;
              case 12:
                Ti(o, c, i);
                break;
              case 13:
                (Ti(o, c, i), i && m & 4 && pd(o, c));
                break;
              case 22:
                (c.memoizedState === null && Ti(o, c, i), Ra(c, c.return));
                break;
              case 30:
                break;
              default:
                Ti(o, c, i);
            }
            t = t.sibling;
          }
        }
        function oo(e, t) {
          var i = null;
          (e !== null &&
            e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (i = e.memoizedState.cachePool.pool),
            (e = null),
            t.memoizedState !== null &&
              t.memoizedState.cachePool !== null &&
              (e = t.memoizedState.cachePool.pool),
            e !== i && (e != null && e.refCount++, i != null && va(i)));
        }
        function uo(e, t) {
          ((e = null),
            t.alternate !== null && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== e && (t.refCount++, e != null && va(e)));
        }
        function Vt(e, t, i, n) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) (vd(e, t, i, n), (t = t.sibling));
        }
        function vd(e, t, i, n) {
          var o = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              (Vt(e, t, i, n), o & 2048 && Ca(9, t));
              break;
            case 1:
              Vt(e, t, i, n);
              break;
            case 3:
              (Vt(e, t, i, n),
                o & 2048 &&
                  ((e = null),
                  t.alternate !== null && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache),
                  t !== e && (t.refCount++, e != null && va(e))));
              break;
            case 12:
              if (o & 2048) {
                (Vt(e, t, i, n), (e = t.stateNode));
                try {
                  var c = t.memoizedProps,
                    m = c.id,
                    v = c.onPostCommit;
                  typeof v == 'function' &&
                    v(
                      m,
                      t.alternate === null ? 'mount' : 'update',
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (S) {
                  ze(t, t.return, S);
                }
              } else Vt(e, t, i, n);
              break;
            case 13:
              Vt(e, t, i, n);
              break;
            case 23:
              break;
            case 22:
              ((c = t.stateNode),
                (m = t.alternate),
                t.memoizedState !== null
                  ? c._visibility & 2
                    ? Vt(e, t, i, n)
                    : Da(e, t)
                  : c._visibility & 2
                    ? Vt(e, t, i, n)
                    : ((c._visibility |= 2),
                      jn(e, t, i, n, (t.subtreeFlags & 10256) !== 0)),
                o & 2048 && oo(m, t));
              break;
            case 24:
              (Vt(e, t, i, n), o & 2048 && uo(t.alternate, t));
              break;
            default:
              Vt(e, t, i, n);
          }
        }
        function jn(e, t, i, n, o) {
          for (
            o = o && (t.subtreeFlags & 10256) !== 0, t = t.child;
            t !== null;
          ) {
            var c = e,
              m = t,
              v = i,
              S = n,
              N = m.flags;
            switch (m.tag) {
              case 0:
              case 11:
              case 15:
                (jn(c, m, v, S, o), Ca(8, m));
                break;
              case 23:
                break;
              case 22:
                var U = m.stateNode;
                (m.memoizedState !== null
                  ? U._visibility & 2
                    ? jn(c, m, v, S, o)
                    : Da(c, m)
                  : ((U._visibility |= 2), jn(c, m, v, S, o)),
                  o && N & 2048 && oo(m.alternate, m));
                break;
              case 24:
                (jn(c, m, v, S, o), o && N & 2048 && uo(m.alternate, m));
                break;
              default:
                jn(c, m, v, S, o);
            }
            t = t.sibling;
          }
        }
        function Da(e, t) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) {
              var i = e,
                n = t,
                o = n.flags;
              switch (n.tag) {
                case 22:
                  (Da(i, n), o & 2048 && oo(n.alternate, n));
                  break;
                case 24:
                  (Da(i, n), o & 2048 && uo(n.alternate, n));
                  break;
                default:
                  Da(i, n);
              }
              t = t.sibling;
            }
        }
        var La = 8192;
        function Bn(e) {
          if (e.subtreeFlags & La)
            for (e = e.child; e !== null; ) (yd(e), (e = e.sibling));
        }
        function yd(e) {
          switch (e.tag) {
            case 26:
              (Bn(e),
                e.flags & La &&
                  e.memoizedState !== null &&
                  Fg(Lt, e.memoizedState, e.memoizedProps));
              break;
            case 5:
              Bn(e);
              break;
            case 3:
            case 4:
              var t = Lt;
              ((Lt = ss(e.stateNode.containerInfo)), Bn(e), (Lt = t));
              break;
            case 22:
              e.memoizedState === null &&
                ((t = e.alternate),
                t !== null && t.memoizedState !== null
                  ? ((t = La), (La = 16777216), Bn(e), (La = t))
                  : Bn(e));
              break;
            default:
              Bn(e);
          }
        }
        function bd(e) {
          var t = e.alternate;
          if (t !== null && ((e = t.child), e !== null)) {
            t.child = null;
            do ((t = e.sibling), (e.sibling = null), (e = t));
            while (e !== null);
          }
        }
        function ja(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                ((Qe = n), xd(n, e));
              }
            bd(e);
          }
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null; ) (Sd(e), (e = e.sibling));
        }
        function Sd(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              (ja(e), e.flags & 2048 && Si(9, e, e.return));
              break;
            case 3:
              ja(e);
              break;
            case 12:
              ja(e);
              break;
            case 22:
              var t = e.stateNode;
              e.memoizedState !== null &&
              t._visibility & 2 &&
              (e.return === null || e.return.tag !== 13)
                ? ((t._visibility &= -3), Zl(e))
                : ja(e);
              break;
            default:
              ja(e);
          }
        }
        function Zl(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                ((Qe = n), xd(n, e));
              }
            bd(e);
          }
          for (e = e.child; e !== null; ) {
            switch (((t = e), t.tag)) {
              case 0:
              case 11:
              case 15:
                (Si(8, t, t.return), Zl(t));
                break;
              case 22:
                ((i = t.stateNode),
                  i._visibility & 2 && ((i._visibility &= -3), Zl(t)));
                break;
              default:
                Zl(t);
            }
            e = e.sibling;
          }
        }
        function xd(e, t) {
          for (; Qe !== null; ) {
            var i = Qe;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                Si(8, i, t);
                break;
              case 23:
              case 22:
                if (
                  i.memoizedState !== null &&
                  i.memoizedState.cachePool !== null
                ) {
                  var n = i.memoizedState.cachePool.pool;
                  n != null && n.refCount++;
                }
                break;
              case 24:
                va(i.memoizedState.cache);
            }
            if (((n = i.child), n !== null)) ((n.return = i), (Qe = n));
            else
              e: for (i = e; Qe !== null; ) {
                n = Qe;
                var o = n.sibling,
                  c = n.return;
                if ((dd(n), n === i)) {
                  Qe = null;
                  break e;
                }
                if (o !== null) {
                  ((o.return = c), (Qe = o));
                  break e;
                }
                Qe = c;
              }
          }
        }
        var dg = {
            getCacheForType: function (e) {
              var t = tt(Ye),
                i = t.data.get(e);
              return (i === void 0 && ((i = e()), t.data.set(e, i)), i);
            },
          },
          hg = typeof WeakMap == 'function' ? WeakMap : Map,
          we = 0,
          Ne = null,
          ve = null,
          be = 0,
          Ae = 0,
          St = null,
          Ei = !1,
          Hn = !1,
          co = !1,
          ii = 0,
          je = 0,
          wi = 0,
          Pi = 0,
          fo = 0,
          Ct = 0,
          Un = 0,
          Ba = null,
          ct = null,
          ho = !1,
          po = 0,
          Jl = 1 / 0,
          Fl = null,
          Ai = null,
          Ie = 0,
          Mi = null,
          Gn = null,
          Vn = 0,
          mo = 0,
          go = null,
          Td = null,
          Ha = 0,
          vo = null;
        function xt() {
          if ((we & 2) !== 0 && be !== 0) return be & -be;
          if (D.T !== null) {
            var e = On;
            return e !== 0 ? e : wo();
          }
          return Hu();
        }
        function Ed() {
          Ct === 0 && (Ct = (be & 536870912) === 0 || Te ? Du() : 536870912);
          var e = Nt.current;
          return (e !== null && (e.flags |= 32), Ct);
        }
        function Tt(e, t, i) {
          (((e === Ne && (Ae === 2 || Ae === 9)) ||
            e.cancelPendingCommit !== null) &&
            (Yn(e, 0), Oi(e, be, Ct, !1)),
            ta(e, i),
            ((we & 2) === 0 || e !== Ne) &&
              (e === Ne &&
                ((we & 2) === 0 && (Pi |= i), je === 4 && Oi(e, be, Ct, !1)),
              Yt(e)));
        }
        function wd(e, t, i) {
          if ((we & 6) !== 0) throw Error(r(327));
          var n =
              (!i && (t & 124) === 0 && (t & e.expiredLanes) === 0) || ea(e, t),
            o = n ? gg(e, t) : So(e, t, !0),
            c = n;
          do {
            if (o === 0) {
              Hn && !n && Oi(e, t, 0, !1);
              break;
            } else {
              if (((i = e.current.alternate), c && !pg(i))) {
                ((o = So(e, t, !1)), (c = !1));
                continue;
              }
              if (o === 2) {
                if (((c = t), e.errorRecoveryDisabledLanes & c)) var m = 0;
                else
                  ((m = e.pendingLanes & -536870913),
                    (m = m !== 0 ? m : m & 536870912 ? 536870912 : 0));
                if (m !== 0) {
                  t = m;
                  e: {
                    var v = e;
                    o = Ba;
                    var S = v.current.memoizedState.isDehydrated;
                    if (
                      (S && (Yn(v, m).flags |= 256),
                      (m = So(v, m, !1)),
                      m !== 2)
                    ) {
                      if (co && !S) {
                        ((v.errorRecoveryDisabledLanes |= c),
                          (Pi |= c),
                          (o = 4));
                        break e;
                      }
                      ((c = ct),
                        (ct = o),
                        c !== null &&
                          (ct === null ? (ct = c) : ct.push.apply(ct, c)));
                    }
                    o = m;
                  }
                  if (((c = !1), o !== 2)) continue;
                }
              }
              if (o === 1) {
                (Yn(e, 0), Oi(e, t, 0, !0));
                break;
              }
              e: {
                switch (((n = e), (c = o), c)) {
                  case 0:
                  case 1:
                    throw Error(r(345));
                  case 4:
                    if ((t & 4194048) !== t) break;
                  case 6:
                    Oi(n, t, Ct, !Ei);
                    break e;
                  case 2:
                    ct = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(r(329));
                }
                if ((t & 62914560) === t && ((o = po + 300 - Bt()), 10 < o)) {
                  if ((Oi(n, t, Ct, !Ei), rl(n, 0, !0) !== 0)) break e;
                  n.timeoutHandle = Wd(
                    Ad.bind(
                      null,
                      n,
                      i,
                      ct,
                      Fl,
                      ho,
                      t,
                      Ct,
                      Pi,
                      Un,
                      Ei,
                      c,
                      2,
                      -0,
                      0
                    ),
                    o
                  );
                  break e;
                }
                Ad(n, i, ct, Fl, ho, t, Ct, Pi, Un, Ei, c, 0, -0, 0);
              }
            }
            break;
          } while (!0);
          Yt(e);
        }
        function Ad(e, t, i, n, o, c, m, v, S, N, U, Y, C, R) {
          if (
            ((e.timeoutHandle = -1),
            (Y = t.subtreeFlags),
            (Y & 8192 || (Y & 16785408) === 16785408) &&
              ((Ka = { stylesheets: null, count: 0, unsuspend: Jg }),
              yd(t),
              (Y = Ig()),
              Y !== null))
          ) {
            ((e.cancelPendingCommit = Y(
              Rd.bind(null, e, t, c, i, n, o, m, v, S, U, 1, C, R)
            )),
              Oi(e, c, m, !N));
            return;
          }
          Rd(e, t, c, i, n, o, m, v, S);
        }
        function pg(e) {
          for (var t = e; ; ) {
            var i = t.tag;
            if (
              (i === 0 || i === 11 || i === 15) &&
              t.flags & 16384 &&
              ((i = t.updateQueue), i !== null && ((i = i.stores), i !== null))
            )
              for (var n = 0; n < i.length; n++) {
                var o = i[n],
                  c = o.getSnapshot;
                o = o.value;
                try {
                  if (!gt(c(), o)) return !1;
                } catch {
                  return !1;
                }
              }
            if (((i = t.child), t.subtreeFlags & 16384 && i !== null))
              ((i.return = t), (t = i));
            else {
              if (t === e) break;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e) return !0;
                t = t.return;
              }
              ((t.sibling.return = t.return), (t = t.sibling));
            }
          }
          return !0;
        }
        function Oi(e, t, i, n) {
          ((t &= ~fo),
            (t &= ~Pi),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            n && (e.warmLanes |= t),
            (n = e.expirationTimes));
          for (var o = t; 0 < o; ) {
            var c = 31 - mt(o),
              m = 1 << c;
            ((n[c] = -1), (o &= ~m));
          }
          i !== 0 && ju(e, i, t);
        }
        function Il() {
          return (we & 6) === 0 ? (Ua(0), !1) : !0;
        }
        function yo() {
          if (ve !== null) {
            if (Ae === 0) var e = ve.return;
            else
              ((e = ve),
                (Zt = Xi = null),
                Lr(e),
                (Dn = null),
                (_a = 0),
                (e = ve));
            for (; e !== null; ) (ad(e.alternate, e), (e = e.return));
            ve = null;
          }
        }
        function Yn(e, t) {
          var i = e.timeoutHandle;
          (i !== -1 && ((e.timeoutHandle = -1), Rg(i)),
            (i = e.cancelPendingCommit),
            i !== null && ((e.cancelPendingCommit = null), i()),
            yo(),
            (Ne = e),
            (ve = i = kt(e.current, null)),
            (be = t),
            (Ae = 0),
            (St = null),
            (Ei = !1),
            (Hn = ea(e, t)),
            (co = !1),
            (Un = Ct = fo = Pi = wi = je = 0),
            (ct = Ba = null),
            (ho = !1),
            (t & 8) !== 0 && (t |= t & 32));
          var n = e.entangledLanes;
          if (n !== 0)
            for (e = e.entanglements, n &= t; 0 < n; ) {
              var o = 31 - mt(n),
                c = 1 << o;
              ((t |= e[o]), (n &= ~c));
            }
          return ((ii = t), bl(), i);
        }
        function Md(e, t) {
          ((me = null),
            (D.H = Ul),
            t === ba || t === _l
              ? ((t = qc()), (Ae = 3))
              : t === Gc
                ? ((t = qc()), (Ae = 4))
                : (Ae =
                    t === Kf
                      ? 8
                      : t !== null &&
                          typeof t == 'object' &&
                          typeof t.then == 'function'
                        ? 6
                        : 1),
            (St = t),
            ve === null && ((je = 1), $l(e, Mt(t, e.current))));
        }
        function Od() {
          var e = D.H;
          return ((D.H = Ul), e === null ? Ul : e);
        }
        function _d() {
          var e = D.A;
          return ((D.A = dg), e);
        }
        function bo() {
          ((je = 4),
            Ei || ((be & 4194048) !== be && Nt.current !== null) || (Hn = !0),
            ((wi & 134217727) === 0 && (Pi & 134217727) === 0) ||
              Ne === null ||
              Oi(Ne, be, Ct, !1));
        }
        function So(e, t, i) {
          var n = we;
          we |= 2;
          var o = Od(),
            c = _d();
          ((Ne !== e || be !== t) && ((Fl = null), Yn(e, t)), (t = !1));
          var m = je;
          e: do
            try {
              if (Ae !== 0 && ve !== null) {
                var v = ve,
                  S = St;
                switch (Ae) {
                  case 8:
                    (yo(), (m = 6));
                    break e;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    Nt.current === null && (t = !0);
                    var N = Ae;
                    if (((Ae = 0), (St = null), qn(e, v, S, N), i && Hn)) {
                      m = 0;
                      break e;
                    }
                    break;
                  default:
                    ((N = Ae), (Ae = 0), (St = null), qn(e, v, S, N));
                }
              }
              (mg(), (m = je));
              break;
            } catch (U) {
              Md(e, U);
            }
          while (!0);
          return (
            t && e.shellSuspendCounter++,
            (Zt = Xi = null),
            (we = n),
            (D.H = o),
            (D.A = c),
            ve === null && ((Ne = null), (be = 0), bl()),
            m
          );
        }
        function mg() {
          for (; ve !== null; ) zd(ve);
        }
        function gg(e, t) {
          var i = we;
          we |= 2;
          var n = Od(),
            o = _d();
          Ne !== e || be !== t
            ? ((Fl = null), (Jl = Bt() + 500), Yn(e, t))
            : (Hn = ea(e, t));
          e: do
            try {
              if (Ae !== 0 && ve !== null) {
                t = ve;
                var c = St;
                t: switch (Ae) {
                  case 1:
                    ((Ae = 0), (St = null), qn(e, t, c, 1));
                    break;
                  case 2:
                  case 9:
                    if (Vc(c)) {
                      ((Ae = 0), (St = null), Nd(t));
                      break;
                    }
                    ((t = function () {
                      ((Ae !== 2 && Ae !== 9) || Ne !== e || (Ae = 7), Yt(e));
                    }),
                      c.then(t, t));
                    break e;
                  case 3:
                    Ae = 7;
                    break e;
                  case 4:
                    Ae = 5;
                    break e;
                  case 7:
                    Vc(c)
                      ? ((Ae = 0), (St = null), Nd(t))
                      : ((Ae = 0), (St = null), qn(e, t, c, 7));
                    break;
                  case 5:
                    var m = null;
                    switch (ve.tag) {
                      case 26:
                        m = ve.memoizedState;
                      case 5:
                      case 27:
                        var v = ve;
                        if (!m || fh(m)) {
                          ((Ae = 0), (St = null));
                          var S = v.sibling;
                          if (S !== null) ve = S;
                          else {
                            var N = v.return;
                            N !== null ? ((ve = N), Pl(N)) : (ve = null);
                          }
                          break t;
                        }
                    }
                    ((Ae = 0), (St = null), qn(e, t, c, 5));
                    break;
                  case 6:
                    ((Ae = 0), (St = null), qn(e, t, c, 6));
                    break;
                  case 8:
                    (yo(), (je = 6));
                    break e;
                  default:
                    throw Error(r(462));
                }
              }
              vg();
              break;
            } catch (U) {
              Md(e, U);
            }
          while (!0);
          return (
            (Zt = Xi = null),
            (D.H = n),
            (D.A = o),
            (we = i),
            ve !== null ? 0 : ((Ne = null), (be = 0), bl(), je)
          );
        }
        function vg() {
          for (; ve !== null && !Gp(); ) zd(ve);
        }
        function zd(e) {
          var t = id(e.alternate, e, ii);
          ((e.memoizedProps = e.pendingProps), t === null ? Pl(e) : (ve = t));
        }
        function Nd(e) {
          var t = e,
            i = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Ff(i, t, t.pendingProps, t.type, void 0, be);
              break;
            case 11:
              t = Ff(i, t, t.pendingProps, t.type.render, t.ref, be);
              break;
            case 5:
              Lr(t);
            default:
              (ad(i, t), (t = ve = Nc(t, ii)), (t = id(i, t, ii)));
          }
          ((e.memoizedProps = e.pendingProps), t === null ? Pl(e) : (ve = t));
        }
        function qn(e, t, i, n) {
          ((Zt = Xi = null), Lr(t), (Dn = null), (_a = 0));
          var o = t.return;
          try {
            if (sg(e, o, t, i, be)) {
              ((je = 1), $l(e, Mt(i, e.current)), (ve = null));
              return;
            }
          } catch (c) {
            if (o !== null) throw ((ve = o), c);
            ((je = 1), $l(e, Mt(i, e.current)), (ve = null));
            return;
          }
          t.flags & 32768
            ? (Te || n === 1
                ? (e = !0)
                : Hn || (be & 536870912) !== 0
                  ? (e = !1)
                  : ((Ei = e = !0),
                    (n === 2 || n === 9 || n === 3 || n === 6) &&
                      ((n = Nt.current),
                      n !== null && n.tag === 13 && (n.flags |= 16384))),
              Cd(t, e))
            : Pl(t);
        }
        function Pl(e) {
          var t = e;
          do {
            if ((t.flags & 32768) !== 0) {
              Cd(t, Ei);
              return;
            }
            e = t.return;
            var i = og(t.alternate, t, ii);
            if (i !== null) {
              ve = i;
              return;
            }
            if (((t = t.sibling), t !== null)) {
              ve = t;
              return;
            }
            ve = t = e;
          } while (t !== null);
          je === 0 && (je = 5);
        }
        function Cd(e, t) {
          do {
            var i = ug(e.alternate, e);
            if (i !== null) {
              ((i.flags &= 32767), (ve = i));
              return;
            }
            if (
              ((i = e.return),
              i !== null &&
                ((i.flags |= 32768),
                (i.subtreeFlags = 0),
                (i.deletions = null)),
              !t && ((e = e.sibling), e !== null))
            ) {
              ve = e;
              return;
            }
            ve = e = i;
          } while (e !== null);
          ((je = 6), (ve = null));
        }
        function Rd(e, t, i, n, o, c, m, v, S) {
          e.cancelPendingCommit = null;
          do Wl();
          while (Ie !== 0);
          if ((we & 6) !== 0) throw Error(r(327));
          if (t !== null) {
            if (t === e.current) throw Error(r(177));
            if (
              ((c = t.lanes | t.childLanes),
              (c |= ur),
              Jp(e, i, c, m, v, S),
              e === Ne && ((ve = Ne = null), (be = 0)),
              (Gn = t),
              (Mi = e),
              (Vn = i),
              (mo = c),
              (go = o),
              (Td = n),
              (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                ? ((e.callbackNode = null),
                  (e.callbackPriority = 0),
                  xg(al, function () {
                    return (Hd(), null);
                  }))
                : ((e.callbackNode = null), (e.callbackPriority = 0)),
              (n = (t.flags & 13878) !== 0),
              (t.subtreeFlags & 13878) !== 0 || n)
            ) {
              ((n = D.T),
                (D.T = null),
                (o = X.p),
                (X.p = 2),
                (m = we),
                (we |= 4));
              try {
                cg(e, t);
              } finally {
                ((we = m), (X.p = o), (D.T = n));
              }
            }
            ((Ie = 1), Dd(), Ld(), jd());
          }
        }
        function Dd() {
          if (Ie === 1) {
            Ie = 0;
            var e = Mi,
              t = Gn,
              i = (t.flags & 13878) !== 0;
            if ((t.subtreeFlags & 13878) !== 0 || i) {
              ((i = D.T), (D.T = null));
              var n = X.p;
              X.p = 2;
              var o = we;
              we |= 4;
              try {
                md(t, e);
                var c = Ro,
                  m = Sc(e.containerInfo),
                  v = c.focusedElem,
                  S = c.selectionRange;
                if (
                  m !== v &&
                  v &&
                  v.ownerDocument &&
                  bc(v.ownerDocument.documentElement, v)
                ) {
                  if (S !== null && ar(v)) {
                    var N = S.start,
                      U = S.end;
                    if ((U === void 0 && (U = N), 'selectionStart' in v))
                      ((v.selectionStart = N),
                        (v.selectionEnd = Math.min(U, v.value.length)));
                    else {
                      var Y = v.ownerDocument || document,
                        C = (Y && Y.defaultView) || window;
                      if (C.getSelection) {
                        var R = C.getSelection(),
                          ce = v.textContent.length,
                          se = Math.min(S.start, ce),
                          _e = S.end === void 0 ? se : Math.min(S.end, ce);
                        !R.extend && se > _e && ((m = _e), (_e = se), (se = m));
                        var M = yc(v, se),
                          E = yc(v, _e);
                        if (
                          M &&
                          E &&
                          (R.rangeCount !== 1 ||
                            R.anchorNode !== M.node ||
                            R.anchorOffset !== M.offset ||
                            R.focusNode !== E.node ||
                            R.focusOffset !== E.offset)
                        ) {
                          var z = Y.createRange();
                          (z.setStart(M.node, M.offset),
                            R.removeAllRanges(),
                            se > _e
                              ? (R.addRange(z), R.extend(E.node, E.offset))
                              : (z.setEnd(E.node, E.offset), R.addRange(z)));
                        }
                      }
                    }
                  }
                  for (Y = [], R = v; (R = R.parentNode); )
                    R.nodeType === 1 &&
                      Y.push({
                        element: R,
                        left: R.scrollLeft,
                        top: R.scrollTop,
                      });
                  for (
                    typeof v.focus == 'function' && v.focus(), v = 0;
                    v < Y.length;
                    v++
                  ) {
                    var V = Y[v];
                    ((V.element.scrollLeft = V.left),
                      (V.element.scrollTop = V.top));
                  }
                }
                ((fs = !!Co), (Ro = Co = null));
              } finally {
                ((we = o), (X.p = n), (D.T = i));
              }
            }
            ((e.current = t), (Ie = 2));
          }
        }
        function Ld() {
          if (Ie === 2) {
            Ie = 0;
            var e = Mi,
              t = Gn,
              i = (t.flags & 8772) !== 0;
            if ((t.subtreeFlags & 8772) !== 0 || i) {
              ((i = D.T), (D.T = null));
              var n = X.p;
              X.p = 2;
              var o = we;
              we |= 4;
              try {
                fd(e, t.alternate, t);
              } finally {
                ((we = o), (X.p = n), (D.T = i));
              }
            }
            Ie = 3;
          }
        }
        function jd() {
          if (Ie === 4 || Ie === 3) {
            ((Ie = 0), Vp());
            var e = Mi,
              t = Gn,
              i = Vn,
              n = Td;
            (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
              ? (Ie = 5)
              : ((Ie = 0), (Gn = Mi = null), Bd(e, e.pendingLanes));
            var o = e.pendingLanes;
            if (
              (o === 0 && (Ai = null),
              Hs(i),
              (t = t.stateNode),
              pt && typeof pt.onCommitFiberRoot == 'function')
            )
              try {
                pt.onCommitFiberRoot(
                  Wn,
                  t,
                  void 0,
                  (t.current.flags & 128) === 128
                );
              } catch {}
            if (n !== null) {
              ((t = D.T), (o = X.p), (X.p = 2), (D.T = null));
              try {
                for (var c = e.onRecoverableError, m = 0; m < n.length; m++) {
                  var v = n[m];
                  c(v.value, { componentStack: v.stack });
                }
              } finally {
                ((D.T = t), (X.p = o));
              }
            }
            ((Vn & 3) !== 0 && Wl(),
              Yt(e),
              (o = e.pendingLanes),
              (i & 4194090) !== 0 && (o & 42) !== 0
                ? e === vo
                  ? Ha++
                  : ((Ha = 0), (vo = e))
                : (Ha = 0),
              Ua(0));
          }
        }
        function Bd(e, t) {
          (e.pooledCacheLanes &= t) === 0 &&
            ((t = e.pooledCache), t != null && ((e.pooledCache = null), va(t)));
        }
        function Wl(e) {
          return (Dd(), Ld(), jd(), Hd());
        }
        function Hd() {
          if (Ie !== 5) return !1;
          var e = Mi,
            t = mo;
          mo = 0;
          var i = Hs(Vn),
            n = D.T,
            o = X.p;
          try {
            ((X.p = 32 > i ? 32 : i), (D.T = null), (i = go), (go = null));
            var c = Mi,
              m = Vn;
            if (((Ie = 0), (Gn = Mi = null), (Vn = 0), (we & 6) !== 0))
              throw Error(r(331));
            var v = we;
            if (
              ((we |= 4),
              Sd(c.current),
              vd(c, c.current, m, i),
              (we = v),
              Ua(0),
              pt && typeof pt.onPostCommitFiberRoot == 'function')
            )
              try {
                pt.onPostCommitFiberRoot(Wn, c);
              } catch {}
            return !0;
          } finally {
            ((X.p = o), (D.T = n), Bd(e, t));
          }
        }
        function Ud(e, t, i) {
          ((t = Mt(i, t)),
            (t = Zr(e.stateNode, t, 2)),
            (e = gi(e, t, 2)),
            e !== null && (ta(e, 2), Yt(e)));
        }
        function ze(e, t, i) {
          if (e.tag === 3) Ud(e, e, i);
          else
            for (; t !== null; ) {
              if (t.tag === 3) {
                Ud(t, e, i);
                break;
              } else if (t.tag === 1) {
                var n = t.stateNode;
                if (
                  typeof t.type.getDerivedStateFromError == 'function' ||
                  (typeof n.componentDidCatch == 'function' &&
                    (Ai === null || !Ai.has(n)))
                ) {
                  ((e = Mt(i, e)),
                    (i = qf(2)),
                    (n = gi(t, i, 2)),
                    n !== null && ($f(i, n, t, e), ta(n, 2), Yt(n)));
                  break;
                }
              }
              t = t.return;
            }
        }
        function xo(e, t, i) {
          var n = e.pingCache;
          if (n === null) {
            n = e.pingCache = new hg();
            var o = new Set();
            n.set(t, o);
          } else
            ((o = n.get(t)), o === void 0 && ((o = new Set()), n.set(t, o)));
          o.has(i) ||
            ((co = !0), o.add(i), (e = yg.bind(null, e, t, i)), t.then(e, e));
        }
        function yg(e, t, i) {
          var n = e.pingCache;
          (n !== null && n.delete(t),
            (e.pingedLanes |= e.suspendedLanes & i),
            (e.warmLanes &= ~i),
            Ne === e &&
              (be & i) === i &&
              (je === 4 ||
              (je === 3 && (be & 62914560) === be && 300 > Bt() - po)
                ? (we & 2) === 0 && Yn(e, 0)
                : (fo |= i),
              Un === be && (Un = 0)),
            Yt(e));
        }
        function Gd(e, t) {
          (t === 0 && (t = Lu()),
            (e = En(e, t)),
            e !== null && (ta(e, t), Yt(e)));
        }
        function bg(e) {
          var t = e.memoizedState,
            i = 0;
          (t !== null && (i = t.retryLane), Gd(e, i));
        }
        function Sg(e, t) {
          var i = 0;
          switch (e.tag) {
            case 13:
              var n = e.stateNode,
                o = e.memoizedState;
              o !== null && (i = o.retryLane);
              break;
            case 19:
              n = e.stateNode;
              break;
            case 22:
              n = e.stateNode._retryCache;
              break;
            default:
              throw Error(r(314));
          }
          (n !== null && n.delete(t), Gd(e, i));
        }
        function xg(e, t) {
          return Ds(e, t);
        }
        var es = null,
          $n = null,
          To = !1,
          ts = !1,
          Eo = !1,
          Wi = 0;
        function Yt(e) {
          (e !== $n &&
            e.next === null &&
            ($n === null ? (es = $n = e) : ($n = $n.next = e)),
            (ts = !0),
            To || ((To = !0), Eg()));
        }
        function Ua(e, t) {
          if (!Eo && ts) {
            Eo = !0;
            do
              for (var i = !1, n = es; n !== null; ) {
                if (e !== 0) {
                  var o = n.pendingLanes;
                  if (o === 0) var c = 0;
                  else {
                    var m = n.suspendedLanes,
                      v = n.pingedLanes;
                    ((c = (1 << (31 - mt(42 | e) + 1)) - 1),
                      (c &= o & ~(m & ~v)),
                      (c =
                        c & 201326741 ? (c & 201326741) | 1 : c ? c | 2 : 0));
                  }
                  c !== 0 && ((i = !0), $d(n, c));
                } else
                  ((c = be),
                    (c = rl(
                      n,
                      n === Ne ? c : 0,
                      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
                    )),
                    (c & 3) === 0 || ea(n, c) || ((i = !0), $d(n, c)));
                n = n.next;
              }
            while (i);
            Eo = !1;
          }
        }
        function Tg() {
          Vd();
        }
        function Vd() {
          ts = To = !1;
          var e = 0;
          Wi !== 0 && (Cg() && (e = Wi), (Wi = 0));
          for (var t = Bt(), i = null, n = es; n !== null; ) {
            var o = n.next,
              c = Yd(n, t);
            (c === 0
              ? ((n.next = null),
                i === null ? (es = o) : (i.next = o),
                o === null && ($n = i))
              : ((i = n), (e !== 0 || (c & 3) !== 0) && (ts = !0)),
              (n = o));
          }
          Ua(e);
        }
        function Yd(e, t) {
          for (
            var i = e.suspendedLanes,
              n = e.pingedLanes,
              o = e.expirationTimes,
              c = e.pendingLanes & -62914561;
            0 < c;
          ) {
            var m = 31 - mt(c),
              v = 1 << m,
              S = o[m];
            (S === -1
              ? ((v & i) === 0 || (v & n) !== 0) && (o[m] = Zp(v, t))
              : S <= t && (e.expiredLanes |= v),
              (c &= ~v));
          }
          if (
            ((t = Ne),
            (i = be),
            (i = rl(
              e,
              e === t ? i : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            (n = e.callbackNode),
            i === 0 ||
              (e === t && (Ae === 2 || Ae === 9)) ||
              e.cancelPendingCommit !== null)
          )
            return (
              n !== null && n !== null && Ls(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if ((i & 3) === 0 || ea(e, i)) {
            if (((t = i & -i), t === e.callbackPriority)) return t;
            switch ((n !== null && Ls(n), Hs(i))) {
              case 2:
              case 8:
                i = Cu;
                break;
              case 32:
                i = al;
                break;
              case 268435456:
                i = Ru;
                break;
              default:
                i = al;
            }
            return (
              (n = qd.bind(null, e)),
              (i = Ds(i, n)),
              (e.callbackPriority = t),
              (e.callbackNode = i),
              t
            );
          }
          return (
            n !== null && n !== null && Ls(n),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function qd(e, t) {
          if (Ie !== 0 && Ie !== 5)
            return ((e.callbackNode = null), (e.callbackPriority = 0), null);
          var i = e.callbackNode;
          if (Wl() && e.callbackNode !== i) return null;
          var n = be;
          return (
            (n = rl(
              e,
              e === Ne ? n : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            n === 0
              ? null
              : (wd(e, n, t),
                Yd(e, Bt()),
                e.callbackNode != null && e.callbackNode === i
                  ? qd.bind(null, e)
                  : null)
          );
        }
        function $d(e, t) {
          if (Wl()) return null;
          wd(e, t, !0);
        }
        function Eg() {
          Dg(function () {
            (we & 6) !== 0 ? Ds(Nu, Tg) : Vd();
          });
        }
        function wo() {
          return (Wi === 0 && (Wi = Du()), Wi);
        }
        function Kd(e) {
          return e == null || typeof e == 'symbol' || typeof e == 'boolean'
            ? null
            : typeof e == 'function'
              ? e
              : dl('' + e);
        }
        function kd(e, t) {
          var i = t.ownerDocument.createElement('input');
          return (
            (i.name = t.name),
            (i.value = t.value),
            e.id && i.setAttribute('form', e.id),
            t.parentNode.insertBefore(i, t),
            (e = new FormData(e)),
            i.parentNode.removeChild(i),
            e
          );
        }
        function wg(e, t, i, n, o) {
          if (t === 'submit' && i && i.stateNode === o) {
            var c = Kd((o[st] || null).action),
              m = n.submitter;
            m &&
              ((t = (t = m[st] || null)
                ? Kd(t.formAction)
                : m.getAttribute('formAction')),
              t !== null && ((c = t), (m = null)));
            var v = new gl('action', 'action', null, n, o);
            e.push({
              event: v,
              listeners: [
                {
                  instance: null,
                  listener: function () {
                    if (n.defaultPrevented) {
                      if (Wi !== 0) {
                        var S = m ? kd(o, m) : new FormData(o);
                        $r(
                          i,
                          { pending: !0, data: S, method: o.method, action: c },
                          null,
                          S
                        );
                      }
                    } else
                      typeof c == 'function' &&
                        (v.preventDefault(),
                        (S = m ? kd(o, m) : new FormData(o)),
                        $r(
                          i,
                          { pending: !0, data: S, method: o.method, action: c },
                          c,
                          S
                        ));
                  },
                  currentTarget: o,
                },
              ],
            });
          }
        }
        for (var Ao = 0; Ao < or.length; Ao++) {
          var Mo = or[Ao],
            Ag = Mo.toLowerCase(),
            Mg = Mo[0].toUpperCase() + Mo.slice(1);
          Dt(Ag, 'on' + Mg);
        }
        (Dt(Ec, 'onAnimationEnd'),
          Dt(wc, 'onAnimationIteration'),
          Dt(Ac, 'onAnimationStart'),
          Dt('dblclick', 'onDoubleClick'),
          Dt('focusin', 'onFocus'),
          Dt('focusout', 'onBlur'),
          Dt($m, 'onTransitionRun'),
          Dt(Km, 'onTransitionStart'),
          Dt(km, 'onTransitionCancel'),
          Dt(Mc, 'onTransitionEnd'),
          hn('onMouseEnter', ['mouseout', 'mouseover']),
          hn('onMouseLeave', ['mouseout', 'mouseover']),
          hn('onPointerEnter', ['pointerout', 'pointerover']),
          hn('onPointerLeave', ['pointerout', 'pointerover']),
          Hi(
            'onChange',
            'change click focusin focusout input keydown keyup selectionchange'.split(
              ' '
            )
          ),
          Hi(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
              ' '
            )
          ),
          Hi('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste',
          ]),
          Hi(
            'onCompositionEnd',
            'compositionend focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Hi(
            'onCompositionStart',
            'compositionstart focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Hi(
            'onCompositionUpdate',
            'compositionupdate focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ));
        var Ga =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          Og = new Set(
            'beforetoggle cancel close invalid load scroll scrollend toggle'
              .split(' ')
              .concat(Ga)
          );
        function Xd(e, t) {
          t = (t & 4) !== 0;
          for (var i = 0; i < e.length; i++) {
            var n = e[i],
              o = n.event;
            n = n.listeners;
            e: {
              var c = void 0;
              if (t)
                for (var m = n.length - 1; 0 <= m; m--) {
                  var v = n[m],
                    S = v.instance,
                    N = v.currentTarget;
                  if (((v = v.listener), S !== c && o.isPropagationStopped()))
                    break e;
                  ((c = v), (o.currentTarget = N));
                  try {
                    c(o);
                  } catch (U) {
                    ql(U);
                  }
                  ((o.currentTarget = null), (c = S));
                }
              else
                for (m = 0; m < n.length; m++) {
                  if (
                    ((v = n[m]),
                    (S = v.instance),
                    (N = v.currentTarget),
                    (v = v.listener),
                    S !== c && o.isPropagationStopped())
                  )
                    break e;
                  ((c = v), (o.currentTarget = N));
                  try {
                    c(o);
                  } catch (U) {
                    ql(U);
                  }
                  ((o.currentTarget = null), (c = S));
                }
            }
          }
        }
        function ye(e, t) {
          var i = t[Us];
          i === void 0 && (i = t[Us] = new Set());
          var n = e + '__bubble';
          i.has(n) || (Qd(t, e, 2, !1), i.add(n));
        }
        function Oo(e, t, i) {
          var n = 0;
          (t && (n |= 4), Qd(i, e, n, t));
        }
        var is = '_reactListening' + Math.random().toString(36).slice(2);
        function _o(e) {
          if (!e[is]) {
            ((e[is] = !0),
              Gu.forEach(function (i) {
                i !== 'selectionchange' &&
                  (Og.has(i) || Oo(i, !1, e), Oo(i, !0, e));
              }));
            var t = e.nodeType === 9 ? e : e.ownerDocument;
            t === null || t[is] || ((t[is] = !0), Oo('selectionchange', !1, t));
          }
        }
        function Qd(e, t, i, n) {
          switch (vh(t)) {
            case 2:
              var o = ev;
              break;
            case 8:
              o = tv;
              break;
            default:
              o = qo;
          }
          ((i = o.bind(null, t, i, e)),
            (o = void 0),
            !Js ||
              (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
              (o = !0),
            n
              ? o !== void 0
                ? e.addEventListener(t, i, { capture: !0, passive: o })
                : e.addEventListener(t, i, !0)
              : o !== void 0
                ? e.addEventListener(t, i, { passive: o })
                : e.addEventListener(t, i, !1));
        }
        function zo(e, t, i, n, o) {
          var c = n;
          if ((t & 1) === 0 && (t & 2) === 0 && n !== null)
            e: for (;;) {
              if (n === null) return;
              var m = n.tag;
              if (m === 3 || m === 4) {
                var v = n.stateNode.containerInfo;
                if (v === o) break;
                if (m === 4)
                  for (m = n.return; m !== null; ) {
                    var S = m.tag;
                    if ((S === 3 || S === 4) && m.stateNode.containerInfo === o)
                      return;
                    m = m.return;
                  }
                for (; v !== null; ) {
                  if (((m = cn(v)), m === null)) return;
                  if (
                    ((S = m.tag), S === 5 || S === 6 || S === 26 || S === 27)
                  ) {
                    n = c = m;
                    continue e;
                  }
                  v = v.parentNode;
                }
              }
              n = n.return;
            }
          Wu(function () {
            var N = c,
              U = Qs(i),
              Y = [];
            e: {
              var C = Oc.get(e);
              if (C !== void 0) {
                var R = gl,
                  ce = e;
                switch (e) {
                  case 'keypress':
                    if (pl(i) === 0) break e;
                  case 'keydown':
                  case 'keyup':
                    R = xm;
                    break;
                  case 'focusin':
                    ((ce = 'focus'), (R = Ws));
                    break;
                  case 'focusout':
                    ((ce = 'blur'), (R = Ws));
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    R = Ws;
                    break;
                  case 'click':
                    if (i.button === 2) break e;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    R = ic;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    R = um;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    R = wm;
                    break;
                  case Ec:
                  case wc:
                  case Ac:
                    R = dm;
                    break;
                  case Mc:
                    R = Mm;
                    break;
                  case 'scroll':
                  case 'scrollend':
                    R = rm;
                    break;
                  case 'wheel':
                    R = _m;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    R = pm;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    R = ac;
                    break;
                  case 'toggle':
                  case 'beforetoggle':
                    R = Nm;
                }
                var se = (t & 4) !== 0,
                  _e = !se && (e === 'scroll' || e === 'scrollend'),
                  M = se ? (C !== null ? C + 'Capture' : null) : C;
                se = [];
                for (var E = N, z; E !== null; ) {
                  var V = E;
                  if (
                    ((z = V.stateNode),
                    (V = V.tag),
                    (V !== 5 && V !== 26 && V !== 27) ||
                      z === null ||
                      M === null ||
                      ((V = aa(E, M)), V != null && se.push(Va(E, V, z))),
                    _e)
                  )
                    break;
                  E = E.return;
                }
                0 < se.length &&
                  ((C = new R(C, ce, null, i, U)),
                  Y.push({ event: C, listeners: se }));
              }
            }
            if ((t & 7) === 0) {
              e: {
                if (
                  ((C = e === 'mouseover' || e === 'pointerover'),
                  (R = e === 'mouseout' || e === 'pointerout'),
                  C &&
                    i !== Xs &&
                    (ce = i.relatedTarget || i.fromElement) &&
                    (cn(ce) || ce[un]))
                )
                  break e;
                if (
                  (R || C) &&
                  ((C =
                    U.window === U
                      ? U
                      : (C = U.ownerDocument)
                        ? C.defaultView || C.parentWindow
                        : window),
                  R
                    ? ((ce = i.relatedTarget || i.toElement),
                      (R = N),
                      (ce = ce ? cn(ce) : null),
                      ce !== null &&
                        ((_e = f(ce)),
                        (se = ce.tag),
                        ce !== _e || (se !== 5 && se !== 27 && se !== 6)) &&
                        (ce = null))
                    : ((R = null), (ce = N)),
                  R !== ce)
                ) {
                  if (
                    ((se = ic),
                    (V = 'onMouseLeave'),
                    (M = 'onMouseEnter'),
                    (E = 'mouse'),
                    (e === 'pointerout' || e === 'pointerover') &&
                      ((se = ac),
                      (V = 'onPointerLeave'),
                      (M = 'onPointerEnter'),
                      (E = 'pointer')),
                    (_e = R == null ? C : na(R)),
                    (z = ce == null ? C : na(ce)),
                    (C = new se(V, E + 'leave', R, i, U)),
                    (C.target = _e),
                    (C.relatedTarget = z),
                    (V = null),
                    cn(U) === N &&
                      ((se = new se(M, E + 'enter', ce, i, U)),
                      (se.target = z),
                      (se.relatedTarget = _e),
                      (V = se)),
                    (_e = V),
                    R && ce)
                  )
                    t: {
                      for (se = R, M = ce, E = 0, z = se; z; z = Kn(z)) E++;
                      for (z = 0, V = M; V; V = Kn(V)) z++;
                      for (; 0 < E - z; ) ((se = Kn(se)), E--);
                      for (; 0 < z - E; ) ((M = Kn(M)), z--);
                      for (; E--; ) {
                        if (se === M || (M !== null && se === M.alternate))
                          break t;
                        ((se = Kn(se)), (M = Kn(M)));
                      }
                      se = null;
                    }
                  else se = null;
                  (R !== null && Zd(Y, C, R, se, !1),
                    ce !== null && _e !== null && Zd(Y, _e, ce, se, !0));
                }
              }
              e: {
                if (
                  ((C = N ? na(N) : window),
                  (R = C.nodeName && C.nodeName.toLowerCase()),
                  R === 'select' || (R === 'input' && C.type === 'file'))
                )
                  var te = dc;
                else if (cc(C))
                  if (hc) te = Vm;
                  else {
                    te = Um;
                    var ge = Hm;
                  }
                else
                  ((R = C.nodeName),
                    !R ||
                    R.toLowerCase() !== 'input' ||
                    (C.type !== 'checkbox' && C.type !== 'radio')
                      ? N && ks(N.elementType) && (te = dc)
                      : (te = Gm));
                if (te && (te = te(e, N))) {
                  fc(Y, te, i, U);
                  break e;
                }
                (ge && ge(e, C, N),
                  e === 'focusout' &&
                    N &&
                    C.type === 'number' &&
                    N.memoizedProps.value != null &&
                    Ks(C, 'number', C.value));
              }
              switch (((ge = N ? na(N) : window), e)) {
                case 'focusin':
                  (cc(ge) || ge.contentEditable === 'true') &&
                    ((Sn = ge), (lr = N), (da = null));
                  break;
                case 'focusout':
                  da = lr = Sn = null;
                  break;
                case 'mousedown':
                  sr = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  ((sr = !1), xc(Y, i, U));
                  break;
                case 'selectionchange':
                  if (qm) break;
                case 'keydown':
                case 'keyup':
                  xc(Y, i, U);
              }
              var ae;
              if (tr)
                e: {
                  switch (e) {
                    case 'compositionstart':
                      var re = 'onCompositionStart';
                      break e;
                    case 'compositionend':
                      re = 'onCompositionEnd';
                      break e;
                    case 'compositionupdate':
                      re = 'onCompositionUpdate';
                      break e;
                  }
                  re = void 0;
                }
              else
                bn
                  ? oc(e, i) && (re = 'onCompositionEnd')
                  : e === 'keydown' &&
                    i.keyCode === 229 &&
                    (re = 'onCompositionStart');
              (re &&
                (lc &&
                  i.locale !== 'ko' &&
                  (bn || re !== 'onCompositionStart'
                    ? re === 'onCompositionEnd' && bn && (ae = ec())
                    : ((di = U),
                      (Fs = 'value' in di ? di.value : di.textContent),
                      (bn = !0))),
                (ge = ns(N, re)),
                0 < ge.length &&
                  ((re = new nc(re, e, null, i, U)),
                  Y.push({ event: re, listeners: ge }),
                  ae
                    ? (re.data = ae)
                    : ((ae = uc(i)), ae !== null && (re.data = ae)))),
                (ae = Rm ? Dm(e, i) : Lm(e, i)) &&
                  ((re = ns(N, 'onBeforeInput')),
                  0 < re.length &&
                    ((ge = new nc('onBeforeInput', 'beforeinput', null, i, U)),
                    Y.push({ event: ge, listeners: re }),
                    (ge.data = ae))),
                wg(Y, e, N, i, U));
            }
            Xd(Y, t);
          });
        }
        function Va(e, t, i) {
          return { instance: e, listener: t, currentTarget: i };
        }
        function ns(e, t) {
          for (var i = t + 'Capture', n = []; e !== null; ) {
            var o = e,
              c = o.stateNode;
            if (
              ((o = o.tag),
              (o !== 5 && o !== 26 && o !== 27) ||
                c === null ||
                ((o = aa(e, i)),
                o != null && n.unshift(Va(e, o, c)),
                (o = aa(e, t)),
                o != null && n.push(Va(e, o, c))),
              e.tag === 3)
            )
              return n;
            e = e.return;
          }
          return [];
        }
        function Kn(e) {
          if (e === null) return null;
          do e = e.return;
          while (e && e.tag !== 5 && e.tag !== 27);
          return e || null;
        }
        function Zd(e, t, i, n, o) {
          for (var c = t._reactName, m = []; i !== null && i !== n; ) {
            var v = i,
              S = v.alternate,
              N = v.stateNode;
            if (((v = v.tag), S !== null && S === n)) break;
            ((v !== 5 && v !== 26 && v !== 27) ||
              N === null ||
              ((S = N),
              o
                ? ((N = aa(i, c)), N != null && m.unshift(Va(i, N, S)))
                : o || ((N = aa(i, c)), N != null && m.push(Va(i, N, S)))),
              (i = i.return));
          }
          m.length !== 0 && e.push({ event: t, listeners: m });
        }
        var _g = /\r\n?/g,
          zg = /\u0000|\uFFFD/g;
        function Jd(e) {
          return (typeof e == 'string' ? e : '' + e)
            .replace(
              _g,
              `
`
            )
            .replace(zg, '');
        }
        function Fd(e, t) {
          return ((t = Jd(t)), Jd(e) === t);
        }
        function as() {}
        function Oe(e, t, i, n, o, c) {
          switch (i) {
            case 'children':
              typeof n == 'string'
                ? t === 'body' || (t === 'textarea' && n === '') || gn(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  t !== 'body' &&
                  gn(e, '' + n);
              break;
            case 'className':
              ul(e, 'class', n);
              break;
            case 'tabIndex':
              ul(e, 'tabindex', n);
              break;
            case 'dir':
            case 'role':
            case 'viewBox':
            case 'width':
            case 'height':
              ul(e, i, n);
              break;
            case 'style':
              Iu(e, n, c);
              break;
            case 'data':
              if (t !== 'object') {
                ul(e, 'data', n);
                break;
              }
            case 'src':
            case 'href':
              if (n === '' && (t !== 'a' || i !== 'href')) {
                e.removeAttribute(i);
                break;
              }
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'symbol' ||
                typeof n == 'boolean'
              ) {
                e.removeAttribute(i);
                break;
              }
              ((n = dl('' + n)), e.setAttribute(i, n));
              break;
            case 'action':
            case 'formAction':
              if (typeof n == 'function') {
                e.setAttribute(
                  i,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              } else
                typeof c == 'function' &&
                  (i === 'formAction'
                    ? (t !== 'input' && Oe(e, t, 'name', o.name, o, null),
                      Oe(e, t, 'formEncType', o.formEncType, o, null),
                      Oe(e, t, 'formMethod', o.formMethod, o, null),
                      Oe(e, t, 'formTarget', o.formTarget, o, null))
                    : (Oe(e, t, 'encType', o.encType, o, null),
                      Oe(e, t, 'method', o.method, o, null),
                      Oe(e, t, 'target', o.target, o, null)));
              if (n == null || typeof n == 'symbol' || typeof n == 'boolean') {
                e.removeAttribute(i);
                break;
              }
              ((n = dl('' + n)), e.setAttribute(i, n));
              break;
            case 'onClick':
              n != null && (e.onclick = as);
              break;
            case 'onScroll':
              n != null && ye('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && ye('scrollend', e);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((i = n.__html), i != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = i;
                }
              }
              break;
            case 'multiple':
              e.multiple = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'muted':
              e.muted = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'defaultValue':
            case 'defaultChecked':
            case 'innerHTML':
            case 'ref':
              break;
            case 'autoFocus':
              break;
            case 'xlinkHref':
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'boolean' ||
                typeof n == 'symbol'
              ) {
                e.removeAttribute('xlink:href');
                break;
              }
              ((i = dl('' + n)),
                e.setAttributeNS(
                  'http://www.w3.org/1999/xlink',
                  'xlink:href',
                  i
                ));
              break;
            case 'contentEditable':
            case 'spellCheck':
            case 'draggable':
            case 'value':
            case 'autoReverse':
            case 'externalResourcesRequired':
            case 'focusable':
            case 'preserveAlpha':
              n != null && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(i, '' + n)
                : e.removeAttribute(i);
              break;
            case 'inert':
            case 'allowFullScreen':
            case 'async':
            case 'autoPlay':
            case 'controls':
            case 'default':
            case 'defer':
            case 'disabled':
            case 'disablePictureInPicture':
            case 'disableRemotePlayback':
            case 'formNoValidate':
            case 'hidden':
            case 'loop':
            case 'noModule':
            case 'noValidate':
            case 'open':
            case 'playsInline':
            case 'readOnly':
            case 'required':
            case 'reversed':
            case 'scoped':
            case 'seamless':
            case 'itemScope':
              n && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(i, '')
                : e.removeAttribute(i);
              break;
            case 'capture':
            case 'download':
              n === !0
                ? e.setAttribute(i, '')
                : n !== !1 &&
                    n != null &&
                    typeof n != 'function' &&
                    typeof n != 'symbol'
                  ? e.setAttribute(i, n)
                  : e.removeAttribute(i);
              break;
            case 'cols':
            case 'rows':
            case 'size':
            case 'span':
              n != null &&
              typeof n != 'function' &&
              typeof n != 'symbol' &&
              !isNaN(n) &&
              1 <= n
                ? e.setAttribute(i, n)
                : e.removeAttribute(i);
              break;
            case 'rowSpan':
            case 'start':
              n == null ||
              typeof n == 'function' ||
              typeof n == 'symbol' ||
              isNaN(n)
                ? e.removeAttribute(i)
                : e.setAttribute(i, n);
              break;
            case 'popover':
              (ye('beforetoggle', e), ye('toggle', e), ol(e, 'popover', n));
              break;
            case 'xlinkActuate':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:actuate', n);
              break;
            case 'xlinkArcrole':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:arcrole', n);
              break;
            case 'xlinkRole':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:role', n);
              break;
            case 'xlinkShow':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:show', n);
              break;
            case 'xlinkTitle':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:title', n);
              break;
            case 'xlinkType':
              $t(e, 'http://www.w3.org/1999/xlink', 'xlink:type', n);
              break;
            case 'xmlBase':
              $t(e, 'http://www.w3.org/XML/1998/namespace', 'xml:base', n);
              break;
            case 'xmlLang':
              $t(e, 'http://www.w3.org/XML/1998/namespace', 'xml:lang', n);
              break;
            case 'xmlSpace':
              $t(e, 'http://www.w3.org/XML/1998/namespace', 'xml:space', n);
              break;
            case 'is':
              ol(e, 'is', n);
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              (!(2 < i.length) ||
                (i[0] !== 'o' && i[0] !== 'O') ||
                (i[1] !== 'n' && i[1] !== 'N')) &&
                ((i = lm.get(i) || i), ol(e, i, n));
          }
        }
        function No(e, t, i, n, o, c) {
          switch (i) {
            case 'style':
              Iu(e, n, c);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((i = n.__html), i != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = i;
                }
              }
              break;
            case 'children':
              typeof n == 'string'
                ? gn(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  gn(e, '' + n);
              break;
            case 'onScroll':
              n != null && ye('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && ye('scrollend', e);
              break;
            case 'onClick':
              n != null && (e.onclick = as);
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'innerHTML':
            case 'ref':
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              if (!Vu.hasOwnProperty(i))
                e: {
                  if (
                    i[0] === 'o' &&
                    i[1] === 'n' &&
                    ((o = i.endsWith('Capture')),
                    (t = i.slice(2, o ? i.length - 7 : void 0)),
                    (c = e[st] || null),
                    (c = c != null ? c[i] : null),
                    typeof c == 'function' && e.removeEventListener(t, c, o),
                    typeof n == 'function')
                  ) {
                    (typeof c != 'function' &&
                      c !== null &&
                      (i in e
                        ? (e[i] = null)
                        : e.hasAttribute(i) && e.removeAttribute(i)),
                      e.addEventListener(t, n, o));
                    break e;
                  }
                  i in e
                    ? (e[i] = n)
                    : n === !0
                      ? e.setAttribute(i, '')
                      : ol(e, i, n);
                }
          }
        }
        function Pe(e, t, i) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'img':
              (ye('error', e), ye('load', e));
              var n = !1,
                o = !1,
                c;
              for (c in i)
                if (i.hasOwnProperty(c)) {
                  var m = i[c];
                  if (m != null)
                    switch (c) {
                      case 'src':
                        n = !0;
                        break;
                      case 'srcSet':
                        o = !0;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        throw Error(r(137, t));
                      default:
                        Oe(e, t, c, m, i, null);
                    }
                }
              (o && Oe(e, t, 'srcSet', i.srcSet, i, null),
                n && Oe(e, t, 'src', i.src, i, null));
              return;
            case 'input':
              ye('invalid', e);
              var v = (c = m = o = null),
                S = null,
                N = null;
              for (n in i)
                if (i.hasOwnProperty(n)) {
                  var U = i[n];
                  if (U != null)
                    switch (n) {
                      case 'name':
                        o = U;
                        break;
                      case 'type':
                        m = U;
                        break;
                      case 'checked':
                        S = U;
                        break;
                      case 'defaultChecked':
                        N = U;
                        break;
                      case 'value':
                        c = U;
                        break;
                      case 'defaultValue':
                        v = U;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        if (U != null) throw Error(r(137, t));
                        break;
                      default:
                        Oe(e, t, n, U, i, null);
                    }
                }
              (Qu(e, c, v, S, N, m, o, !1), cl(e));
              return;
            case 'select':
              (ye('invalid', e), (n = m = c = null));
              for (o in i)
                if (i.hasOwnProperty(o) && ((v = i[o]), v != null))
                  switch (o) {
                    case 'value':
                      c = v;
                      break;
                    case 'defaultValue':
                      m = v;
                      break;
                    case 'multiple':
                      n = v;
                    default:
                      Oe(e, t, o, v, i, null);
                  }
              ((t = c),
                (i = m),
                (e.multiple = !!n),
                t != null ? mn(e, !!n, t, !1) : i != null && mn(e, !!n, i, !0));
              return;
            case 'textarea':
              (ye('invalid', e), (c = o = n = null));
              for (m in i)
                if (i.hasOwnProperty(m) && ((v = i[m]), v != null))
                  switch (m) {
                    case 'value':
                      n = v;
                      break;
                    case 'defaultValue':
                      o = v;
                      break;
                    case 'children':
                      c = v;
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (v != null) throw Error(r(91));
                      break;
                    default:
                      Oe(e, t, m, v, i, null);
                  }
              (Ju(e, n, o, c), cl(e));
              return;
            case 'option':
              for (S in i)
                if (i.hasOwnProperty(S) && ((n = i[S]), n != null))
                  switch (S) {
                    case 'selected':
                      e.selected =
                        n && typeof n != 'function' && typeof n != 'symbol';
                      break;
                    default:
                      Oe(e, t, S, n, i, null);
                  }
              return;
            case 'dialog':
              (ye('beforetoggle', e),
                ye('toggle', e),
                ye('cancel', e),
                ye('close', e));
              break;
            case 'iframe':
            case 'object':
              ye('load', e);
              break;
            case 'video':
            case 'audio':
              for (n = 0; n < Ga.length; n++) ye(Ga[n], e);
              break;
            case 'image':
              (ye('error', e), ye('load', e));
              break;
            case 'details':
              ye('toggle', e);
              break;
            case 'embed':
            case 'source':
            case 'link':
              (ye('error', e), ye('load', e));
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (N in i)
                if (i.hasOwnProperty(N) && ((n = i[N]), n != null))
                  switch (N) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      throw Error(r(137, t));
                    default:
                      Oe(e, t, N, n, i, null);
                  }
              return;
            default:
              if (ks(t)) {
                for (U in i)
                  i.hasOwnProperty(U) &&
                    ((n = i[U]), n !== void 0 && No(e, t, U, n, i, void 0));
                return;
              }
          }
          for (v in i)
            i.hasOwnProperty(v) &&
              ((n = i[v]), n != null && Oe(e, t, v, n, i, null));
        }
        function Ng(e, t, i, n) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'input':
              var o = null,
                c = null,
                m = null,
                v = null,
                S = null,
                N = null,
                U = null;
              for (R in i) {
                var Y = i[R];
                if (i.hasOwnProperty(R) && Y != null)
                  switch (R) {
                    case 'checked':
                      break;
                    case 'value':
                      break;
                    case 'defaultValue':
                      S = Y;
                    default:
                      n.hasOwnProperty(R) || Oe(e, t, R, null, n, Y);
                  }
              }
              for (var C in n) {
                var R = n[C];
                if (
                  ((Y = i[C]), n.hasOwnProperty(C) && (R != null || Y != null))
                )
                  switch (C) {
                    case 'type':
                      c = R;
                      break;
                    case 'name':
                      o = R;
                      break;
                    case 'checked':
                      N = R;
                      break;
                    case 'defaultChecked':
                      U = R;
                      break;
                    case 'value':
                      m = R;
                      break;
                    case 'defaultValue':
                      v = R;
                      break;
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (R != null) throw Error(r(137, t));
                      break;
                    default:
                      R !== Y && Oe(e, t, C, R, n, Y);
                  }
              }
              $s(e, m, v, S, N, U, c, o);
              return;
            case 'select':
              R = m = v = C = null;
              for (c in i)
                if (((S = i[c]), i.hasOwnProperty(c) && S != null))
                  switch (c) {
                    case 'value':
                      break;
                    case 'multiple':
                      R = S;
                    default:
                      n.hasOwnProperty(c) || Oe(e, t, c, null, n, S);
                  }
              for (o in n)
                if (
                  ((c = n[o]),
                  (S = i[o]),
                  n.hasOwnProperty(o) && (c != null || S != null))
                )
                  switch (o) {
                    case 'value':
                      C = c;
                      break;
                    case 'defaultValue':
                      v = c;
                      break;
                    case 'multiple':
                      m = c;
                    default:
                      c !== S && Oe(e, t, o, c, n, S);
                  }
              ((t = v),
                (i = m),
                (n = R),
                C != null
                  ? mn(e, !!i, C, !1)
                  : !!n != !!i &&
                    (t != null
                      ? mn(e, !!i, t, !0)
                      : mn(e, !!i, i ? [] : '', !1)));
              return;
            case 'textarea':
              R = C = null;
              for (v in i)
                if (
                  ((o = i[v]),
                  i.hasOwnProperty(v) && o != null && !n.hasOwnProperty(v))
                )
                  switch (v) {
                    case 'value':
                      break;
                    case 'children':
                      break;
                    default:
                      Oe(e, t, v, null, n, o);
                  }
              for (m in n)
                if (
                  ((o = n[m]),
                  (c = i[m]),
                  n.hasOwnProperty(m) && (o != null || c != null))
                )
                  switch (m) {
                    case 'value':
                      C = o;
                      break;
                    case 'defaultValue':
                      R = o;
                      break;
                    case 'children':
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (o != null) throw Error(r(91));
                      break;
                    default:
                      o !== c && Oe(e, t, m, o, n, c);
                  }
              Zu(e, C, R);
              return;
            case 'option':
              for (var ce in i)
                if (
                  ((C = i[ce]),
                  i.hasOwnProperty(ce) && C != null && !n.hasOwnProperty(ce))
                )
                  switch (ce) {
                    case 'selected':
                      e.selected = !1;
                      break;
                    default:
                      Oe(e, t, ce, null, n, C);
                  }
              for (S in n)
                if (
                  ((C = n[S]),
                  (R = i[S]),
                  n.hasOwnProperty(S) && C !== R && (C != null || R != null))
                )
                  switch (S) {
                    case 'selected':
                      e.selected =
                        C && typeof C != 'function' && typeof C != 'symbol';
                      break;
                    default:
                      Oe(e, t, S, C, n, R);
                  }
              return;
            case 'img':
            case 'link':
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'embed':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'source':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (var se in i)
                ((C = i[se]),
                  i.hasOwnProperty(se) &&
                    C != null &&
                    !n.hasOwnProperty(se) &&
                    Oe(e, t, se, null, n, C));
              for (N in n)
                if (
                  ((C = n[N]),
                  (R = i[N]),
                  n.hasOwnProperty(N) && C !== R && (C != null || R != null))
                )
                  switch (N) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (C != null) throw Error(r(137, t));
                      break;
                    default:
                      Oe(e, t, N, C, n, R);
                  }
              return;
            default:
              if (ks(t)) {
                for (var _e in i)
                  ((C = i[_e]),
                    i.hasOwnProperty(_e) &&
                      C !== void 0 &&
                      !n.hasOwnProperty(_e) &&
                      No(e, t, _e, void 0, n, C));
                for (U in n)
                  ((C = n[U]),
                    (R = i[U]),
                    !n.hasOwnProperty(U) ||
                      C === R ||
                      (C === void 0 && R === void 0) ||
                      No(e, t, U, C, n, R));
                return;
              }
          }
          for (var M in i)
            ((C = i[M]),
              i.hasOwnProperty(M) &&
                C != null &&
                !n.hasOwnProperty(M) &&
                Oe(e, t, M, null, n, C));
          for (Y in n)
            ((C = n[Y]),
              (R = i[Y]),
              !n.hasOwnProperty(Y) ||
                C === R ||
                (C == null && R == null) ||
                Oe(e, t, Y, C, n, R));
        }
        var Co = null,
          Ro = null;
        function ls(e) {
          return e.nodeType === 9 ? e : e.ownerDocument;
        }
        function Id(e) {
          switch (e) {
            case 'http://www.w3.org/2000/svg':
              return 1;
            case 'http://www.w3.org/1998/Math/MathML':
              return 2;
            default:
              return 0;
          }
        }
        function Pd(e, t) {
          if (e === 0)
            switch (t) {
              case 'svg':
                return 1;
              case 'math':
                return 2;
              default:
                return 0;
            }
          return e === 1 && t === 'foreignObject' ? 0 : e;
        }
        function Do(e, t) {
          return (
            e === 'textarea' ||
            e === 'noscript' ||
            typeof t.children == 'string' ||
            typeof t.children == 'number' ||
            typeof t.children == 'bigint' ||
            (typeof t.dangerouslySetInnerHTML == 'object' &&
              t.dangerouslySetInnerHTML !== null &&
              t.dangerouslySetInnerHTML.__html != null)
          );
        }
        var Lo = null;
        function Cg() {
          var e = window.event;
          return e && e.type === 'popstate'
            ? e === Lo
              ? !1
              : ((Lo = e), !0)
            : ((Lo = null), !1);
        }
        var Wd = typeof setTimeout == 'function' ? setTimeout : void 0,
          Rg = typeof clearTimeout == 'function' ? clearTimeout : void 0,
          eh = typeof Promise == 'function' ? Promise : void 0,
          Dg =
            typeof queueMicrotask == 'function'
              ? queueMicrotask
              : typeof eh < 'u'
                ? function (e) {
                    return eh.resolve(null).then(e).catch(Lg);
                  }
                : Wd;
        function Lg(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function _i(e) {
          return e === 'head';
        }
        function th(e, t) {
          var i = t,
            n = 0,
            o = 0;
          do {
            var c = i.nextSibling;
            if ((e.removeChild(i), c && c.nodeType === 8))
              if (((i = c.data), i === '/$')) {
                if (0 < n && 8 > n) {
                  i = n;
                  var m = e.ownerDocument;
                  if (
                    (i & 1 && Ya(m.documentElement), i & 2 && Ya(m.body), i & 4)
                  )
                    for (i = m.head, Ya(i), m = i.firstChild; m; ) {
                      var v = m.nextSibling,
                        S = m.nodeName;
                      (m[ia] ||
                        S === 'SCRIPT' ||
                        S === 'STYLE' ||
                        (S === 'LINK' &&
                          m.rel.toLowerCase() === 'stylesheet') ||
                        i.removeChild(m),
                        (m = v));
                    }
                }
                if (o === 0) {
                  (e.removeChild(c), Ja(t));
                  return;
                }
                o--;
              } else
                i === '$' || i === '$?' || i === '$!'
                  ? o++
                  : (n = i.charCodeAt(0) - 48);
            else n = 0;
            i = c;
          } while (i);
          Ja(t);
        }
        function jo(e) {
          var t = e.firstChild;
          for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
            var i = t;
            switch (((t = t.nextSibling), i.nodeName)) {
              case 'HTML':
              case 'HEAD':
              case 'BODY':
                (jo(i), Gs(i));
                continue;
              case 'SCRIPT':
              case 'STYLE':
                continue;
              case 'LINK':
                if (i.rel.toLowerCase() === 'stylesheet') continue;
            }
            e.removeChild(i);
          }
        }
        function jg(e, t, i, n) {
          for (; e.nodeType === 1; ) {
            var o = i;
            if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
              if (!n && (e.nodeName !== 'INPUT' || e.type !== 'hidden')) break;
            } else if (n) {
              if (!e[ia])
                switch (t) {
                  case 'meta':
                    if (!e.hasAttribute('itemprop')) break;
                    return e;
                  case 'link':
                    if (
                      ((c = e.getAttribute('rel')),
                      c === 'stylesheet' && e.hasAttribute('data-precedence'))
                    )
                      break;
                    if (
                      c !== o.rel ||
                      e.getAttribute('href') !==
                        (o.href == null || o.href === '' ? null : o.href) ||
                      e.getAttribute('crossorigin') !==
                        (o.crossOrigin == null ? null : o.crossOrigin) ||
                      e.getAttribute('title') !==
                        (o.title == null ? null : o.title)
                    )
                      break;
                    return e;
                  case 'style':
                    if (e.hasAttribute('data-precedence')) break;
                    return e;
                  case 'script':
                    if (
                      ((c = e.getAttribute('src')),
                      (c !== (o.src == null ? null : o.src) ||
                        e.getAttribute('type') !==
                          (o.type == null ? null : o.type) ||
                        e.getAttribute('crossorigin') !==
                          (o.crossOrigin == null ? null : o.crossOrigin)) &&
                        c &&
                        e.hasAttribute('async') &&
                        !e.hasAttribute('itemprop'))
                    )
                      break;
                    return e;
                  default:
                    return e;
                }
            } else if (t === 'input' && e.type === 'hidden') {
              var c = o.name == null ? null : '' + o.name;
              if (o.type === 'hidden' && e.getAttribute('name') === c) return e;
            } else return e;
            if (((e = jt(e.nextSibling)), e === null)) break;
          }
          return null;
        }
        function Bg(e, t, i) {
          if (t === '') return null;
          for (; e.nodeType !== 3; )
            if (
              ((e.nodeType !== 1 ||
                e.nodeName !== 'INPUT' ||
                e.type !== 'hidden') &&
                !i) ||
              ((e = jt(e.nextSibling)), e === null)
            )
              return null;
          return e;
        }
        function Bo(e) {
          return (
            e.data === '$!' ||
            (e.data === '$?' && e.ownerDocument.readyState === 'complete')
          );
        }
        function Hg(e, t) {
          var i = e.ownerDocument;
          if (e.data !== '$?' || i.readyState === 'complete') t();
          else {
            var n = function () {
              (t(), i.removeEventListener('DOMContentLoaded', n));
            };
            (i.addEventListener('DOMContentLoaded', n), (e._reactRetry = n));
          }
        }
        function jt(e) {
          for (; e != null; e = e.nextSibling) {
            var t = e.nodeType;
            if (t === 1 || t === 3) break;
            if (t === 8) {
              if (
                ((t = e.data),
                t === '$' ||
                  t === '$!' ||
                  t === '$?' ||
                  t === 'F!' ||
                  t === 'F')
              )
                break;
              if (t === '/$') return null;
            }
          }
          return e;
        }
        var Ho = null;
        function ih(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (e.nodeType === 8) {
              var i = e.data;
              if (i === '$' || i === '$!' || i === '$?') {
                if (t === 0) return e;
                t--;
              } else i === '/$' && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function nh(e, t, i) {
          switch (((t = ls(i)), e)) {
            case 'html':
              if (((e = t.documentElement), !e)) throw Error(r(452));
              return e;
            case 'head':
              if (((e = t.head), !e)) throw Error(r(453));
              return e;
            case 'body':
              if (((e = t.body), !e)) throw Error(r(454));
              return e;
            default:
              throw Error(r(451));
          }
        }
        function Ya(e) {
          for (var t = e.attributes; t.length; ) e.removeAttributeNode(t[0]);
          Gs(e);
        }
        var Rt = new Map(),
          ah = new Set();
        function ss(e) {
          return typeof e.getRootNode == 'function'
            ? e.getRootNode()
            : e.nodeType === 9
              ? e
              : e.ownerDocument;
        }
        var ni = X.d;
        X.d = { f: Ug, r: Gg, D: Vg, C: Yg, L: qg, m: $g, X: kg, S: Kg, M: Xg };
        function Ug() {
          var e = ni.f(),
            t = Il();
          return e || t;
        }
        function Gg(e) {
          var t = fn(e);
          t !== null && t.tag === 5 && t.type === 'form' ? wf(t) : ni.r(e);
        }
        var kn = typeof document > 'u' ? null : document;
        function lh(e, t, i) {
          var n = kn;
          if (n && typeof t == 'string' && t) {
            var o = At(t);
            ((o = 'link[rel="' + e + '"][href="' + o + '"]'),
              typeof i == 'string' && (o += '[crossorigin="' + i + '"]'),
              ah.has(o) ||
                (ah.add(o),
                (e = { rel: e, crossOrigin: i, href: t }),
                n.querySelector(o) === null &&
                  ((t = n.createElement('link')),
                  Pe(t, 'link', e),
                  ke(t),
                  n.head.appendChild(t))));
          }
        }
        function Vg(e) {
          (ni.D(e), lh('dns-prefetch', e, null));
        }
        function Yg(e, t) {
          (ni.C(e, t), lh('preconnect', e, t));
        }
        function qg(e, t, i) {
          ni.L(e, t, i);
          var n = kn;
          if (n && e && t) {
            var o = 'link[rel="preload"][as="' + At(t) + '"]';
            t === 'image' && i && i.imageSrcSet
              ? ((o += '[imagesrcset="' + At(i.imageSrcSet) + '"]'),
                typeof i.imageSizes == 'string' &&
                  (o += '[imagesizes="' + At(i.imageSizes) + '"]'))
              : (o += '[href="' + At(e) + '"]');
            var c = o;
            switch (t) {
              case 'style':
                c = Xn(e);
                break;
              case 'script':
                c = Qn(e);
            }
            Rt.has(c) ||
              ((e = b(
                {
                  rel: 'preload',
                  href: t === 'image' && i && i.imageSrcSet ? void 0 : e,
                  as: t,
                },
                i
              )),
              Rt.set(c, e),
              n.querySelector(o) !== null ||
                (t === 'style' && n.querySelector(qa(c))) ||
                (t === 'script' && n.querySelector($a(c))) ||
                ((t = n.createElement('link')),
                Pe(t, 'link', e),
                ke(t),
                n.head.appendChild(t)));
          }
        }
        function $g(e, t) {
          ni.m(e, t);
          var i = kn;
          if (i && e) {
            var n = t && typeof t.as == 'string' ? t.as : 'script',
              o =
                'link[rel="modulepreload"][as="' +
                At(n) +
                '"][href="' +
                At(e) +
                '"]',
              c = o;
            switch (n) {
              case 'audioworklet':
              case 'paintworklet':
              case 'serviceworker':
              case 'sharedworker':
              case 'worker':
              case 'script':
                c = Qn(e);
            }
            if (
              !Rt.has(c) &&
              ((e = b({ rel: 'modulepreload', href: e }, t)),
              Rt.set(c, e),
              i.querySelector(o) === null)
            ) {
              switch (n) {
                case 'audioworklet':
                case 'paintworklet':
                case 'serviceworker':
                case 'sharedworker':
                case 'worker':
                case 'script':
                  if (i.querySelector($a(c))) return;
              }
              ((n = i.createElement('link')),
                Pe(n, 'link', e),
                ke(n),
                i.head.appendChild(n));
            }
          }
        }
        function Kg(e, t, i) {
          ni.S(e, t, i);
          var n = kn;
          if (n && e) {
            var o = dn(n).hoistableStyles,
              c = Xn(e);
            t = t || 'default';
            var m = o.get(c);
            if (!m) {
              var v = { loading: 0, preload: null };
              if ((m = n.querySelector(qa(c)))) v.loading = 5;
              else {
                ((e = b(
                  { rel: 'stylesheet', href: e, 'data-precedence': t },
                  i
                )),
                  (i = Rt.get(c)) && Uo(e, i));
                var S = (m = n.createElement('link'));
                (ke(S),
                  Pe(S, 'link', e),
                  (S._p = new Promise(function (N, U) {
                    ((S.onload = N), (S.onerror = U));
                  })),
                  S.addEventListener('load', function () {
                    v.loading |= 1;
                  }),
                  S.addEventListener('error', function () {
                    v.loading |= 2;
                  }),
                  (v.loading |= 4),
                  rs(m, t, n));
              }
              ((m = { type: 'stylesheet', instance: m, count: 1, state: v }),
                o.set(c, m));
            }
          }
        }
        function kg(e, t) {
          ni.X(e, t);
          var i = kn;
          if (i && e) {
            var n = dn(i).hoistableScripts,
              o = Qn(e),
              c = n.get(o);
            c ||
              ((c = i.querySelector($a(o))),
              c ||
                ((e = b({ src: e, async: !0 }, t)),
                (t = Rt.get(o)) && Go(e, t),
                (c = i.createElement('script')),
                ke(c),
                Pe(c, 'link', e),
                i.head.appendChild(c)),
              (c = { type: 'script', instance: c, count: 1, state: null }),
              n.set(o, c));
          }
        }
        function Xg(e, t) {
          ni.M(e, t);
          var i = kn;
          if (i && e) {
            var n = dn(i).hoistableScripts,
              o = Qn(e),
              c = n.get(o);
            c ||
              ((c = i.querySelector($a(o))),
              c ||
                ((e = b({ src: e, async: !0, type: 'module' }, t)),
                (t = Rt.get(o)) && Go(e, t),
                (c = i.createElement('script')),
                ke(c),
                Pe(c, 'link', e),
                i.head.appendChild(c)),
              (c = { type: 'script', instance: c, count: 1, state: null }),
              n.set(o, c));
          }
        }
        function sh(e, t, i, n) {
          var o = (o = de.current) ? ss(o) : null;
          if (!o) throw Error(r(446));
          switch (e) {
            case 'meta':
            case 'title':
              return null;
            case 'style':
              return typeof i.precedence == 'string' &&
                typeof i.href == 'string'
                ? ((t = Xn(i.href)),
                  (i = dn(o).hoistableStyles),
                  (n = i.get(t)),
                  n ||
                    ((n = {
                      type: 'style',
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    i.set(t, n)),
                  n)
                : { type: 'void', instance: null, count: 0, state: null };
            case 'link':
              if (
                i.rel === 'stylesheet' &&
                typeof i.href == 'string' &&
                typeof i.precedence == 'string'
              ) {
                e = Xn(i.href);
                var c = dn(o).hoistableStyles,
                  m = c.get(e);
                if (
                  (m ||
                    ((o = o.ownerDocument || o),
                    (m = {
                      type: 'stylesheet',
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    c.set(e, m),
                    (c = o.querySelector(qa(e))) &&
                      !c._p &&
                      ((m.instance = c), (m.state.loading = 5)),
                    Rt.has(e) ||
                      ((i = {
                        rel: 'preload',
                        as: 'style',
                        href: i.href,
                        crossOrigin: i.crossOrigin,
                        integrity: i.integrity,
                        media: i.media,
                        hrefLang: i.hrefLang,
                        referrerPolicy: i.referrerPolicy,
                      }),
                      Rt.set(e, i),
                      c || Qg(o, e, i, m.state))),
                  t && n === null)
                )
                  throw Error(r(528, ''));
                return m;
              }
              if (t && n !== null) throw Error(r(529, ''));
              return null;
            case 'script':
              return (
                (t = i.async),
                (i = i.src),
                typeof i == 'string' &&
                t &&
                typeof t != 'function' &&
                typeof t != 'symbol'
                  ? ((t = Qn(i)),
                    (i = dn(o).hoistableScripts),
                    (n = i.get(t)),
                    n ||
                      ((n = {
                        type: 'script',
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      i.set(t, n)),
                    n)
                  : { type: 'void', instance: null, count: 0, state: null }
              );
            default:
              throw Error(r(444, e));
          }
        }
        function Xn(e) {
          return 'href="' + At(e) + '"';
        }
        function qa(e) {
          return 'link[rel="stylesheet"][' + e + ']';
        }
        function rh(e) {
          return b({}, e, {
            'data-precedence': e.precedence,
            precedence: null,
          });
        }
        function Qg(e, t, i, n) {
          e.querySelector('link[rel="preload"][as="style"][' + t + ']')
            ? (n.loading = 1)
            : ((t = e.createElement('link')),
              (n.preload = t),
              t.addEventListener('load', function () {
                return (n.loading |= 1);
              }),
              t.addEventListener('error', function () {
                return (n.loading |= 2);
              }),
              Pe(t, 'link', i),
              ke(t),
              e.head.appendChild(t));
        }
        function Qn(e) {
          return '[src="' + At(e) + '"]';
        }
        function $a(e) {
          return 'script[async]' + e;
        }
        function oh(e, t, i) {
          if ((t.count++, t.instance === null))
            switch (t.type) {
              case 'style':
                var n = e.querySelector(
                  'style[data-href~="' + At(i.href) + '"]'
                );
                if (n) return ((t.instance = n), ke(n), n);
                var o = b({}, i, {
                  'data-href': i.href,
                  'data-precedence': i.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  (n = (e.ownerDocument || e).createElement('style')),
                  ke(n),
                  Pe(n, 'style', o),
                  rs(n, i.precedence, e),
                  (t.instance = n)
                );
              case 'stylesheet':
                o = Xn(i.href);
                var c = e.querySelector(qa(o));
                if (c)
                  return ((t.state.loading |= 4), (t.instance = c), ke(c), c);
                ((n = rh(i)),
                  (o = Rt.get(o)) && Uo(n, o),
                  (c = (e.ownerDocument || e).createElement('link')),
                  ke(c));
                var m = c;
                return (
                  (m._p = new Promise(function (v, S) {
                    ((m.onload = v), (m.onerror = S));
                  })),
                  Pe(c, 'link', n),
                  (t.state.loading |= 4),
                  rs(c, i.precedence, e),
                  (t.instance = c)
                );
              case 'script':
                return (
                  (c = Qn(i.src)),
                  (o = e.querySelector($a(c)))
                    ? ((t.instance = o), ke(o), o)
                    : ((n = i),
                      (o = Rt.get(c)) && ((n = b({}, i)), Go(n, o)),
                      (e = e.ownerDocument || e),
                      (o = e.createElement('script')),
                      ke(o),
                      Pe(o, 'link', n),
                      e.head.appendChild(o),
                      (t.instance = o))
                );
              case 'void':
                return null;
              default:
                throw Error(r(443, t.type));
            }
          else
            t.type === 'stylesheet' &&
              (t.state.loading & 4) === 0 &&
              ((n = t.instance),
              (t.state.loading |= 4),
              rs(n, i.precedence, e));
          return t.instance;
        }
        function rs(e, t, i) {
          for (
            var n = i.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              o = n.length ? n[n.length - 1] : null,
              c = o,
              m = 0;
            m < n.length;
            m++
          ) {
            var v = n[m];
            if (v.dataset.precedence === t) c = v;
            else if (c !== o) break;
          }
          c
            ? c.parentNode.insertBefore(e, c.nextSibling)
            : ((t = i.nodeType === 9 ? i.head : i),
              t.insertBefore(e, t.firstChild));
        }
        function Uo(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.title == null && (e.title = t.title));
        }
        function Go(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.integrity == null && (e.integrity = t.integrity));
        }
        var os = null;
        function uh(e, t, i) {
          if (os === null) {
            var n = new Map(),
              o = (os = new Map());
            o.set(i, n);
          } else
            ((o = os), (n = o.get(i)), n || ((n = new Map()), o.set(i, n)));
          if (n.has(e)) return n;
          for (
            n.set(e, null), i = i.getElementsByTagName(e), o = 0;
            o < i.length;
            o++
          ) {
            var c = i[o];
            if (
              !(
                c[ia] ||
                c[et] ||
                (e === 'link' && c.getAttribute('rel') === 'stylesheet')
              ) &&
              c.namespaceURI !== 'http://www.w3.org/2000/svg'
            ) {
              var m = c.getAttribute(t) || '';
              m = e + m;
              var v = n.get(m);
              v ? v.push(c) : n.set(m, [c]);
            }
          }
          return n;
        }
        function ch(e, t, i) {
          ((e = e.ownerDocument || e),
            e.head.insertBefore(
              i,
              t === 'title' ? e.querySelector('head > title') : null
            ));
        }
        function Zg(e, t, i) {
          if (i === 1 || t.itemProp != null) return !1;
          switch (e) {
            case 'meta':
            case 'title':
              return !0;
            case 'style':
              if (
                typeof t.precedence != 'string' ||
                typeof t.href != 'string' ||
                t.href === ''
              )
                break;
              return !0;
            case 'link':
              if (
                typeof t.rel != 'string' ||
                typeof t.href != 'string' ||
                t.href === '' ||
                t.onLoad ||
                t.onError
              )
                break;
              switch (t.rel) {
                case 'stylesheet':
                  return (
                    (e = t.disabled),
                    typeof t.precedence == 'string' && e == null
                  );
                default:
                  return !0;
              }
            case 'script':
              if (
                t.async &&
                typeof t.async != 'function' &&
                typeof t.async != 'symbol' &&
                !t.onLoad &&
                !t.onError &&
                t.src &&
                typeof t.src == 'string'
              )
                return !0;
          }
          return !1;
        }
        function fh(e) {
          return !(e.type === 'stylesheet' && (e.state.loading & 3) === 0);
        }
        var Ka = null;
        function Jg() {}
        function Fg(e, t, i) {
          if (Ka === null) throw Error(r(475));
          var n = Ka;
          if (
            t.type === 'stylesheet' &&
            (typeof i.media != 'string' ||
              matchMedia(i.media).matches !== !1) &&
            (t.state.loading & 4) === 0
          ) {
            if (t.instance === null) {
              var o = Xn(i.href),
                c = e.querySelector(qa(o));
              if (c) {
                ((e = c._p),
                  e !== null &&
                    typeof e == 'object' &&
                    typeof e.then == 'function' &&
                    (n.count++, (n = us.bind(n)), e.then(n, n)),
                  (t.state.loading |= 4),
                  (t.instance = c),
                  ke(c));
                return;
              }
              ((c = e.ownerDocument || e),
                (i = rh(i)),
                (o = Rt.get(o)) && Uo(i, o),
                (c = c.createElement('link')),
                ke(c));
              var m = c;
              ((m._p = new Promise(function (v, S) {
                ((m.onload = v), (m.onerror = S));
              })),
                Pe(c, 'link', i),
                (t.instance = c));
            }
            (n.stylesheets === null && (n.stylesheets = new Map()),
              n.stylesheets.set(t, e),
              (e = t.state.preload) &&
                (t.state.loading & 3) === 0 &&
                (n.count++,
                (t = us.bind(n)),
                e.addEventListener('load', t),
                e.addEventListener('error', t)));
          }
        }
        function Ig() {
          if (Ka === null) throw Error(r(475));
          var e = Ka;
          return (
            e.stylesheets && e.count === 0 && Vo(e, e.stylesheets),
            0 < e.count
              ? function (t) {
                  var i = setTimeout(function () {
                    if ((e.stylesheets && Vo(e, e.stylesheets), e.unsuspend)) {
                      var n = e.unsuspend;
                      ((e.unsuspend = null), n());
                    }
                  }, 6e4);
                  return (
                    (e.unsuspend = t),
                    function () {
                      ((e.unsuspend = null), clearTimeout(i));
                    }
                  );
                }
              : null
          );
        }
        function us() {
          if ((this.count--, this.count === 0)) {
            if (this.stylesheets) Vo(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              ((this.unsuspend = null), e());
            }
          }
        }
        var cs = null;
        function Vo(e, t) {
          ((e.stylesheets = null),
            e.unsuspend !== null &&
              (e.count++,
              (cs = new Map()),
              t.forEach(Pg, e),
              (cs = null),
              us.call(e)));
        }
        function Pg(e, t) {
          if (!(t.state.loading & 4)) {
            var i = cs.get(e);
            if (i) var n = i.get(null);
            else {
              ((i = new Map()), cs.set(e, i));
              for (
                var o = e.querySelectorAll(
                    'link[data-precedence],style[data-precedence]'
                  ),
                  c = 0;
                c < o.length;
                c++
              ) {
                var m = o[c];
                (m.nodeName === 'LINK' ||
                  m.getAttribute('media') !== 'not all') &&
                  (i.set(m.dataset.precedence, m), (n = m));
              }
              n && i.set(null, n);
            }
            ((o = t.instance),
              (m = o.getAttribute('data-precedence')),
              (c = i.get(m) || n),
              c === n && i.set(null, o),
              i.set(m, o),
              this.count++,
              (n = us.bind(this)),
              o.addEventListener('load', n),
              o.addEventListener('error', n),
              c
                ? c.parentNode.insertBefore(o, c.nextSibling)
                : ((e = e.nodeType === 9 ? e.head : e),
                  e.insertBefore(o, e.firstChild)),
              (t.state.loading |= 4));
          }
        }
        var ka = {
          $$typeof: K,
          Provider: null,
          Consumer: null,
          _currentValue: q,
          _currentValue2: q,
          _threadCount: 0,
        };
        function Wg(e, t, i, n, o, c, m, v) {
          ((this.tag = 1),
            (this.containerInfo = e),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = js(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = js(0)),
            (this.hiddenUpdates = js(null)),
            (this.identifierPrefix = n),
            (this.onUncaughtError = o),
            (this.onCaughtError = c),
            (this.onRecoverableError = m),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = v),
            (this.incompleteTransitions = new Map()));
        }
        function dh(e, t, i, n, o, c, m, v, S, N, U, Y) {
          return (
            (e = new Wg(e, t, i, m, v, S, N, Y)),
            (t = 1),
            c === !0 && (t |= 24),
            (c = vt(3, null, null, t)),
            (e.current = c),
            (c.stateNode = e),
            (t = Sr()),
            t.refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (c.memoizedState = { element: n, isDehydrated: i, cache: t }),
            wr(c),
            e
          );
        }
        function hh(e) {
          return e ? ((e = wn), e) : wn;
        }
        function ph(e, t, i, n, o, c) {
          ((o = hh(o)),
            n.context === null ? (n.context = o) : (n.pendingContext = o),
            (n = mi(t)),
            (n.payload = { element: i }),
            (c = c === void 0 ? null : c),
            c !== null && (n.callback = c),
            (i = gi(e, n, t)),
            i !== null && (Tt(i, e, t), xa(i, e, t)));
        }
        function mh(e, t) {
          if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
            var i = e.retryLane;
            e.retryLane = i !== 0 && i < t ? i : t;
          }
        }
        function Yo(e, t) {
          (mh(e, t), (e = e.alternate) && mh(e, t));
        }
        function gh(e) {
          if (e.tag === 13) {
            var t = En(e, 67108864);
            (t !== null && Tt(t, e, 67108864), Yo(e, 67108864));
          }
        }
        var fs = !0;
        function ev(e, t, i, n) {
          var o = D.T;
          D.T = null;
          var c = X.p;
          try {
            ((X.p = 2), qo(e, t, i, n));
          } finally {
            ((X.p = c), (D.T = o));
          }
        }
        function tv(e, t, i, n) {
          var o = D.T;
          D.T = null;
          var c = X.p;
          try {
            ((X.p = 8), qo(e, t, i, n));
          } finally {
            ((X.p = c), (D.T = o));
          }
        }
        function qo(e, t, i, n) {
          if (fs) {
            var o = $o(n);
            if (o === null) (zo(e, t, n, ds, i), yh(e, n));
            else if (nv(o, e, t, i, n)) n.stopPropagation();
            else if ((yh(e, n), t & 4 && -1 < iv.indexOf(e))) {
              for (; o !== null; ) {
                var c = fn(o);
                if (c !== null)
                  switch (c.tag) {
                    case 3:
                      if (
                        ((c = c.stateNode),
                        c.current.memoizedState.isDehydrated)
                      ) {
                        var m = Bi(c.pendingLanes);
                        if (m !== 0) {
                          var v = c;
                          for (
                            v.pendingLanes |= 2, v.entangledLanes |= 2;
                            m;
                          ) {
                            var S = 1 << (31 - mt(m));
                            ((v.entanglements[1] |= S), (m &= ~S));
                          }
                          (Yt(c), (we & 6) === 0 && ((Jl = Bt() + 500), Ua(0)));
                        }
                      }
                      break;
                    case 13:
                      ((v = En(c, 2)),
                        v !== null && Tt(v, c, 2),
                        Il(),
                        Yo(c, 2));
                  }
                if (((c = $o(n)), c === null && zo(e, t, n, ds, i), c === o))
                  break;
                o = c;
              }
              o !== null && n.stopPropagation();
            } else zo(e, t, n, null, i);
          }
        }
        function $o(e) {
          return ((e = Qs(e)), Ko(e));
        }
        var ds = null;
        function Ko(e) {
          if (((ds = null), (e = cn(e)), e !== null)) {
            var t = f(e);
            if (t === null) e = null;
            else {
              var i = t.tag;
              if (i === 13) {
                if (((e = h(t)), e !== null)) return e;
                e = null;
              } else if (i === 3) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return t.tag === 3 ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return ((ds = e), null);
        }
        function vh(e) {
          switch (e) {
            case 'beforetoggle':
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'toggle':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 2;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 8;
            case 'message':
              switch (Yp()) {
                case Nu:
                  return 2;
                case Cu:
                  return 8;
                case al:
                case qp:
                  return 32;
                case Ru:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var ko = !1,
          zi = null,
          Ni = null,
          Ci = null,
          Xa = new Map(),
          Qa = new Map(),
          Ri = [],
          iv =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
              ' '
            );
        function yh(e, t) {
          switch (e) {
            case 'focusin':
            case 'focusout':
              zi = null;
              break;
            case 'dragenter':
            case 'dragleave':
              Ni = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Ci = null;
              break;
            case 'pointerover':
            case 'pointerout':
              Xa.delete(t.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              Qa.delete(t.pointerId);
          }
        }
        function Za(e, t, i, n, o, c) {
          return e === null || e.nativeEvent !== c
            ? ((e = {
                blockedOn: t,
                domEventName: i,
                eventSystemFlags: n,
                nativeEvent: c,
                targetContainers: [o],
              }),
              t !== null && ((t = fn(t)), t !== null && gh(t)),
              e)
            : ((e.eventSystemFlags |= n),
              (t = e.targetContainers),
              o !== null && t.indexOf(o) === -1 && t.push(o),
              e);
        }
        function nv(e, t, i, n, o) {
          switch (t) {
            case 'focusin':
              return ((zi = Za(zi, e, t, i, n, o)), !0);
            case 'dragenter':
              return ((Ni = Za(Ni, e, t, i, n, o)), !0);
            case 'mouseover':
              return ((Ci = Za(Ci, e, t, i, n, o)), !0);
            case 'pointerover':
              var c = o.pointerId;
              return (Xa.set(c, Za(Xa.get(c) || null, e, t, i, n, o)), !0);
            case 'gotpointercapture':
              return (
                (c = o.pointerId),
                Qa.set(c, Za(Qa.get(c) || null, e, t, i, n, o)),
                !0
              );
          }
          return !1;
        }
        function bh(e) {
          var t = cn(e.target);
          if (t !== null) {
            var i = f(t);
            if (i !== null) {
              if (((t = i.tag), t === 13)) {
                if (((t = h(i)), t !== null)) {
                  ((e.blockedOn = t),
                    Fp(e.priority, function () {
                      if (i.tag === 13) {
                        var n = xt();
                        n = Bs(n);
                        var o = En(i, n);
                        (o !== null && Tt(o, i, n), Yo(i, n));
                      }
                    }));
                  return;
                }
              } else if (
                t === 3 &&
                i.stateNode.current.memoizedState.isDehydrated
              ) {
                e.blockedOn = i.tag === 3 ? i.stateNode.containerInfo : null;
                return;
              }
            }
          }
          e.blockedOn = null;
        }
        function hs(e) {
          if (e.blockedOn !== null) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var i = $o(e.nativeEvent);
            if (i === null) {
              i = e.nativeEvent;
              var n = new i.constructor(i.type, i);
              ((Xs = n), i.target.dispatchEvent(n), (Xs = null));
            } else
              return ((t = fn(i)), t !== null && gh(t), (e.blockedOn = i), !1);
            t.shift();
          }
          return !0;
        }
        function Sh(e, t, i) {
          hs(e) && i.delete(t);
        }
        function av() {
          ((ko = !1),
            zi !== null && hs(zi) && (zi = null),
            Ni !== null && hs(Ni) && (Ni = null),
            Ci !== null && hs(Ci) && (Ci = null),
            Xa.forEach(Sh),
            Qa.forEach(Sh));
        }
        function ps(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            ko ||
              ((ko = !0),
              s.unstable_scheduleCallback(s.unstable_NormalPriority, av)));
        }
        var ms = null;
        function xh(e) {
          ms !== e &&
            ((ms = e),
            s.unstable_scheduleCallback(s.unstable_NormalPriority, function () {
              ms === e && (ms = null);
              for (var t = 0; t < e.length; t += 3) {
                var i = e[t],
                  n = e[t + 1],
                  o = e[t + 2];
                if (typeof n != 'function') {
                  if (Ko(n || i) === null) continue;
                  break;
                }
                var c = fn(i);
                c !== null &&
                  (e.splice(t, 3),
                  (t -= 3),
                  $r(
                    c,
                    { pending: !0, data: o, method: i.method, action: n },
                    n,
                    o
                  ));
              }
            }));
        }
        function Ja(e) {
          function t(S) {
            return ps(S, e);
          }
          (zi !== null && ps(zi, e),
            Ni !== null && ps(Ni, e),
            Ci !== null && ps(Ci, e),
            Xa.forEach(t),
            Qa.forEach(t));
          for (var i = 0; i < Ri.length; i++) {
            var n = Ri[i];
            n.blockedOn === e && (n.blockedOn = null);
          }
          for (; 0 < Ri.length && ((i = Ri[0]), i.blockedOn === null); )
            (bh(i), i.blockedOn === null && Ri.shift());
          if (((i = (e.ownerDocument || e).$$reactFormReplay), i != null))
            for (n = 0; n < i.length; n += 3) {
              var o = i[n],
                c = i[n + 1],
                m = o[st] || null;
              if (typeof c == 'function') m || xh(i);
              else if (m) {
                var v = null;
                if (c && c.hasAttribute('formAction')) {
                  if (((o = c), (m = c[st] || null))) v = m.formAction;
                  else if (Ko(o) !== null) continue;
                } else v = m.action;
                (typeof v == 'function'
                  ? (i[n + 1] = v)
                  : (i.splice(n, 3), (n -= 3)),
                  xh(i));
              }
            }
        }
        function Xo(e) {
          this._internalRoot = e;
        }
        ((gs.prototype.render = Xo.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (t === null) throw Error(r(409));
            var i = t.current,
              n = xt();
            ph(i, n, e, t, null, null);
          }),
          (gs.prototype.unmount = Xo.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (e !== null) {
                this._internalRoot = null;
                var t = e.containerInfo;
                (ph(e.current, 2, null, e, null, null), Il(), (t[un] = null));
              }
            }));
        function gs(e) {
          this._internalRoot = e;
        }
        gs.prototype.unstable_scheduleHydration = function (e) {
          if (e) {
            var t = Hu();
            e = { blockedOn: null, target: e, priority: t };
            for (
              var i = 0;
              i < Ri.length && t !== 0 && t < Ri[i].priority;
              i++
            );
            (Ri.splice(i, 0, e), i === 0 && bh(e));
          }
        };
        var Th = a.version;
        if (Th !== '19.1.1') throw Error(r(527, Th, '19.1.1'));
        X.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (t === void 0)
            throw typeof e.render == 'function'
              ? Error(r(188))
              : ((e = Object.keys(e).join(',')), Error(r(268, e)));
          return (
            (e = d(t)),
            (e = e !== null ? p(e) : null),
            (e = e === null ? null : e.stateNode),
            e
          );
        };
        var lv = {
          bundleType: 0,
          version: '19.1.1',
          rendererPackageName: 'react-dom',
          currentDispatcherRef: D,
          reconcilerVersion: '19.1.1',
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
          var vs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!vs.isDisabled && vs.supportsFiber)
            try {
              ((Wn = vs.inject(lv)), (pt = vs));
            } catch {}
        }
        return (
          (Ia.createRoot = function (e, t) {
            if (!u(e)) throw Error(r(299));
            var i = !1,
              n = '',
              o = Uf,
              c = Gf,
              m = Vf,
              v = null;
            return (
              t != null &&
                (t.unstable_strictMode === !0 && (i = !0),
                t.identifierPrefix !== void 0 && (n = t.identifierPrefix),
                t.onUncaughtError !== void 0 && (o = t.onUncaughtError),
                t.onCaughtError !== void 0 && (c = t.onCaughtError),
                t.onRecoverableError !== void 0 && (m = t.onRecoverableError),
                t.unstable_transitionCallbacks !== void 0 &&
                  (v = t.unstable_transitionCallbacks)),
              (t = dh(e, 1, !1, null, null, i, n, o, c, m, v, null)),
              (e[un] = t.current),
              _o(e),
              new Xo(t)
            );
          }),
          (Ia.hydrateRoot = function (e, t, i) {
            if (!u(e)) throw Error(r(299));
            var n = !1,
              o = '',
              c = Uf,
              m = Gf,
              v = Vf,
              S = null,
              N = null;
            return (
              i != null &&
                (i.unstable_strictMode === !0 && (n = !0),
                i.identifierPrefix !== void 0 && (o = i.identifierPrefix),
                i.onUncaughtError !== void 0 && (c = i.onUncaughtError),
                i.onCaughtError !== void 0 && (m = i.onCaughtError),
                i.onRecoverableError !== void 0 && (v = i.onRecoverableError),
                i.unstable_transitionCallbacks !== void 0 &&
                  (S = i.unstable_transitionCallbacks),
                i.formState !== void 0 && (N = i.formState)),
              (t = dh(e, 1, !0, t, i ?? null, n, o, c, m, v, S, N)),
              (t.context = hh(null)),
              (i = t.current),
              (n = xt()),
              (n = Bs(n)),
              (o = mi(n)),
              (o.callback = null),
              gi(i, o, n),
              (i = n),
              (t.current.lanes = i),
              ta(t, i),
              Yt(t),
              (e[un] = t.current),
              _o(e),
              new gs(t)
            );
          }),
          (Ia.version = '19.1.1'),
          Ia
        );
      }
      var Rh;
      function gv() {
        if (Rh) return Zo.exports;
        Rh = 1;
        function s() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
            } catch (a) {
              console.error(a);
            }
        }
        return (s(), (Zo.exports = mv()), Zo.exports);
      }
      var vv = gv(),
        F = Tu();
      const $e = rv(F),
        fe = s => typeof s == 'string',
        Pa = () => {
          let s, a;
          const l = new Promise((r, u) => {
            ((s = r), (a = u));
          });
          return ((l.resolve = s), (l.reject = a), l);
        },
        Dh = s => (s == null ? '' : '' + s),
        yv = (s, a, l) => {
          s.forEach(r => {
            a[r] && (l[r] = a[r]);
          });
        },
        bv = /###/g,
        Lh = s => (s && s.indexOf('###') > -1 ? s.replace(bv, '.') : s),
        jh = s => !s || fe(s),
        Wa = (s, a, l) => {
          const r = fe(a) ? a.split('.') : a;
          let u = 0;
          for (; u < r.length - 1; ) {
            if (jh(s)) return {};
            const f = Lh(r[u]);
            (!s[f] && l && (s[f] = new l()),
              Object.prototype.hasOwnProperty.call(s, f)
                ? (s = s[f])
                : (s = {}),
              ++u);
          }
          return jh(s) ? {} : { obj: s, k: Lh(r[u]) };
        },
        Bh = (s, a, l) => {
          const { obj: r, k: u } = Wa(s, a, Object);
          if (r !== void 0 || a.length === 1) {
            r[u] = l;
            return;
          }
          let f = a[a.length - 1],
            h = a.slice(0, a.length - 1),
            g = Wa(s, h, Object);
          for (; g.obj === void 0 && h.length; )
            ((f = `${h[h.length - 1]}.${f}`),
              (h = h.slice(0, h.length - 1)),
              (g = Wa(s, h, Object)),
              g?.obj && typeof g.obj[`${g.k}.${f}`] < 'u' && (g.obj = void 0));
          g.obj[`${g.k}.${f}`] = l;
        },
        Sv = (s, a, l, r) => {
          const { obj: u, k: f } = Wa(s, a, Object);
          ((u[f] = u[f] || []), u[f].push(l));
        },
        Es = (s, a) => {
          const { obj: l, k: r } = Wa(s, a);
          if (l && Object.prototype.hasOwnProperty.call(l, r)) return l[r];
        },
        xv = (s, a, l) => {
          const r = Es(s, l);
          return r !== void 0 ? r : Es(a, l);
        },
        dp = (s, a, l) => {
          for (const r in a)
            r !== '__proto__' &&
              r !== 'constructor' &&
              (r in s
                ? fe(s[r]) ||
                  s[r] instanceof String ||
                  fe(a[r]) ||
                  a[r] instanceof String
                  ? l && (s[r] = a[r])
                  : dp(s[r], a[r], l)
                : (s[r] = a[r]));
          return s;
        },
        Zn = s => s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var Tv = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const Ev = s => (fe(s) ? s.replace(/[&<>"'\/]/g, a => Tv[a]) : s);
      class wv {
        constructor(a) {
          ((this.capacity = a),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(a) {
          const l = this.regExpMap.get(a);
          if (l !== void 0) return l;
          const r = new RegExp(a);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(a, r),
            this.regExpQueue.push(a),
            r
          );
        }
      }
      const Av = [' ', ',', '?', '!', ';'],
        Mv = new wv(20),
        Ov = (s, a, l) => {
          ((a = a || ''), (l = l || ''));
          const r = Av.filter(h => a.indexOf(h) < 0 && l.indexOf(h) < 0);
          if (r.length === 0) return !0;
          const u = Mv.getRegExp(
            `(${r.map(h => (h === '?' ? '\\?' : h)).join('|')})`
          );
          let f = !u.test(s);
          if (!f) {
            const h = s.indexOf(l);
            h > 0 && !u.test(s.substring(0, h)) && (f = !0);
          }
          return f;
        },
        cu = (s, a, l = '.') => {
          if (!s) return;
          if (s[a])
            return Object.prototype.hasOwnProperty.call(s, a) ? s[a] : void 0;
          const r = a.split(l);
          let u = s;
          for (let f = 0; f < r.length; ) {
            if (!u || typeof u != 'object') return;
            let h,
              g = '';
            for (let d = f; d < r.length; ++d)
              if (
                (d !== f && (g += l), (g += r[d]), (h = u[g]), h !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof h) > -1 &&
                  d < r.length - 1
                )
                  continue;
                f += d - f + 1;
                break;
              }
            u = h;
          }
          return u;
        },
        tl = s => s?.replace('_', '-'),
        _v = {
          type: 'logger',
          log(s) {
            this.output('log', s);
          },
          warn(s) {
            this.output('warn', s);
          },
          error(s) {
            this.output('error', s);
          },
          output(s, a) {
            console?.[s]?.apply?.(console, a);
          },
        };
      class ws {
        constructor(a, l = {}) {
          this.init(a, l);
        }
        init(a, l = {}) {
          ((this.prefix = l.prefix || 'i18next:'),
            (this.logger = a || _v),
            (this.options = l),
            (this.debug = l.debug));
        }
        log(...a) {
          return this.forward(a, 'log', '', !0);
        }
        warn(...a) {
          return this.forward(a, 'warn', '', !0);
        }
        error(...a) {
          return this.forward(a, 'error', '');
        }
        deprecate(...a) {
          return this.forward(a, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(a, l, r, u) {
          return u && !this.debug
            ? null
            : (fe(a[0]) && (a[0] = `${r}${this.prefix} ${a[0]}`),
              this.logger[l](a));
        }
        create(a) {
          return new ws(this.logger, {
            prefix: `${this.prefix}:${a}:`,
            ...this.options,
          });
        }
        clone(a) {
          return (
            (a = a || this.options),
            (a.prefix = a.prefix || this.prefix),
            new ws(this.logger, a)
          );
        }
      }
      var qt = new ws();
      class zs {
        constructor() {
          this.observers = {};
        }
        on(a, l) {
          return (
            a.split(' ').forEach(r => {
              this.observers[r] || (this.observers[r] = new Map());
              const u = this.observers[r].get(l) || 0;
              this.observers[r].set(l, u + 1);
            }),
            this
          );
        }
        off(a, l) {
          if (this.observers[a]) {
            if (!l) {
              delete this.observers[a];
              return;
            }
            this.observers[a].delete(l);
          }
        }
        emit(a, ...l) {
          (this.observers[a] &&
            Array.from(this.observers[a].entries()).forEach(([u, f]) => {
              for (let h = 0; h < f; h++) u(...l);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([u, f]) => {
                for (let h = 0; h < f; h++) u.apply(u, [a, ...l]);
              }));
        }
      }
      class Hh extends zs {
        constructor(a, l = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = a || {}),
            (this.options = l),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(a) {
          this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
        }
        removeNamespaces(a) {
          const l = this.options.ns.indexOf(a);
          l > -1 && this.options.ns.splice(l, 1);
        }
        getResource(a, l, r, u = {}) {
          const f =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            h =
              u.ignoreJSONStructure !== void 0
                ? u.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let g;
          a.indexOf('.') > -1
            ? (g = a.split('.'))
            : ((g = [a, l]),
              r &&
                (Array.isArray(r)
                  ? g.push(...r)
                  : fe(r) && f
                    ? g.push(...r.split(f))
                    : g.push(r)));
          const d = Es(this.data, g);
          return (
            !d &&
              !l &&
              !r &&
              a.indexOf('.') > -1 &&
              ((a = g[0]), (l = g[1]), (r = g.slice(2).join('.'))),
            d || !h || !fe(r) ? d : cu(this.data?.[a]?.[l], r, f)
          );
        }
        addResource(a, l, r, u, f = { silent: !1 }) {
          const h =
            f.keySeparator !== void 0
              ? f.keySeparator
              : this.options.keySeparator;
          let g = [a, l];
          (r && (g = g.concat(h ? r.split(h) : r)),
            a.indexOf('.') > -1 && ((g = a.split('.')), (u = l), (l = g[1])),
            this.addNamespaces(l),
            Bh(this.data, g, u),
            f.silent || this.emit('added', a, l, r, u));
        }
        addResources(a, l, r, u = { silent: !1 }) {
          for (const f in r)
            (fe(r[f]) || Array.isArray(r[f])) &&
              this.addResource(a, l, f, r[f], { silent: !0 });
          u.silent || this.emit('added', a, l, r);
        }
        addResourceBundle(a, l, r, u, f, h = { silent: !1, skipCopy: !1 }) {
          let g = [a, l];
          (a.indexOf('.') > -1 &&
            ((g = a.split('.')), (u = r), (r = l), (l = g[1])),
            this.addNamespaces(l));
          let d = Es(this.data, g) || {};
          (h.skipCopy || (r = JSON.parse(JSON.stringify(r))),
            u ? dp(d, r, f) : (d = { ...d, ...r }),
            Bh(this.data, g, d),
            h.silent || this.emit('added', a, l, r));
        }
        removeResourceBundle(a, l) {
          (this.hasResourceBundle(a, l) && delete this.data[a][l],
            this.removeNamespaces(l),
            this.emit('removed', a, l));
        }
        hasResourceBundle(a, l) {
          return this.getResource(a, l) !== void 0;
        }
        getResourceBundle(a, l) {
          return (l || (l = this.options.defaultNS), this.getResource(a, l));
        }
        getDataByLanguage(a) {
          return this.data[a];
        }
        hasLanguageSomeTranslations(a) {
          const l = this.getDataByLanguage(a);
          return !!((l && Object.keys(l)) || []).find(
            u => l[u] && Object.keys(l[u]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var hp = {
        processors: {},
        addPostProcessor(s) {
          this.processors[s.name] = s;
        },
        handle(s, a, l, r, u) {
          return (
            s.forEach(f => {
              a = this.processors[f]?.process(a, l, r, u) ?? a;
            }),
            a
          );
        },
      };
      const pp = Symbol('i18next/PATH_KEY');
      function zv() {
        const s = [],
          a = Object.create(null);
        let l;
        return (
          (a.get = (r, u) => (
            l?.revoke?.(),
            u === pp ? s : (s.push(u), (l = Proxy.revocable(r, a)), l.proxy)
          )),
          Proxy.revocable(Object.create(null), a).proxy
        );
      }
      function fu(s, a) {
        const { [pp]: l } = s(zv());
        return l.join(a?.keySeparator ?? '.');
      }
      const Uh = {},
        Wo = s => !fe(s) && typeof s != 'boolean' && typeof s != 'number';
      class As extends zs {
        constructor(a, l = {}) {
          (super(),
            yv(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              a,
              this
            ),
            (this.options = l),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = qt.create('translator')));
        }
        changeLanguage(a) {
          a && (this.language = a);
        }
        exists(a, l = { interpolation: {} }) {
          const r = { ...l };
          if (a == null) return !1;
          const u = this.resolve(a, r);
          if (u?.res === void 0) return !1;
          const f = Wo(u.res);
          return !(r.returnObjects === !1 && f);
        }
        extractFromKey(a, l) {
          let r =
            l.nsSeparator !== void 0 ? l.nsSeparator : this.options.nsSeparator;
          r === void 0 && (r = ':');
          const u =
            l.keySeparator !== void 0
              ? l.keySeparator
              : this.options.keySeparator;
          let f = l.ns || this.options.defaultNS || [];
          const h = r && a.indexOf(r) > -1,
            g =
              !this.options.userDefinedKeySeparator &&
              !l.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !l.nsSeparator &&
              !Ov(a, r, u);
          if (h && !g) {
            const d = a.match(this.interpolator.nestingRegexp);
            if (d && d.length > 0)
              return { key: a, namespaces: fe(f) ? [f] : f };
            const p = a.split(r);
            ((r !== u || (r === u && this.options.ns.indexOf(p[0]) > -1)) &&
              (f = p.shift()),
              (a = p.join(u)));
          }
          return { key: a, namespaces: fe(f) ? [f] : f };
        }
        translate(a, l, r) {
          let u = typeof l == 'object' ? { ...l } : l;
          if (
            (typeof u != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (u = this.options.overloadTranslationOptionHandler(arguments)),
            typeof u == 'object' && (u = { ...u }),
            u || (u = {}),
            a == null)
          )
            return '';
          (typeof a == 'function' && (a = fu(a, { ...this.options, ...u })),
            Array.isArray(a) || (a = [String(a)]));
          const f =
              u.returnDetails !== void 0
                ? u.returnDetails
                : this.options.returnDetails,
            h =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            { key: g, namespaces: d } = this.extractFromKey(a[a.length - 1], u),
            p = d[d.length - 1];
          let b =
            u.nsSeparator !== void 0 ? u.nsSeparator : this.options.nsSeparator;
          b === void 0 && (b = ':');
          const y = u.lng || this.language,
            w =
              u.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (y?.toLowerCase() === 'cimode')
            return w
              ? f
                ? {
                    res: `${p}${b}${g}`,
                    usedKey: g,
                    exactUsedKey: g,
                    usedLng: y,
                    usedNS: p,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : `${p}${b}${g}`
              : f
                ? {
                    res: g,
                    usedKey: g,
                    exactUsedKey: g,
                    usedLng: y,
                    usedNS: p,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : g;
          const x = this.resolve(a, u);
          let O = x?.res;
          const _ = x?.usedKey || g,
            L = x?.exactUsedKey || g,
            $ = ['[object Number]', '[object Function]', '[object RegExp]'],
            B =
              u.joinArrays !== void 0 ? u.joinArrays : this.options.joinArrays,
            K = !this.i18nFormat || this.i18nFormat.handleAsObject,
            k = u.count !== void 0 && !fe(u.count),
            H = As.hasDefaultValue(u),
            J = k ? this.pluralResolver.getSuffix(y, u.count, u) : '',
            Z =
              u.ordinal && k
                ? this.pluralResolver.getSuffix(y, u.count, { ordinal: !1 })
                : '',
            G = k && !u.ordinal && u.count === 0,
            ee =
              (G && u[`defaultValue${this.options.pluralSeparator}zero`]) ||
              u[`defaultValue${J}`] ||
              u[`defaultValue${Z}`] ||
              u.defaultValue;
          let Q = O;
          K && !O && H && (Q = ee);
          const I = Wo(Q),
            ie = Object.prototype.toString.apply(Q);
          if (
            K &&
            Q &&
            I &&
            $.indexOf(ie) < 0 &&
            !(fe(B) && Array.isArray(Q))
          ) {
            if (!u.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const oe = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(_, Q, { ...u, ns: d })
                : `key '${g} (${this.language})' returned an object instead of string.`;
              return f
                ? ((x.res = oe),
                  (x.usedParams = this.getUsedParamsDetails(u)),
                  x)
                : oe;
            }
            if (h) {
              const oe = Array.isArray(Q),
                ue = oe ? [] : {},
                he = oe ? L : _;
              for (const D in Q)
                if (Object.prototype.hasOwnProperty.call(Q, D)) {
                  const X = `${he}${h}${D}`;
                  (H && !O
                    ? (ue[D] = this.translate(X, {
                        ...u,
                        defaultValue: Wo(ee) ? ee[D] : void 0,
                        joinArrays: !1,
                        ns: d,
                      }))
                    : (ue[D] = this.translate(X, {
                        ...u,
                        joinArrays: !1,
                        ns: d,
                      })),
                    ue[D] === X && (ue[D] = Q[D]));
                }
              O = ue;
            }
          } else if (K && fe(B) && Array.isArray(O))
            ((O = O.join(B)), O && (O = this.extendTranslation(O, a, u, r)));
          else {
            let oe = !1,
              ue = !1;
            (!this.isValidLookup(O) && H && ((oe = !0), (O = ee)),
              this.isValidLookup(O) || ((ue = !0), (O = g)));
            const D =
                (u.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                ue
                  ? void 0
                  : O,
              X = H && ee !== O && this.options.updateMissing;
            if (ue || oe || X) {
              if (
                (this.logger.log(
                  X ? 'updateKey' : 'missingKey',
                  y,
                  p,
                  g,
                  X ? ee : O
                ),
                h)
              ) {
                const j = this.resolve(g, { ...u, keySeparator: !1 });
                j &&
                  j.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let q = [];
              const ne = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                u.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && ne && ne[0])
                for (let j = 0; j < ne.length; j++) q.push(ne[j]);
              else
                this.options.saveMissingTo === 'all'
                  ? (q = this.languageUtils.toResolveHierarchy(
                      u.lng || this.language
                    ))
                  : q.push(u.lng || this.language);
              const T = (j, W, P) => {
                const le = H && P !== O ? P : D;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(j, p, W, le, X, u)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(j, p, W, le, X, u),
                  this.emit('missingKey', j, p, W, O));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && k
                  ? q.forEach(j => {
                      const W = this.pluralResolver.getSuffixes(j, u);
                      (G &&
                        u[`defaultValue${this.options.pluralSeparator}zero`] &&
                        W.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        W.push(`${this.options.pluralSeparator}zero`),
                        W.forEach(P => {
                          T([j], g + P, u[`defaultValue${P}`] || ee);
                        }));
                    })
                  : T(q, g, ee));
            }
            ((O = this.extendTranslation(O, a, u, x, r)),
              ue &&
                O === g &&
                this.options.appendNamespaceToMissingKey &&
                (O = `${p}${b}${g}`),
              (ue || oe) &&
                this.options.parseMissingKeyHandler &&
                (O = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${p}${b}${g}` : g,
                  oe ? O : void 0,
                  u
                )));
          }
          return f
            ? ((x.res = O), (x.usedParams = this.getUsedParamsDetails(u)), x)
            : O;
        }
        extendTranslation(a, l, r, u, f) {
          if (this.i18nFormat?.parse)
            a = this.i18nFormat.parse(
              a,
              { ...this.options.interpolation.defaultVariables, ...r },
              r.lng || this.language || u.usedLng,
              u.usedNS,
              u.usedKey,
              { resolved: u }
            );
          else if (!r.skipInterpolation) {
            r.interpolation &&
              this.interpolator.init({
                ...r,
                interpolation: {
                  ...this.options.interpolation,
                  ...r.interpolation,
                },
              });
            const d =
              fe(a) &&
              (r?.interpolation?.skipOnVariables !== void 0
                ? r.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let p;
            if (d) {
              const y = a.match(this.interpolator.nestingRegexp);
              p = y && y.length;
            }
            let b = r.replace && !fe(r.replace) ? r.replace : r;
            if (
              (this.options.interpolation.defaultVariables &&
                (b = { ...this.options.interpolation.defaultVariables, ...b }),
              (a = this.interpolator.interpolate(
                a,
                b,
                r.lng || this.language || u.usedLng,
                r
              )),
              d)
            ) {
              const y = a.match(this.interpolator.nestingRegexp),
                w = y && y.length;
              p < w && (r.nest = !1);
            }
            (!r.lng && u && u.res && (r.lng = this.language || u.usedLng),
              r.nest !== !1 &&
                (a = this.interpolator.nest(
                  a,
                  (...y) =>
                    f?.[0] === y[0] && !r.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${y[0]} in key: ${l[0]}`
                        ),
                        null)
                      : this.translate(...y, l),
                  r
                )),
              r.interpolation && this.interpolator.reset());
          }
          const h = r.postProcess || this.options.postProcess,
            g = fe(h) ? [h] : h;
          return (
            a != null &&
              g?.length &&
              r.applyPostProcessor !== !1 &&
              (a = hp.handle(
                g,
                a,
                l,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...u,
                        usedParams: this.getUsedParamsDetails(r),
                      },
                      ...r,
                    }
                  : r,
                this
              )),
            a
          );
        }
        resolve(a, l = {}) {
          let r, u, f, h, g;
          return (
            fe(a) && (a = [a]),
            a.forEach(d => {
              if (this.isValidLookup(r)) return;
              const p = this.extractFromKey(d, l),
                b = p.key;
              u = b;
              let y = p.namespaces;
              this.options.fallbackNS &&
                (y = y.concat(this.options.fallbackNS));
              const w = l.count !== void 0 && !fe(l.count),
                x = w && !l.ordinal && l.count === 0,
                O =
                  l.context !== void 0 &&
                  (fe(l.context) || typeof l.context == 'number') &&
                  l.context !== '',
                _ = l.lngs
                  ? l.lngs
                  : this.languageUtils.toResolveHierarchy(
                      l.lng || this.language,
                      l.fallbackLng
                    );
              y.forEach(L => {
                this.isValidLookup(r) ||
                  ((g = L),
                  !Uh[`${_[0]}-${L}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(g) &&
                    ((Uh[`${_[0]}-${L}`] = !0),
                    this.logger.warn(
                      `key "${u}" for languages "${_.join(', ')}" won't get resolved as namespace "${g}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  _.forEach($ => {
                    if (this.isValidLookup(r)) return;
                    h = $;
                    const B = [b];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(B, b, $, L, l);
                    else {
                      let k;
                      w && (k = this.pluralResolver.getSuffix($, l.count, l));
                      const H = `${this.options.pluralSeparator}zero`,
                        J = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (w &&
                          (l.ordinal &&
                            k.indexOf(J) === 0 &&
                            B.push(
                              b + k.replace(J, this.options.pluralSeparator)
                            ),
                          B.push(b + k),
                          x && B.push(b + H)),
                        O)
                      ) {
                        const Z = `${b}${this.options.contextSeparator || '_'}${l.context}`;
                        (B.push(Z),
                          w &&
                            (l.ordinal &&
                              k.indexOf(J) === 0 &&
                              B.push(
                                Z + k.replace(J, this.options.pluralSeparator)
                              ),
                            B.push(Z + k),
                            x && B.push(Z + H)));
                      }
                    }
                    let K;
                    for (; (K = B.pop()); )
                      this.isValidLookup(r) ||
                        ((f = K), (r = this.getResource($, L, K, l)));
                  }));
              });
            }),
            { res: r, usedKey: u, exactUsedKey: f, usedLng: h, usedNS: g }
          );
        }
        isValidLookup(a) {
          return (
            a !== void 0 &&
            !(!this.options.returnNull && a === null) &&
            !(!this.options.returnEmptyString && a === '')
          );
        }
        getResource(a, l, r, u = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(a, l, r, u)
            : this.resourceStore.getResource(a, l, r, u);
        }
        getUsedParamsDetails(a = {}) {
          const l = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            r = a.replace && !fe(a.replace);
          let u = r ? a.replace : a;
          if (
            (r && typeof a.count < 'u' && (u.count = a.count),
            this.options.interpolation.defaultVariables &&
              (u = { ...this.options.interpolation.defaultVariables, ...u }),
            !r)
          ) {
            u = { ...u };
            for (const f of l) delete u[f];
          }
          return u;
        }
        static hasDefaultValue(a) {
          const l = 'defaultValue';
          for (const r in a)
            if (
              Object.prototype.hasOwnProperty.call(a, r) &&
              l === r.substring(0, l.length) &&
              a[r] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class Gh {
        constructor(a) {
          ((this.options = a),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = qt.create('languageUtils')));
        }
        getScriptPartFromCode(a) {
          if (((a = tl(a)), !a || a.indexOf('-') < 0)) return null;
          const l = a.split('-');
          return l.length === 2 ||
            (l.pop(), l[l.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(l.join('-'));
        }
        getLanguagePartFromCode(a) {
          if (((a = tl(a)), !a || a.indexOf('-') < 0)) return a;
          const l = a.split('-');
          return this.formatLanguageCode(l[0]);
        }
        formatLanguageCode(a) {
          if (fe(a) && a.indexOf('-') > -1) {
            let l;
            try {
              l = Intl.getCanonicalLocales(a)[0];
            } catch {}
            return (
              l && this.options.lowerCaseLng && (l = l.toLowerCase()),
              l || (this.options.lowerCaseLng ? a.toLowerCase() : a)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? a.toLowerCase()
            : a;
        }
        isSupportedCode(a) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (a = this.getLanguagePartFromCode(a)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(a) > -1
          );
        }
        getBestMatchFromCodes(a) {
          if (!a) return null;
          let l;
          return (
            a.forEach(r => {
              if (l) return;
              const u = this.formatLanguageCode(r);
              (!this.options.supportedLngs || this.isSupportedCode(u)) &&
                (l = u);
            }),
            !l &&
              this.options.supportedLngs &&
              a.forEach(r => {
                if (l) return;
                const u = this.getScriptPartFromCode(r);
                if (this.isSupportedCode(u)) return (l = u);
                const f = this.getLanguagePartFromCode(r);
                if (this.isSupportedCode(f)) return (l = f);
                l = this.options.supportedLngs.find(h => {
                  if (h === f) return h;
                  if (
                    !(h.indexOf('-') < 0 && f.indexOf('-') < 0) &&
                    ((h.indexOf('-') > 0 &&
                      f.indexOf('-') < 0 &&
                      h.substring(0, h.indexOf('-')) === f) ||
                      (h.indexOf(f) === 0 && f.length > 1))
                  )
                    return h;
                });
              }),
            l || (l = this.getFallbackCodes(this.options.fallbackLng)[0]),
            l
          );
        }
        getFallbackCodes(a, l) {
          if (!a) return [];
          if (
            (typeof a == 'function' && (a = a(l)),
            fe(a) && (a = [a]),
            Array.isArray(a))
          )
            return a;
          if (!l) return a.default || [];
          let r = a[l];
          return (
            r || (r = a[this.getScriptPartFromCode(l)]),
            r || (r = a[this.formatLanguageCode(l)]),
            r || (r = a[this.getLanguagePartFromCode(l)]),
            r || (r = a.default),
            r || []
          );
        }
        toResolveHierarchy(a, l) {
          const r = this.getFallbackCodes(
              (l === !1 ? [] : l) || this.options.fallbackLng || [],
              a
            ),
            u = [],
            f = h => {
              h &&
                (this.isSupportedCode(h)
                  ? u.push(h)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${h}`
                    ));
            };
          return (
            fe(a) && (a.indexOf('-') > -1 || a.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  f(this.formatLanguageCode(a)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  f(this.getScriptPartFromCode(a)),
                this.options.load !== 'currentOnly' &&
                  f(this.getLanguagePartFromCode(a)))
              : fe(a) && f(this.formatLanguageCode(a)),
            r.forEach(h => {
              u.indexOf(h) < 0 && f(this.formatLanguageCode(h));
            }),
            u
          );
        }
      }
      const Vh = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        Yh = {
          select: s => (s === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class Nv {
        constructor(a, l = {}) {
          ((this.languageUtils = a),
            (this.options = l),
            (this.logger = qt.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        addRule(a, l) {
          this.rules[a] = l;
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(a, l = {}) {
          const r = tl(a === 'dev' ? 'en' : a),
            u = l.ordinal ? 'ordinal' : 'cardinal',
            f = JSON.stringify({ cleanedCode: r, type: u });
          if (f in this.pluralRulesCache) return this.pluralRulesCache[f];
          let h;
          try {
            h = new Intl.PluralRules(r, { type: u });
          } catch {
            if (!Intl)
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                Yh
              );
            if (!a.match(/-|_/)) return Yh;
            const d = this.languageUtils.getLanguagePartFromCode(a);
            h = this.getRule(d, l);
          }
          return ((this.pluralRulesCache[f] = h), h);
        }
        needsPlural(a, l = {}) {
          let r = this.getRule(a, l);
          return (
            r || (r = this.getRule('dev', l)),
            r?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(a, l, r = {}) {
          return this.getSuffixes(a, r).map(u => `${l}${u}`);
        }
        getSuffixes(a, l = {}) {
          let r = this.getRule(a, l);
          return (
            r || (r = this.getRule('dev', l)),
            r
              ? r
                  .resolvedOptions()
                  .pluralCategories.sort((u, f) => Vh[u] - Vh[f])
                  .map(
                    u =>
                      `${this.options.prepend}${l.ordinal ? `ordinal${this.options.prepend}` : ''}${u}`
                  )
              : []
          );
        }
        getSuffix(a, l, r = {}) {
          const u = this.getRule(a, r);
          return u
            ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ''}${u.select(l)}`
            : (this.logger.warn(`no plural rule found for: ${a}`),
              this.getSuffix('dev', l, r));
        }
      }
      const qh = (s, a, l, r = '.', u = !0) => {
          let f = xv(s, a, l);
          return (
            !f &&
              u &&
              fe(l) &&
              ((f = cu(s, l, r)), f === void 0 && (f = cu(a, l, r))),
            f
          );
        },
        eu = s => s.replace(/\$/g, '$$$$');
      class Cv {
        constructor(a = {}) {
          ((this.logger = qt.create('interpolator')),
            (this.options = a),
            (this.format = a?.interpolation?.format || (l => l)),
            this.init(a));
        }
        init(a = {}) {
          a.interpolation || (a.interpolation = { escapeValue: !0 });
          const {
            escape: l,
            escapeValue: r,
            useRawValueToEscape: u,
            prefix: f,
            prefixEscaped: h,
            suffix: g,
            suffixEscaped: d,
            formatSeparator: p,
            unescapeSuffix: b,
            unescapePrefix: y,
            nestingPrefix: w,
            nestingPrefixEscaped: x,
            nestingSuffix: O,
            nestingSuffixEscaped: _,
            nestingOptionsSeparator: L,
            maxReplaces: $,
            alwaysFormat: B,
          } = a.interpolation;
          ((this.escape = l !== void 0 ? l : Ev),
            (this.escapeValue = r !== void 0 ? r : !0),
            (this.useRawValueToEscape = u !== void 0 ? u : !1),
            (this.prefix = f ? Zn(f) : h || '{{'),
            (this.suffix = g ? Zn(g) : d || '}}'),
            (this.formatSeparator = p || ','),
            (this.unescapePrefix = b ? '' : y || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : b || ''),
            (this.nestingPrefix = w ? Zn(w) : x || Zn('$t(')),
            (this.nestingSuffix = O ? Zn(O) : _ || Zn(')')),
            (this.nestingOptionsSeparator = L || ','),
            (this.maxReplaces = $ || 1e3),
            (this.alwaysFormat = B !== void 0 ? B : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const a = (l, r) =>
            l?.source === r ? ((l.lastIndex = 0), l) : new RegExp(r, 'g');
          ((this.regexp = a(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = a(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = a(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(a, l, r, u) {
          let f, h, g;
          const d =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            p = x => {
              if (x.indexOf(this.formatSeparator) < 0) {
                const $ = qh(
                  l,
                  d,
                  x,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format($, void 0, r, {
                      ...u,
                      ...l,
                      interpolationkey: x,
                    })
                  : $;
              }
              const O = x.split(this.formatSeparator),
                _ = O.shift().trim(),
                L = O.join(this.formatSeparator).trim();
              return this.format(
                qh(
                  l,
                  d,
                  _,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                L,
                r,
                { ...u, ...l, interpolationkey: _ }
              );
            };
          this.resetRegExp();
          const b =
              u?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            y =
              u?.interpolation?.skipOnVariables !== void 0
                ? u.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: x => eu(x) },
              {
                regex: this.regexp,
                safeValue: x => (this.escapeValue ? eu(this.escape(x)) : eu(x)),
              },
            ].forEach(x => {
              for (g = 0; (f = x.regex.exec(a)); ) {
                const O = f[1].trim();
                if (((h = p(O)), h === void 0))
                  if (typeof b == 'function') {
                    const L = b(a, f, u);
                    h = fe(L) ? L : '';
                  } else if (u && Object.prototype.hasOwnProperty.call(u, O))
                    h = '';
                  else if (y) {
                    h = f[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${O} for interpolating ${a}`
                    ),
                      (h = ''));
                else !fe(h) && !this.useRawValueToEscape && (h = Dh(h));
                const _ = x.safeValue(h);
                if (
                  ((a = a.replace(f[0], _)),
                  y
                    ? ((x.regex.lastIndex += h.length),
                      (x.regex.lastIndex -= f[0].length))
                    : (x.regex.lastIndex = 0),
                  g++,
                  g >= this.maxReplaces)
                )
                  break;
              }
            }),
            a
          );
        }
        nest(a, l, r = {}) {
          let u, f, h;
          const g = (d, p) => {
            const b = this.nestingOptionsSeparator;
            if (d.indexOf(b) < 0) return d;
            const y = d.split(new RegExp(`${b}[ ]*{`));
            let w = `{${y[1]}`;
            ((d = y[0]), (w = this.interpolate(w, h)));
            const x = w.match(/'/g),
              O = w.match(/"/g);
            (((x?.length ?? 0) % 2 === 0 && !O) || O.length % 2 !== 0) &&
              (w = w.replace(/'/g, '"'));
            try {
              ((h = JSON.parse(w)), p && (h = { ...p, ...h }));
            } catch (_) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${d}`,
                  _
                ),
                `${d}${b}${w}`
              );
            }
            return (
              h.defaultValue &&
                h.defaultValue.indexOf(this.prefix) > -1 &&
                delete h.defaultValue,
              d
            );
          };
          for (; (u = this.nestingRegexp.exec(a)); ) {
            let d = [];
            ((h = { ...r }),
              (h = h.replace && !fe(h.replace) ? h.replace : h),
              (h.applyPostProcessor = !1),
              delete h.defaultValue);
            const p = /{.*}/.test(u[1])
              ? u[1].lastIndexOf('}') + 1
              : u[1].indexOf(this.formatSeparator);
            if (
              (p !== -1 &&
                ((d = u[1]
                  .slice(p)
                  .split(this.formatSeparator)
                  .map(b => b.trim())
                  .filter(Boolean)),
                (u[1] = u[1].slice(0, p))),
              (f = l(g.call(this, u[1].trim(), h), h)),
              f && u[0] === a && !fe(f))
            )
              return f;
            (fe(f) || (f = Dh(f)),
              f ||
                (this.logger.warn(`missed to resolve ${u[1]} for nesting ${a}`),
                (f = '')),
              d.length &&
                (f = d.reduce(
                  (b, y) =>
                    this.format(b, y, r.lng, {
                      ...r,
                      interpolationkey: u[1].trim(),
                    }),
                  f.trim()
                )),
              (a = a.replace(u[0], f)),
              (this.regexp.lastIndex = 0));
          }
          return a;
        }
      }
      const Rv = s => {
          let a = s.toLowerCase().trim();
          const l = {};
          if (s.indexOf('(') > -1) {
            const r = s.split('(');
            a = r[0].toLowerCase().trim();
            const u = r[1].substring(0, r[1].length - 1);
            a === 'currency' && u.indexOf(':') < 0
              ? l.currency || (l.currency = u.trim())
              : a === 'relativetime' && u.indexOf(':') < 0
                ? l.range || (l.range = u.trim())
                : u.split(';').forEach(h => {
                    if (h) {
                      const [g, ...d] = h.split(':'),
                        p = d
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        b = g.trim();
                      (l[b] || (l[b] = p),
                        p === 'false' && (l[b] = !1),
                        p === 'true' && (l[b] = !0),
                        isNaN(p) || (l[b] = parseInt(p, 10)));
                    }
                  });
          }
          return { formatName: a, formatOptions: l };
        },
        $h = s => {
          const a = {};
          return (l, r, u) => {
            let f = u;
            u &&
              u.interpolationkey &&
              u.formatParams &&
              u.formatParams[u.interpolationkey] &&
              u[u.interpolationkey] &&
              (f = { ...f, [u.interpolationkey]: void 0 });
            const h = r + JSON.stringify(f);
            let g = a[h];
            return (g || ((g = s(tl(r), u)), (a[h] = g)), g(l));
          };
        },
        Dv = s => (a, l, r) => s(tl(l), r)(a);
      class Lv {
        constructor(a = {}) {
          ((this.logger = qt.create('formatter')),
            (this.options = a),
            this.init(a));
        }
        init(a, l = { interpolation: {} }) {
          this.formatSeparator = l.interpolation.formatSeparator || ',';
          const r = l.cacheInBuiltFormats ? $h : Dv;
          this.formats = {
            number: r((u, f) => {
              const h = new Intl.NumberFormat(u, { ...f });
              return g => h.format(g);
            }),
            currency: r((u, f) => {
              const h = new Intl.NumberFormat(u, { ...f, style: 'currency' });
              return g => h.format(g);
            }),
            datetime: r((u, f) => {
              const h = new Intl.DateTimeFormat(u, { ...f });
              return g => h.format(g);
            }),
            relativetime: r((u, f) => {
              const h = new Intl.RelativeTimeFormat(u, { ...f });
              return g => h.format(g, f.range || 'day');
            }),
            list: r((u, f) => {
              const h = new Intl.ListFormat(u, { ...f });
              return g => h.format(g);
            }),
          };
        }
        add(a, l) {
          this.formats[a.toLowerCase().trim()] = l;
        }
        addCached(a, l) {
          this.formats[a.toLowerCase().trim()] = $h(l);
        }
        format(a, l, r, u = {}) {
          const f = l.split(this.formatSeparator);
          if (
            f.length > 1 &&
            f[0].indexOf('(') > 1 &&
            f[0].indexOf(')') < 0 &&
            f.find(g => g.indexOf(')') > -1)
          ) {
            const g = f.findIndex(d => d.indexOf(')') > -1);
            f[0] = [f[0], ...f.splice(1, g)].join(this.formatSeparator);
          }
          return f.reduce((g, d) => {
            const { formatName: p, formatOptions: b } = Rv(d);
            if (this.formats[p]) {
              let y = g;
              try {
                const w = u?.formatParams?.[u.interpolationkey] || {},
                  x = w.locale || w.lng || u.locale || u.lng || r;
                y = this.formats[p](g, x, { ...b, ...u, ...w });
              } catch (w) {
                this.logger.warn(w);
              }
              return y;
            } else this.logger.warn(`there was no format function for ${p}`);
            return g;
          }, a);
        }
      }
      const jv = (s, a) => {
        s.pending[a] !== void 0 && (delete s.pending[a], s.pendingCount--);
      };
      class Bv extends zs {
        constructor(a, l, r, u = {}) {
          (super(),
            (this.backend = a),
            (this.store = l),
            (this.services = r),
            (this.languageUtils = r.languageUtils),
            (this.options = u),
            (this.logger = qt.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = u.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = u.maxRetries >= 0 ? u.maxRetries : 5),
            (this.retryTimeout = u.retryTimeout >= 1 ? u.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(r, u.backend, u));
        }
        queueLoad(a, l, r, u) {
          const f = {},
            h = {},
            g = {},
            d = {};
          return (
            a.forEach(p => {
              let b = !0;
              (l.forEach(y => {
                const w = `${p}|${y}`;
                !r.reload && this.store.hasResourceBundle(p, y)
                  ? (this.state[w] = 2)
                  : this.state[w] < 0 ||
                    (this.state[w] === 1
                      ? h[w] === void 0 && (h[w] = !0)
                      : ((this.state[w] = 1),
                        (b = !1),
                        h[w] === void 0 && (h[w] = !0),
                        f[w] === void 0 && (f[w] = !0),
                        d[y] === void 0 && (d[y] = !0)));
              }),
                b || (g[p] = !0));
            }),
            (Object.keys(f).length || Object.keys(h).length) &&
              this.queue.push({
                pending: h,
                pendingCount: Object.keys(h).length,
                loaded: {},
                errors: [],
                callback: u,
              }),
            {
              toLoad: Object.keys(f),
              pending: Object.keys(h),
              toLoadLanguages: Object.keys(g),
              toLoadNamespaces: Object.keys(d),
            }
          );
        }
        loaded(a, l, r) {
          const u = a.split('|'),
            f = u[0],
            h = u[1];
          (l && this.emit('failedLoading', f, h, l),
            !l &&
              r &&
              this.store.addResourceBundle(f, h, r, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[a] = l ? -1 : 2),
            l && r && (this.state[a] = 0));
          const g = {};
          (this.queue.forEach(d => {
            (Sv(d.loaded, [f], h),
              jv(d, a),
              l && d.errors.push(l),
              d.pendingCount === 0 &&
                !d.done &&
                (Object.keys(d.loaded).forEach(p => {
                  g[p] || (g[p] = {});
                  const b = d.loaded[p];
                  b.length &&
                    b.forEach(y => {
                      g[p][y] === void 0 && (g[p][y] = !0);
                    });
                }),
                (d.done = !0),
                d.errors.length ? d.callback(d.errors) : d.callback()));
          }),
            this.emit('loaded', g),
            (this.queue = this.queue.filter(d => !d.done)));
        }
        read(a, l, r, u = 0, f = this.retryTimeout, h) {
          if (!a.length) return h(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: a,
              ns: l,
              fcName: r,
              tried: u,
              wait: f,
              callback: h,
            });
            return;
          }
          this.readingCalls++;
          const g = (p, b) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const y = this.waitingReads.shift();
                this.read(y.lng, y.ns, y.fcName, y.tried, y.wait, y.callback);
              }
              if (p && b && u < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, a, l, r, u + 1, f * 2, h);
                }, f);
                return;
              }
              h(p, b);
            },
            d = this.backend[r].bind(this.backend);
          if (d.length === 2) {
            try {
              const p = d(a, l);
              p && typeof p.then == 'function'
                ? p.then(b => g(null, b)).catch(g)
                : g(null, p);
            } catch (p) {
              g(p);
            }
            return;
          }
          return d(a, l, g);
        }
        prepareLoading(a, l, r = {}, u) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              u && u()
            );
          (fe(a) && (a = this.languageUtils.toResolveHierarchy(a)),
            fe(l) && (l = [l]));
          const f = this.queueLoad(a, l, r, u);
          if (!f.toLoad.length) return (f.pending.length || u(), null);
          f.toLoad.forEach(h => {
            this.loadOne(h);
          });
        }
        load(a, l, r) {
          this.prepareLoading(a, l, {}, r);
        }
        reload(a, l, r) {
          this.prepareLoading(a, l, { reload: !0 }, r);
        }
        loadOne(a, l = '') {
          const r = a.split('|'),
            u = r[0],
            f = r[1];
          this.read(u, f, 'read', void 0, void 0, (h, g) => {
            (h &&
              this.logger.warn(
                `${l}loading namespace ${f} for language ${u} failed`,
                h
              ),
              !h &&
                g &&
                this.logger.log(
                  `${l}loaded namespace ${f} for language ${u}`,
                  g
                ),
              this.loaded(a, h, g));
          });
        }
        saveMissing(a, l, r, u, f, h = {}, g = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(l)
          ) {
            this.logger.warn(
              `did not save key "${r}" as the namespace "${l}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(r == null || r === '')) {
            if (this.backend?.create) {
              const d = { ...h, isUpdate: f },
                p = this.backend.create.bind(this.backend);
              if (p.length < 6)
                try {
                  let b;
                  (p.length === 5
                    ? (b = p(a, l, r, u, d))
                    : (b = p(a, l, r, u)),
                    b && typeof b.then == 'function'
                      ? b.then(y => g(null, y)).catch(g)
                      : g(null, b));
                } catch (b) {
                  g(b);
                }
              else p(a, l, r, u, g, d);
            }
            !a || !a[0] || this.store.addResource(a[0], l, r, u);
          }
        }
      }
      const Kh = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: s => {
            let a = {};
            if (
              (typeof s[1] == 'object' && (a = s[1]),
              fe(s[1]) && (a.defaultValue = s[1]),
              fe(s[2]) && (a.tDescription = s[2]),
              typeof s[2] == 'object' || typeof s[3] == 'object')
            ) {
              const l = s[3] || s[2];
              Object.keys(l).forEach(r => {
                a[r] = l[r];
              });
            }
            return a;
          },
          interpolation: {
            escapeValue: !0,
            format: s => s,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        kh = s => (
          fe(s.ns) && (s.ns = [s.ns]),
          fe(s.fallbackLng) && (s.fallbackLng = [s.fallbackLng]),
          fe(s.fallbackNS) && (s.fallbackNS = [s.fallbackNS]),
          s.supportedLngs?.indexOf?.('cimode') < 0 &&
            (s.supportedLngs = s.supportedLngs.concat(['cimode'])),
          typeof s.initImmediate == 'boolean' &&
            (s.initAsync = s.initImmediate),
          s
        ),
        ys = () => {},
        Hv = s => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(s)).forEach(l => {
            typeof s[l] == 'function' && (s[l] = s[l].bind(s));
          });
        };
      class il extends zs {
        constructor(a = {}, l) {
          if (
            (super(),
            (this.options = kh(a)),
            (this.services = {}),
            (this.logger = qt),
            (this.modules = { external: [] }),
            Hv(this),
            l && !this.isInitialized && !a.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(a, l), this);
            setTimeout(() => {
              this.init(a, l);
            }, 0);
          }
        }
        init(a = {}, l) {
          ((this.isInitializing = !0),
            typeof a == 'function' && ((l = a), (a = {})),
            a.defaultNS == null &&
              a.ns &&
              (fe(a.ns)
                ? (a.defaultNS = a.ns)
                : a.ns.indexOf('translation') < 0 && (a.defaultNS = a.ns[0])));
          const r = Kh();
          ((this.options = { ...r, ...this.options, ...kh(a) }),
            (this.options.interpolation = {
              ...r.interpolation,
              ...this.options.interpolation,
            }),
            a.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = a.keySeparator),
            a.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = a.nsSeparator));
          const u = p => (p ? (typeof p == 'function' ? new p() : p) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? qt.init(u(this.modules.logger), this.options)
              : qt.init(null, this.options);
            let p;
            this.modules.formatter ? (p = this.modules.formatter) : (p = Lv);
            const b = new Gh(this.options);
            this.store = new Hh(this.options.resources, this.options);
            const y = this.services;
            ((y.logger = qt),
              (y.resourceStore = this.store),
              (y.languageUtils = b),
              (y.pluralResolver = new Nv(b, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== r.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              p &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    r.interpolation.format) &&
                ((y.formatter = u(p)),
                y.formatter.init && y.formatter.init(y, this.options),
                (this.options.interpolation.format = y.formatter.format.bind(
                  y.formatter
                ))),
              (y.interpolator = new Cv(this.options)),
              (y.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (y.backendConnector = new Bv(
                u(this.modules.backend),
                y.resourceStore,
                y,
                this.options
              )),
              y.backendConnector.on('*', (x, ...O) => {
                this.emit(x, ...O);
              }),
              this.modules.languageDetector &&
                ((y.languageDetector = u(this.modules.languageDetector)),
                y.languageDetector.init &&
                  y.languageDetector.init(
                    y,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((y.i18nFormat = u(this.modules.i18nFormat)),
                y.i18nFormat.init && y.i18nFormat.init(this)),
              (this.translator = new As(this.services, this.options)),
              this.translator.on('*', (x, ...O) => {
                this.emit(x, ...O);
              }),
              this.modules.external.forEach(x => {
                x.init && x.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            l || (l = ys),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const p = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            p.length > 0 && p[0] !== 'dev' && (this.options.lng = p[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(p => {
              this[p] = (...b) => this.store[p](...b);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(p => {
              this[p] = (...b) => (this.store[p](...b), this);
            }));
          const g = Pa(),
            d = () => {
              const p = (b, y) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  g.resolve(y),
                  l(b, y));
              };
              if (this.languages && !this.isInitialized)
                return p(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, p);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? d()
              : setTimeout(d, 0),
            g
          );
        }
        loadResources(a, l = ys) {
          let r = l;
          const u = fe(a) ? a : this.language;
          if (
            (typeof a == 'function' && (r = a),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              u?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return r();
            const f = [],
              h = g => {
                if (!g || g === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(g).forEach(p => {
                  p !== 'cimode' && f.indexOf(p) < 0 && f.push(p);
                });
              };
            (u
              ? h(u)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(d => h(d)),
              this.options.preload?.forEach?.(g => h(g)),
              this.services.backendConnector.load(f, this.options.ns, g => {
                (!g &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  r(g));
              }));
          } else r(null);
        }
        reloadResources(a, l, r) {
          const u = Pa();
          return (
            typeof a == 'function' && ((r = a), (a = void 0)),
            typeof l == 'function' && ((r = l), (l = void 0)),
            a || (a = this.languages),
            l || (l = this.options.ns),
            r || (r = ys),
            this.services.backendConnector.reload(a, l, f => {
              (u.resolve(), r(f));
            }),
            u
          );
        }
        use(a) {
          if (!a)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!a.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            a.type === 'backend' && (this.modules.backend = a),
            (a.type === 'logger' || (a.log && a.warn && a.error)) &&
              (this.modules.logger = a),
            a.type === 'languageDetector' &&
              (this.modules.languageDetector = a),
            a.type === 'i18nFormat' && (this.modules.i18nFormat = a),
            a.type === 'postProcessor' && hp.addPostProcessor(a),
            a.type === 'formatter' && (this.modules.formatter = a),
            a.type === '3rdParty' && this.modules.external.push(a),
            this
          );
        }
        setResolvedLanguage(a) {
          if (
            !(!a || !this.languages) &&
            !(['cimode', 'dev'].indexOf(a) > -1)
          ) {
            for (let l = 0; l < this.languages.length; l++) {
              const r = this.languages[l];
              if (
                !(['cimode', 'dev'].indexOf(r) > -1) &&
                this.store.hasLanguageSomeTranslations(r)
              ) {
                this.resolvedLanguage = r;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(a) < 0 &&
              this.store.hasLanguageSomeTranslations(a) &&
              ((this.resolvedLanguage = a), this.languages.unshift(a));
          }
        }
        changeLanguage(a, l) {
          this.isLanguageChangingTo = a;
          const r = Pa();
          this.emit('languageChanging', a);
          const u = g => {
              ((this.language = g),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(g)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(g));
            },
            f = (g, d) => {
              (d
                ? this.isLanguageChangingTo === a &&
                  (u(d),
                  this.translator.changeLanguage(d),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', d),
                  this.logger.log('languageChanged', d))
                : (this.isLanguageChangingTo = void 0),
                r.resolve((...p) => this.t(...p)),
                l && l(g, (...p) => this.t(...p)));
            },
            h = g => {
              !a && !g && this.services.languageDetector && (g = []);
              const d = fe(g) ? g : g && g[0],
                p = this.store.hasLanguageSomeTranslations(d)
                  ? d
                  : this.services.languageUtils.getBestMatchFromCodes(
                      fe(g) ? [g] : g
                    );
              (p &&
                (this.language || u(p),
                this.translator.language || this.translator.changeLanguage(p),
                this.services.languageDetector?.cacheUserLanguage?.(p)),
                this.loadResources(p, b => {
                  f(b, p);
                }));
            };
          return (
            !a &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? h(this.services.languageDetector.detect())
              : !a &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(h)
                  : this.services.languageDetector.detect(h)
                : h(a),
            r
          );
        }
        getFixedT(a, l, r) {
          const u = (f, h, ...g) => {
            let d;
            (typeof h != 'object'
              ? (d = this.options.overloadTranslationOptionHandler(
                  [f, h].concat(g)
                ))
              : (d = { ...h }),
              (d.lng = d.lng || u.lng),
              (d.lngs = d.lngs || u.lngs),
              (d.ns = d.ns || u.ns),
              d.keyPrefix !== '' &&
                (d.keyPrefix = d.keyPrefix || r || u.keyPrefix));
            const p = this.options.keySeparator || '.';
            let b;
            return (
              d.keyPrefix && Array.isArray(f)
                ? (b = f.map(
                    y => (
                      typeof y == 'function' &&
                        (y = fu(y, { ...this.options, ...h })),
                      `${d.keyPrefix}${p}${y}`
                    )
                  ))
                : (typeof f == 'function' &&
                    (f = fu(f, { ...this.options, ...h })),
                  (b = d.keyPrefix ? `${d.keyPrefix}${p}${f}` : f)),
              this.t(b, d)
            );
          };
          return (
            fe(a) ? (u.lng = a) : (u.lngs = a),
            (u.ns = l),
            (u.keyPrefix = r),
            u
          );
        }
        t(...a) {
          return this.translator?.translate(...a);
        }
        exists(...a) {
          return this.translator?.exists(...a);
        }
        setDefaultNamespace(a) {
          this.options.defaultNS = a;
        }
        hasLoadedNamespace(a, l = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const r = l.lng || this.resolvedLanguage || this.languages[0],
            u = this.options ? this.options.fallbackLng : !1,
            f = this.languages[this.languages.length - 1];
          if (r.toLowerCase() === 'cimode') return !0;
          const h = (g, d) => {
            const p = this.services.backendConnector.state[`${g}|${d}`];
            return p === -1 || p === 0 || p === 2;
          };
          if (l.precheck) {
            const g = l.precheck(this, h);
            if (g !== void 0) return g;
          }
          return !!(
            this.hasResourceBundle(r, a) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (h(r, a) && (!u || h(f, a)))
          );
        }
        loadNamespaces(a, l) {
          const r = Pa();
          return this.options.ns
            ? (fe(a) && (a = [a]),
              a.forEach(u => {
                this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
              }),
              this.loadResources(u => {
                (r.resolve(), l && l(u));
              }),
              r)
            : (l && l(), Promise.resolve());
        }
        loadLanguages(a, l) {
          const r = Pa();
          fe(a) && (a = [a]);
          const u = this.options.preload || [],
            f = a.filter(
              h =>
                u.indexOf(h) < 0 &&
                this.services.languageUtils.isSupportedCode(h)
            );
          return f.length
            ? ((this.options.preload = u.concat(f)),
              this.loadResources(h => {
                (r.resolve(), l && l(h));
              }),
              r)
            : (l && l(), Promise.resolve());
        }
        dir(a) {
          if (
            (a ||
              (a =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !a)
          )
            return 'rtl';
          try {
            const u = new Intl.Locale(a);
            if (u && u.getTextInfo) {
              const f = u.getTextInfo();
              if (f && f.direction) return f.direction;
            }
          } catch {}
          const l = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            r = this.services?.languageUtils || new Gh(Kh());
          return a.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : l.indexOf(r.getLanguagePartFromCode(a)) > -1 ||
                a.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(a = {}, l) {
          return new il(a, l);
        }
        cloneInstance(a = {}, l = ys) {
          const r = a.forkResourceStore;
          r && delete a.forkResourceStore;
          const u = { ...this.options, ...a, isClone: !0 },
            f = new il(u);
          if (
            ((a.debug !== void 0 || a.prefix !== void 0) &&
              (f.logger = f.logger.clone(a)),
            ['store', 'services', 'language'].forEach(g => {
              f[g] = this[g];
            }),
            (f.services = { ...this.services }),
            (f.services.utils = {
              hasLoadedNamespace: f.hasLoadedNamespace.bind(f),
            }),
            r)
          ) {
            const g = Object.keys(this.store.data).reduce(
              (d, p) => (
                (d[p] = { ...this.store.data[p] }),
                (d[p] = Object.keys(d[p]).reduce(
                  (b, y) => ((b[y] = { ...d[p][y] }), b),
                  d[p]
                )),
                d
              ),
              {}
            );
            ((f.store = new Hh(g, u)), (f.services.resourceStore = f.store));
          }
          return (
            (f.translator = new As(f.services, u)),
            f.translator.on('*', (g, ...d) => {
              f.emit(g, ...d);
            }),
            f.init(u, l),
            (f.translator.options = u),
            (f.translator.backendConnector.services.utils = {
              hasLoadedNamespace: f.hasLoadedNamespace.bind(f),
            }),
            f
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Eu = il.createInstance();
      Eu.createInstance = il.createInstance;
      const Uv = (s, a, l, r) => {
          const u = [l, { code: a, ...(r || {}) }];
          if (s?.services?.logger?.forward)
            return s.services.logger.forward(u, 'warn', 'react-i18next::', !0);
          (sn(u[0]) && (u[0] = `react-i18next:: ${u[0]}`),
            s?.services?.logger?.warn
              ? s.services.logger.warn(...u)
              : console?.warn && console.warn(...u));
        },
        Xh = {},
        du = (s, a, l, r) => {
          (sn(l) && Xh[l]) || (sn(l) && (Xh[l] = new Date()), Uv(s, a, l, r));
        },
        mp = (s, a) => () => {
          if (s.isInitialized) a();
          else {
            const l = () => {
              (setTimeout(() => {
                s.off('initialized', l);
              }, 0),
                a());
            };
            s.on('initialized', l);
          }
        },
        hu = (s, a, l) => {
          s.loadNamespaces(a, mp(s, l));
        },
        Qh = (s, a, l, r) => {
          if (
            (sn(l) && (l = [l]),
            s.options.preload && s.options.preload.indexOf(a) > -1)
          )
            return hu(s, l, r);
          (l.forEach(u => {
            s.options.ns.indexOf(u) < 0 && s.options.ns.push(u);
          }),
            s.loadLanguages(a, mp(s, r)));
        },
        Gv = (s, a, l = {}) =>
          !a.languages || !a.languages.length
            ? (du(a, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: a.languages,
              }),
              !0)
            : a.hasLoadedNamespace(s, {
                lng: l.lng,
                precheck: (r, u) => {
                  if (
                    l.bindI18n &&
                    l.bindI18n.indexOf('languageChanging') > -1 &&
                    r.services.backendConnector.backend &&
                    r.isLanguageChangingTo &&
                    !u(r.isLanguageChangingTo, s)
                  )
                    return !1;
                },
              }),
        sn = s => typeof s == 'string',
        Vv = s => typeof s == 'object' && s !== null,
        Yv =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        qv = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        $v = s => qv[s],
        Kv = s => s.replace(Yv, $v);
      let pu = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: Kv,
      };
      const kv = (s = {}) => {
          pu = { ...pu, ...s };
        },
        Xv = () => pu;
      let gp;
      const Qv = s => {
          gp = s;
        },
        Zv = () => gp,
        Jv = {
          type: '3rdParty',
          init(s) {
            (kv(s.options.react), Qv(s));
          },
        },
        vp = F.createContext();
      class Fv {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(a) {
          a.forEach(l => {
            this.usedNamespaces[l] || (this.usedNamespaces[l] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const Iv = (s, a) => {
          const l = F.useRef();
          return (
            F.useEffect(() => {
              l.current = s;
            }, [s, a]),
            l.current
          );
        },
        yp = (s, a, l, r) => s.getFixedT(a, l, r),
        Pv = (s, a, l, r) => F.useCallback(yp(s, a, l, r), [s, a, l, r]),
        Ke = (s, a = {}) => {
          const { i18n: l } = a,
            { i18n: r, defaultNS: u } = F.useContext(vp) || {},
            f = l || r || Zv();
          if (
            (f && !f.reportNamespaces && (f.reportNamespaces = new Fv()), !f)
          ) {
            du(
              f,
              'NO_I18NEXT_INSTANCE',
              'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
            );
            const k = (J, Z) =>
                sn(Z)
                  ? Z
                  : Vv(Z) && sn(Z.defaultValue)
                    ? Z.defaultValue
                    : Array.isArray(J)
                      ? J[J.length - 1]
                      : J,
              H = [k, {}, !1];
            return ((H.t = k), (H.i18n = {}), (H.ready = !1), H);
          }
          f.options.react?.wait &&
            du(
              f,
              'DEPRECATED_OPTION',
              'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
            );
          const h = { ...Xv(), ...f.options.react, ...a },
            { useSuspense: g, keyPrefix: d } = h;
          let p = s || u || f.options?.defaultNS;
          ((p = sn(p) ? [p] : p || ['translation']),
            f.reportNamespaces.addUsedNamespaces?.(p));
          const b =
              (f.isInitialized || f.initializedStoreOnce) &&
              p.every(k => Gv(k, f, h)),
            y = Pv(f, a.lng || null, h.nsMode === 'fallback' ? p : p[0], d),
            w = () => y,
            x = () =>
              yp(f, a.lng || null, h.nsMode === 'fallback' ? p : p[0], d),
            [O, _] = F.useState(w);
          let L = p.join();
          a.lng && (L = `${a.lng}${L}`);
          const $ = Iv(L),
            B = F.useRef(!0);
          (F.useEffect(() => {
            const { bindI18n: k, bindI18nStore: H } = h;
            ((B.current = !0),
              !b &&
                !g &&
                (a.lng
                  ? Qh(f, a.lng, p, () => {
                      B.current && _(x);
                    })
                  : hu(f, p, () => {
                      B.current && _(x);
                    })),
              b && $ && $ !== L && B.current && _(x));
            const J = () => {
              B.current && _(x);
            };
            return (
              k && f?.on(k, J),
              H && f?.store.on(H, J),
              () => {
                ((B.current = !1),
                  f && k && k?.split(' ').forEach(Z => f.off(Z, J)),
                  H && f && H.split(' ').forEach(Z => f.store.off(Z, J)));
              }
            );
          }, [f, L]),
            F.useEffect(() => {
              B.current && b && _(w);
            }, [f, d, b]));
          const K = [O, f, b];
          if (((K.t = O), (K.i18n = f), (K.ready = b), b || (!b && !g)))
            return K;
          throw new Promise(k => {
            a.lng ? Qh(f, a.lng, p, () => k()) : hu(f, p, () => k());
          });
        };
      function Wv({ i18n: s, defaultNS: a, children: l }) {
        const r = F.useMemo(() => ({ i18n: s, defaultNS: a }), [s, a]);
        return F.createElement(vp.Provider, { value: r }, l);
      }
      const ey = 'page_u-FRu',
        ty = { page: ey },
        iy = 'stack_jQUt5',
        ny = { stack: iy },
        ay = 'nav_Gz3v4',
        ly = 'visible_K-81c',
        sy = 'inner_akxCF',
        ry = 'title_h-wE3',
        oy = 'cta_KMii5',
        uy = 'mbNav_leuiB',
        Jn = { nav: ay, visible: ly, inner: sy, title: ry, cta: oy, mbNav: uy },
        cy = new Set([
          'creality.com',
          'www.creality.com',
          'devofficial.creality.com',
        ]);
      function fy() {
        return cy.has(window.location.hostname.toLowerCase());
      }
      function dy({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb',
          r = F.useRef(null),
          [u, f] = F.useState(!1),
          [h, g] = F.useState(!1);
        return (
          F.useEffect(() => {
            fy() || f(!0);
          }, []),
          F.useEffect(() => {
            if (!u) return;
            const d =
              document.querySelector('.t1-nav-trigger') ??
              r.current?.nextElementSibling;
            if (!d) return;
            const p = () => {
              g(d.getBoundingClientRect().top < -24);
            };
            return (
              window.addEventListener('scroll', p, { passive: !0 }),
              window.addEventListener('resize', p),
              p(),
              () => {
                (window.removeEventListener('scroll', p),
                  window.removeEventListener('resize', p));
              }
            );
          }, [u]),
          u
            ? A.jsx('nav', {
                ref: r,
                className: `t1-sticky-nav ${Jn.nav} ${l ? Jn.mbNav : ''} ${h ? Jn.visible : ''}`,
                'aria-hidden': !h,
                children: A.jsxs('div', {
                  className: Jn.inner,
                  children: [
                    A.jsx('span', {
                      className: Jn.title,
                      children: a('stickyNav.title'),
                    }),
                    A.jsx('a', {
                      className: Jn.cta,
                      href: a('stickyNav.shopLink'),
                      target: '_blank',
                      rel: 'noreferrer',
                      children: a('stickyNav.shopNow'),
                    }),
                  ],
                }),
              })
            : null
        );
      }
      function hy(s) {
        return s.replace(/\n/g, '<br />');
      }
      function Ee({ html: s, as: a = 'p', ...l }) {
        return s
          ? A.jsx(a, { ...l, dangerouslySetInnerHTML: { __html: hy(s) } })
          : null;
      }
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const py =
          typeof document < 'u' && document.documentMode,
        my = {
          rootMargin: '0px',
          threshold: 0,
          load(s) {
            if (s.nodeName.toLowerCase() === 'picture') {
              let l = s.querySelector('img'),
                r = !1;
              (l === null && ((l = document.createElement('img')), (r = !0)),
                py &&
                  s.getAttribute('data-iesrc') &&
                  (l.src = s.getAttribute('data-iesrc')),
                s.getAttribute('data-alt') &&
                  (l.alt = s.getAttribute('data-alt')),
                r && s.append(l));
            }
            if (
              s.nodeName.toLowerCase() === 'video' &&
              !s.getAttribute('data-src') &&
              s.children
            ) {
              const l = s.children;
              let r;
              for (let u = 0; u <= l.length - 1; u++)
                ((r = l[u].getAttribute('data-src')), r && (l[u].src = r));
              s.load();
            }
            (s.getAttribute('data-poster') &&
              (s.poster = s.getAttribute('data-poster')),
              s.getAttribute('data-src') &&
                (s.src = s.getAttribute('data-src')),
              s.getAttribute('data-srcset') &&
                s.setAttribute('srcset', s.getAttribute('data-srcset')));
            let a = ',';
            if (
              (s.getAttribute('data-background-delimiter') &&
                (a = s.getAttribute('data-background-delimiter')),
              s.getAttribute('data-background-image'))
            )
              s.style.backgroundImage = `url('${s.getAttribute('data-background-image').split(a).join("'),url('")}')`;
            else if (s.getAttribute('data-background-image-set')) {
              const l = s.getAttribute('data-background-image-set').split(a);
              let r = l[0].substr(0, l[0].indexOf(' ')) || l[0];
              ((r = r.indexOf('url(') === -1 ? `url(${r})` : r),
                l.length === 1
                  ? (s.style.backgroundImage = r)
                  : s.setAttribute(
                      'style',
                      (s.getAttribute('style') || '') +
                        `background-image: ${r}; background-image: -webkit-image-set(${l}); background-image: image-set(${l})`
                    ));
            }
            s.getAttribute('data-toggle-class') &&
              s.classList.toggle(s.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function mu(s) {
        s.setAttribute('data-loaded', !0);
      }
      function gy(s) {
        s.getAttribute('data-placeholder-background') &&
          (s.style.background = s.getAttribute('data-placeholder-background'));
      }
      const gu = s => s.getAttribute('data-loaded') === 'true',
        vy = (s, a) => (l, r) => {
          l.forEach(u => {
            (u.intersectionRatio > 0 || u.isIntersecting) &&
              (r.unobserve(u.target),
              gu(u.target) || (s(u.target), mu(u.target), a(u.target)));
          });
        },
        Zh = (s, a = document) =>
          s instanceof Element
            ? [s]
            : s instanceof NodeList
              ? s
              : a.querySelectorAll(s);
      function yy(s = '.lozad', a = {}) {
        const {
          root: l,
          rootMargin: r,
          threshold: u,
          load: f,
          loaded: h,
        } = Object.assign({}, my, a);
        let g;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (g = new IntersectionObserver(vy(f, h), {
            root: l,
            rootMargin: r,
            threshold: u,
          }));
        const d = Zh(s, l);
        for (let p = 0; p < d.length; p++) gy(d[p]);
        return {
          observe() {
            const p = Zh(s, l);
            for (let b = 0; b < p.length; b++)
              if (!gu(p[b])) {
                if (g) {
                  g.observe(p[b]);
                  continue;
                }
                (f(p[b]), mu(p[b]), h(p[b]));
              }
          },
          triggerLoad(p) {
            gu(p) || (f(p), mu(p), h(p));
          },
          observer: g,
        };
      }
      const by = ({ name: s, className: a = '', style: l, size: r, ...u }) => {
        const f = { lineHeight: '1', fontSize: r, ...l };
        return A.jsx('i', {
          className: `creality-product-info-iconfont ${s} ${a}`,
          style: f,
          ...u,
        });
      };
      function bp(...s) {
        const a = [];
        for (const l of s)
          if (l) {
            if (typeof l == 'string' || typeof l == 'number') a.push(l);
            else if (Array.isArray(l)) {
              const r = bp(...l);
              r && a.push(r);
            } else if (typeof l == 'object')
              for (const r in l) l.hasOwnProperty(r) && l[r] && a.push(r);
          }
        return a.join(' ');
      }
      const Sy = () => {
          if (typeof window > 'u') {
            const s = globalThis.__SSR_LANG__;
            if (s) return s;
          }
          return 'de';
        },
        xy = 'mediaPicture_GEnv7',
        Ty = 'mediaImage_pGzlz',
        Jh = { mediaPicture: xy, mediaImage: Ty },
        tu = '(max-width: 768px)';
      function Fh(s) {
        return s
          ? Object.entries(s)
              .filter(([, a]) => a != null && a !== '')
              .map(([a, l]) => {
                const r = a.startsWith('--')
                    ? a
                    : a.replace(/[A-Z]/g, f => `-${f.toLowerCase()}`),
                  u =
                    typeof l == 'number' &&
                    !/^(zIndex|opacity|flex|order|lineHeight|fontWeight|zoom)$/.test(
                      a
                    )
                      ? `${l}px`
                      : String(l);
                return `${r}:${u} !important;`;
              })
              .join('')
          : '';
      }
      function Ih(s) {
        if (typeof s != 'string') return;
        const a = s.trim();
        if (a !== '') return a.startsWith('//') ? `https:${a}` : a;
      }
      const Ey = ({
          pcSrc: s,
          mobileSrc: a,
          style: l,
          pcAspectRatio: r,
          mobileAspectRatio: u,
          pcClassName: f,
          mobileClassName: h,
          pcStyle: g,
          mobileStyle: d,
          fallback: p,
          showFallbackText: b = !0,
          enableLazyLoad: y = !1,
          rootMargin: w = '400px',
          threshold: x = 0,
          alt: O = '',
          ..._
        }) => {
          const [L, $] = F.useState(!1),
            [B, K] = F.useState(!1),
            k = F.useRef(null),
            J = `mediaImage-${F.useId().replace(/[^a-zA-Z0-9_-]/g, '')}`,
            Z = Ih(s),
            G = Ih(a),
            ee = Z ?? G;
          (F.useEffect(() => {
            K(!0);
          }, []),
            F.useEffect(() => {
              $(!1);
            }, [Z, G]),
            F.useEffect(() => {
              if (!y || !B || !k.current) return;
              yy(k.current, {
                rootMargin: w,
                threshold: x,
                loaded: he => he.classList.add('lozad-loaded'),
              }).observe();
            }, [B, y, w, x, Z, G]));
          const Q = A.jsx('div', {
            style: {
              width: _.width || '100%',
              height: _.height || '100%',
              aspectRatio: r || u,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(243,244,246)',
              ...l,
            },
            children: A.jsx(by, {
              name: 'icon-zhanweifu',
              style: {
                fontSize: '36px',
                lineHeight: '40px',
                color: 'rgba(156,163,175)',
                opacity: 0.2,
              },
            }),
          });
          if (!ee) return p ? A.jsx(A.Fragment, { children: p }) : b ? Q : null;
          if (B && L)
            return p ? A.jsx(A.Fragment, { children: p }) : b ? Q : null;
          const I = Fh({ ...(r ? { aspectRatio: r } : {}), ...g }),
            ie = Fh({ ...(u ? { aspectRatio: u } : {}), ...d }),
            oe = [
              I ? `@media not all and ${tu}{.${J}{${I}}}` : '',
              ie ? `@media ${tu}{.${J}{${ie}}}` : '',
            ]
              .filter(Boolean)
              .join('');
          return A.jsxs(A.Fragment, {
            children: [
              oe && A.jsx('style', { dangerouslySetInnerHTML: { __html: oe } }),
              A.jsxs('picture', {
                className: Jh.mediaPicture,
                children: [
                  G && A.jsx('source', { media: tu, srcSet: G }),
                  Z && A.jsx('source', { srcSet: Z }),
                  A.jsx('img', {
                    loading: 'lazy',
                    ref: k,
                    'data-src': y ? ee : void 0,
                    src: y ? void 0 : ee,
                    alt: O,
                    onError: () => $(!0),
                    ..._,
                    className: bp('lozad', Jh.mediaImage, J, _.className, f, h),
                    style: {
                      ...(_.width ? { width: _.width } : {}),
                      ...(_.height ? { height: _.height } : {}),
                      objectFit: 'cover',
                      display: 'block',
                      ...l,
                    },
                  }),
                ],
              }),
            ],
          });
        },
        Sp = (s, a, l = `${a}M`) => {
          const r = s(a),
            u = s(l) || r;
          return { pcSrc: r, mobileSrc: u };
        },
        wy = 'media_Wv7Xf',
        Ay = 'host_XsniQ',
        My = 'placeholder_L-dax',
        vu = { media: wy, host: Ay, placeholder: My },
        Oy = '1400px 0px',
        Ph = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
      function dt({
        imageKey: s,
        mobileImageKey: a,
        className: l,
        eager: r = !1,
        pcAspectRatio: u,
        mobileAspectRatio: f,
        alt: h = '',
        variant: g = 'pc',
        kind: d = 'image',
        active: p,
        loop: b = !0,
        onEnded: y,
      }) {
        const { t: w } = Ke('imageUrl'),
          { pcSrc: x, mobileSrc: O } = Sp(w, s, a),
          _ = g === 'mb' ? O : x,
          L = `${vu.media} ${l ?? ''}`,
          $ = A.jsx('div', {
            className: `${L} ${vu.placeholder}`,
            style: { '--t1-media-pc-ar': u, '--t1-media-mb-ar': f },
            'aria-hidden': 'true',
          });
        if (d === 'video' || Ph.test(_)) {
          if (!_) return $;
          if (Ph.test(_))
            return A.jsx(_y, {
              src: _,
              eager: r,
              active: p,
              loop: b,
              onEnded: y,
              className: l,
              mediaClass: L,
              placeholder: $,
            });
        }
        return A.jsx(Ey, {
          className: L,
          fallback: $,
          pcSrc: x,
          mobileSrc: O,
          pcAspectRatio: u,
          mobileAspectRatio: f,
          alt: h,
          loading: r ? 'eager' : 'lazy',
          fetchPriority: r ? 'high' : void 0,
          enableLazyLoad: !1,
        });
      }
      function _y({
        src: s,
        eager: a,
        active: l,
        loop: r,
        onEnded: u,
        className: f,
        mediaClass: h,
        placeholder: g,
      }) {
        const d = F.useRef(null),
          p = F.useRef(null),
          [b, y] = F.useState(a),
          [w, x] = F.useState(!1),
          O = w && l !== !1;
        return (
          F.useEffect(() => {
            const _ = d.current;
            if (!_) return;
            const L = new IntersectionObserver(
                ([B]) => {
                  B?.isIntersecting && y(!0);
                },
                { rootMargin: Oy }
              ),
              $ = new IntersectionObserver(
                ([B]) => {
                  B?.target.isConnected && x(B.isIntersecting);
                },
                { threshold: 0 }
              );
            return (
              L.observe(_),
              $.observe(_),
              () => {
                (L.disconnect(), $.disconnect());
              }
            );
          }, []),
          F.useEffect(() => {
            const _ = p.current;
            if (_) {
              if (O) {
                _.play().catch(() => {});
                return;
              }
              _.pause();
            }
          }, [O, s]),
          F.useEffect(() => {
            if (r || l === !1) return;
            const _ = p.current;
            if (
              !_ ||
              !(
                _.ended ||
                (Number.isFinite(_.duration) &&
                  _.duration > 0 &&
                  _.currentTime >= _.duration - 0.05)
              )
            )
              return;
            const $ = () => {
              (_.removeEventListener('seeked', $), _.play().catch(() => {}));
            };
            return (
              _.addEventListener('seeked', $),
              (_.currentTime = 0),
              () => _.removeEventListener('seeked', $)
            );
          }, [l, r, s]),
          A.jsx('div', {
            ref: d,
            className: `${vu.host} ${f ?? ''}`,
            children: b
              ? A.jsx(
                  'video',
                  {
                    ref: p,
                    className: h,
                    src: s,
                    muted: !0,
                    loop: r,
                    playsInline: !0,
                    preload: 'auto',
                    onEnded: u,
                  },
                  s
                )
              : g,
          })
        );
      }
      const zy = 'section_-LFWd',
        Ny = 'mbSection_wQ8w8',
        Cy = 'bg_lqoBJ',
        Ry = 'content_Z55eF',
        Dy = 'title_OG39E',
        Ly = 'subtitle_utBl-',
        jy = 'cta_gil0z',
        en = {
          section: zy,
          mbSection: Ny,
          bg: Cy,
          content: Ry,
          title: Dy,
          subtitle: Ly,
          cta: jy,
        };
      function By({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsxs('section', {
          className: `t1-nav-trigger ${en.section} ${l ? en.mbSection : ''}`,
          children: [
            A.jsx(dt, {
              className: en.bg,
              imageKey: 'heroKV',
              pcAspectRatio: '2560/1442',
              mobileAspectRatio: '750/1000',
              eager: !0,
            }),
            A.jsxs('div', {
              className: en.content,
              children: [
                A.jsx(Ee, {
                  as: 'h1',
                  className: en.title,
                  html: a('section1.title'),
                }),
                A.jsx(Ee, {
                  className: en.subtitle,
                  html: a('section1.subtitle'),
                }),
                A.jsx('a', {
                  className: en.cta,
                  href: a('section1.shopLink'),
                  target: '_blank',
                  children: a('section1.shopNow'),
                }),
              ],
            }),
          ],
        });
      }
      const Hy = 'section_gd0rk',
        Uy = 'mbSection_RO5fI',
        Gy = 'body_A0n1o',
        iu = { section: Hy, mbSection: Uy, body: Gy };
      function Vy({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsx('section', {
          className: `${iu.section} ${l ? iu.mbSection : ''}`,
          children: A.jsx(Ee, { className: iu.body, html: a('section2.body') }),
        });
      }
      const Yy = 'section_2hgqK',
        qy = 'mbSection_Nf-Ie',
        $y = 'grid_8N4-1',
        Ky = 'row_asbJs',
        ky = 'rowReversed_joxJj',
        Xy = 'column_wovYz',
        Qy = 'big_0DzuC',
        Zy = 'small_ziv0I',
        Jy = 'card_vReDX',
        Fy = 'cardMedia_tmIBq',
        Iy = 'light_m7h2d',
        Py = 'cardTitle_7Pa4r',
        Wy = 'cardDesc_hCo-B',
        eb = 'cardCopy_QcA-9',
        tb = 'mbList_5fHCR',
        ib = 'mbCard_H6Z4C',
        We = {
          section: Yy,
          mbSection: qy,
          grid: $y,
          row: Ky,
          rowReversed: ky,
          column: Xy,
          big: Qy,
          small: Zy,
          card: Jy,
          cardMedia: Fy,
          light: Iy,
          cardTitle: Py,
          cardDesc: Wy,
          cardCopy: eb,
          mbList: tb,
          mbCard: ib,
        },
        Je = {
          lasers: { id: 'lasers', imageKey: 'hlModule', kind: 'video' },
          toolFree: { id: 'toolFree', imageKey: 'hlPrecision', kind: 'video' },
          materials: { id: 'materials', imageKey: 'hlGalvo', theme: 'light' },
          chooseLaser: {
            id: 'chooseLaser',
            imageKey: 'hlAutoFocus',
            kind: 'video',
          },
          hdCamera: { id: 'hdCamera', imageKey: 'hlScreen', theme: 'light' },
          autoFocus: { id: 'autoFocus', imageKey: 'hlDetail', kind: 'video' },
          class1: { id: 'class1', imageKey: 'hlSafety', kind: 'video' },
          portable: { id: 'portable', imageKey: 'hlConveyor', theme: 'light' },
          ai: { id: 'ai', imageKey: 'hlAi', theme: 'light' },
        },
        nb = [
          { big: Je.lasers, smalls: [Je.toolFree, Je.materials] },
          {
            big: Je.autoFocus,
            smalls: [Je.chooseLaser, Je.hdCamera],
            reversed: !0,
          },
          { big: Je.class1, smalls: [Je.portable, Je.ai] },
        ],
        ab = [
          Je.lasers,
          Je.toolFree,
          Je.materials,
          Je.chooseLaser,
          Je.hdCamera,
          Je.autoFocus,
          Je.class1,
          Je.portable,
          Je.ai,
        ];
      function yu({ card: s, className: a, mb: l = !1 }) {
        const { t: r } = Ke(),
          u = s.theme === 'light';
        return A.jsxs('div', {
          className: `${We.card} ${u ? We.light : ''} ${a ?? ''}`,
          children: [
            A.jsx(dt, {
              className: We.cardMedia,
              imageKey: s.imageKey,
              variant: l ? 'mb' : 'pc',
              kind: s.kind,
              eager: !0,
            }),
            A.jsxs('div', {
              className: We.cardCopy,
              children: [
                A.jsx(Ee, {
                  as: 'h3',
                  className: We.cardTitle,
                  html: r(`section3.${s.id}.title`),
                }),
                A.jsx(Ee, {
                  className: We.cardDesc,
                  html: r(`section3.${s.id}.desc`),
                }),
              ],
            }),
          ],
        });
      }
      function lb() {
        return A.jsx('section', {
          className: We.section,
          children: A.jsx('div', {
            className: We.grid,
            children: nb.map(s =>
              A.jsxs(
                'div',
                {
                  className: `${We.row} ${s.reversed ? We.rowReversed : ''}`,
                  children: [
                    A.jsx(yu, { card: s.big, className: We.big }),
                    A.jsx('div', {
                      className: We.column,
                      children: s.smalls.map(a =>
                        A.jsx(yu, { card: a, className: We.small }, a.id)
                      ),
                    }),
                  ],
                },
                s.big.id
              )
            ),
          }),
        });
      }
      function sb() {
        return A.jsx('section', {
          className: `${We.section} ${We.mbSection}`,
          children: A.jsx('div', {
            className: We.mbList,
            children: ab.map(s =>
              A.jsx(yu, { card: s, className: We.mbCard, mb: !0 }, s.id)
            ),
          }),
        });
      }
      function rb({ variant: s = 'pc' }) {
        return s === 'mb' ? A.jsx(sb, {}) : A.jsx(lb, {});
      }
      const ob = 'section_kDgRv',
        ub = 'mbSection_B9Jrh',
        cb = 'content_15zCe',
        fb = 'title_WGW59',
        db = 'body_Wh7Pm',
        hb = 'media_sToSB',
        pb = 'video_aIWLE',
        tn = {
          section: ob,
          mbSection: ub,
          content: cb,
          title: fb,
          body: db,
          media: hb,
          video: pb,
        };
      function mb({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsxs('section', {
          className: `${tn.section} ${l ? tn.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: tn.content,
              children: [
                A.jsx(Ee, {
                  as: 'h2',
                  className: tn.title,
                  html: a('section4.title'),
                }),
                A.jsx(Ee, { className: tn.body, html: a('section4.body') }),
              ],
            }),
            A.jsx('div', {
              className: tn.media,
              children: A.jsx(dt, {
                className: tn.video,
                imageKey: 'section4Bg',
                variant: s,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      function Wh(s) {
        return (
          s !== null &&
          typeof s == 'object' &&
          'constructor' in s &&
          s.constructor === Object
        );
      }
      function wu(s = {}, a = {}) {
        const l = ['__proto__', 'constructor', 'prototype'];
        Object.keys(a)
          .filter(r => l.indexOf(r) < 0)
          .forEach(r => {
            typeof s[r] > 'u'
              ? (s[r] = a[r])
              : Wh(a[r]) &&
                Wh(s[r]) &&
                Object.keys(a[r]).length > 0 &&
                wu(s[r], a[r]);
          });
      }
      const xp = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function on() {
        const s = typeof document < 'u' ? document : {};
        return (wu(s, xp), s);
      }
      const gb = {
        document: xp,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return '';
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(s) {
          return typeof setTimeout > 'u' ? (s(), null) : setTimeout(s, 0);
        },
        cancelAnimationFrame(s) {
          typeof setTimeout > 'u' || clearTimeout(s);
        },
      };
      function lt() {
        const s = typeof window < 'u' ? window : {};
        return (wu(s, gb), s);
      }
      function vb(s = '') {
        return s
          .trim()
          .split(' ')
          .filter(a => !!a.trim());
      }
      function yb(s) {
        const a = s;
        Object.keys(a).forEach(l => {
          try {
            a[l] = null;
          } catch {}
          try {
            delete a[l];
          } catch {}
        });
      }
      function Tp(s, a = 0) {
        return setTimeout(s, a);
      }
      function Ms() {
        return Date.now();
      }
      function bb(s) {
        const a = lt();
        let l;
        return (
          a.getComputedStyle && (l = a.getComputedStyle(s, null)),
          !l && s.currentStyle && (l = s.currentStyle),
          l || (l = s.style),
          l
        );
      }
      function Sb(s, a = 'x') {
        const l = lt();
        let r, u, f;
        const h = bb(s);
        return (
          l.WebKitCSSMatrix
            ? ((u = h.transform || h.webkitTransform),
              u.split(',').length > 6 &&
                (u = u
                  .split(', ')
                  .map(g => g.replace(',', '.'))
                  .join(', ')),
              (f = new l.WebKitCSSMatrix(u === 'none' ? '' : u)))
            : ((f =
                h.MozTransform ||
                h.OTransform ||
                h.MsTransform ||
                h.msTransform ||
                h.transform ||
                h
                  .getPropertyValue('transform')
                  .replace('translate(', 'matrix(1, 0, 0, 1,')),
              (r = f.toString().split(','))),
          a === 'x' &&
            (l.WebKitCSSMatrix
              ? (u = f.m41)
              : r.length === 16
                ? (u = parseFloat(r[12]))
                : (u = parseFloat(r[4]))),
          a === 'y' &&
            (l.WebKitCSSMatrix
              ? (u = f.m42)
              : r.length === 16
                ? (u = parseFloat(r[13]))
                : (u = parseFloat(r[5]))),
          u || 0
        );
      }
      function bs(s) {
        return (
          typeof s == 'object' &&
          s !== null &&
          s.constructor &&
          Object.prototype.toString.call(s).slice(8, -1) === 'Object'
        );
      }
      function xb(s) {
        return typeof window < 'u' && typeof window.HTMLElement < 'u'
          ? s instanceof HTMLElement
          : s && (s.nodeType === 1 || s.nodeType === 11);
      }
      function Et(...s) {
        const a = Object(s[0]),
          l = ['__proto__', 'constructor', 'prototype'];
        for (let r = 1; r < s.length; r += 1) {
          const u = s[r];
          if (u != null && !xb(u)) {
            const f = Object.keys(Object(u)).filter(h => l.indexOf(h) < 0);
            for (let h = 0, g = f.length; h < g; h += 1) {
              const d = f[h],
                p = Object.getOwnPropertyDescriptor(u, d);
              p !== void 0 &&
                p.enumerable &&
                (bs(a[d]) && bs(u[d])
                  ? u[d].__swiper__
                    ? (a[d] = u[d])
                    : Et(a[d], u[d])
                  : !bs(a[d]) && bs(u[d])
                    ? ((a[d] = {}),
                      u[d].__swiper__ ? (a[d] = u[d]) : Et(a[d], u[d]))
                    : (a[d] = u[d]));
            }
          }
        }
        return a;
      }
      function Ss(s, a, l) {
        s.style.setProperty(a, l);
      }
      function Ep({ swiper: s, targetPosition: a, side: l }) {
        const r = lt(),
          u = -s.translate;
        let f = null,
          h;
        const g = s.params.speed;
        ((s.wrapperEl.style.scrollSnapType = 'none'),
          r.cancelAnimationFrame(s.cssModeFrameID));
        const d = a > u ? 'next' : 'prev',
          p = (y, w) => (d === 'next' && y >= w) || (d === 'prev' && y <= w),
          b = () => {
            ((h = new Date().getTime()), f === null && (f = h));
            const y = Math.max(Math.min((h - f) / g, 1), 0),
              w = 0.5 - Math.cos(y * Math.PI) / 2;
            let x = u + w * (a - u);
            if (
              (p(x, a) && (x = a), s.wrapperEl.scrollTo({ [l]: x }), p(x, a))
            ) {
              ((s.wrapperEl.style.overflow = 'hidden'),
                (s.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  ((s.wrapperEl.style.overflow = ''),
                    s.wrapperEl.scrollTo({ [l]: x }));
                }),
                r.cancelAnimationFrame(s.cssModeFrameID));
              return;
            }
            s.cssModeFrameID = r.requestAnimationFrame(b);
          };
        b();
      }
      function oi(s, a = '') {
        const l = lt(),
          r = [...s.children];
        return (
          l.HTMLSlotElement &&
            s instanceof HTMLSlotElement &&
            r.push(...s.assignedElements()),
          a ? r.filter(u => u.matches(a)) : r
        );
      }
      function Tb(s, a) {
        const l = [a];
        for (; l.length > 0; ) {
          const r = l.shift();
          if (s === r) return !0;
          l.push(
            ...r.children,
            ...(r.shadowRoot ? r.shadowRoot.children : []),
            ...(r.assignedElements ? r.assignedElements() : [])
          );
        }
      }
      function Eb(s, a) {
        const l = lt();
        let r = a.contains(s);
        return (
          !r &&
            l.HTMLSlotElement &&
            a instanceof HTMLSlotElement &&
            ((r = [...a.assignedElements()].includes(s)), r || (r = Tb(s, a))),
          r
        );
      }
      function Os(s) {
        try {
          console.warn(s);
          return;
        } catch {}
      }
      function bu(s, a = []) {
        const l = document.createElement(s);
        return (l.classList.add(...(Array.isArray(a) ? a : vb(a))), l);
      }
      function wb(s, a) {
        const l = [];
        for (; s.previousElementSibling; ) {
          const r = s.previousElementSibling;
          (a ? r.matches(a) && l.push(r) : l.push(r), (s = r));
        }
        return l;
      }
      function Ab(s, a) {
        const l = [];
        for (; s.nextElementSibling; ) {
          const r = s.nextElementSibling;
          (a ? r.matches(a) && l.push(r) : l.push(r), (s = r));
        }
        return l;
      }
      function ji(s, a) {
        return lt().getComputedStyle(s, null).getPropertyValue(a);
      }
      function ep(s) {
        let a = s,
          l;
        if (a) {
          for (l = 0; (a = a.previousSibling) !== null; )
            a.nodeType === 1 && (l += 1);
          return l;
        }
      }
      function Mb(s, a) {
        const l = [];
        let r = s.parentElement;
        for (; r; ) (l.push(r), (r = r.parentElement));
        return l;
      }
      function tp(s, a, l) {
        const r = lt();
        return (
          s[a === 'width' ? 'offsetWidth' : 'offsetHeight'] +
          parseFloat(
            r
              .getComputedStyle(s, null)
              .getPropertyValue(a === 'width' ? 'margin-right' : 'margin-top')
          ) +
          parseFloat(
            r
              .getComputedStyle(s, null)
              .getPropertyValue(a === 'width' ? 'margin-left' : 'margin-bottom')
          )
        );
      }
      function ip(s, a = '') {
        typeof trustedTypes < 'u'
          ? (s.innerHTML = trustedTypes
              .createPolicy('html', { createHTML: l => l })
              .createHTML(a))
          : (s.innerHTML = a);
      }
      let nu;
      function Ob() {
        const s = lt(),
          a = on();
        return {
          smoothScroll:
            a.documentElement &&
            a.documentElement.style &&
            'scrollBehavior' in a.documentElement.style,
          touch: !!(
            'ontouchstart' in s ||
            (s.DocumentTouch && a instanceof s.DocumentTouch)
          ),
        };
      }
      function wp() {
        return (nu || (nu = Ob()), nu);
      }
      let au;
      function _b({ userAgent: s } = {}) {
        const a = wp(),
          l = lt(),
          r = l.navigator.platform,
          u = s || l.navigator.userAgent,
          f = { ios: !1, android: !1 },
          h = l.screen.width,
          g = l.screen.height,
          d = u.match(/(Android);?[\s\/]+([\d.]+)?/);
        let p = u.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const b = u.match(/(iPod)(.*OS\s([\d_]+))?/),
          y = !p && u.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
          w = r === 'Win32';
        let x = r === 'MacIntel';
        const O = [
          '1024x1366',
          '1366x1024',
          '834x1194',
          '1194x834',
          '834x1112',
          '1112x834',
          '768x1024',
          '1024x768',
          '820x1180',
          '1180x820',
          '810x1080',
          '1080x810',
        ];
        return (
          !p &&
            x &&
            a.touch &&
            O.indexOf(`${h}x${g}`) >= 0 &&
            ((p = u.match(/(Version)\/([\d.]+)/)),
            p || (p = [0, 1, '13_0_0']),
            (x = !1)),
          d && !w && ((f.os = 'android'), (f.android = !0)),
          (p || y || b) && ((f.os = 'ios'), (f.ios = !0)),
          f
        );
      }
      function Ap(s = {}) {
        return (au || (au = _b(s)), au);
      }
      let lu;
      function zb() {
        const s = lt(),
          a = Ap();
        let l = !1;
        function r() {
          const g = s.navigator.userAgent.toLowerCase();
          return (
            g.indexOf('safari') >= 0 &&
            g.indexOf('chrome') < 0 &&
            g.indexOf('android') < 0
          );
        }
        if (r()) {
          const g = String(s.navigator.userAgent);
          if (g.includes('Version/')) {
            const [d, p] = g
              .split('Version/')[1]
              .split(' ')[0]
              .split('.')
              .map(b => Number(b));
            l = d < 16 || (d === 16 && p < 2);
          }
        }
        const u = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            s.navigator.userAgent
          ),
          f = r(),
          h = f || (u && a.ios);
        return {
          isSafari: l || f,
          needPerspectiveFix: l,
          need3dFix: h,
          isWebView: u,
        };
      }
      function Mp() {
        return (lu || (lu = zb()), lu);
      }
      function Nb({ swiper: s, on: a, emit: l }) {
        const r = lt();
        let u = null,
          f = null;
        const h = () => {
            !s ||
              s.destroyed ||
              !s.initialized ||
              (l('beforeResize'), l('resize'));
          },
          g = () => {
            !s ||
              s.destroyed ||
              !s.initialized ||
              ((u = new ResizeObserver(b => {
                f = r.requestAnimationFrame(() => {
                  const { width: y, height: w } = s;
                  let x = y,
                    O = w;
                  (b.forEach(
                    ({ contentBoxSize: _, contentRect: L, target: $ }) => {
                      ($ && $ !== s.el) ||
                        ((x = L ? L.width : (_[0] || _).inlineSize),
                        (O = L ? L.height : (_[0] || _).blockSize));
                    }
                  ),
                    (x !== y || O !== w) && h());
                });
              })),
              u.observe(s.el));
          },
          d = () => {
            (f && r.cancelAnimationFrame(f),
              u && u.unobserve && s.el && (u.unobserve(s.el), (u = null)));
          },
          p = () => {
            !s || s.destroyed || !s.initialized || l('orientationchange');
          };
        (a('init', () => {
          if (s.params.resizeObserver && typeof r.ResizeObserver < 'u') {
            g();
            return;
          }
          (r.addEventListener('resize', h),
            r.addEventListener('orientationchange', p));
        }),
          a('destroy', () => {
            (d(),
              r.removeEventListener('resize', h),
              r.removeEventListener('orientationchange', p));
          }));
      }
      function Cb({ swiper: s, extendParams: a, on: l, emit: r }) {
        const u = [],
          f = lt(),
          h = (p, b = {}) => {
            const y = f.MutationObserver || f.WebkitMutationObserver,
              w = new y(x => {
                if (s.__preventObserver__) return;
                if (x.length === 1) {
                  r('observerUpdate', x[0]);
                  return;
                }
                const O = function () {
                  r('observerUpdate', x[0]);
                };
                f.requestAnimationFrame
                  ? f.requestAnimationFrame(O)
                  : f.setTimeout(O, 0);
              });
            (w.observe(p, {
              attributes: typeof b.attributes > 'u' ? !0 : b.attributes,
              childList:
                s.isElement || (typeof b.childList > 'u' ? !0 : b).childList,
              characterData:
                typeof b.characterData > 'u' ? !0 : b.characterData,
            }),
              u.push(w));
          },
          g = () => {
            if (s.params.observer) {
              if (s.params.observeParents) {
                const p = Mb(s.hostEl);
                for (let b = 0; b < p.length; b += 1) h(p[b]);
              }
              (h(s.hostEl, { childList: s.params.observeSlideChildren }),
                h(s.wrapperEl, { attributes: !1 }));
            }
          },
          d = () => {
            (u.forEach(p => {
              p.disconnect();
            }),
              u.splice(0, u.length));
          };
        (a({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          l('init', g),
          l('destroy', d));
      }
      var Rb = {
        on(s, a, l) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof a != 'function')
            return r;
          const u = l ? 'unshift' : 'push';
          return (
            s.split(' ').forEach(f => {
              (r.eventsListeners[f] || (r.eventsListeners[f] = []),
                r.eventsListeners[f][u](a));
            }),
            r
          );
        },
        once(s, a, l) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof a != 'function')
            return r;
          function u(...f) {
            (r.off(s, u),
              u.__emitterProxy && delete u.__emitterProxy,
              a.apply(r, f));
          }
          return ((u.__emitterProxy = a), r.on(s, u, l));
        },
        onAny(s, a) {
          const l = this;
          if (!l.eventsListeners || l.destroyed || typeof s != 'function')
            return l;
          const r = a ? 'unshift' : 'push';
          return (
            l.eventsAnyListeners.indexOf(s) < 0 && l.eventsAnyListeners[r](s),
            l
          );
        },
        offAny(s) {
          const a = this;
          if (!a.eventsListeners || a.destroyed || !a.eventsAnyListeners)
            return a;
          const l = a.eventsAnyListeners.indexOf(s);
          return (l >= 0 && a.eventsAnyListeners.splice(l, 1), a);
        },
        off(s, a) {
          const l = this;
          return (
            !l.eventsListeners ||
              l.destroyed ||
              !l.eventsListeners ||
              s.split(' ').forEach(r => {
                typeof a > 'u'
                  ? (l.eventsListeners[r] = [])
                  : l.eventsListeners[r] &&
                    l.eventsListeners[r].forEach((u, f) => {
                      (u === a ||
                        (u.__emitterProxy && u.__emitterProxy === a)) &&
                        l.eventsListeners[r].splice(f, 1);
                    });
              }),
            l
          );
        },
        emit(...s) {
          const a = this;
          if (!a.eventsListeners || a.destroyed || !a.eventsListeners) return a;
          let l, r, u;
          return (
            typeof s[0] == 'string' || Array.isArray(s[0])
              ? ((l = s[0]), (r = s.slice(1, s.length)), (u = a))
              : ((l = s[0].events), (r = s[0].data), (u = s[0].context || a)),
            r.unshift(u),
            (Array.isArray(l) ? l : l.split(' ')).forEach(h => {
              (a.eventsAnyListeners &&
                a.eventsAnyListeners.length &&
                a.eventsAnyListeners.forEach(g => {
                  g.apply(u, [h, ...r]);
                }),
                a.eventsListeners &&
                  a.eventsListeners[h] &&
                  a.eventsListeners[h].forEach(g => {
                    g.apply(u, r);
                  }));
            }),
            a
          );
        },
      };
      function Db() {
        const s = this;
        let a, l;
        const r = s.el;
        (typeof s.params.width < 'u' && s.params.width !== null
          ? (a = s.params.width)
          : (a = r.clientWidth),
          typeof s.params.height < 'u' && s.params.height !== null
            ? (l = s.params.height)
            : (l = r.clientHeight),
          !((a === 0 && s.isHorizontal()) || (l === 0 && s.isVertical())) &&
            ((a =
              a -
              parseInt(ji(r, 'padding-left') || 0, 10) -
              parseInt(ji(r, 'padding-right') || 0, 10)),
            (l =
              l -
              parseInt(ji(r, 'padding-top') || 0, 10) -
              parseInt(ji(r, 'padding-bottom') || 0, 10)),
            Number.isNaN(a) && (a = 0),
            Number.isNaN(l) && (l = 0),
            Object.assign(s, {
              width: a,
              height: l,
              size: s.isHorizontal() ? a : l,
            })));
      }
      function Lb() {
        const s = this;
        function a(Q, I) {
          return parseFloat(Q.getPropertyValue(s.getDirectionLabel(I)) || 0);
        }
        const l = s.params,
          { wrapperEl: r, slidesEl: u, rtlTranslate: f, wrongRTL: h } = s,
          g = s.virtual && l.virtual.enabled,
          d = g ? s.virtual.slides.length : s.slides.length,
          p = oi(u, `.${s.params.slideClass}, swiper-slide`),
          b = g ? s.virtual.slides.length : p.length;
        let y = [];
        const w = [],
          x = [];
        let O = l.slidesOffsetBefore;
        typeof O == 'function' && (O = l.slidesOffsetBefore.call(s));
        let _ = l.slidesOffsetAfter;
        typeof _ == 'function' && (_ = l.slidesOffsetAfter.call(s));
        const L = s.snapGrid.length,
          $ = s.slidesGrid.length,
          B = s.size - O - _;
        let K = l.spaceBetween,
          k = -O,
          H = 0,
          J = 0;
        if (typeof B > 'u') return;
        (typeof K == 'string' && K.indexOf('%') >= 0
          ? (K = (parseFloat(K.replace('%', '')) / 100) * B)
          : typeof K == 'string' && (K = parseFloat(K)),
          (s.virtualSize = -K - O - _),
          p.forEach(Q => {
            (f ? (Q.style.marginLeft = '') : (Q.style.marginRight = ''),
              (Q.style.marginBottom = ''),
              (Q.style.marginTop = ''));
          }),
          l.centeredSlides &&
            l.cssMode &&
            (Ss(r, '--swiper-centered-offset-before', ''),
            Ss(r, '--swiper-centered-offset-after', '')));
        const Z = l.grid && l.grid.rows > 1 && s.grid;
        Z ? s.grid.initSlides(p) : s.grid && s.grid.unsetSlides();
        let G;
        const ee =
          l.slidesPerView === 'auto' &&
          l.breakpoints &&
          Object.keys(l.breakpoints).filter(
            Q => typeof l.breakpoints[Q].slidesPerView < 'u'
          ).length > 0;
        for (let Q = 0; Q < b; Q += 1) {
          G = 0;
          const I = p[Q];
          if (
            !(
              I &&
              (Z && s.grid.updateSlide(Q, I, p), ji(I, 'display') === 'none')
            )
          ) {
            if (g && l.slidesPerView === 'auto')
              (l.virtual.slidesPerViewAutoSlideSize &&
                (G = l.virtual.slidesPerViewAutoSlideSize),
                G &&
                  I &&
                  (l.roundLengths && (G = Math.floor(G)),
                  (I.style[s.getDirectionLabel('width')] = `${G}px`)));
            else if (l.slidesPerView === 'auto') {
              ee && (I.style[s.getDirectionLabel('width')] = '');
              const ie = getComputedStyle(I),
                oe = I.style.transform,
                ue = I.style.webkitTransform;
              if (
                (oe && (I.style.transform = 'none'),
                ue && (I.style.webkitTransform = 'none'),
                l.roundLengths)
              )
                G = s.isHorizontal() ? tp(I, 'width') : tp(I, 'height');
              else {
                const he = a(ie, 'width'),
                  D = a(ie, 'padding-left'),
                  X = a(ie, 'padding-right'),
                  q = a(ie, 'margin-left'),
                  ne = a(ie, 'margin-right'),
                  T = ie.getPropertyValue('box-sizing');
                if (T && T === 'border-box') G = he + q + ne;
                else {
                  const { clientWidth: j, offsetWidth: W } = I;
                  G = he + D + X + q + ne + (W - j);
                }
              }
              (oe && (I.style.transform = oe),
                ue && (I.style.webkitTransform = ue),
                l.roundLengths && (G = Math.floor(G)));
            } else
              ((G = (B - (l.slidesPerView - 1) * K) / l.slidesPerView),
                l.roundLengths && (G = Math.floor(G)),
                I && (I.style[s.getDirectionLabel('width')] = `${G}px`));
            (I && (I.swiperSlideSize = G),
              x.push(G),
              l.centeredSlides
                ? ((k = k + G / 2 + H / 2 + K),
                  H === 0 && Q !== 0 && (k = k - B / 2 - K),
                  Q === 0 && (k = k - B / 2 - K),
                  Math.abs(k) < 1 / 1e3 && (k = 0),
                  l.roundLengths && (k = Math.floor(k)),
                  J % l.slidesPerGroup === 0 && y.push(k),
                  w.push(k))
                : (l.roundLengths && (k = Math.floor(k)),
                  (J - Math.min(s.params.slidesPerGroupSkip, J)) %
                    s.params.slidesPerGroup ===
                    0 && y.push(k),
                  w.push(k),
                  (k = k + G + K)),
              (s.virtualSize += G + K),
              (H = G),
              (J += 1));
          }
        }
        if (
          ((s.virtualSize = Math.max(s.virtualSize, B) + _),
          f &&
            h &&
            (l.effect === 'slide' || l.effect === 'coverflow') &&
            (r.style.width = `${s.virtualSize + K}px`),
          l.setWrapperSize &&
            (r.style[s.getDirectionLabel('width')] = `${s.virtualSize + K}px`),
          Z && s.grid.updateWrapperSize(G, y),
          !l.centeredSlides)
        ) {
          const Q = [];
          for (let I = 0; I < y.length; I += 1) {
            let ie = y[I];
            (l.roundLengths && (ie = Math.floor(ie)),
              y[I] <= s.virtualSize - B && Q.push(ie));
          }
          ((y = Q),
            Math.floor(s.virtualSize - B) - Math.floor(y[y.length - 1]) > 1 &&
              y.push(s.virtualSize - B));
        }
        if (g && l.loop) {
          const Q = x[0] + K;
          if (l.slidesPerGroup > 1) {
            const I = Math.ceil(
                (s.virtual.slidesBefore + s.virtual.slidesAfter) /
                  l.slidesPerGroup
              ),
              ie = Q * l.slidesPerGroup;
            for (let oe = 0; oe < I; oe += 1) y.push(y[y.length - 1] + ie);
          }
          for (
            let I = 0;
            I < s.virtual.slidesBefore + s.virtual.slidesAfter;
            I += 1
          )
            (l.slidesPerGroup === 1 && y.push(y[y.length - 1] + Q),
              w.push(w[w.length - 1] + Q),
              (s.virtualSize += Q));
        }
        if ((y.length === 0 && (y = [0]), K !== 0)) {
          const Q =
            s.isHorizontal() && f
              ? 'marginLeft'
              : s.getDirectionLabel('marginRight');
          p.filter((I, ie) =>
            !l.cssMode || l.loop ? !0 : ie !== p.length - 1
          ).forEach(I => {
            I.style[Q] = `${K}px`;
          });
        }
        if (l.centeredSlides && l.centeredSlidesBounds) {
          let Q = 0;
          (x.forEach(ie => {
            Q += ie + (K || 0);
          }),
            (Q -= K));
          const I = Q > B ? Q - B : 0;
          y = y.map(ie => (ie <= 0 ? -O : ie > I ? I + _ : ie));
        }
        if (l.centerInsufficientSlides) {
          let Q = 0;
          (x.forEach(ie => {
            Q += ie + (K || 0);
          }),
            (Q -= K));
          const I = (O || 0) + (_ || 0);
          if (Q + I < B) {
            const ie = (B - Q - I) / 2;
            (y.forEach((oe, ue) => {
              y[ue] = oe - ie;
            }),
              w.forEach((oe, ue) => {
                w[ue] = oe + ie;
              }));
          }
        }
        if (
          (Object.assign(s, {
            slides: p,
            snapGrid: y,
            slidesGrid: w,
            slidesSizesGrid: x,
          }),
          l.centeredSlides && l.cssMode && !l.centeredSlidesBounds)
        ) {
          (Ss(r, '--swiper-centered-offset-before', `${-y[0]}px`),
            Ss(
              r,
              '--swiper-centered-offset-after',
              `${s.size / 2 - x[x.length - 1] / 2}px`
            ));
          const Q = -s.snapGrid[0],
            I = -s.slidesGrid[0];
          ((s.snapGrid = s.snapGrid.map(ie => ie + Q)),
            (s.slidesGrid = s.slidesGrid.map(ie => ie + I)));
        }
        if (
          (b !== d && s.emit('slidesLengthChange'),
          y.length !== L &&
            (s.params.watchOverflow && s.checkOverflow(),
            s.emit('snapGridLengthChange')),
          w.length !== $ && s.emit('slidesGridLengthChange'),
          l.watchSlidesProgress && s.updateSlidesOffset(),
          s.emit('slidesUpdated'),
          !g && !l.cssMode && (l.effect === 'slide' || l.effect === 'fade'))
        ) {
          const Q = `${l.containerModifierClass}backface-hidden`,
            I = s.el.classList.contains(Q);
          b <= l.maxBackfaceHiddenSlides
            ? I || s.el.classList.add(Q)
            : I && s.el.classList.remove(Q);
        }
      }
      function jb(s) {
        const a = this,
          l = [],
          r = a.virtual && a.params.virtual.enabled;
        let u = 0,
          f;
        typeof s == 'number'
          ? a.setTransition(s)
          : s === !0 && a.setTransition(a.params.speed);
        const h = g => (r ? a.slides[a.getSlideIndexByData(g)] : a.slides[g]);
        if (a.params.slidesPerView !== 'auto' && a.params.slidesPerView > 1)
          if (a.params.centeredSlides)
            (a.visibleSlides || []).forEach(g => {
              l.push(g);
            });
          else
            for (f = 0; f < Math.ceil(a.params.slidesPerView); f += 1) {
              const g = a.activeIndex + f;
              if (g > a.slides.length && !r) break;
              l.push(h(g));
            }
        else l.push(h(a.activeIndex));
        for (f = 0; f < l.length; f += 1)
          if (typeof l[f] < 'u') {
            const g = l[f].offsetHeight;
            u = g > u ? g : u;
          }
        (u || u === 0) && (a.wrapperEl.style.height = `${u}px`);
      }
      function Bb() {
        const s = this,
          a = s.slides,
          l = s.isElement
            ? s.isHorizontal()
              ? s.wrapperEl.offsetLeft
              : s.wrapperEl.offsetTop
            : 0;
        for (let r = 0; r < a.length; r += 1)
          a[r].swiperSlideOffset =
            (s.isHorizontal() ? a[r].offsetLeft : a[r].offsetTop) -
            l -
            s.cssOverflowAdjustment();
      }
      const np = (s, a, l) => {
        a && !s.classList.contains(l)
          ? s.classList.add(l)
          : !a && s.classList.contains(l) && s.classList.remove(l);
      };
      function Hb(s = (this && this.translate) || 0) {
        const a = this,
          l = a.params,
          { slides: r, rtlTranslate: u, snapGrid: f } = a;
        if (r.length === 0) return;
        typeof r[0].swiperSlideOffset > 'u' && a.updateSlidesOffset();
        let h = -s;
        (u && (h = s), (a.visibleSlidesIndexes = []), (a.visibleSlides = []));
        let g = l.spaceBetween;
        typeof g == 'string' && g.indexOf('%') >= 0
          ? (g = (parseFloat(g.replace('%', '')) / 100) * a.size)
          : typeof g == 'string' && (g = parseFloat(g));
        for (let d = 0; d < r.length; d += 1) {
          const p = r[d];
          let b = p.swiperSlideOffset;
          l.cssMode && l.centeredSlides && (b -= r[0].swiperSlideOffset);
          const y =
              (h + (l.centeredSlides ? a.minTranslate() : 0) - b) /
              (p.swiperSlideSize + g),
            w =
              (h - f[0] + (l.centeredSlides ? a.minTranslate() : 0) - b) /
              (p.swiperSlideSize + g),
            x = -(h - b),
            O = x + a.slidesSizesGrid[d],
            _ = x >= 0 && x <= a.size - a.slidesSizesGrid[d],
            L =
              (x >= 0 && x < a.size - 1) ||
              (O > 1 && O <= a.size) ||
              (x <= 0 && O >= a.size);
          (L && (a.visibleSlides.push(p), a.visibleSlidesIndexes.push(d)),
            np(p, L, l.slideVisibleClass),
            np(p, _, l.slideFullyVisibleClass),
            (p.progress = u ? -y : y),
            (p.originalProgress = u ? -w : w));
        }
      }
      function Ub(s) {
        const a = this;
        if (typeof s > 'u') {
          const b = a.rtlTranslate ? -1 : 1;
          s = (a && a.translate && a.translate * b) || 0;
        }
        const l = a.params,
          r = a.maxTranslate() - a.minTranslate();
        let { progress: u, isBeginning: f, isEnd: h, progressLoop: g } = a;
        const d = f,
          p = h;
        if (r === 0) ((u = 0), (f = !0), (h = !0));
        else {
          u = (s - a.minTranslate()) / r;
          const b = Math.abs(s - a.minTranslate()) < 1,
            y = Math.abs(s - a.maxTranslate()) < 1;
          ((f = b || u <= 0), (h = y || u >= 1), b && (u = 0), y && (u = 1));
        }
        if (l.loop) {
          const b = a.getSlideIndexByData(0),
            y = a.getSlideIndexByData(a.slides.length - 1),
            w = a.slidesGrid[b],
            x = a.slidesGrid[y],
            O = a.slidesGrid[a.slidesGrid.length - 1],
            _ = Math.abs(s);
          (_ >= w ? (g = (_ - w) / O) : (g = (_ + O - x) / O),
            g > 1 && (g -= 1));
        }
        (Object.assign(a, {
          progress: u,
          progressLoop: g,
          isBeginning: f,
          isEnd: h,
        }),
          (l.watchSlidesProgress || (l.centeredSlides && l.autoHeight)) &&
            a.updateSlidesProgress(s),
          f && !d && a.emit('reachBeginning toEdge'),
          h && !p && a.emit('reachEnd toEdge'),
          ((d && !f) || (p && !h)) && a.emit('fromEdge'),
          a.emit('progress', u));
      }
      const su = (s, a, l) => {
        a && !s.classList.contains(l)
          ? s.classList.add(l)
          : !a && s.classList.contains(l) && s.classList.remove(l);
      };
      function Gb() {
        const s = this,
          { slides: a, params: l, slidesEl: r, activeIndex: u } = s,
          f = s.virtual && l.virtual.enabled,
          h = s.grid && l.grid && l.grid.rows > 1,
          g = y => oi(r, `.${l.slideClass}${y}, swiper-slide${y}`)[0];
        let d, p, b;
        if (f)
          if (l.loop) {
            let y = u - s.virtual.slidesBefore;
            (y < 0 && (y = s.virtual.slides.length + y),
              y >= s.virtual.slides.length && (y -= s.virtual.slides.length),
              (d = g(`[data-swiper-slide-index="${y}"]`)));
          } else d = g(`[data-swiper-slide-index="${u}"]`);
        else
          h
            ? ((d = a.find(y => y.column === u)),
              (b = a.find(y => y.column === u + 1)),
              (p = a.find(y => y.column === u - 1)))
            : (d = a[u]);
        (d &&
          (h ||
            ((b = Ab(d, `.${l.slideClass}, swiper-slide`)[0]),
            l.loop && !b && (b = a[0]),
            (p = wb(d, `.${l.slideClass}, swiper-slide`)[0]),
            l.loop && !p === 0 && (p = a[a.length - 1]))),
          a.forEach(y => {
            (su(y, y === d, l.slideActiveClass),
              su(y, y === b, l.slideNextClass),
              su(y, y === p, l.slidePrevClass));
          }),
          s.emitSlidesClasses());
      }
      const Ts = (s, a) => {
          if (!s || s.destroyed || !s.params) return;
          const l = () =>
              s.isElement ? 'swiper-slide' : `.${s.params.slideClass}`,
            r = a.closest(l());
          if (r) {
            let u = r.querySelector(`.${s.params.lazyPreloaderClass}`);
            (!u &&
              s.isElement &&
              (r.shadowRoot
                ? (u = r.shadowRoot.querySelector(
                    `.${s.params.lazyPreloaderClass}`
                  ))
                : requestAnimationFrame(() => {
                    r.shadowRoot &&
                      ((u = r.shadowRoot.querySelector(
                        `.${s.params.lazyPreloaderClass}`
                      )),
                      u && u.remove());
                  })),
              u && u.remove());
          }
        },
        ru = (s, a) => {
          if (!s.slides[a]) return;
          const l = s.slides[a].querySelector('[loading="lazy"]');
          l && l.removeAttribute('loading');
        },
        Su = s => {
          if (!s || s.destroyed || !s.params) return;
          let a = s.params.lazyPreloadPrevNext;
          const l = s.slides.length;
          if (!l || !a || a < 0) return;
          a = Math.min(a, l);
          const r =
              s.params.slidesPerView === 'auto'
                ? s.slidesPerViewDynamic()
                : Math.ceil(s.params.slidesPerView),
            u = s.activeIndex;
          if (s.params.grid && s.params.grid.rows > 1) {
            const h = u,
              g = [h - a];
            (g.push(...Array.from({ length: a }).map((d, p) => h + r + p)),
              s.slides.forEach((d, p) => {
                g.includes(d.column) && ru(s, p);
              }));
            return;
          }
          const f = u + r - 1;
          if (s.params.rewind || s.params.loop)
            for (let h = u - a; h <= f + a; h += 1) {
              const g = ((h % l) + l) % l;
              (g < u || g > f) && ru(s, g);
            }
          else
            for (
              let h = Math.max(u - a, 0);
              h <= Math.min(f + a, l - 1);
              h += 1
            )
              h !== u && (h > f || h < u) && ru(s, h);
        };
      function Vb(s) {
        const { slidesGrid: a, params: l } = s,
          r = s.rtlTranslate ? s.translate : -s.translate;
        let u;
        for (let f = 0; f < a.length; f += 1)
          typeof a[f + 1] < 'u'
            ? r >= a[f] && r < a[f + 1] - (a[f + 1] - a[f]) / 2
              ? (u = f)
              : r >= a[f] && r < a[f + 1] && (u = f + 1)
            : r >= a[f] && (u = f);
        return (
          l.normalizeSlideIndex && (u < 0 || typeof u > 'u') && (u = 0),
          u
        );
      }
      function Yb(s) {
        const a = this,
          l = a.rtlTranslate ? a.translate : -a.translate,
          {
            snapGrid: r,
            params: u,
            activeIndex: f,
            realIndex: h,
            snapIndex: g,
          } = a;
        let d = s,
          p;
        const b = x => {
          let O = x - a.virtual.slidesBefore;
          return (
            O < 0 && (O = a.virtual.slides.length + O),
            O >= a.virtual.slides.length && (O -= a.virtual.slides.length),
            O
          );
        };
        if ((typeof d > 'u' && (d = Vb(a)), r.indexOf(l) >= 0))
          p = r.indexOf(l);
        else {
          const x = Math.min(u.slidesPerGroupSkip, d);
          p = x + Math.floor((d - x) / u.slidesPerGroup);
        }
        if ((p >= r.length && (p = r.length - 1), d === f && !a.params.loop)) {
          p !== g && ((a.snapIndex = p), a.emit('snapIndexChange'));
          return;
        }
        if (d === f && a.params.loop && a.virtual && a.params.virtual.enabled) {
          a.realIndex = b(d);
          return;
        }
        const y = a.grid && u.grid && u.grid.rows > 1;
        let w;
        if (a.virtual && u.virtual.enabled && u.loop) w = b(d);
        else if (y) {
          const x = a.slides.find(_ => _.column === d);
          let O = parseInt(x.getAttribute('data-swiper-slide-index'), 10);
          (Number.isNaN(O) && (O = Math.max(a.slides.indexOf(x), 0)),
            (w = Math.floor(O / u.grid.rows)));
        } else if (a.slides[d]) {
          const x = a.slides[d].getAttribute('data-swiper-slide-index');
          x ? (w = parseInt(x, 10)) : (w = d);
        } else w = d;
        (Object.assign(a, {
          previousSnapIndex: g,
          snapIndex: p,
          previousRealIndex: h,
          realIndex: w,
          previousIndex: f,
          activeIndex: d,
        }),
          a.initialized && Su(a),
          a.emit('activeIndexChange'),
          a.emit('snapIndexChange'),
          (a.initialized || a.params.runCallbacksOnInit) &&
            (h !== w && a.emit('realIndexChange'), a.emit('slideChange')));
      }
      function qb(s, a) {
        const l = this,
          r = l.params;
        let u = s.closest(`.${r.slideClass}, swiper-slide`);
        !u &&
          l.isElement &&
          a &&
          a.length > 1 &&
          a.includes(s) &&
          [...a.slice(a.indexOf(s) + 1, a.length)].forEach(g => {
            !u &&
              g.matches &&
              g.matches(`.${r.slideClass}, swiper-slide`) &&
              (u = g);
          });
        let f = !1,
          h;
        if (u) {
          for (let g = 0; g < l.slides.length; g += 1)
            if (l.slides[g] === u) {
              ((f = !0), (h = g));
              break;
            }
        }
        if (u && f)
          ((l.clickedSlide = u),
            l.virtual && l.params.virtual.enabled
              ? (l.clickedIndex = parseInt(
                  u.getAttribute('data-swiper-slide-index'),
                  10
                ))
              : (l.clickedIndex = h));
        else {
          ((l.clickedSlide = void 0), (l.clickedIndex = void 0));
          return;
        }
        r.slideToClickedSlide &&
          l.clickedIndex !== void 0 &&
          l.clickedIndex !== l.activeIndex &&
          l.slideToClickedSlide();
      }
      var $b = {
        updateSize: Db,
        updateSlides: Lb,
        updateAutoHeight: jb,
        updateSlidesOffset: Bb,
        updateSlidesProgress: Hb,
        updateProgress: Ub,
        updateSlidesClasses: Gb,
        updateActiveIndex: Yb,
        updateClickedSlide: qb,
      };
      function Kb(s = this.isHorizontal() ? 'x' : 'y') {
        const a = this,
          { params: l, rtlTranslate: r, translate: u, wrapperEl: f } = a;
        if (l.virtualTranslate) return r ? -u : u;
        if (l.cssMode) return u;
        let h = Sb(f, s);
        return ((h += a.cssOverflowAdjustment()), r && (h = -h), h || 0);
      }
      function kb(s, a) {
        const l = this,
          { rtlTranslate: r, params: u, wrapperEl: f, progress: h } = l;
        let g = 0,
          d = 0;
        const p = 0;
        (l.isHorizontal() ? (g = r ? -s : s) : (d = s),
          u.roundLengths && ((g = Math.floor(g)), (d = Math.floor(d))),
          (l.previousTranslate = l.translate),
          (l.translate = l.isHorizontal() ? g : d),
          u.cssMode
            ? (f[l.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                l.isHorizontal() ? -g : -d)
            : u.virtualTranslate ||
              (l.isHorizontal()
                ? (g -= l.cssOverflowAdjustment())
                : (d -= l.cssOverflowAdjustment()),
              (f.style.transform = `translate3d(${g}px, ${d}px, ${p}px)`)));
        let b;
        const y = l.maxTranslate() - l.minTranslate();
        (y === 0 ? (b = 0) : (b = (s - l.minTranslate()) / y),
          b !== h && l.updateProgress(s),
          l.emit('setTranslate', l.translate, a));
      }
      function Xb() {
        return -this.snapGrid[0];
      }
      function Qb() {
        return -this.snapGrid[this.snapGrid.length - 1];
      }
      function Zb(s = 0, a = this.params.speed, l = !0, r = !0, u) {
        const f = this,
          { params: h, wrapperEl: g } = f;
        if (f.animating && h.preventInteractionOnTransition) return !1;
        const d = f.minTranslate(),
          p = f.maxTranslate();
        let b;
        if (
          (r && s > d ? (b = d) : r && s < p ? (b = p) : (b = s),
          f.updateProgress(b),
          h.cssMode)
        ) {
          const y = f.isHorizontal();
          if (a === 0) g[y ? 'scrollLeft' : 'scrollTop'] = -b;
          else {
            if (!f.support.smoothScroll)
              return (
                Ep({ swiper: f, targetPosition: -b, side: y ? 'left' : 'top' }),
                !0
              );
            g.scrollTo({ [y ? 'left' : 'top']: -b, behavior: 'smooth' });
          }
          return !0;
        }
        return (
          a === 0
            ? (f.setTransition(0),
              f.setTranslate(b),
              l &&
                (f.emit('beforeTransitionStart', a, u),
                f.emit('transitionEnd')))
            : (f.setTransition(a),
              f.setTranslate(b),
              l &&
                (f.emit('beforeTransitionStart', a, u),
                f.emit('transitionStart')),
              f.animating ||
                ((f.animating = !0),
                f.onTranslateToWrapperTransitionEnd ||
                  (f.onTranslateToWrapperTransitionEnd = function (w) {
                    !f ||
                      f.destroyed ||
                      (w.target === this &&
                        (f.wrapperEl.removeEventListener(
                          'transitionend',
                          f.onTranslateToWrapperTransitionEnd
                        ),
                        (f.onTranslateToWrapperTransitionEnd = null),
                        delete f.onTranslateToWrapperTransitionEnd,
                        (f.animating = !1),
                        l && f.emit('transitionEnd')));
                  }),
                f.wrapperEl.addEventListener(
                  'transitionend',
                  f.onTranslateToWrapperTransitionEnd
                ))),
          !0
        );
      }
      var Jb = {
        getTranslate: Kb,
        setTranslate: kb,
        minTranslate: Xb,
        maxTranslate: Qb,
        translateTo: Zb,
      };
      function Fb(s, a) {
        const l = this;
        (l.params.cssMode ||
          ((l.wrapperEl.style.transitionDuration = `${s}ms`),
          (l.wrapperEl.style.transitionDelay = s === 0 ? '0ms' : '')),
          l.emit('setTransition', s, a));
      }
      function Op({ swiper: s, runCallbacks: a, direction: l, step: r }) {
        const { activeIndex: u, previousIndex: f } = s;
        let h = l;
        (h || (u > f ? (h = 'next') : u < f ? (h = 'prev') : (h = 'reset')),
          s.emit(`transition${r}`),
          a && h === 'reset'
            ? s.emit(`slideResetTransition${r}`)
            : a &&
              u !== f &&
              (s.emit(`slideChangeTransition${r}`),
              h === 'next'
                ? s.emit(`slideNextTransition${r}`)
                : s.emit(`slidePrevTransition${r}`)));
      }
      function Ib(s = !0, a) {
        const l = this,
          { params: r } = l;
        r.cssMode ||
          (r.autoHeight && l.updateAutoHeight(),
          Op({ swiper: l, runCallbacks: s, direction: a, step: 'Start' }));
      }
      function Pb(s = !0, a) {
        const l = this,
          { params: r } = l;
        ((l.animating = !1),
          !r.cssMode &&
            (l.setTransition(0),
            Op({ swiper: l, runCallbacks: s, direction: a, step: 'End' })));
      }
      var Wb = { setTransition: Fb, transitionStart: Ib, transitionEnd: Pb };
      function e0(s = 0, a, l = !0, r, u) {
        typeof s == 'string' && (s = parseInt(s, 10));
        const f = this;
        let h = s;
        h < 0 && (h = 0);
        const {
          params: g,
          snapGrid: d,
          slidesGrid: p,
          previousIndex: b,
          activeIndex: y,
          rtlTranslate: w,
          wrapperEl: x,
          enabled: O,
        } = f;
        if (
          (!O && !r && !u) ||
          f.destroyed ||
          (f.animating && g.preventInteractionOnTransition)
        )
          return !1;
        typeof a > 'u' && (a = f.params.speed);
        const _ = Math.min(f.params.slidesPerGroupSkip, h);
        let L = _ + Math.floor((h - _) / f.params.slidesPerGroup);
        L >= d.length && (L = d.length - 1);
        const $ = -d[L];
        if (g.normalizeSlideIndex)
          for (let Z = 0; Z < p.length; Z += 1) {
            const G = -Math.floor($ * 100),
              ee = Math.floor(p[Z] * 100),
              Q = Math.floor(p[Z + 1] * 100);
            typeof p[Z + 1] < 'u'
              ? G >= ee && G < Q - (Q - ee) / 2
                ? (h = Z)
                : G >= ee && G < Q && (h = Z + 1)
              : G >= ee && (h = Z);
          }
        if (
          f.initialized &&
          h !== y &&
          ((!f.allowSlideNext &&
            (w
              ? $ > f.translate && $ > f.minTranslate()
              : $ < f.translate && $ < f.minTranslate())) ||
            (!f.allowSlidePrev &&
              $ > f.translate &&
              $ > f.maxTranslate() &&
              (y || 0) !== h))
        )
          return !1;
        (h !== (b || 0) && l && f.emit('beforeSlideChangeStart'),
          f.updateProgress($));
        let B;
        h > y ? (B = 'next') : h < y ? (B = 'prev') : (B = 'reset');
        const K = f.virtual && f.params.virtual.enabled;
        if (
          !(K && u) &&
          ((w && -$ === f.translate) || (!w && $ === f.translate))
        )
          return (
            f.updateActiveIndex(h),
            g.autoHeight && f.updateAutoHeight(),
            f.updateSlidesClasses(),
            g.effect !== 'slide' && f.setTranslate($),
            B !== 'reset' && (f.transitionStart(l, B), f.transitionEnd(l, B)),
            !1
          );
        if (g.cssMode) {
          const Z = f.isHorizontal(),
            G = w ? $ : -$;
          if (a === 0)
            (K &&
              ((f.wrapperEl.style.scrollSnapType = 'none'),
              (f._immediateVirtual = !0)),
              K && !f._cssModeVirtualInitialSet && f.params.initialSlide > 0
                ? ((f._cssModeVirtualInitialSet = !0),
                  requestAnimationFrame(() => {
                    x[Z ? 'scrollLeft' : 'scrollTop'] = G;
                  }))
                : (x[Z ? 'scrollLeft' : 'scrollTop'] = G),
              K &&
                requestAnimationFrame(() => {
                  ((f.wrapperEl.style.scrollSnapType = ''),
                    (f._immediateVirtual = !1));
                }));
          else {
            if (!f.support.smoothScroll)
              return (
                Ep({ swiper: f, targetPosition: G, side: Z ? 'left' : 'top' }),
                !0
              );
            x.scrollTo({ [Z ? 'left' : 'top']: G, behavior: 'smooth' });
          }
          return !0;
        }
        const J = Mp().isSafari;
        return (
          K && !u && J && f.isElement && f.virtual.update(!1, !1, h),
          f.setTransition(a),
          f.setTranslate($),
          f.updateActiveIndex(h),
          f.updateSlidesClasses(),
          f.emit('beforeTransitionStart', a, r),
          f.transitionStart(l, B),
          a === 0
            ? f.transitionEnd(l, B)
            : f.animating ||
              ((f.animating = !0),
              f.onSlideToWrapperTransitionEnd ||
                (f.onSlideToWrapperTransitionEnd = function (G) {
                  !f ||
                    f.destroyed ||
                    (G.target === this &&
                      (f.wrapperEl.removeEventListener(
                        'transitionend',
                        f.onSlideToWrapperTransitionEnd
                      ),
                      (f.onSlideToWrapperTransitionEnd = null),
                      delete f.onSlideToWrapperTransitionEnd,
                      f.transitionEnd(l, B)));
                }),
              f.wrapperEl.addEventListener(
                'transitionend',
                f.onSlideToWrapperTransitionEnd
              )),
          !0
        );
      }
      function t0(s = 0, a, l = !0, r) {
        typeof s == 'string' && (s = parseInt(s, 10));
        const u = this;
        if (u.destroyed) return;
        typeof a > 'u' && (a = u.params.speed);
        const f = u.grid && u.params.grid && u.params.grid.rows > 1;
        let h = s;
        if (u.params.loop)
          if (u.virtual && u.params.virtual.enabled)
            h = h + u.virtual.slidesBefore;
          else {
            let g;
            if (f) {
              const _ = h * u.params.grid.rows;
              g = u.slides.find(
                L => L.getAttribute('data-swiper-slide-index') * 1 === _
              ).column;
            } else g = u.getSlideIndexByData(h);
            const d = f
                ? Math.ceil(u.slides.length / u.params.grid.rows)
                : u.slides.length,
              {
                centeredSlides: p,
                slidesOffsetBefore: b,
                slidesOffsetAfter: y,
              } = u.params,
              w = p || !!b || !!y;
            let x = u.params.slidesPerView;
            x === 'auto'
              ? (x = u.slidesPerViewDynamic())
              : ((x = Math.ceil(parseFloat(u.params.slidesPerView, 10))),
                w && x % 2 === 0 && (x = x + 1));
            let O = d - g < x;
            if (
              (w && (O = O || g < Math.ceil(x / 2)),
              r && w && u.params.slidesPerView !== 'auto' && !f && (O = !1),
              O)
            ) {
              const _ = w
                ? g < u.activeIndex
                  ? 'prev'
                  : 'next'
                : g - u.activeIndex - 1 < u.params.slidesPerView
                  ? 'next'
                  : 'prev';
              u.loopFix({
                direction: _,
                slideTo: !0,
                activeSlideIndex: _ === 'next' ? g + 1 : g - d + 1,
                slideRealIndex: _ === 'next' ? u.realIndex : void 0,
              });
            }
            if (f) {
              const _ = h * u.params.grid.rows;
              h = u.slides.find(
                L => L.getAttribute('data-swiper-slide-index') * 1 === _
              ).column;
            } else h = u.getSlideIndexByData(h);
          }
        return (
          requestAnimationFrame(() => {
            u.slideTo(h, a, l, r);
          }),
          u
        );
      }
      function i0(s, a = !0, l) {
        const r = this,
          { enabled: u, params: f, animating: h } = r;
        if (!u || r.destroyed) return r;
        typeof s > 'u' && (s = r.params.speed);
        let g = f.slidesPerGroup;
        f.slidesPerView === 'auto' &&
          f.slidesPerGroup === 1 &&
          f.slidesPerGroupAuto &&
          (g = Math.max(r.slidesPerViewDynamic('current', !0), 1));
        const d = r.activeIndex < f.slidesPerGroupSkip ? 1 : g,
          p = r.virtual && f.virtual.enabled;
        if (f.loop) {
          if (h && !p && f.loopPreventsSliding) return !1;
          if (
            (r.loopFix({ direction: 'next' }),
            (r._clientLeft = r.wrapperEl.clientLeft),
            r.activeIndex === r.slides.length - 1 && f.cssMode)
          )
            return (
              requestAnimationFrame(() => {
                r.slideTo(r.activeIndex + d, s, a, l);
              }),
              !0
            );
        }
        return f.rewind && r.isEnd
          ? r.slideTo(0, s, a, l)
          : r.slideTo(r.activeIndex + d, s, a, l);
      }
      function n0(s, a = !0, l) {
        const r = this,
          {
            params: u,
            snapGrid: f,
            slidesGrid: h,
            rtlTranslate: g,
            enabled: d,
            animating: p,
          } = r;
        if (!d || r.destroyed) return r;
        typeof s > 'u' && (s = r.params.speed);
        const b = r.virtual && u.virtual.enabled;
        if (u.loop) {
          if (p && !b && u.loopPreventsSliding) return !1;
          (r.loopFix({ direction: 'prev' }),
            (r._clientLeft = r.wrapperEl.clientLeft));
        }
        const y = g ? r.translate : -r.translate;
        function w(B) {
          return B < 0 ? -Math.floor(Math.abs(B)) : Math.floor(B);
        }
        const x = w(y),
          O = f.map(B => w(B)),
          _ = u.freeMode && u.freeMode.enabled;
        let L = f[O.indexOf(x) - 1];
        if (typeof L > 'u' && (u.cssMode || _)) {
          let B;
          (f.forEach((K, k) => {
            x >= K && (B = k);
          }),
            typeof B < 'u' && (L = _ ? f[B] : f[B > 0 ? B - 1 : B]));
        }
        let $ = 0;
        if (
          (typeof L < 'u' &&
            (($ = h.indexOf(L)),
            $ < 0 && ($ = r.activeIndex - 1),
            u.slidesPerView === 'auto' &&
              u.slidesPerGroup === 1 &&
              u.slidesPerGroupAuto &&
              (($ = $ - r.slidesPerViewDynamic('previous', !0) + 1),
              ($ = Math.max($, 0)))),
          u.rewind && r.isBeginning)
        ) {
          const B =
            r.params.virtual && r.params.virtual.enabled && r.virtual
              ? r.virtual.slides.length - 1
              : r.slides.length - 1;
          return r.slideTo(B, s, a, l);
        } else if (u.loop && r.activeIndex === 0 && u.cssMode)
          return (
            requestAnimationFrame(() => {
              r.slideTo($, s, a, l);
            }),
            !0
          );
        return r.slideTo($, s, a, l);
      }
      function a0(s, a = !0, l) {
        const r = this;
        if (!r.destroyed)
          return (
            typeof s > 'u' && (s = r.params.speed),
            r.slideTo(r.activeIndex, s, a, l)
          );
      }
      function l0(s, a = !0, l, r = 0.5) {
        const u = this;
        if (u.destroyed) return;
        typeof s > 'u' && (s = u.params.speed);
        let f = u.activeIndex;
        const h = Math.min(u.params.slidesPerGroupSkip, f),
          g = h + Math.floor((f - h) / u.params.slidesPerGroup),
          d = u.rtlTranslate ? u.translate : -u.translate;
        if (d >= u.snapGrid[g]) {
          const p = u.snapGrid[g],
            b = u.snapGrid[g + 1];
          d - p > (b - p) * r && (f += u.params.slidesPerGroup);
        } else {
          const p = u.snapGrid[g - 1],
            b = u.snapGrid[g];
          d - p <= (b - p) * r && (f -= u.params.slidesPerGroup);
        }
        return (
          (f = Math.max(f, 0)),
          (f = Math.min(f, u.slidesGrid.length - 1)),
          u.slideTo(f, s, a, l)
        );
      }
      function s0() {
        const s = this;
        if (s.destroyed) return;
        const { params: a, slidesEl: l } = s,
          r =
            a.slidesPerView === 'auto'
              ? s.slidesPerViewDynamic()
              : a.slidesPerView;
        let u = s.getSlideIndexWhenGrid(s.clickedIndex),
          f;
        const h = s.isElement ? 'swiper-slide' : `.${a.slideClass}`,
          g = s.grid && s.params.grid && s.params.grid.rows > 1;
        if (a.loop) {
          if (s.animating) return;
          ((f = parseInt(
            s.clickedSlide.getAttribute('data-swiper-slide-index'),
            10
          )),
            a.centeredSlides
              ? s.slideToLoop(f)
              : u >
                  (g
                    ? (s.slides.length - r) / 2 - (s.params.grid.rows - 1)
                    : s.slides.length - r)
                ? (s.loopFix(),
                  (u = s.getSlideIndex(
                    oi(l, `${h}[data-swiper-slide-index="${f}"]`)[0]
                  )),
                  Tp(() => {
                    s.slideTo(u);
                  }))
                : s.slideTo(u));
        } else s.slideTo(u);
      }
      var r0 = {
        slideTo: e0,
        slideToLoop: t0,
        slideNext: i0,
        slidePrev: n0,
        slideReset: a0,
        slideToClosest: l0,
        slideToClickedSlide: s0,
      };
      function o0(s, a) {
        const l = this,
          { params: r, slidesEl: u } = l;
        if (!r.loop || (l.virtual && l.params.virtual.enabled)) return;
        const f = () => {
            oi(u, `.${r.slideClass}, swiper-slide`).forEach((O, _) => {
              O.setAttribute('data-swiper-slide-index', _);
            });
          },
          h = () => {
            const x = oi(u, `.${r.slideBlankClass}`);
            (x.forEach(O => {
              O.remove();
            }),
              x.length > 0 && (l.recalcSlides(), l.updateSlides()));
          },
          g = l.grid && r.grid && r.grid.rows > 1;
        r.loopAddBlankSlides && (r.slidesPerGroup > 1 || g) && h();
        const d = r.slidesPerGroup * (g ? r.grid.rows : 1),
          p = l.slides.length % d !== 0,
          b = g && l.slides.length % r.grid.rows !== 0,
          y = x => {
            for (let O = 0; O < x; O += 1) {
              const _ = l.isElement
                ? bu('swiper-slide', [r.slideBlankClass])
                : bu('div', [r.slideClass, r.slideBlankClass]);
              l.slidesEl.append(_);
            }
          };
        if (p) {
          if (r.loopAddBlankSlides) {
            const x = d - (l.slides.length % d);
            (y(x), l.recalcSlides(), l.updateSlides());
          } else
            Os(
              'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          f();
        } else if (b) {
          if (r.loopAddBlankSlides) {
            const x = r.grid.rows - (l.slides.length % r.grid.rows);
            (y(x), l.recalcSlides(), l.updateSlides());
          } else
            Os(
              'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          f();
        } else f();
        const w =
          r.centeredSlides || !!r.slidesOffsetBefore || !!r.slidesOffsetAfter;
        l.loopFix({
          slideRealIndex: s,
          direction: w ? void 0 : 'next',
          initial: a,
        });
      }
      function u0({
        slideRealIndex: s,
        slideTo: a = !0,
        direction: l,
        setTranslate: r,
        activeSlideIndex: u,
        initial: f,
        byController: h,
        byMousewheel: g,
      } = {}) {
        const d = this;
        if (!d.params.loop) return;
        d.emit('beforeLoopFix');
        const {
            slides: p,
            allowSlidePrev: b,
            allowSlideNext: y,
            slidesEl: w,
            params: x,
          } = d,
          {
            centeredSlides: O,
            slidesOffsetBefore: _,
            slidesOffsetAfter: L,
            initialSlide: $,
          } = x,
          B = O || !!_ || !!L;
        if (
          ((d.allowSlidePrev = !0),
          (d.allowSlideNext = !0),
          d.virtual && x.virtual.enabled)
        ) {
          (a &&
            (!B && d.snapIndex === 0
              ? d.slideTo(d.virtual.slides.length, 0, !1, !0)
              : B && d.snapIndex < x.slidesPerView
                ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0)
                : d.snapIndex === d.snapGrid.length - 1 &&
                  d.slideTo(d.virtual.slidesBefore, 0, !1, !0)),
            (d.allowSlidePrev = b),
            (d.allowSlideNext = y),
            d.emit('loopFix'));
          return;
        }
        let K = x.slidesPerView;
        K === 'auto'
          ? (K = d.slidesPerViewDynamic())
          : ((K = Math.ceil(parseFloat(x.slidesPerView, 10))),
            B && K % 2 === 0 && (K = K + 1));
        const k = x.slidesPerGroupAuto ? K : x.slidesPerGroup;
        let H = B ? Math.max(k, Math.ceil(K / 2)) : k;
        (H % k !== 0 && (H += k - (H % k)),
          (H += x.loopAdditionalSlides),
          (d.loopedSlides = H));
        const J = d.grid && x.grid && x.grid.rows > 1;
        p.length < K + H ||
        (d.params.effect === 'cards' && p.length < K + H * 2)
          ? Os(
              'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
            )
          : J &&
            x.grid.fill === 'row' &&
            Os(
              'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
            );
        const Z = [],
          G = [],
          ee = J ? Math.ceil(p.length / x.grid.rows) : p.length,
          Q = f && ee - $ < K && !B;
        let I = Q ? $ : d.activeIndex;
        typeof u > 'u'
          ? (u = d.getSlideIndex(
              p.find(q => q.classList.contains(x.slideActiveClass))
            ))
          : (I = u);
        const ie = l === 'next' || !l,
          oe = l === 'prev' || !l;
        let ue = 0,
          he = 0;
        const X =
          (J ? p[u].column : u) + (B && typeof r > 'u' ? -K / 2 + 0.5 : 0);
        if (X < H) {
          ue = Math.max(H - X, k);
          for (let q = 0; q < H - X; q += 1) {
            const ne = q - Math.floor(q / ee) * ee;
            if (J) {
              const T = ee - ne - 1;
              for (let j = p.length - 1; j >= 0; j -= 1)
                p[j].column === T && Z.push(j);
            } else Z.push(ee - ne - 1);
          }
        } else if (X + K > ee - H) {
          ((he = Math.max(X - (ee - H * 2), k)),
            Q && (he = Math.max(he, K - ee + $ + 1)));
          for (let q = 0; q < he; q += 1) {
            const ne = q - Math.floor(q / ee) * ee;
            J
              ? p.forEach((T, j) => {
                  T.column === ne && G.push(j);
                })
              : G.push(ne);
          }
        }
        if (
          ((d.__preventObserver__ = !0),
          requestAnimationFrame(() => {
            d.__preventObserver__ = !1;
          }),
          d.params.effect === 'cards' &&
            p.length < K + H * 2 &&
            (G.includes(u) && G.splice(G.indexOf(u), 1),
            Z.includes(u) && Z.splice(Z.indexOf(u), 1)),
          oe &&
            Z.forEach(q => {
              ((p[q].swiperLoopMoveDOM = !0),
                w.prepend(p[q]),
                (p[q].swiperLoopMoveDOM = !1));
            }),
          ie &&
            G.forEach(q => {
              ((p[q].swiperLoopMoveDOM = !0),
                w.append(p[q]),
                (p[q].swiperLoopMoveDOM = !1));
            }),
          d.recalcSlides(),
          x.slidesPerView === 'auto'
            ? d.updateSlides()
            : J &&
              ((Z.length > 0 && oe) || (G.length > 0 && ie)) &&
              d.slides.forEach((q, ne) => {
                d.grid.updateSlide(ne, q, d.slides);
              }),
          x.watchSlidesProgress && d.updateSlidesOffset(),
          a)
        ) {
          if (Z.length > 0 && oe) {
            if (typeof s > 'u') {
              const q = d.slidesGrid[I],
                T = d.slidesGrid[I + ue] - q;
              g
                ? d.setTranslate(d.translate - T)
                : (d.slideTo(I + Math.ceil(ue), 0, !1, !0),
                  r &&
                    ((d.touchEventsData.startTranslate =
                      d.touchEventsData.startTranslate - T),
                    (d.touchEventsData.currentTranslate =
                      d.touchEventsData.currentTranslate - T)));
            } else if (r) {
              const q = J ? Z.length / x.grid.rows : Z.length;
              (d.slideTo(d.activeIndex + q, 0, !1, !0),
                (d.touchEventsData.currentTranslate = d.translate));
            }
          } else if (G.length > 0 && ie)
            if (typeof s > 'u') {
              const q = d.slidesGrid[I],
                T = d.slidesGrid[I - he] - q;
              g
                ? d.setTranslate(d.translate - T)
                : (d.slideTo(I - he, 0, !1, !0),
                  r &&
                    ((d.touchEventsData.startTranslate =
                      d.touchEventsData.startTranslate - T),
                    (d.touchEventsData.currentTranslate =
                      d.touchEventsData.currentTranslate - T)));
            } else {
              const q = J ? G.length / x.grid.rows : G.length;
              d.slideTo(d.activeIndex - q, 0, !1, !0);
            }
        }
        if (
          ((d.allowSlidePrev = b),
          (d.allowSlideNext = y),
          d.controller && d.controller.control && !h)
        ) {
          const q = {
            slideRealIndex: s,
            direction: l,
            setTranslate: r,
            activeSlideIndex: u,
            byController: !0,
          };
          Array.isArray(d.controller.control)
            ? d.controller.control.forEach(ne => {
                !ne.destroyed &&
                  ne.params.loop &&
                  ne.loopFix({
                    ...q,
                    slideTo:
                      ne.params.slidesPerView === x.slidesPerView ? a : !1,
                  });
              })
            : d.controller.control instanceof d.constructor &&
              d.controller.control.params.loop &&
              d.controller.control.loopFix({
                ...q,
                slideTo:
                  d.controller.control.params.slidesPerView === x.slidesPerView
                    ? a
                    : !1,
              });
        }
        d.emit('loopFix');
      }
      function c0() {
        const s = this,
          { params: a, slidesEl: l } = s;
        if (!a.loop || !l || (s.virtual && s.params.virtual.enabled)) return;
        s.recalcSlides();
        const r = [];
        (s.slides.forEach(u => {
          const f =
            typeof u.swiperSlideIndex > 'u'
              ? u.getAttribute('data-swiper-slide-index') * 1
              : u.swiperSlideIndex;
          r[f] = u;
        }),
          s.slides.forEach(u => {
            u.removeAttribute('data-swiper-slide-index');
          }),
          r.forEach(u => {
            l.append(u);
          }),
          s.recalcSlides(),
          s.slideTo(s.realIndex, 0));
      }
      var f0 = { loopCreate: o0, loopFix: u0, loopDestroy: c0 };
      function d0(s) {
        const a = this;
        if (
          !a.params.simulateTouch ||
          (a.params.watchOverflow && a.isLocked) ||
          a.params.cssMode
        )
          return;
        const l =
          a.params.touchEventsTarget === 'container' ? a.el : a.wrapperEl;
        (a.isElement && (a.__preventObserver__ = !0),
          (l.style.cursor = 'move'),
          (l.style.cursor = s ? 'grabbing' : 'grab'),
          a.isElement &&
            requestAnimationFrame(() => {
              a.__preventObserver__ = !1;
            }));
      }
      function h0() {
        const s = this;
        (s.params.watchOverflow && s.isLocked) ||
          s.params.cssMode ||
          (s.isElement && (s.__preventObserver__ = !0),
          (s[
            s.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
          ].style.cursor = ''),
          s.isElement &&
            requestAnimationFrame(() => {
              s.__preventObserver__ = !1;
            }));
      }
      var p0 = { setGrabCursor: d0, unsetGrabCursor: h0 };
      function m0(s, a = this) {
        function l(r) {
          if (!r || r === on() || r === lt()) return null;
          r.assignedSlot && (r = r.assignedSlot);
          const u = r.closest(s);
          return !u && !r.getRootNode ? null : u || l(r.getRootNode().host);
        }
        return l(a);
      }
      function ap(s, a, l) {
        const r = lt(),
          { params: u } = s,
          f = u.edgeSwipeDetection,
          h = u.edgeSwipeThreshold;
        return f && (l <= h || l >= r.innerWidth - h)
          ? f === 'prevent'
            ? (a.preventDefault(), !0)
            : !1
          : !0;
      }
      function g0(s) {
        const a = this,
          l = on();
        let r = s;
        r.originalEvent && (r = r.originalEvent);
        const u = a.touchEventsData;
        if (r.type === 'pointerdown') {
          if (u.pointerId !== null && u.pointerId !== r.pointerId) return;
          u.pointerId = r.pointerId;
        } else
          r.type === 'touchstart' &&
            r.targetTouches.length === 1 &&
            (u.touchId = r.targetTouches[0].identifier);
        if (r.type === 'touchstart') {
          ap(a, r, r.targetTouches[0].pageX);
          return;
        }
        const { params: f, touches: h, enabled: g } = a;
        if (
          !g ||
          (!f.simulateTouch && r.pointerType === 'mouse') ||
          (a.animating && f.preventInteractionOnTransition)
        )
          return;
        !a.animating && f.cssMode && f.loop && a.loopFix();
        let d = r.target;
        if (
          (f.touchEventsTarget === 'wrapper' && !Eb(d, a.wrapperEl)) ||
          ('which' in r && r.which === 3) ||
          ('button' in r && r.button > 0) ||
          (u.isTouched && u.isMoved)
        )
          return;
        const p = !!f.noSwipingClass && f.noSwipingClass !== '',
          b = r.composedPath ? r.composedPath() : r.path;
        p && r.target && r.target.shadowRoot && b && (d = b[0]);
        const y = f.noSwipingSelector
            ? f.noSwipingSelector
            : `.${f.noSwipingClass}`,
          w = !!(r.target && r.target.shadowRoot);
        if (f.noSwiping && (w ? m0(y, d) : d.closest(y))) {
          a.allowClick = !0;
          return;
        }
        if (f.swipeHandler && !d.closest(f.swipeHandler)) return;
        ((h.currentX = r.pageX), (h.currentY = r.pageY));
        const x = h.currentX,
          O = h.currentY;
        if (!ap(a, r, x)) return;
        (Object.assign(u, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (h.startX = x),
          (h.startY = O),
          (u.touchStartTime = Ms()),
          (a.allowClick = !0),
          a.updateSize(),
          (a.swipeDirection = void 0),
          f.threshold > 0 && (u.allowThresholdMove = !1));
        let _ = !0;
        (d.matches(u.focusableElements) &&
          ((_ = !1), d.nodeName === 'SELECT' && (u.isTouched = !1)),
          l.activeElement &&
            l.activeElement.matches(u.focusableElements) &&
            l.activeElement !== d &&
            (r.pointerType === 'mouse' ||
              (r.pointerType !== 'mouse' && !d.matches(u.focusableElements))) &&
            l.activeElement.blur());
        const L = _ && a.allowTouchMove && f.touchStartPreventDefault;
        ((f.touchStartForcePreventDefault || L) &&
          !d.isContentEditable &&
          r.preventDefault(),
          f.freeMode &&
            f.freeMode.enabled &&
            a.freeMode &&
            a.animating &&
            !f.cssMode &&
            a.freeMode.onTouchStart(),
          a.emit('touchStart', r));
      }
      function v0(s) {
        const a = on(),
          l = this,
          r = l.touchEventsData,
          { params: u, touches: f, rtlTranslate: h, enabled: g } = l;
        if (!g || (!u.simulateTouch && s.pointerType === 'mouse')) return;
        let d = s;
        if (
          (d.originalEvent && (d = d.originalEvent),
          d.type === 'pointermove' &&
            (r.touchId !== null || d.pointerId !== r.pointerId))
        )
          return;
        let p;
        if (d.type === 'touchmove') {
          if (
            ((p = [...d.changedTouches].find(H => H.identifier === r.touchId)),
            !p || p.identifier !== r.touchId)
          )
            return;
        } else p = d;
        if (!r.isTouched) {
          r.startMoving && r.isScrolling && l.emit('touchMoveOpposite', d);
          return;
        }
        const b = p.pageX,
          y = p.pageY;
        if (d.preventedByNestedSwiper) {
          ((f.startX = b), (f.startY = y));
          return;
        }
        if (!l.allowTouchMove) {
          (d.target.matches(r.focusableElements) || (l.allowClick = !1),
            r.isTouched &&
              (Object.assign(f, {
                startX: b,
                startY: y,
                currentX: b,
                currentY: y,
              }),
              (r.touchStartTime = Ms())));
          return;
        }
        if (u.touchReleaseOnEdges && !u.loop)
          if (l.isVertical()) {
            if (
              (y < f.startY && l.translate <= l.maxTranslate()) ||
              (y > f.startY && l.translate >= l.minTranslate())
            ) {
              ((r.isTouched = !1), (r.isMoved = !1));
              return;
            }
          } else {
            if (
              h &&
              ((b > f.startX && -l.translate <= l.maxTranslate()) ||
                (b < f.startX && -l.translate >= l.minTranslate()))
            )
              return;
            if (
              !h &&
              ((b < f.startX && l.translate <= l.maxTranslate()) ||
                (b > f.startX && l.translate >= l.minTranslate()))
            )
              return;
          }
        if (
          (a.activeElement &&
            a.activeElement.matches(r.focusableElements) &&
            a.activeElement !== d.target &&
            d.pointerType !== 'mouse' &&
            a.activeElement.blur(),
          a.activeElement &&
            d.target === a.activeElement &&
            d.target.matches(r.focusableElements))
        ) {
          ((r.isMoved = !0), (l.allowClick = !1));
          return;
        }
        (r.allowTouchCallbacks && l.emit('touchMove', d),
          (f.previousX = f.currentX),
          (f.previousY = f.currentY),
          (f.currentX = b),
          (f.currentY = y));
        const w = f.currentX - f.startX,
          x = f.currentY - f.startY;
        if (
          l.params.threshold &&
          Math.sqrt(w ** 2 + x ** 2) < l.params.threshold
        )
          return;
        if (typeof r.isScrolling > 'u') {
          let H;
          (l.isHorizontal() && f.currentY === f.startY) ||
          (l.isVertical() && f.currentX === f.startX)
            ? (r.isScrolling = !1)
            : w * w + x * x >= 25 &&
              ((H = (Math.atan2(Math.abs(x), Math.abs(w)) * 180) / Math.PI),
              (r.isScrolling = l.isHorizontal()
                ? H > u.touchAngle
                : 90 - H > u.touchAngle));
        }
        if (
          (r.isScrolling && l.emit('touchMoveOpposite', d),
          typeof r.startMoving > 'u' &&
            (f.currentX !== f.startX || f.currentY !== f.startY) &&
            (r.startMoving = !0),
          r.isScrolling ||
            (d.type === 'touchmove' && r.preventTouchMoveFromPointerMove))
        ) {
          r.isTouched = !1;
          return;
        }
        if (!r.startMoving) return;
        ((l.allowClick = !1),
          !u.cssMode && d.cancelable && d.preventDefault(),
          u.touchMoveStopPropagation && !u.nested && d.stopPropagation());
        let O = l.isHorizontal() ? w : x,
          _ = l.isHorizontal()
            ? f.currentX - f.previousX
            : f.currentY - f.previousY;
        (u.oneWayMovement &&
          ((O = Math.abs(O) * (h ? 1 : -1)), (_ = Math.abs(_) * (h ? 1 : -1))),
          (f.diff = O),
          (O *= u.touchRatio),
          h && ((O = -O), (_ = -_)));
        const L = l.touchesDirection;
        ((l.swipeDirection = O > 0 ? 'prev' : 'next'),
          (l.touchesDirection = _ > 0 ? 'prev' : 'next'));
        const $ = l.params.loop && !u.cssMode,
          B =
            (l.touchesDirection === 'next' && l.allowSlideNext) ||
            (l.touchesDirection === 'prev' && l.allowSlidePrev);
        if (!r.isMoved) {
          if (
            ($ && B && l.loopFix({ direction: l.swipeDirection }),
            (r.startTranslate = l.getTranslate()),
            l.setTransition(0),
            l.animating)
          ) {
            const H = new window.CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
              detail: { bySwiperTouchMove: !0 },
            });
            l.wrapperEl.dispatchEvent(H);
          }
          ((r.allowMomentumBounce = !1),
            u.grabCursor &&
              (l.allowSlideNext === !0 || l.allowSlidePrev === !0) &&
              l.setGrabCursor(!0),
            l.emit('sliderFirstMove', d));
        }
        if (
          (new Date().getTime(),
          u._loopSwapReset !== !1 &&
            r.isMoved &&
            r.allowThresholdMove &&
            L !== l.touchesDirection &&
            $ &&
            B &&
            Math.abs(O) >= 1)
        ) {
          (Object.assign(f, {
            startX: b,
            startY: y,
            currentX: b,
            currentY: y,
            startTranslate: r.currentTranslate,
          }),
            (r.loopSwapReset = !0),
            (r.startTranslate = r.currentTranslate));
          return;
        }
        (l.emit('sliderMove', d),
          (r.isMoved = !0),
          (r.currentTranslate = O + r.startTranslate));
        let K = !0,
          k = u.resistanceRatio;
        if (
          (u.touchReleaseOnEdges && (k = 0),
          O > 0
            ? ($ &&
                B &&
                r.allowThresholdMove &&
                r.currentTranslate >
                  (u.centeredSlides
                    ? l.minTranslate() -
                      l.slidesSizesGrid[l.activeIndex + 1] -
                      (u.slidesPerView !== 'auto' &&
                      l.slides.length - u.slidesPerView >= 2
                        ? l.slidesSizesGrid[l.activeIndex + 1] +
                          l.params.spaceBetween
                        : 0) -
                      l.params.spaceBetween
                    : l.minTranslate()) &&
                l.loopFix({
                  direction: 'prev',
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              r.currentTranslate > l.minTranslate() &&
                ((K = !1),
                u.resistance &&
                  (r.currentTranslate =
                    l.minTranslate() -
                    1 +
                    (-l.minTranslate() + r.startTranslate + O) ** k)))
            : O < 0 &&
              ($ &&
                B &&
                r.allowThresholdMove &&
                r.currentTranslate <
                  (u.centeredSlides
                    ? l.maxTranslate() +
                      l.slidesSizesGrid[l.slidesSizesGrid.length - 1] +
                      l.params.spaceBetween +
                      (u.slidesPerView !== 'auto' &&
                      l.slides.length - u.slidesPerView >= 2
                        ? l.slidesSizesGrid[l.slidesSizesGrid.length - 1] +
                          l.params.spaceBetween
                        : 0)
                    : l.maxTranslate()) &&
                l.loopFix({
                  direction: 'next',
                  setTranslate: !0,
                  activeSlideIndex:
                    l.slides.length -
                    (u.slidesPerView === 'auto'
                      ? l.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(u.slidesPerView, 10))),
                }),
              r.currentTranslate < l.maxTranslate() &&
                ((K = !1),
                u.resistance &&
                  (r.currentTranslate =
                    l.maxTranslate() +
                    1 -
                    (l.maxTranslate() - r.startTranslate - O) ** k))),
          K && (d.preventedByNestedSwiper = !0),
          !l.allowSlideNext &&
            l.swipeDirection === 'next' &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !l.allowSlidePrev &&
            l.swipeDirection === 'prev' &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !l.allowSlidePrev &&
            !l.allowSlideNext &&
            (r.currentTranslate = r.startTranslate),
          u.threshold > 0)
        )
          if (Math.abs(O) > u.threshold || r.allowThresholdMove) {
            if (!r.allowThresholdMove) {
              ((r.allowThresholdMove = !0),
                (f.startX = f.currentX),
                (f.startY = f.currentY),
                (r.currentTranslate = r.startTranslate),
                (f.diff = l.isHorizontal()
                  ? f.currentX - f.startX
                  : f.currentY - f.startY));
              return;
            }
          } else {
            r.currentTranslate = r.startTranslate;
            return;
          }
        !u.followFinger ||
          u.cssMode ||
          (((u.freeMode && u.freeMode.enabled && l.freeMode) ||
            u.watchSlidesProgress) &&
            (l.updateActiveIndex(), l.updateSlidesClasses()),
          u.freeMode &&
            u.freeMode.enabled &&
            l.freeMode &&
            l.freeMode.onTouchMove(),
          l.updateProgress(r.currentTranslate),
          l.setTranslate(r.currentTranslate));
      }
      function y0(s) {
        const a = this,
          l = a.touchEventsData;
        let r = s;
        r.originalEvent && (r = r.originalEvent);
        let u;
        if (r.type === 'touchend' || r.type === 'touchcancel') {
          if (
            ((u = [...r.changedTouches].find(H => H.identifier === l.touchId)),
            !u || u.identifier !== l.touchId)
          )
            return;
        } else {
          if (l.touchId !== null || r.pointerId !== l.pointerId) return;
          u = r;
        }
        if (
          [
            'pointercancel',
            'pointerout',
            'pointerleave',
            'contextmenu',
          ].includes(r.type) &&
          !(
            ['pointercancel', 'contextmenu'].includes(r.type) &&
            (a.browser.isSafari || a.browser.isWebView)
          )
        )
          return;
        ((l.pointerId = null), (l.touchId = null));
        const {
          params: h,
          touches: g,
          rtlTranslate: d,
          slidesGrid: p,
          enabled: b,
        } = a;
        if (!b || (!h.simulateTouch && r.pointerType === 'mouse')) return;
        if (
          (l.allowTouchCallbacks && a.emit('touchEnd', r),
          (l.allowTouchCallbacks = !1),
          !l.isTouched)
        ) {
          (l.isMoved && h.grabCursor && a.setGrabCursor(!1),
            (l.isMoved = !1),
            (l.startMoving = !1));
          return;
        }
        h.grabCursor &&
          l.isMoved &&
          l.isTouched &&
          (a.allowSlideNext === !0 || a.allowSlidePrev === !0) &&
          a.setGrabCursor(!1);
        const y = Ms(),
          w = y - l.touchStartTime;
        if (a.allowClick) {
          const H = r.path || (r.composedPath && r.composedPath());
          (a.updateClickedSlide((H && H[0]) || r.target, H),
            a.emit('tap click', r),
            w < 300 &&
              y - l.lastClickTime < 300 &&
              a.emit('doubleTap doubleClick', r));
        }
        if (
          ((l.lastClickTime = Ms()),
          Tp(() => {
            a.destroyed || (a.allowClick = !0);
          }),
          !l.isTouched ||
            !l.isMoved ||
            !a.swipeDirection ||
            (g.diff === 0 && !l.loopSwapReset) ||
            (l.currentTranslate === l.startTranslate && !l.loopSwapReset))
        ) {
          ((l.isTouched = !1), (l.isMoved = !1), (l.startMoving = !1));
          return;
        }
        ((l.isTouched = !1), (l.isMoved = !1), (l.startMoving = !1));
        let x;
        if (
          (h.followFinger
            ? (x = d ? a.translate : -a.translate)
            : (x = -l.currentTranslate),
          h.cssMode)
        )
          return;
        if (h.freeMode && h.freeMode.enabled) {
          a.freeMode.onTouchEnd({ currentPos: x });
          return;
        }
        const O = x >= -a.maxTranslate() && !a.params.loop;
        let _ = 0,
          L = a.slidesSizesGrid[0];
        for (
          let H = 0;
          H < p.length;
          H += H < h.slidesPerGroupSkip ? 1 : h.slidesPerGroup
        ) {
          const J = H < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
          typeof p[H + J] < 'u'
            ? (O || (x >= p[H] && x < p[H + J])) &&
              ((_ = H), (L = p[H + J] - p[H]))
            : (O || x >= p[H]) &&
              ((_ = H), (L = p[p.length - 1] - p[p.length - 2]));
        }
        let $ = null,
          B = null;
        h.rewind &&
          (a.isBeginning
            ? (B =
                h.virtual && h.virtual.enabled && a.virtual
                  ? a.virtual.slides.length - 1
                  : a.slides.length - 1)
            : a.isEnd && ($ = 0));
        const K = (x - p[_]) / L,
          k = _ < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
        if (w > h.longSwipesMs) {
          if (!h.longSwipes) {
            a.slideTo(a.activeIndex);
            return;
          }
          (a.swipeDirection === 'next' &&
            (K >= h.longSwipesRatio
              ? a.slideTo(h.rewind && a.isEnd ? $ : _ + k)
              : a.slideTo(_)),
            a.swipeDirection === 'prev' &&
              (K > 1 - h.longSwipesRatio
                ? a.slideTo(_ + k)
                : B !== null && K < 0 && Math.abs(K) > h.longSwipesRatio
                  ? a.slideTo(B)
                  : a.slideTo(_)));
        } else {
          if (!h.shortSwipes) {
            a.slideTo(a.activeIndex);
            return;
          }
          a.navigation &&
          (r.target === a.navigation.nextEl || r.target === a.navigation.prevEl)
            ? r.target === a.navigation.nextEl
              ? a.slideTo(_ + k)
              : a.slideTo(_)
            : (a.swipeDirection === 'next' && a.slideTo($ !== null ? $ : _ + k),
              a.swipeDirection === 'prev' && a.slideTo(B !== null ? B : _));
        }
      }
      function lp() {
        const s = this,
          { params: a, el: l } = s;
        if (l && l.offsetWidth === 0) return;
        a.breakpoints && s.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: u, snapGrid: f } = s,
          h = s.virtual && s.params.virtual.enabled;
        ((s.allowSlideNext = !0),
          (s.allowSlidePrev = !0),
          s.updateSize(),
          s.updateSlides(),
          s.updateSlidesClasses());
        const g = h && a.loop;
        ((a.slidesPerView === 'auto' || a.slidesPerView > 1) &&
        s.isEnd &&
        !s.isBeginning &&
        !s.params.centeredSlides &&
        !g
          ? s.slideTo(s.slides.length - 1, 0, !1, !0)
          : s.params.loop && !h
            ? s.slideToLoop(s.realIndex, 0, !1, !0)
            : s.slideTo(s.activeIndex, 0, !1, !0),
          s.autoplay &&
            s.autoplay.running &&
            s.autoplay.paused &&
            (clearTimeout(s.autoplay.resizeTimeout),
            (s.autoplay.resizeTimeout = setTimeout(() => {
              s.autoplay &&
                s.autoplay.running &&
                s.autoplay.paused &&
                s.autoplay.resume();
            }, 500))),
          (s.allowSlidePrev = u),
          (s.allowSlideNext = r),
          s.params.watchOverflow && f !== s.snapGrid && s.checkOverflow());
      }
      function b0(s) {
        const a = this;
        a.enabled &&
          (a.allowClick ||
            (a.params.preventClicks && s.preventDefault(),
            a.params.preventClicksPropagation &&
              a.animating &&
              (s.stopPropagation(), s.stopImmediatePropagation())));
      }
      function S0() {
        const s = this,
          { wrapperEl: a, rtlTranslate: l, enabled: r } = s;
        if (!r) return;
        ((s.previousTranslate = s.translate),
          s.isHorizontal()
            ? (s.translate = -a.scrollLeft)
            : (s.translate = -a.scrollTop),
          s.translate === 0 && (s.translate = 0),
          s.updateActiveIndex(),
          s.updateSlidesClasses());
        let u;
        const f = s.maxTranslate() - s.minTranslate();
        (f === 0 ? (u = 0) : (u = (s.translate - s.minTranslate()) / f),
          u !== s.progress && s.updateProgress(l ? -s.translate : s.translate),
          s.emit('setTranslate', s.translate, !1));
      }
      function x0(s) {
        const a = this;
        (Ts(a, s.target),
          !(
            a.params.cssMode ||
            (a.params.slidesPerView !== 'auto' && !a.params.autoHeight)
          ) && a.update());
      }
      function T0() {
        const s = this;
        s.documentTouchHandlerProceeded ||
          ((s.documentTouchHandlerProceeded = !0),
          s.params.touchReleaseOnEdges && (s.el.style.touchAction = 'auto'));
      }
      const _p = (s, a) => {
        const l = on(),
          { params: r, el: u, wrapperEl: f, device: h } = s,
          g = !!r.nested,
          d = a === 'on' ? 'addEventListener' : 'removeEventListener',
          p = a;
        !u ||
          typeof u == 'string' ||
          (l[d]('touchstart', s.onDocumentTouchStart, {
            passive: !1,
            capture: g,
          }),
          u[d]('touchstart', s.onTouchStart, { passive: !1 }),
          u[d]('pointerdown', s.onTouchStart, { passive: !1 }),
          l[d]('touchmove', s.onTouchMove, { passive: !1, capture: g }),
          l[d]('pointermove', s.onTouchMove, { passive: !1, capture: g }),
          l[d]('touchend', s.onTouchEnd, { passive: !0 }),
          l[d]('pointerup', s.onTouchEnd, { passive: !0 }),
          l[d]('pointercancel', s.onTouchEnd, { passive: !0 }),
          l[d]('touchcancel', s.onTouchEnd, { passive: !0 }),
          l[d]('pointerout', s.onTouchEnd, { passive: !0 }),
          l[d]('pointerleave', s.onTouchEnd, { passive: !0 }),
          l[d]('contextmenu', s.onTouchEnd, { passive: !0 }),
          (r.preventClicks || r.preventClicksPropagation) &&
            u[d]('click', s.onClick, !0),
          r.cssMode && f[d]('scroll', s.onScroll),
          r.updateOnWindowResize
            ? s[p](
                h.ios || h.android
                  ? 'resize orientationchange observerUpdate'
                  : 'resize observerUpdate',
                lp,
                !0
              )
            : s[p]('observerUpdate', lp, !0),
          u[d]('load', s.onLoad, { capture: !0 }));
      };
      function E0() {
        const s = this,
          { params: a } = s;
        ((s.onTouchStart = g0.bind(s)),
          (s.onTouchMove = v0.bind(s)),
          (s.onTouchEnd = y0.bind(s)),
          (s.onDocumentTouchStart = T0.bind(s)),
          a.cssMode && (s.onScroll = S0.bind(s)),
          (s.onClick = b0.bind(s)),
          (s.onLoad = x0.bind(s)),
          _p(s, 'on'));
      }
      function w0() {
        _p(this, 'off');
      }
      var A0 = { attachEvents: E0, detachEvents: w0 };
      const sp = (s, a) => s.grid && a.grid && a.grid.rows > 1;
      function M0() {
        const s = this,
          { realIndex: a, initialized: l, params: r, el: u } = s,
          f = r.breakpoints;
        if (!f || (f && Object.keys(f).length === 0)) return;
        const h = on(),
          g =
            r.breakpointsBase === 'window' || !r.breakpointsBase
              ? r.breakpointsBase
              : 'container',
          d =
            ['window', 'container'].includes(r.breakpointsBase) ||
            !r.breakpointsBase
              ? s.el
              : h.querySelector(r.breakpointsBase),
          p = s.getBreakpoint(f, g, d);
        if (!p || s.currentBreakpoint === p) return;
        const y = (p in f ? f[p] : void 0) || s.originalParams,
          w = sp(s, r),
          x = sp(s, y),
          O = s.params.grabCursor,
          _ = y.grabCursor,
          L = r.enabled;
        (w && !x
          ? (u.classList.remove(
              `${r.containerModifierClass}grid`,
              `${r.containerModifierClass}grid-column`
            ),
            s.emitContainerClasses())
          : !w &&
            x &&
            (u.classList.add(`${r.containerModifierClass}grid`),
            ((y.grid.fill && y.grid.fill === 'column') ||
              (!y.grid.fill && r.grid.fill === 'column')) &&
              u.classList.add(`${r.containerModifierClass}grid-column`),
            s.emitContainerClasses()),
          O && !_ ? s.unsetGrabCursor() : !O && _ && s.setGrabCursor(),
          ['navigation', 'pagination', 'scrollbar'].forEach(J => {
            if (typeof y[J] > 'u') return;
            const Z = r[J] && r[J].enabled,
              G = y[J] && y[J].enabled;
            (Z && !G && s[J].disable(), !Z && G && s[J].enable());
          }));
        const $ = y.direction && y.direction !== r.direction,
          B = r.loop && (y.slidesPerView !== r.slidesPerView || $),
          K = r.loop;
        ($ && l && s.changeDirection(), Et(s.params, y));
        const k = s.params.enabled,
          H = s.params.loop;
        (Object.assign(s, {
          allowTouchMove: s.params.allowTouchMove,
          allowSlideNext: s.params.allowSlideNext,
          allowSlidePrev: s.params.allowSlidePrev,
        }),
          L && !k ? s.disable() : !L && k && s.enable(),
          (s.currentBreakpoint = p),
          s.emit('_beforeBreakpoint', y),
          l &&
            (B
              ? (s.loopDestroy(), s.loopCreate(a), s.updateSlides())
              : !K && H
                ? (s.loopCreate(a), s.updateSlides())
                : K && !H && s.loopDestroy()),
          s.emit('breakpoint', y));
      }
      function O0(s, a = 'window', l) {
        if (!s || (a === 'container' && !l)) return;
        let r = !1;
        const u = lt(),
          f = a === 'window' ? u.innerHeight : l.clientHeight,
          h = Object.keys(s).map(g => {
            if (typeof g == 'string' && g.indexOf('@') === 0) {
              const d = parseFloat(g.substr(1));
              return { value: f * d, point: g };
            }
            return { value: g, point: g };
          });
        h.sort((g, d) => parseInt(g.value, 10) - parseInt(d.value, 10));
        for (let g = 0; g < h.length; g += 1) {
          const { point: d, value: p } = h[g];
          a === 'window'
            ? u.matchMedia(`(min-width: ${p}px)`).matches && (r = d)
            : p <= l.clientWidth && (r = d);
        }
        return r || 'max';
      }
      var _0 = { setBreakpoint: M0, getBreakpoint: O0 };
      function z0(s, a) {
        const l = [];
        return (
          s.forEach(r => {
            typeof r == 'object'
              ? Object.keys(r).forEach(u => {
                  r[u] && l.push(a + u);
                })
              : typeof r == 'string' && l.push(a + r);
          }),
          l
        );
      }
      function N0() {
        const s = this,
          { classNames: a, params: l, rtl: r, el: u, device: f } = s,
          h = z0(
            [
              'initialized',
              l.direction,
              { 'free-mode': s.params.freeMode && l.freeMode.enabled },
              { autoheight: l.autoHeight },
              { rtl: r },
              { grid: l.grid && l.grid.rows > 1 },
              {
                'grid-column':
                  l.grid && l.grid.rows > 1 && l.grid.fill === 'column',
              },
              { android: f.android },
              { ios: f.ios },
              { 'css-mode': l.cssMode },
              { centered: l.cssMode && l.centeredSlides },
              { 'watch-progress': l.watchSlidesProgress },
            ],
            l.containerModifierClass
          );
        (a.push(...h), u.classList.add(...a), s.emitContainerClasses());
      }
      function C0() {
        const s = this,
          { el: a, classNames: l } = s;
        !a ||
          typeof a == 'string' ||
          (a.classList.remove(...l), s.emitContainerClasses());
      }
      var R0 = { addClasses: N0, removeClasses: C0 };
      function D0() {
        const s = this,
          { isLocked: a, params: l } = s,
          { slidesOffsetBefore: r } = l;
        if (r) {
          const u = s.slides.length - 1,
            f = s.slidesGrid[u] + s.slidesSizesGrid[u] + r * 2;
          s.isLocked = s.size > f;
        } else s.isLocked = s.snapGrid.length === 1;
        (l.allowSlideNext === !0 && (s.allowSlideNext = !s.isLocked),
          l.allowSlidePrev === !0 && (s.allowSlidePrev = !s.isLocked),
          a && a !== s.isLocked && (s.isEnd = !1),
          a !== s.isLocked && s.emit(s.isLocked ? 'lock' : 'unlock'));
      }
      var L0 = { checkOverflow: D0 },
        xu = {
          init: !0,
          direction: 'horizontal',
          oneWayMovement: !1,
          swiperElementNodeName: 'SWIPER-CONTAINER',
          touchEventsTarget: 'wrapper',
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          eventsPrefix: 'swiper',
          enabled: !0,
          focusableElements:
            'input, select, option, textarea, button, video, label',
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: 'slide',
          breakpoints: void 0,
          breakpointsBase: 'window',
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopAddBlankSlides: !0,
          loopAdditionalSlides: 0,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: 'swiper-no-swiping',
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: 'swiper-',
          slideClass: 'swiper-slide',
          slideBlankClass: 'swiper-slide-blank',
          slideActiveClass: 'swiper-slide-active',
          slideVisibleClass: 'swiper-slide-visible',
          slideFullyVisibleClass: 'swiper-slide-fully-visible',
          slideNextClass: 'swiper-slide-next',
          slidePrevClass: 'swiper-slide-prev',
          wrapperClass: 'swiper-wrapper',
          lazyPreloaderClass: 'swiper-lazy-preloader',
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function j0(s, a) {
        return function (r = {}) {
          const u = Object.keys(r)[0],
            f = r[u];
          if (typeof f != 'object' || f === null) {
            Et(a, r);
            return;
          }
          if (
            (s[u] === !0 && (s[u] = { enabled: !0 }),
            u === 'navigation' &&
              s[u] &&
              s[u].enabled &&
              !s[u].prevEl &&
              !s[u].nextEl &&
              (s[u].auto = !0),
            ['pagination', 'scrollbar'].indexOf(u) >= 0 &&
              s[u] &&
              s[u].enabled &&
              !s[u].el &&
              (s[u].auto = !0),
            !(u in s && 'enabled' in f))
          ) {
            Et(a, r);
            return;
          }
          (typeof s[u] == 'object' &&
            !('enabled' in s[u]) &&
            (s[u].enabled = !0),
            s[u] || (s[u] = { enabled: !1 }),
            Et(a, r));
        };
      }
      const ou = {
          eventsEmitter: Rb,
          update: $b,
          translate: Jb,
          transition: Wb,
          slide: r0,
          loop: f0,
          grabCursor: p0,
          events: A0,
          breakpoints: _0,
          checkOverflow: L0,
          classes: R0,
        },
        uu = {};
      let Au = class si {
        constructor(...a) {
          let l, r;
          (a.length === 1 &&
          a[0].constructor &&
          Object.prototype.toString.call(a[0]).slice(8, -1) === 'Object'
            ? (r = a[0])
            : ([l, r] = a),
            r || (r = {}),
            (r = Et({}, r)),
            l && !r.el && (r.el = l));
          const u = on();
          if (
            r.el &&
            typeof r.el == 'string' &&
            u.querySelectorAll(r.el).length > 1
          ) {
            const d = [];
            return (
              u.querySelectorAll(r.el).forEach(p => {
                const b = Et({}, r, { el: p });
                d.push(new si(b));
              }),
              d
            );
          }
          const f = this;
          ((f.__swiper__ = !0),
            (f.support = wp()),
            (f.device = Ap({ userAgent: r.userAgent })),
            (f.browser = Mp()),
            (f.eventsListeners = {}),
            (f.eventsAnyListeners = []),
            (f.modules = [...f.__modules__]),
            r.modules &&
              Array.isArray(r.modules) &&
              f.modules.push(...r.modules));
          const h = {};
          f.modules.forEach(d => {
            d({
              params: r,
              swiper: f,
              extendParams: j0(r, h),
              on: f.on.bind(f),
              once: f.once.bind(f),
              off: f.off.bind(f),
              emit: f.emit.bind(f),
            });
          });
          const g = Et({}, xu, h);
          return (
            (f.params = Et({}, g, uu, r)),
            (f.originalParams = Et({}, f.params)),
            (f.passedParams = Et({}, r)),
            f.params &&
              f.params.on &&
              Object.keys(f.params.on).forEach(d => {
                f.on(d, f.params.on[d]);
              }),
            f.params && f.params.onAny && f.onAny(f.params.onAny),
            Object.assign(f, {
              enabled: f.params.enabled,
              el: l,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return f.params.direction === 'horizontal';
              },
              isVertical() {
                return f.params.direction === 'vertical';
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: f.params.allowSlideNext,
              allowSlidePrev: f.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: f.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: f.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            f.emit('_swiper'),
            f.params.init && f.init(),
            f
          );
        }
        getDirectionLabel(a) {
          return this.isHorizontal()
            ? a
            : {
                width: 'height',
                'margin-top': 'margin-left',
                'margin-bottom ': 'margin-right',
                'margin-left': 'margin-top',
                'margin-right': 'margin-bottom',
                'padding-left': 'padding-top',
                'padding-right': 'padding-bottom',
                marginRight: 'marginBottom',
              }[a];
        }
        getSlideIndex(a) {
          const { slidesEl: l, params: r } = this,
            u = oi(l, `.${r.slideClass}, swiper-slide`),
            f = ep(u[0]);
          return ep(a) - f;
        }
        getSlideIndexByData(a) {
          return this.getSlideIndex(
            this.slides.find(
              l => l.getAttribute('data-swiper-slide-index') * 1 === a
            )
          );
        }
        getSlideIndexWhenGrid(a) {
          return (
            this.grid &&
              this.params.grid &&
              this.params.grid.rows > 1 &&
              (this.params.grid.fill === 'column'
                ? (a = Math.floor(a / this.params.grid.rows))
                : this.params.grid.fill === 'row' &&
                  (a =
                    a % Math.ceil(this.slides.length / this.params.grid.rows))),
            a
          );
        }
        recalcSlides() {
          const a = this,
            { slidesEl: l, params: r } = a;
          a.slides = oi(l, `.${r.slideClass}, swiper-slide`);
        }
        enable() {
          const a = this;
          a.enabled ||
            ((a.enabled = !0),
            a.params.grabCursor && a.setGrabCursor(),
            a.emit('enable'));
        }
        disable() {
          const a = this;
          a.enabled &&
            ((a.enabled = !1),
            a.params.grabCursor && a.unsetGrabCursor(),
            a.emit('disable'));
        }
        setProgress(a, l) {
          const r = this;
          a = Math.min(Math.max(a, 0), 1);
          const u = r.minTranslate(),
            h = (r.maxTranslate() - u) * a + u;
          (r.translateTo(h, typeof l > 'u' ? 0 : l),
            r.updateActiveIndex(),
            r.updateSlidesClasses());
        }
        emitContainerClasses() {
          const a = this;
          if (!a.params._emitClasses || !a.el) return;
          const l = a.el.className
            .split(' ')
            .filter(
              r =>
                r.indexOf('swiper') === 0 ||
                r.indexOf(a.params.containerModifierClass) === 0
            );
          a.emit('_containerClasses', l.join(' '));
        }
        getSlideClasses(a) {
          const l = this;
          return l.destroyed
            ? ''
            : a.className
                .split(' ')
                .filter(
                  r =>
                    r.indexOf('swiper-slide') === 0 ||
                    r.indexOf(l.params.slideClass) === 0
                )
                .join(' ');
        }
        emitSlidesClasses() {
          const a = this;
          if (!a.params._emitClasses || !a.el) return;
          const l = [];
          (a.slides.forEach(r => {
            const u = a.getSlideClasses(r);
            (l.push({ slideEl: r, classNames: u }),
              a.emit('_slideClass', r, u));
          }),
            a.emit('_slideClasses', l));
        }
        slidesPerViewDynamic(a = 'current', l = !1) {
          const r = this,
            {
              params: u,
              slides: f,
              slidesGrid: h,
              slidesSizesGrid: g,
              size: d,
              activeIndex: p,
            } = r;
          let b = 1;
          if (typeof u.slidesPerView == 'number') return u.slidesPerView;
          if (u.centeredSlides) {
            let y = f[p] ? Math.ceil(f[p].swiperSlideSize) : 0,
              w;
            for (let x = p + 1; x < f.length; x += 1)
              f[x] &&
                !w &&
                ((y += Math.ceil(f[x].swiperSlideSize)),
                (b += 1),
                y > d && (w = !0));
            for (let x = p - 1; x >= 0; x -= 1)
              f[x] &&
                !w &&
                ((y += f[x].swiperSlideSize), (b += 1), y > d && (w = !0));
          } else if (a === 'current')
            for (let y = p + 1; y < f.length; y += 1)
              (l ? h[y] + g[y] - h[p] < d : h[y] - h[p] < d) && (b += 1);
          else for (let y = p - 1; y >= 0; y -= 1) h[p] - h[y] < d && (b += 1);
          return b;
        }
        update() {
          const a = this;
          if (!a || a.destroyed) return;
          const { snapGrid: l, params: r } = a;
          (r.breakpoints && a.setBreakpoint(),
            [...a.el.querySelectorAll('[loading="lazy"]')].forEach(h => {
              h.complete && Ts(a, h);
            }),
            a.updateSize(),
            a.updateSlides(),
            a.updateProgress(),
            a.updateSlidesClasses());
          function u() {
            const h = a.rtlTranslate ? a.translate * -1 : a.translate,
              g = Math.min(Math.max(h, a.maxTranslate()), a.minTranslate());
            (a.setTranslate(g), a.updateActiveIndex(), a.updateSlidesClasses());
          }
          let f;
          if (r.freeMode && r.freeMode.enabled && !r.cssMode)
            (u(), r.autoHeight && a.updateAutoHeight());
          else {
            if (
              (r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
              a.isEnd &&
              !r.centeredSlides
            ) {
              const h =
                a.virtual && r.virtual.enabled ? a.virtual.slides : a.slides;
              f = a.slideTo(h.length - 1, 0, !1, !0);
            } else f = a.slideTo(a.activeIndex, 0, !1, !0);
            f || u();
          }
          (r.watchOverflow && l !== a.snapGrid && a.checkOverflow(),
            a.emit('update'));
        }
        changeDirection(a, l = !0) {
          const r = this,
            u = r.params.direction;
          return (
            a || (a = u === 'horizontal' ? 'vertical' : 'horizontal'),
            a === u ||
              (a !== 'horizontal' && a !== 'vertical') ||
              (r.el.classList.remove(`${r.params.containerModifierClass}${u}`),
              r.el.classList.add(`${r.params.containerModifierClass}${a}`),
              r.emitContainerClasses(),
              (r.params.direction = a),
              r.slides.forEach(f => {
                a === 'vertical' ? (f.style.width = '') : (f.style.height = '');
              }),
              r.emit('changeDirection'),
              l && r.update()),
            r
          );
        }
        changeLanguageDirection(a) {
          const l = this;
          (l.rtl && a === 'rtl') ||
            (!l.rtl && a === 'ltr') ||
            ((l.rtl = a === 'rtl'),
            (l.rtlTranslate = l.params.direction === 'horizontal' && l.rtl),
            l.rtl
              ? (l.el.classList.add(`${l.params.containerModifierClass}rtl`),
                (l.el.dir = 'rtl'))
              : (l.el.classList.remove(`${l.params.containerModifierClass}rtl`),
                (l.el.dir = 'ltr')),
            l.update());
        }
        mount(a) {
          const l = this;
          if (l.mounted) return !0;
          let r = a || l.params.el;
          if ((typeof r == 'string' && (r = document.querySelector(r)), !r))
            return !1;
          ((r.swiper = l),
            r.parentNode &&
              r.parentNode.host &&
              r.parentNode.host.nodeName ===
                l.params.swiperElementNodeName.toUpperCase() &&
              (l.isElement = !0));
          const u = () =>
            `.${(l.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let h =
            r && r.shadowRoot && r.shadowRoot.querySelector
              ? r.shadowRoot.querySelector(u())
              : oi(r, u())[0];
          return (
            !h &&
              l.params.createElements &&
              ((h = bu('div', l.params.wrapperClass)),
              r.append(h),
              oi(r, `.${l.params.slideClass}`).forEach(g => {
                h.append(g);
              })),
            Object.assign(l, {
              el: r,
              wrapperEl: h,
              slidesEl:
                l.isElement && !r.parentNode.host.slideSlots
                  ? r.parentNode.host
                  : h,
              hostEl: l.isElement ? r.parentNode.host : r,
              mounted: !0,
              rtl:
                r.dir.toLowerCase() === 'rtl' || ji(r, 'direction') === 'rtl',
              rtlTranslate:
                l.params.direction === 'horizontal' &&
                (r.dir.toLowerCase() === 'rtl' || ji(r, 'direction') === 'rtl'),
              wrongRTL: ji(h, 'display') === '-webkit-box',
            }),
            !0
          );
        }
        init(a) {
          const l = this;
          if (l.initialized || l.mount(a) === !1) return l;
          (l.emit('beforeInit'),
            l.params.breakpoints && l.setBreakpoint(),
            l.addClasses(),
            l.updateSize(),
            l.updateSlides(),
            l.params.watchOverflow && l.checkOverflow(),
            l.params.grabCursor && l.enabled && l.setGrabCursor(),
            l.params.loop && l.virtual && l.params.virtual.enabled
              ? l.slideTo(
                  l.params.initialSlide + l.virtual.slidesBefore,
                  0,
                  l.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : l.slideTo(
                  l.params.initialSlide,
                  0,
                  l.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            l.params.loop && l.loopCreate(void 0, !0),
            l.attachEvents());
          const u = [...l.el.querySelectorAll('[loading="lazy"]')];
          return (
            l.isElement &&
              u.push(...l.hostEl.querySelectorAll('[loading="lazy"]')),
            u.forEach(f => {
              f.complete
                ? Ts(l, f)
                : f.addEventListener('load', h => {
                    Ts(l, h.target);
                  });
            }),
            Su(l),
            (l.initialized = !0),
            Su(l),
            l.emit('init'),
            l.emit('afterInit'),
            l
          );
        }
        destroy(a = !0, l = !0) {
          const r = this,
            { params: u, el: f, wrapperEl: h, slides: g } = r;
          return (
            typeof r.params > 'u' ||
              r.destroyed ||
              (r.emit('beforeDestroy'),
              (r.initialized = !1),
              r.detachEvents(),
              u.loop && r.loopDestroy(),
              l &&
                (r.removeClasses(),
                f && typeof f != 'string' && f.removeAttribute('style'),
                h && h.removeAttribute('style'),
                g &&
                  g.length &&
                  g.forEach(d => {
                    (d.classList.remove(
                      u.slideVisibleClass,
                      u.slideFullyVisibleClass,
                      u.slideActiveClass,
                      u.slideNextClass,
                      u.slidePrevClass
                    ),
                      d.removeAttribute('style'),
                      d.removeAttribute('data-swiper-slide-index'));
                  })),
              r.emit('destroy'),
              Object.keys(r.eventsListeners).forEach(d => {
                r.off(d);
              }),
              a !== !1 &&
                (r.el && typeof r.el != 'string' && (r.el.swiper = null),
                yb(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(a) {
          Et(uu, a);
        }
        static get extendedDefaults() {
          return uu;
        }
        static get defaults() {
          return xu;
        }
        static installModule(a) {
          si.prototype.__modules__ || (si.prototype.__modules__ = []);
          const l = si.prototype.__modules__;
          typeof a == 'function' && l.indexOf(a) < 0 && l.push(a);
        }
        static use(a) {
          return Array.isArray(a)
            ? (a.forEach(l => si.installModule(l)), si)
            : (si.installModule(a), si);
        }
      };
      Object.keys(ou).forEach(s => {
        Object.keys(ou[s]).forEach(a => {
          Au.prototype[a] = ou[s][a];
        });
      });
      Au.use([Nb, Cb]);
      const zp = [
        'eventsPrefix',
        'injectStyles',
        'injectStylesUrls',
        'modules',
        'init',
        '_direction',
        'oneWayMovement',
        'swiperElementNodeName',
        'touchEventsTarget',
        'initialSlide',
        '_speed',
        'cssMode',
        'updateOnWindowResize',
        'resizeObserver',
        'nested',
        'focusableElements',
        '_enabled',
        '_width',
        '_height',
        'preventInteractionOnTransition',
        'userAgent',
        'url',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_freeMode',
        '_autoHeight',
        'setWrapperSize',
        'virtualTranslate',
        '_effect',
        'breakpoints',
        'breakpointsBase',
        '_spaceBetween',
        '_slidesPerView',
        'maxBackfaceHiddenSlides',
        '_grid',
        '_slidesPerGroup',
        '_slidesPerGroupSkip',
        '_slidesPerGroupAuto',
        '_centeredSlides',
        '_centeredSlidesBounds',
        '_slidesOffsetBefore',
        '_slidesOffsetAfter',
        'normalizeSlideIndex',
        '_centerInsufficientSlides',
        '_watchOverflow',
        'roundLengths',
        'touchRatio',
        'touchAngle',
        'simulateTouch',
        '_shortSwipes',
        '_longSwipes',
        'longSwipesRatio',
        'longSwipesMs',
        '_followFinger',
        'allowTouchMove',
        '_threshold',
        'touchMoveStopPropagation',
        'touchStartPreventDefault',
        'touchStartForcePreventDefault',
        'touchReleaseOnEdges',
        'uniqueNavElements',
        '_resistance',
        '_resistanceRatio',
        '_watchSlidesProgress',
        '_grabCursor',
        'preventClicks',
        'preventClicksPropagation',
        '_slideToClickedSlide',
        '_loop',
        'loopAdditionalSlides',
        'loopAddBlankSlides',
        'loopPreventsSliding',
        '_rewind',
        '_allowSlidePrev',
        '_allowSlideNext',
        '_swipeHandler',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'passiveListeners',
        'containerModifierClass',
        'slideClass',
        'slideActiveClass',
        'slideVisibleClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        'slideBlankClass',
        'wrapperClass',
        'lazyPreloaderClass',
        'lazyPreloadPrevNext',
        'runCallbacksOnInit',
        'observer',
        'observeParents',
        'observeSlideChildren',
        'a11y',
        '_autoplay',
        '_controller',
        'coverflowEffect',
        'cubeEffect',
        'fadeEffect',
        'flipEffect',
        'creativeEffect',
        'cardsEffect',
        'hashNavigation',
        'history',
        'keyboard',
        'mousewheel',
        '_navigation',
        '_pagination',
        'parallax',
        '_scrollbar',
        '_thumbs',
        'virtual',
        'zoom',
        'control',
      ];
      function rn(s) {
        return (
          typeof s == 'object' &&
          s !== null &&
          s.constructor &&
          Object.prototype.toString.call(s).slice(8, -1) === 'Object' &&
          !s.__swiper__
        );
      }
      function Pn(s, a) {
        const l = ['__proto__', 'constructor', 'prototype'];
        Object.keys(a)
          .filter(r => l.indexOf(r) < 0)
          .forEach(r => {
            typeof s[r] > 'u'
              ? (s[r] = a[r])
              : rn(a[r]) && rn(s[r]) && Object.keys(a[r]).length > 0
                ? a[r].__swiper__
                  ? (s[r] = a[r])
                  : Pn(s[r], a[r])
                : (s[r] = a[r]);
          });
      }
      function Np(s = {}) {
        return (
          s.navigation &&
          typeof s.navigation.nextEl > 'u' &&
          typeof s.navigation.prevEl > 'u'
        );
      }
      function Cp(s = {}) {
        return s.pagination && typeof s.pagination.el > 'u';
      }
      function Rp(s = {}) {
        return s.scrollbar && typeof s.scrollbar.el > 'u';
      }
      function Dp(s = '') {
        const a = s
            .split(' ')
            .map(r => r.trim())
            .filter(r => !!r),
          l = [];
        return (
          a.forEach(r => {
            l.indexOf(r) < 0 && l.push(r);
          }),
          l.join(' ')
        );
      }
      function B0(s = '') {
        return s
          ? s.includes('swiper-wrapper')
            ? s
            : `swiper-wrapper ${s}`
          : 'swiper-wrapper';
      }
      function H0({
        swiper: s,
        slides: a,
        passedParams: l,
        changedParams: r,
        nextEl: u,
        prevEl: f,
        scrollbarEl: h,
        paginationEl: g,
      }) {
        const d = r.filter(
            G => G !== 'children' && G !== 'direction' && G !== 'wrapperClass'
          ),
          {
            params: p,
            pagination: b,
            navigation: y,
            scrollbar: w,
            virtual: x,
            thumbs: O,
          } = s;
        let _, L, $, B, K, k, H, J;
        (r.includes('thumbs') &&
          l.thumbs &&
          l.thumbs.swiper &&
          !l.thumbs.swiper.destroyed &&
          p.thumbs &&
          (!p.thumbs.swiper || p.thumbs.swiper.destroyed) &&
          (_ = !0),
          r.includes('controller') &&
            l.controller &&
            l.controller.control &&
            p.controller &&
            !p.controller.control &&
            (L = !0),
          r.includes('pagination') &&
            l.pagination &&
            (l.pagination.el || g) &&
            (p.pagination || p.pagination === !1) &&
            b &&
            !b.el &&
            ($ = !0),
          r.includes('scrollbar') &&
            l.scrollbar &&
            (l.scrollbar.el || h) &&
            (p.scrollbar || p.scrollbar === !1) &&
            w &&
            !w.el &&
            (B = !0),
          r.includes('navigation') &&
            l.navigation &&
            (l.navigation.prevEl || f) &&
            (l.navigation.nextEl || u) &&
            (p.navigation || p.navigation === !1) &&
            y &&
            !y.prevEl &&
            !y.nextEl &&
            (K = !0));
        const Z = G => {
          s[G] &&
            (s[G].destroy(),
            G === 'navigation'
              ? (s.isElement && (s[G].prevEl.remove(), s[G].nextEl.remove()),
                (p[G].prevEl = void 0),
                (p[G].nextEl = void 0),
                (s[G].prevEl = void 0),
                (s[G].nextEl = void 0))
              : (s.isElement && s[G].el.remove(),
                (p[G].el = void 0),
                (s[G].el = void 0)));
        };
        (r.includes('loop') &&
          s.isElement &&
          (p.loop && !l.loop
            ? (k = !0)
            : !p.loop && l.loop
              ? (H = !0)
              : (J = !0)),
          d.forEach(G => {
            if (rn(p[G]) && rn(l[G]))
              (Object.assign(p[G], l[G]),
                (G === 'navigation' ||
                  G === 'pagination' ||
                  G === 'scrollbar') &&
                  'enabled' in l[G] &&
                  !l[G].enabled &&
                  Z(G));
            else {
              const ee = l[G];
              (ee === !0 || ee === !1) &&
              (G === 'navigation' || G === 'pagination' || G === 'scrollbar')
                ? ee === !1 && Z(G)
                : (p[G] = l[G]);
            }
          }),
          d.includes('controller') &&
            !L &&
            s.controller &&
            s.controller.control &&
            p.controller &&
            p.controller.control &&
            (s.controller.control = p.controller.control),
          r.includes('children') && a && x && p.virtual.enabled
            ? ((x.slides = a), x.update(!0))
            : r.includes('virtual') &&
              x &&
              p.virtual.enabled &&
              (a && (x.slides = a), x.update(!0)),
          r.includes('children') && a && p.loop && (J = !0),
          _ && O.init() && O.update(!0),
          L && (s.controller.control = p.controller.control),
          $ &&
            (s.isElement &&
              (!g || typeof g == 'string') &&
              ((g = document.createElement('div')),
              g.classList.add('swiper-pagination'),
              g.part.add('pagination'),
              s.el.appendChild(g)),
            g && (p.pagination.el = g),
            b.init(),
            b.render(),
            b.update()),
          B &&
            (s.isElement &&
              (!h || typeof h == 'string') &&
              ((h = document.createElement('div')),
              h.classList.add('swiper-scrollbar'),
              h.part.add('scrollbar'),
              s.el.appendChild(h)),
            h && (p.scrollbar.el = h),
            w.init(),
            w.updateSize(),
            w.setTranslate()),
          K &&
            (s.isElement &&
              ((!u || typeof u == 'string') &&
                ((u = document.createElement('div')),
                u.classList.add('swiper-button-next'),
                ip(u, s.hostEl.constructor.nextButtonSvg),
                u.part.add('button-next'),
                s.el.appendChild(u)),
              (!f || typeof f == 'string') &&
                ((f = document.createElement('div')),
                f.classList.add('swiper-button-prev'),
                ip(f, s.hostEl.constructor.prevButtonSvg),
                f.part.add('button-prev'),
                s.el.appendChild(f))),
            u && (p.navigation.nextEl = u),
            f && (p.navigation.prevEl = f),
            y.init(),
            y.update()),
          r.includes('allowSlideNext') && (s.allowSlideNext = l.allowSlideNext),
          r.includes('allowSlidePrev') && (s.allowSlidePrev = l.allowSlidePrev),
          r.includes('direction') && s.changeDirection(l.direction, !1),
          (k || J) && s.loopDestroy(),
          (H || J) && s.loopCreate(),
          s.update());
      }
      function U0(s = {}, a = !0) {
        const l = { on: {} },
          r = {},
          u = {};
        (Pn(l, xu), (l._emitClasses = !0), (l.init = !1));
        const f = {},
          h = zp.map(d => d.replace(/_/, '')),
          g = Object.assign({}, s);
        return (
          Object.keys(g).forEach(d => {
            typeof s[d] > 'u' ||
              (h.indexOf(d) >= 0
                ? rn(s[d])
                  ? ((l[d] = {}), (u[d] = {}), Pn(l[d], s[d]), Pn(u[d], s[d]))
                  : ((l[d] = s[d]), (u[d] = s[d]))
                : d.search(/on[A-Z]/) === 0 && typeof s[d] == 'function'
                  ? a
                    ? (r[`${d[2].toLowerCase()}${d.substr(3)}`] = s[d])
                    : (l.on[`${d[2].toLowerCase()}${d.substr(3)}`] = s[d])
                  : (f[d] = s[d]));
          }),
          ['navigation', 'pagination', 'scrollbar'].forEach(d => {
            (l[d] === !0 && (l[d] = {}), l[d] === !1 && delete l[d]);
          }),
          { params: l, passedParams: u, rest: f, events: r }
        );
      }
      function G0(
        {
          el: s,
          nextEl: a,
          prevEl: l,
          paginationEl: r,
          scrollbarEl: u,
          swiper: f,
        },
        h
      ) {
        (Np(h) &&
          a &&
          l &&
          ((f.params.navigation.nextEl = a),
          (f.originalParams.navigation.nextEl = a),
          (f.params.navigation.prevEl = l),
          (f.originalParams.navigation.prevEl = l)),
          Cp(h) &&
            r &&
            ((f.params.pagination.el = r),
            (f.originalParams.pagination.el = r)),
          Rp(h) &&
            u &&
            ((f.params.scrollbar.el = u), (f.originalParams.scrollbar.el = u)),
          f.init(s));
      }
      function V0(s, a, l, r, u) {
        const f = [];
        if (!a) return f;
        const h = d => {
          f.indexOf(d) < 0 && f.push(d);
        };
        if (l && r) {
          const d = r.map(u),
            p = l.map(u);
          (d.join('') !== p.join('') && h('children'),
            r.length !== l.length && h('children'));
        }
        return (
          zp
            .filter(d => d[0] === '_')
            .map(d => d.replace(/_/, ''))
            .forEach(d => {
              if (d in s && d in a)
                if (rn(s[d]) && rn(a[d])) {
                  const p = Object.keys(s[d]),
                    b = Object.keys(a[d]);
                  p.length !== b.length
                    ? h(d)
                    : (p.forEach(y => {
                        s[d][y] !== a[d][y] && h(d);
                      }),
                      b.forEach(y => {
                        s[d][y] !== a[d][y] && h(d);
                      }));
                } else s[d] !== a[d] && h(d);
            }),
          f
        );
      }
      const Y0 = s => {
        !s ||
          s.destroyed ||
          !s.params.virtual ||
          (s.params.virtual && !s.params.virtual.enabled) ||
          (s.updateSlides(),
          s.updateProgress(),
          s.updateSlidesClasses(),
          s.emit('_virtualUpdated'),
          s.parallax &&
            s.params.parallax &&
            s.params.parallax.enabled &&
            s.parallax.setTranslate());
      };
      function _s() {
        return (
          (_s = Object.assign
            ? Object.assign.bind()
            : function (s) {
                for (var a = 1; a < arguments.length; a++) {
                  var l = arguments[a];
                  for (var r in l)
                    Object.prototype.hasOwnProperty.call(l, r) && (s[r] = l[r]);
                }
                return s;
              }),
          _s.apply(this, arguments)
        );
      }
      function Lp(s) {
        return (
          s.type &&
          s.type.displayName &&
          s.type.displayName.includes('SwiperSlide')
        );
      }
      function jp(s) {
        const a = [];
        return (
          $e.Children.toArray(s).forEach(l => {
            Lp(l)
              ? a.push(l)
              : l.props &&
                l.props.children &&
                jp(l.props.children).forEach(r => a.push(r));
          }),
          a
        );
      }
      function q0(s) {
        const a = [],
          l = {
            'container-start': [],
            'container-end': [],
            'wrapper-start': [],
            'wrapper-end': [],
          };
        return (
          $e.Children.toArray(s).forEach(r => {
            if (Lp(r)) a.push(r);
            else if (r.props && r.props.slot && l[r.props.slot])
              l[r.props.slot].push(r);
            else if (r.props && r.props.children) {
              const u = jp(r.props.children);
              u.length > 0
                ? u.forEach(f => a.push(f))
                : l['container-end'].push(r);
            } else l['container-end'].push(r);
          }),
          { slides: a, slots: l }
        );
      }
      function $0(s, a, l) {
        if (!l) return null;
        const r = b => {
            let y = b;
            return (
              b < 0 ? (y = a.length + b) : y >= a.length && (y = y - a.length),
              y
            );
          },
          u = s.isHorizontal()
            ? { [s.rtlTranslate ? 'right' : 'left']: `${l.offset}px` }
            : { top: `${l.offset}px` },
          { from: f, to: h } = l,
          g = s.params.loop ? -a.length : 0,
          d = s.params.loop ? a.length * 2 : a.length,
          p = [];
        for (let b = g; b < d; b += 1) b >= f && b <= h && p.push(a[r(b)]);
        return p.map((b, y) =>
          $e.cloneElement(b, {
            swiper: s,
            style: u,
            key: b.props.virtualIndex || b.key || `slide-${y}`,
          })
        );
      }
      function el(s, a) {
        return typeof window > 'u'
          ? F.useEffect(s, a)
          : F.useLayoutEffect(s, a);
      }
      const rp = F.createContext(null),
        K0 = F.createContext(null),
        Bp = F.forwardRef(
          (
            {
              className: s,
              tag: a = 'div',
              wrapperTag: l = 'div',
              children: r,
              onSwiper: u,
              ...f
            } = {},
            h
          ) => {
            let g = !1;
            const [d, p] = F.useState('swiper'),
              [b, y] = F.useState(null),
              [w, x] = F.useState(!1),
              O = F.useRef(!1),
              _ = F.useRef(null),
              L = F.useRef(null),
              $ = F.useRef(null),
              B = F.useRef(null),
              K = F.useRef(null),
              k = F.useRef(null),
              H = F.useRef(null),
              J = F.useRef(null),
              { params: Z, passedParams: G, rest: ee, events: Q } = U0(f),
              { slides: I, slots: ie } = q0(r),
              oe = () => {
                x(!w);
              };
            Object.assign(Z.on, {
              _containerClasses(q, ne) {
                p(ne);
              },
            });
            const ue = () => {
              (Object.assign(Z.on, Q), (g = !0));
              const q = { ...Z };
              if (
                (delete q.wrapperClass,
                (L.current = new Au(q)),
                L.current.virtual && L.current.params.virtual.enabled)
              ) {
                L.current.virtual.slides = I;
                const ne = {
                  cache: !1,
                  slides: I,
                  renderExternal: y,
                  renderExternalUpdate: !1,
                };
                (Pn(L.current.params.virtual, ne),
                  Pn(L.current.originalParams.virtual, ne));
              }
            };
            (_.current || ue(),
              L.current && L.current.on('_beforeBreakpoint', oe));
            const he = () => {
                g ||
                  !Q ||
                  !L.current ||
                  Object.keys(Q).forEach(q => {
                    L.current.on(q, Q[q]);
                  });
              },
              D = () => {
                !Q ||
                  !L.current ||
                  Object.keys(Q).forEach(q => {
                    L.current.off(q, Q[q]);
                  });
              };
            (F.useEffect(() => () => {
              L.current && L.current.off('_beforeBreakpoint', oe);
            }),
              F.useEffect(() => {
                !O.current &&
                  L.current &&
                  (L.current.emitSlidesClasses(), (O.current = !0));
              }),
              el(() => {
                if ((h && (h.current = _.current), !!_.current))
                  return (
                    L.current.destroyed && ue(),
                    G0(
                      {
                        el: _.current,
                        nextEl: K.current,
                        prevEl: k.current,
                        paginationEl: H.current,
                        scrollbarEl: J.current,
                        swiper: L.current,
                      },
                      Z
                    ),
                    u && !L.current.destroyed && u(L.current),
                    () => {
                      L.current &&
                        !L.current.destroyed &&
                        L.current.destroy(!0, !1);
                    }
                  );
              }, []),
              el(() => {
                he();
                const q = V0(G, $.current, I, B.current, ne => ne.key);
                return (
                  ($.current = G),
                  (B.current = I),
                  q.length &&
                    L.current &&
                    !L.current.destroyed &&
                    H0({
                      swiper: L.current,
                      slides: I,
                      passedParams: G,
                      changedParams: q,
                      nextEl: K.current,
                      prevEl: k.current,
                      scrollbarEl: J.current,
                      paginationEl: H.current,
                    }),
                  () => {
                    D();
                  }
                );
              }),
              el(() => {
                Y0(L.current);
              }, [b]));
            function X() {
              return Z.virtual
                ? $0(L.current, I, b)
                : I.map((q, ne) =>
                    $e.cloneElement(q, {
                      swiper: L.current,
                      swiperSlideIndex: ne,
                    })
                  );
            }
            return $e.createElement(
              a,
              _s({ ref: _, className: Dp(`${d}${s ? ` ${s}` : ''}`) }, ee),
              $e.createElement(
                K0.Provider,
                { value: L.current },
                ie['container-start'],
                $e.createElement(
                  l,
                  { className: B0(Z.wrapperClass) },
                  ie['wrapper-start'],
                  X(),
                  ie['wrapper-end']
                ),
                Np(Z) &&
                  $e.createElement(
                    $e.Fragment,
                    null,
                    $e.createElement('div', {
                      ref: k,
                      className: 'swiper-button-prev',
                    }),
                    $e.createElement('div', {
                      ref: K,
                      className: 'swiper-button-next',
                    })
                  ),
                Rp(Z) &&
                  $e.createElement('div', {
                    ref: J,
                    className: 'swiper-scrollbar',
                  }),
                Cp(Z) &&
                  $e.createElement('div', {
                    ref: H,
                    className: 'swiper-pagination',
                  }),
                ie['container-end']
              )
            );
          }
        );
      Bp.displayName = 'Swiper';
      const Hp = F.forwardRef(
        (
          {
            tag: s = 'div',
            children: a,
            className: l = '',
            swiper: r,
            zoom: u,
            lazy: f,
            virtualIndex: h,
            swiperSlideIndex: g,
            ...d
          } = {},
          p
        ) => {
          const b = F.useRef(null),
            [y, w] = F.useState('swiper-slide'),
            [x, O] = F.useState(!1);
          function _(K, k, H) {
            k === b.current && w(H);
          }
          (el(() => {
            if (
              (typeof g < 'u' && (b.current.swiperSlideIndex = g),
              p && (p.current = b.current),
              !(!b.current || !r))
            ) {
              if (r.destroyed) {
                y !== 'swiper-slide' && w('swiper-slide');
                return;
              }
              return (
                r.on('_slideClass', _),
                () => {
                  r && r.off('_slideClass', _);
                }
              );
            }
          }),
            el(() => {
              r && b.current && !r.destroyed && w(r.getSlideClasses(b.current));
            }, [r]));
          const L = {
              isActive: y.indexOf('swiper-slide-active') >= 0,
              isVisible: y.indexOf('swiper-slide-visible') >= 0,
              isPrev: y.indexOf('swiper-slide-prev') >= 0,
              isNext: y.indexOf('swiper-slide-next') >= 0,
            },
            $ = () => (typeof a == 'function' ? a(L) : a),
            B = () => {
              O(!0);
            };
          return $e.createElement(
            s,
            _s(
              {
                ref: b,
                className: Dp(`${y}${l ? ` ${l}` : ''}`),
                'data-swiper-slide-index': h,
                onLoad: B,
              },
              d
            ),
            u &&
              $e.createElement(
                rp.Provider,
                { value: L },
                $e.createElement(
                  'div',
                  {
                    className: 'swiper-zoom-container',
                    'data-swiper-zoom': typeof u == 'number' ? u : void 0,
                  },
                  $(),
                  f &&
                    !x &&
                    $e.createElement('div', {
                      className: 'swiper-lazy-preloader',
                    })
                )
              ),
            !u &&
              $e.createElement(
                rp.Provider,
                { value: L },
                $(),
                f &&
                  !x &&
                  $e.createElement('div', {
                    className: 'swiper-lazy-preloader',
                  })
              )
          );
        }
      );
      Hp.displayName = 'SwiperSlide';
      function op(s) {
        return `calc(${s} / 2560 * 100 * var(--t1-pc-vw, 1vw))`;
      }
      function up(s) {
        return `calc(${s} / 750 * 100vw)`;
      }
      const k0 = 'wrap_Kcce3',
        X0 = 'viewport_RhWiN',
        Q0 = 'slideItem_H6aW7',
        Z0 = 'controls_92KXi',
        J0 = 'controlsRow_Kf-87',
        F0 = 'indicator_Tpxmf',
        I0 = 'segment_qpu44',
        P0 = 'segmentActive_UKOGk',
        W0 = 'footer_pfPTO',
        e1 = 'arrows_wSiBC',
        t1 = 'arrowHit_oUDNY',
        i1 = 'arrowHitDisabled_8lnP3',
        n1 = 'arrow_Ltr48',
        a1 = 'arrowIcon_Itorx',
        l1 = 'arrowPrev_86AsN',
        s1 = 'arrowNext_7ww5f',
        Be = {
          wrap: k0,
          viewport: X0,
          slideItem: Q0,
          controls: Z0,
          controlsRow: J0,
          indicator: F0,
          segment: I0,
          segmentActive: P0,
          footer: W0,
          arrows: e1,
          arrowHit: t1,
          arrowHitDisabled: i1,
          arrow: n1,
          arrowIcon: a1,
          arrowPrev: l1,
          arrowNext: s1,
        };
      function cp(s, a) {
        const [l, r] = F.useState(s);
        return (
          F.useEffect(() => {
            const u = () => {
              if (a === 2560) {
                const h =
                  document.querySelector('.t1-page')?.clientWidth ??
                  document.documentElement.clientWidth;
                r((s / 2560) * h);
              } else r((s / 750) * window.innerWidth);
            };
            return (
              u(),
              window.addEventListener('resize', u),
              () => window.removeEventListener('resize', u)
            );
          }, [s, a]),
          l
        );
      }
      function r1({ activeIndex: s, total: a, onPrev: l, onNext: r }) {
        const u = s <= 0,
          f = s >= a - 1;
        return A.jsxs('div', {
          className: Be.arrows,
          children: [
            A.jsx('span', {
              className: `${Be.arrowHit} ${u ? Be.arrowHitDisabled : ''}`,
              children: A.jsx('button', {
                type: 'button',
                className: Be.arrow,
                'aria-label': 'Previous',
                disabled: u,
                onClick: l,
                children: A.jsx('span', {
                  className: `${Be.arrowIcon} ${Be.arrowPrev}`,
                  'aria-hidden': 'true',
                }),
              }),
            }),
            A.jsx('span', {
              className: `${Be.arrowHit} ${f ? Be.arrowHitDisabled : ''}`,
              children: A.jsx('button', {
                type: 'button',
                className: Be.arrow,
                'aria-label': 'Next',
                disabled: f,
                onClick: r,
                children: A.jsx('span', {
                  className: `${Be.arrowIcon} ${Be.arrowNext}`,
                  'aria-hidden': 'true',
                }),
              }),
            }),
          ],
        });
      }
      const Mu = F.forwardRef(function (
        {
          variant: a = 'pc',
          slides: l,
          pcSlideWidth: r = 1228,
          pcSlideHeight: u = 610,
          mbSlideWidth: f = 630,
          mbSlideHeight: h = 420,
          footer: g,
          showControls: d = !0,
          autoplay: p = !1,
          autoplayDelay: b = 4e3,
          onIndexChange: y,
          className: w,
        },
        x
      ) {
        const O = F.useRef(null),
          _ = a === 'pc',
          L = l.length,
          [$, B] = F.useState(0),
          [K, k] = F.useState(!1),
          H = cp(_ ? (2560 - r) / 2 : 60, _ ? 2560 : 750),
          J = cp(_ ? 16 : 10.5, _ ? 2560 : 750),
          Z = F.useCallback(
            ee => {
              ee < 0 || ee >= L || O.current?.slideTo(ee);
            },
            [L]
          ),
          G = F.useCallback(() => {
            const ee = O.current;
            if (!ee || ee.destroyed) return;
            const Q = ee.activeIndex >= L - 1 ? 0 : ee.activeIndex + 1;
            ee.slideTo(Q);
          }, [L]);
        return (
          F.useImperativeHandle(x, () => ({ slideTo: Z, slideNext: G }), [
            Z,
            G,
          ]),
          F.useEffect(() => {
            if (!p || K || L <= 1) return;
            const ee = window.setTimeout(() => {
              const Q = O.current;
              if (!Q || Q.destroyed || Q.animating) return;
              const I = Q.activeIndex >= L - 1 ? 0 : Q.activeIndex + 1;
              Q.slideTo(I);
            }, b);
            return () => window.clearTimeout(ee);
          }, [p, b, K, L, $]),
          A.jsxs('div', {
            className: `${Be.wrap} ${_ ? Be.pcWrap : Be.mbWrap} ${w ?? ''}`,
            style: {
              '--t1-slide-w': _ ? op(r) : up(f),
              '--t1-slide-h': _ ? op(u) : up(h),
            },
            onMouseEnter: () => {
              p && k(!0);
            },
            onMouseLeave: () => {
              p && k(!1);
            },
            children: [
              A.jsx('div', {
                className: Be.viewport,
                children: A.jsx(Bp, {
                  slidesPerView: 'auto',
                  spaceBetween: J,
                  slidesOffsetBefore: H,
                  slidesOffsetAfter: H,
                  speed: 600,
                  resistanceRatio: 0.65,
                  roundLengths: !_,
                  onSwiper: ee => {
                    O.current = ee;
                  },
                  onSlideChange: ee => {
                    (B(ee.activeIndex), y?.(ee.activeIndex));
                  },
                  onSlideChangeTransitionEnd: ee => {
                    B(ee.activeIndex);
                  },
                  children: l.map((ee, Q) =>
                    A.jsx(
                      Hp,
                      {
                        className: Be.slideItem,
                        onClick: () => Z(Q),
                        children: ee,
                      },
                      Q
                    )
                  ),
                }),
              }),
              d
                ? A.jsxs('div', {
                    className: Be.controls,
                    children: [
                      A.jsxs('div', {
                        className: Be.controlsRow,
                        children: [
                          A.jsx('div', {
                            className: Be.indicator,
                            children: l.map((ee, Q) =>
                              A.jsx(
                                'button',
                                {
                                  type: 'button',
                                  className: `${Be.segment} ${Q === $ ? Be.segmentActive : ''}`,
                                  'aria-label': `Go to slide ${Q + 1}`,
                                  'aria-current': Q === $,
                                  onClick: () => Z(Q),
                                },
                                Q
                              )
                            ),
                          }),
                          A.jsx(r1, {
                            activeIndex: $,
                            total: L,
                            onPrev: () => Z($ - 1),
                            onNext: () => Z($ + 1),
                          }),
                        ],
                      }),
                      g
                        ? A.jsx('div', { className: Be.footer, children: g })
                        : null,
                    ],
                  })
                : null,
            ],
          })
        );
      });
      Mu.displayName = 'T1Carousel';
      const o1 = 'section_xONZd',
        u1 = 'head_d1oV8',
        c1 = 'title_NGuI1',
        f1 = 'body_--L55',
        d1 = 'slide_JgfbC',
        h1 = 'slideMedia_Yu5zC',
        p1 = 'caption_mTfq6',
        m1 = 'captionName_JyNwt',
        g1 = 'captionBody_nGnl9',
        ai = {
          section: o1,
          head: u1,
          title: c1,
          body: f1,
          slide: d1,
          slideMedia: h1,
          caption: p1,
          captionName: m1,
          captionBody: g1,
        };
      function Ou({
        variant: s = 'pc',
        titleKey: a,
        bodyKey: l,
        imageKeys: r,
        slidesTextKey: u,
        headPosition: f = 'top',
        className: h,
        bgColor: g,
        mediaKind: d = 'image',
      }) {
        const { t: p } = Ke(),
          [b, y] = F.useState(0),
          w = F.useRef(null),
          x = d === 'video',
          O = u ? (p(u, { returnObjects: !0 }) ?? []) : [],
          _ = Array.isArray(O) ? O[b] : void 0,
          L = A.jsxs('div', {
            className: ai.head,
            children: [
              A.jsx(Ee, { as: 'h2', className: ai.title, html: p(a) }),
              l && A.jsx(Ee, { className: ai.body, html: p(l) }),
            ],
          });
        return A.jsxs('section', {
          className: `${ai.section} ${h ?? ''}`,
          style: g ? { background: g } : void 0,
          children: [
            f === 'top' ? L : null,
            A.jsx(Mu, {
              ref: w,
              variant: s,
              autoplay: !x,
              onIndexChange: y,
              footer:
                _?.name || _?.body
                  ? A.jsxs('div', {
                      className: ai.caption,
                      children: [
                        A.jsx(Ee, { className: ai.captionName, html: _.name }),
                        A.jsx(Ee, { className: ai.captionBody, html: _.body }),
                      ],
                    })
                  : null,
              slides: r.map(($, B) =>
                A.jsx(
                  'div',
                  {
                    className: ai.slide,
                    children: A.jsx(dt, {
                      className: ai.slideMedia,
                      imageKey: $,
                      variant: s,
                      kind: d,
                      loop: !x,
                      active: x ? B === b : void 0,
                      onEnded: x
                        ? () => {
                            B === b && w.current?.slideNext();
                          }
                        : void 0,
                      pcAspectRatio: '1228/610',
                      mobileAspectRatio: '630/420',
                    }),
                  },
                  $
                )
              ),
            }),
            f === 'bottom' ? L : null,
          ],
        });
      }
      const v1 = 'section_OI8y8',
        y1 = { section: v1 },
        b1 = ['section5Slide1', 'section5Slide2', 'section5Slide3'];
      function S1({ variant: s = 'pc' }) {
        return A.jsx(Ou, {
          variant: s,
          titleKey: 'section5.title',
          bodyKey: 'section5.body',
          imageKeys: b1,
          slidesTextKey: 'section5.slides',
          mediaKind: 'video',
          className: y1.section,
        });
      }
      const x1 = 'section_UBGra',
        T1 = 'head_lYUBb',
        E1 = 'title_Q6-cl',
        w1 = 'body_EB52w',
        A1 = 'panel_Ul1Aq',
        M1 = 'media_JQkCC',
        O1 = 'mediaActive_qTOvG',
        _1 = 'mediaImg_5yuFm',
        z1 = 'tabs_hbih7',
        N1 = 'slider_2jz9R',
        C1 = 'sliderReady_Gquw3',
        R1 = 'tab_14Z9-',
        D1 = 'tabActive_0COzl',
        L1 = 'tabRows_nqKuF',
        ft = {
          section: x1,
          head: T1,
          title: E1,
          body: w1,
          panel: A1,
          media: M1,
          mediaActive: O1,
          mediaImg: _1,
          tabs: z1,
          slider: N1,
          sliderReady: C1,
          tab: R1,
          tabActive: D1,
          tabRows: L1,
        };
      function j1(s, a, l, r) {
        const u = F.useRef(null),
          f = F.useRef(() => {});
        return (
          F.useEffect(() => {
            if (!s || l <= 1) return;
            const h = u.current;
            if (!h) return;
            let g = 0,
              d = !1,
              p = !1,
              b = !1;
            const y = () => {
                (window.clearTimeout(g), (g = 0));
              },
              w = () => !d && p && document.visibilityState === 'visible',
              x = () => {
                (y(),
                  w() &&
                    (g = window.setTimeout(() => {
                      ((g = 0), w() && (r(J => (J + 1) % l), x()));
                    }, a)));
              };
            f.current = x;
            const O = new IntersectionObserver(
              ([J]) => {
                ((p = J.isIntersecting), p ? x() : y());
              },
              { threshold: 0.25 }
            );
            O.observe(h);
            const _ = () => {
                ((d = !0), y());
              },
              L = () => {
                ((d = !1), x());
              },
              $ = J => {
                !b || J.pointerType !== 'mouse' || _();
              },
              B = J => {
                J.pointerType === 'mouse' && L();
              },
              K = J => {
                const Z = document.elementFromPoint(J.clientX, J.clientY);
                return !!(Z && (Z === h || h.contains(Z)));
              },
              k = J => {
                ((b = !0), J.pointerType === 'mouse' && K(J) && _());
              },
              H = () => {
                document.visibilityState === 'visible' ? x() : y();
              };
            return (
              h.addEventListener('pointerenter', $),
              h.addEventListener('pointerleave', B),
              window.addEventListener('pointermove', k, {
                once: !0,
                passive: !0,
              }),
              document.addEventListener('visibilitychange', H),
              () => {
                (y(),
                  O.disconnect(),
                  (f.current = () => {}),
                  h.removeEventListener('pointerenter', $),
                  h.removeEventListener('pointerleave', B),
                  window.removeEventListener('pointermove', k),
                  document.removeEventListener('visibilitychange', H));
              }
            );
          }, [a, s, r, l]),
          {
            panelRef: u,
            restartAutoplay() {
              f.current();
            },
          }
        );
      }
      const Fn = 4;
      function Up({
        variant: s = 'pc',
        titleKey: a,
        bodyKey: l,
        tabsKey: r,
        imageKeys: u,
        className: f,
        panelClassName: h,
        tabsWrapMb: g = !1,
        autoplay: d = !0,
        autoplayDelay: p = 4e3,
      }) {
        const { t: b } = Ke(),
          [y, w] = F.useState(0),
          [x, O] = F.useState({ x: 0, w: 0 }),
          [_, L] = F.useState(!1),
          $ = F.useRef(null),
          B = F.useRef([]),
          K = F.useRef([]),
          k = b(r, { returnObjects: !0 }) ?? [],
          H = Array.isArray(k) ? k.length : 0,
          J = g && s === 'mb',
          Z = J ? [k.slice(0, Fn), k.slice(Fn, Fn * 2)] : [k],
          G = J ? Math.floor(y / Fn) : 0;
        F.useLayoutEffect(() => {
          const oe = J ? B.current[Math.floor(y / Fn)] : $.current;
          if (!oe) return;
          const ue = () => {
            const D = K.current[y];
            if (!D) return;
            const X = D.offsetLeft,
              q = D.offsetWidth;
            (O(ne => (ne.x === X && ne.w === q ? ne : { x: X, w: q })), L(!0));
          };
          ue();
          const he = new ResizeObserver(ue);
          return (he.observe(oe), () => he.disconnect());
        }, [y, H, s, J]);
        const ee = Math.min(H, u.length),
          { panelRef: Q, restartAutoplay: I } = j1(d, p, ee, w),
          ie = (oe, ue) =>
            A.jsxs(
              'div',
              {
                className: ft.tabs,
                ref: he => {
                  J ? (B.current[ue] = he) : ($.current = he);
                },
                role: 'tablist',
                children: [
                  ue === G
                    ? A.jsx(
                        'span',
                        {
                          className: `${ft.slider} ${_ ? ft.sliderReady : ''}`,
                          style: {
                            width: x.w,
                            transform: `translate3d(${x.x}px, 0, 0)`,
                          },
                          'aria-hidden': 'true',
                        },
                        G
                      )
                    : null,
                  oe.map((he, D) => {
                    const X = J ? ue * Fn + D : D;
                    return A.jsx(
                      'button',
                      {
                        ref: q => {
                          K.current[X] = q;
                        },
                        type: 'button',
                        role: 'tab',
                        'aria-selected': X === y,
                        className: `${ft.tab} ${X === y ? ft.tabActive : ''}`,
                        onClick: () => {
                          (w(X), I());
                        },
                        children: he,
                      },
                      he
                    );
                  }),
                ],
              },
              ue
            );
        return A.jsxs('section', {
          className: `${ft.section} ${f ?? ''}`,
          children: [
            A.jsxs('div', {
              className: ft.head,
              children: [
                A.jsx(Ee, { as: 'h2', className: ft.title, html: b(a) }),
                l ? A.jsx(Ee, { className: ft.body, html: b(l) }) : null,
              ],
            }),
            A.jsx('div', {
              ref: Q,
              className: `${ft.panel} ${h ?? ''}`,
              children: u.map((oe, ue) =>
                A.jsx(
                  'div',
                  {
                    className: `${ft.media} ${ue === y ? ft.mediaActive : ''}`,
                    'aria-hidden': ue !== y,
                    children: A.jsx(dt, {
                      className: ft.mediaImg,
                      imageKey: oe,
                      variant: s,
                      pcAspectRatio: '1220/646',
                      mobileAspectRatio: '630/420',
                    }),
                  },
                  oe
                )
              ),
            }),
            J
              ? A.jsx('div', {
                  className: ft.tabRows,
                  children: Z.map((oe, ue) => ie(oe, ue)),
                })
              : ie(Z[0], 0),
          ],
        });
      }
      const B1 = 'panel_wGPJX',
        H1 = { panel: B1 },
        U1 = [
          'section6Slide1',
          'section6Slide2',
          'section6Slide3',
          'section6Slide4',
          'section6Slide5',
          'section6Slide6',
          'section6Slide7',
          'section6Slide8',
        ];
      function G1({ variant: s = 'pc' }) {
        return A.jsx(Up, {
          variant: s,
          titleKey: 'section6.title',
          bodyKey: 'section6.body',
          tabsKey: 'section6.tabs',
          imageKeys: U1,
          panelClassName: H1.panel,
          tabsWrapMb: !0,
        });
      }
      const V1 = 'section_D7kVr',
        Y1 = 'mbSection_V5xkn',
        q1 = 'content_IXw89',
        $1 = 'title_ulq-a',
        K1 = 'body_SUrUf',
        k1 = 'media_TSuXz',
        X1 = 'video_WKJx6',
        nn = {
          section: V1,
          mbSection: Y1,
          content: q1,
          title: $1,
          body: K1,
          media: k1,
          video: X1,
        };
      function Q1({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsxs('section', {
          className: `${nn.section} ${l ? nn.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: nn.content,
              children: [
                A.jsx(Ee, {
                  as: 'h2',
                  className: nn.title,
                  html: a('section7.title'),
                }),
                A.jsx(Ee, { className: nn.body, html: a('section7.body') }),
              ],
            }),
            A.jsx('div', {
              className: nn.media,
              children: A.jsx(dt, {
                className: nn.video,
                imageKey: 'section7Bg',
                variant: s,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      const Z1 = 'section_DCHlx',
        J1 = 'head_ds8Ne',
        F1 = 'title_WbQ6j',
        I1 = 'body_0DJf7',
        P1 = 'panel_5h-wW',
        W1 = 'panelMedia_b3rk6',
        In = {
          section: Z1,
          head: J1,
          title: F1,
          body: I1,
          panel: P1,
          panelMedia: W1,
        };
      function _u({
        variant: s = 'pc',
        imageKey: a,
        titleKey: l,
        bodyKey: r,
        pcWidth: u = 1228,
        pcHeight: f = 750,
        mbWidth: h = 630,
        mbHeight: g = 420,
        className: d,
        bgColor: p,
        mediaKind: b = 'image',
      }) {
        const { t: y } = Ke(),
          w = s === 'mb';
        return A.jsxs('section', {
          className: `${In.section} ${d ?? ''}`,
          style: p ? { background: p } : void 0,
          children: [
            A.jsxs('div', {
              className: In.head,
              children: [
                A.jsx(Ee, { as: 'h2', className: In.title, html: y(l) }),
                r && A.jsx(Ee, { className: In.body, html: y(r) }),
              ],
            }),
            A.jsx('div', {
              className: In.panel,
              style: {
                width: w
                  ? `calc(${h} / 750 * 100vw)`
                  : `calc(${u} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
                height: w
                  ? `calc(${g} / 750 * 100vw)`
                  : `calc(${f} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
              },
              children: A.jsx(dt, {
                className: In.panelMedia,
                imageKey: a,
                variant: s,
                kind: b,
                pcAspectRatio: `${u}/${f}`,
                mobileAspectRatio: `${h}/${g}`,
              }),
            }),
          ],
        });
      }
      function eS({ variant: s = 'pc' }) {
        return A.jsx(_u, {
          variant: s,
          imageKey: 'section8Media',
          titleKey: 'section8.title',
          bodyKey: 'section8.body',
          mediaKind: 'video',
        });
      }
      const tS = 'section_QX-tI',
        iS = 'bg_6sljV',
        nS = 'mask_8zETh',
        aS = 'content_TgUCo',
        lS = 'title_6aqkf',
        sS = 'body_lCEFK',
        rS = 'light_FmOFp',
        an = {
          section: tS,
          bg: iS,
          mask: nS,
          content: aS,
          title: lS,
          body: sS,
          light: rS,
        };
      function Ns({
        variant: s = 'pc',
        imageKey: a,
        titleKey: l,
        bodyKey: r,
        maskOpacity: u = 0,
        pcHeight: f = 1200,
        mbHeight: h = 1e3,
        className: g,
        bgColor: d,
        mediaKind: p = 'image',
        lightCopy: b = !1,
      }) {
        const { t: y } = Ke(),
          w = s === 'mb';
        return A.jsxs('section', {
          className: `${an.section} ${b ? an.light : ''} ${g ?? ''}`,
          style: {
            height: w
              ? `calc(${h} / 750 * 100vw)`
              : `calc(${f} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
            ...(d ? { background: d } : {}),
          },
          children: [
            A.jsx(dt, {
              className: an.bg,
              imageKey: a,
              variant: s,
              kind: p,
              pcAspectRatio: `2560/${f}`,
              mobileAspectRatio: `750/${h}`,
            }),
            u > 0 &&
              A.jsx('div', {
                className: an.mask,
                style: { background: `rgba(0, 0, 0, ${u})` },
              }),
            A.jsxs('div', {
              className: an.content,
              children: [
                A.jsx(Ee, { as: 'h2', className: an.title, html: y(l) }),
                r && A.jsx(Ee, { className: an.body, html: y(r) }),
              ],
            }),
          ],
        });
      }
      function oS({ variant: s = 'pc' }) {
        return A.jsx(Ns, {
          variant: s,
          imageKey: 'section9Bg',
          titleKey: 'section9.title',
          bodyKey: 'section9.body',
          gradientMask: !0,
          lightCopy: !0,
        });
      }
      function uS({ variant: s = 'pc' }) {
        return A.jsx(_u, {
          variant: s,
          imageKey: 'section10Media',
          titleKey: 'section10.title',
          bodyKey: 'section10.body',
          mediaKind: 'video',
        });
      }
      function cS({ variant: s = 'pc' }) {
        return A.jsx(_u, {
          variant: s,
          imageKey: 'section11Bg',
          titleKey: 'section11.title',
          bodyKey: 'section11.body',
          mediaKind: 'video',
        });
      }
      const fS = 'section_GTJnS',
        dS = 'mbSection_E-QAf',
        hS = 'content_cDVrX',
        pS = 'title_azg0v',
        mS = 'body_6rbrY',
        gS = 'media_qXyIB',
        vS = 'video_DnRNz',
        ln = {
          section: fS,
          mbSection: dS,
          content: hS,
          title: pS,
          body: mS,
          media: gS,
          video: vS,
        };
      function yS({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsxs('section', {
          className: `${ln.section} ${l ? ln.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: ln.content,
              children: [
                A.jsx(Ee, {
                  as: 'h2',
                  className: ln.title,
                  html: a('section12.title'),
                }),
                A.jsx(Ee, { className: ln.body, html: a('section12.body') }),
              ],
            }),
            A.jsx('div', {
              className: ln.media,
              children: A.jsx(dt, {
                className: ln.video,
                imageKey: 'section12Bg',
                variant: s,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      function bS({ variant: s = 'pc' }) {
        return A.jsx(Ns, {
          variant: s,
          imageKey: 'section13Bg',
          titleKey: 'section13.title',
          bodyKey: 'section13.body',
          gradientMask: !0,
        });
      }
      const SS = 'section_DdtLp',
        xS = 'mbSection_RZ--H',
        TS = 'row_OLfGL',
        ES = 'rowReversed_c4YEn',
        wS = 'media_KQfKa',
        AS = 'mediaImg_fstJA',
        MS = 'copy_I1A8Z',
        OS = 'title_8cm-5',
        _S = 'body_TWAwe',
        at = {
          section: SS,
          mbSection: xS,
          row: TS,
          rowReversed: ES,
          media: wS,
          mediaImg: AS,
          copy: MS,
          title: OS,
          body: _S,
        };
      function zS({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb';
        return A.jsxs('section', {
          className: `${at.section} ${l ? at.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: at.row,
              children: [
                A.jsx('div', {
                  className: at.media,
                  children: A.jsx(dt, {
                    className: at.mediaImg,
                    imageKey: 'section14Library',
                  }),
                }),
                A.jsxs('div', {
                  className: at.copy,
                  children: [
                    A.jsx(Ee, {
                      as: 'h3',
                      className: at.title,
                      html: a('section14.libraryTitle'),
                    }),
                    A.jsx(Ee, {
                      className: at.body,
                      html: a('section14.libraryBody'),
                    }),
                  ],
                }),
              ],
            }),
            A.jsxs('div', {
              className: `${at.row} ${at.rowReversed}`,
              children: [
                A.jsx('div', {
                  className: at.media,
                  children: A.jsx(dt, {
                    className: at.mediaImg,
                    imageKey: 'section14Wiki',
                  }),
                }),
                A.jsxs('div', {
                  className: at.copy,
                  children: [
                    A.jsx(Ee, {
                      as: 'h3',
                      className: at.title,
                      html: a('section14.wikiTitle'),
                    }),
                    A.jsx(Ee, {
                      className: at.body,
                      html: a('section14.wikiBody'),
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      function NS({ variant: s = 'pc' }) {
        return A.jsx(Ns, {
          variant: s,
          imageKey: 'section15Bg',
          titleKey: 'section15.title',
          bodyKey: 'section15.body',
        });
      }
      const CS = 'section_xs330',
        RS = { section: CS },
        DS = [
          'section16Slide1',
          'section16Slide2',
          'section16Slide3',
          'section16Slide4',
        ];
      function LS({ variant: s = 'pc' }) {
        return A.jsx(Ou, {
          variant: s,
          titleKey: 'section16.title',
          bodyKey: 'section16.body',
          imageKeys: DS,
          slidesTextKey: 'section16.slides',
          mediaKind: 'video',
          className: RS.section,
        });
      }
      const jS = 'section_426o7',
        BS = 'bg_d7qmI',
        HS = 'content_C-CDP',
        US = 'title_-ksA5',
        GS = 'icons_Ia6RW',
        VS = 'item_0brSh',
        YS = 'icon_--eVM',
        qS = 'label_hD0Ks',
        Li = {
          section: jS,
          bg: BS,
          content: HS,
          title: US,
          icons: GS,
          item: VS,
          icon: YS,
          label: qS,
        },
        $S = [
          'section17Icon1',
          'section17Icon2',
          'section17Icon3',
          'section17Icon4',
          'section17Icon5',
        ];
      function KS({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = a('section17.items', { returnObjects: !0 }) ?? [],
          r = Array.isArray(l) ? l : [];
        return A.jsxs('section', {
          className: Li.section,
          children: [
            A.jsx(dt, {
              className: Li.bg,
              imageKey: 'section17Bg',
              variant: s,
              pcAspectRatio: '2560/1200',
              mobileAspectRatio: '750/1000',
            }),
            A.jsxs('div', {
              className: Li.content,
              children: [
                A.jsx(Ee, {
                  as: 'h2',
                  className: Li.title,
                  html: a('section17.title'),
                }),
                A.jsx('div', {
                  className: Li.icons,
                  children: $S.map((u, f) =>
                    A.jsxs(
                      'div',
                      {
                        className: Li.item,
                        children: [
                          A.jsx(dt, {
                            className: Li.icon,
                            imageKey: u,
                            variant: s,
                          }),
                          r[f]
                            ? A.jsx(Ee, { className: Li.label, html: r[f] })
                            : null,
                        ],
                      },
                      u
                    )
                  ),
                }),
              ],
            }),
          ],
        });
      }
      const kS = 'section_2Kv08',
        XS = { section: kS },
        QS = [
          'section18Slide1',
          'section18Slide2',
          'section18Slide3',
          'section18Slide4',
          'section18Slide5',
          'section18Slide6',
        ];
      function ZS({ variant: s = 'pc' }) {
        return A.jsx(Ou, {
          variant: s,
          titleKey: 'section18.title',
          bodyKey: 'section18.body',
          imageKeys: QS,
          slidesTextKey: 'section18.slides',
          className: XS.section,
        });
      }
      const JS = 'section_wFcUk',
        FS = 'head_y9T1q',
        IS = 'title_Qixnz',
        PS = 'body_-5ssL',
        WS = 'slide_7On9J',
        e2 = 'poster_tVH9L',
        t2 = 'player_OJnm2',
        i2 = 'playerReady_hr0no',
        n2 = 'placeholder_4cpuj',
        ri = {
          section: JS,
          head: FS,
          title: IS,
          body: PS,
          slide: WS,
          poster: e2,
          player: t2,
          playerReady: i2,
          placeholder: n2,
        };
      function a2(s) {
        if (!s) return '';
        const a = s.trim();
        if (/^[\w-]{11}$/.test(a)) return a;
        try {
          const l = new URL(a);
          if (l.hostname.includes('youtu.be'))
            return l.pathname.replace(/^\//, '').slice(0, 11);
          const r = l.searchParams.get('v');
          if (r) return r;
          const u = l.pathname.match(/\/(?:embed|shorts)\/([\w-]{11})/);
          if (u?.[1]) return u[1];
        } catch {
          return '';
        }
        return '';
      }
      function l2({ id: s, active: a }) {
        const [l, r] = F.useState(!1);
        return (
          F.useEffect(() => {
            a || r(!1);
          }, [a]),
          s
            ? A.jsxs('div', {
                className: ri.slide,
                children: [
                  A.jsx('img', {
                    className: ri.poster,
                    src: `https://i.ytimg.com/vi/${s}/hqdefault.jpg`,
                    alt: '',
                  }),
                  a
                    ? A.jsx('iframe', {
                        className: `${ri.player} ${l ? ri.playerReady : ''} swiper-no-swiping`,
                        src: `https://www.youtube.com/embed/${s}?rel=0&modestbranding=1&playsinline=1`,
                        title: 'YouTube video',
                        referrerPolicy: 'strict-origin-when-cross-origin',
                        allow:
                          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                        allowFullScreen: !0,
                        onLoad: () => r(!0),
                      })
                    : null,
                ],
              })
            : A.jsx('div', { className: ri.placeholder, 'aria-hidden': 'true' })
        );
      }
      function s2({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          [l, r] = F.useState(0),
          u = a('section19.slides', { returnObjects: !0 }) ?? [],
          f = Array.isArray(u) ? u : [];
        return A.jsxs('section', {
          className: ri.section,
          children: [
            A.jsxs('div', {
              className: ri.head,
              children: [
                A.jsx(Ee, {
                  as: 'h2',
                  className: ri.title,
                  html: a('section19.title'),
                }),
                A.jsx(Ee, { className: ri.body, html: a('section19.body') }),
              ],
            }),
            A.jsx(Mu, {
              variant: s,
              autoplay: !0,
              onIndexChange: r,
              slides: f.map((h, g) => {
                const d = a2(h);
                return A.jsx(l2, { id: d, active: g === l }, `${d}-${g}`);
              }),
            }),
          ],
        });
      }
      const r2 = 'section_2zBwG',
        o2 = { section: r2 },
        u2 = [
          'section20Slide1',
          'section20Slide2',
          'section20Slide3',
          'section20Slide4',
        ];
      function c2({ variant: s = 'pc' }) {
        return A.jsx(Up, {
          variant: s,
          titleKey: 'section20.title',
          bodyKey: 'section20.body',
          tabsKey: 'section20.tabs',
          imageKeys: u2,
          className: o2.section,
        });
      }
      function f2({ variant: s = 'pc' }) {
        return A.jsx(Ns, {
          variant: s,
          imageKey: 'section21Bg',
          titleKey: 'section21.title',
          bodyKey: 'section21.body',
        });
      }
      const d2 = 'section_gxL3a',
        h2 = 'mbSection_eTCnu',
        p2 = 'title_NCixj',
        m2 = 'subtitle_-QPHd',
        g2 = 'product_LdQs4',
        v2 = 'productImg_dZ1V0',
        y2 = 'features_QwtZC',
        b2 = 'feature_EOpS3',
        S2 = 'cta_8w-xV',
        li = {
          section: d2,
          mbSection: h2,
          title: p2,
          subtitle: m2,
          product: g2,
          productImg: v2,
          features: y2,
          feature: b2,
          cta: S2,
        };
      function x2({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb',
          r = a('section22.features', { returnObjects: !0 }) ?? [];
        return A.jsxs('section', {
          className: `${li.section} ${l ? li.mbSection : ''}`,
          children: [
            A.jsx(Ee, {
              as: 'h2',
              className: li.title,
              html: a('section22.title'),
            }),
            A.jsx(Ee, {
              className: li.subtitle,
              html: a('section22.subtitle'),
            }),
            A.jsx('div', {
              className: li.product,
              children: A.jsx(dt, {
                className: li.productImg,
                imageKey: 'section22Product',
              }),
            }),
            A.jsx('div', {
              className: li.features,
              children: r.map(u =>
                A.jsx('span', { className: li.feature, children: u }, u)
              ),
            }),
            A.jsx('a', {
              className: li.cta,
              href: a('section22.shopLink'),
              target: '_blank',
              children: a('section22.shopNow'),
            }),
          ],
        });
      }
      const T2 = 'section_gVwpW',
        E2 = 'mbSection_oTIuA',
        w2 = 'list_dhm4u',
        A2 = 'item_L4fH8',
        xs = { section: T2, mbSection: E2, list: w2, item: A2 };
      function M2({ variant: s = 'pc' }) {
        const { t: a } = Ke(),
          l = s === 'mb',
          r = a('section23.body', { returnObjects: !0 }) ?? [];
        return A.jsx('section', {
          className: `${xs.section} ${l ? xs.mbSection : ''}`,
          children: A.jsx('div', {
            className: xs.list,
            children: r.map(u =>
              A.jsx('p', { className: xs.item, children: u }, u.slice(0, 12))
            ),
          }),
        });
      }
      const O2 = [
        By,
        Vy,
        rb,
        mb,
        S1,
        G1,
        Q1,
        eS,
        oS,
        uS,
        cS,
        yS,
        bS,
        zS,
        NS,
        LS,
        KS,
        ZS,
        s2,
        c2,
        f2,
        x2,
        M2,
      ];
      function _2({ variant: s = 'pc' }) {
        return A.jsxs('div', {
          className: ny.stack,
          children: [
            A.jsx(dy, { variant: s }),
            O2.map((a, l) => A.jsx(a, { variant: s }, l)),
          ],
        });
      }
      const zu = '(max-width: 768px)';
      function z2() {
        const [s, a] = F.useState(null);
        return (
          F.useLayoutEffect(() => {
            const l = window.matchMedia(zu),
              r = () => a(l.matches ? 'mb' : 'pc');
            return (
              r(),
              l.addEventListener('change', r),
              () => l.removeEventListener('change', r)
            );
          }, []),
          s
        );
      }
      const N2 = `not all and ${zu}`;
      function C2() {
        const { i18n: s } = Ke(),
          { t: a } = Ke('imageUrl'),
          r = z2() ?? 'pc',
          { pcSrc: u, mobileSrc: f } = Sp(a, 'heroKV'),
          h = F.useRef(null);
        return (
          F.useLayoutEffect(() => {
            const g = h.current;
            if (!g) return;
            const d = () => {
              g.style.setProperty('--t1-pc-vw', `${g.clientWidth / 100}px`);
            };
            d();
            const p = new ResizeObserver(d);
            return (
              p.observe(g),
              window.addEventListener('resize', d),
              () => {
                (p.disconnect(), window.removeEventListener('resize', d));
              }
            );
          }, []),
          A.jsxs('div', {
            ref: h,
            className: `t1-page ${ty.page}`,
            'data-lang': s.language,
            children: [
              u
                ? A.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: u,
                    media: N2,
                    fetchPriority: 'high',
                  })
                : null,
              f
                ? A.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: f,
                    media: zu,
                    fetchPriority: 'high',
                  })
                : null,
              A.jsx(_2, { variant: r }),
            ],
          })
        );
      }
      const R2 = {
          title: 'Creality Falcon A1C',
          description: 'The Perfect First Laser Engraver for Your Home',
          stickyNav: {
            title: 'Creality Falcon A1C',
            shopNow: 'Buy Now',
            shopLink:
              'https://www.crealityfalcon.com/products/creality-falcon-a1c-laser-engraver-with-ai-camera?utm_source=official-website&utm_medium=product_page',
          },
          section1: {
            title: 'Creality Falcon A1C',
            subtitle: 'The Perfect First Laser Engraver for Your Home',
            shopNow: 'Buy now',
            shopLink:
              'https://www.crealityfalcon.com/products/creality-falcon-a1c-laser-engraver-with-ai-camera?utm_source=official-website&utm_medium=product_page',
          },
          section2: {
            body: 'Falcon A1C brings three interchangeable laser modules, support for 300+ materials, True Auto Focus, and smart lifting into one compact machine. Intuitive PC and app control streamlines setup, so first-time users can start with confidence. With Class 1 safety and a compact form, laser creating fits naturally into the home—from everyday DIY to dimensional projects.',
          },
          section3: {
            lasers: {
              title: '3 Laser Modules in One<sup class="fn">[1]</sup>',
              desc: '5W - 10W - 1.2W IR',
            },
            toolFree: { title: 'Tool-Free Swap', desc: 'Switch with ease' },
            materials: {
              title: '300+ Materials<sup class="fn">[6]</sup>',
              desc: 'More surfaces to create on',
            },
            chooseLaser: {
              title: 'Choose Your Laser',
              desc: 'Fine Details in Wood & Metal',
            },
            hdCamera: {
              title: 'HD Camera<sup class="fn">[4]</sup>',
              desc: 'Intuitive Design Placement',
            },
            autoFocus: {
              title: 'True Auto Focus',
              desc: 'No manual adjustment',
            },
            class1: {
              title: 'Class 1 Safety<sup class="fn">[3]</sup>',
              desc: 'Added peace of mind at home',
            },
            portable: {
              title: 'Compact & Portable',
              desc: 'Create Wherever You Go',
            },
            ai: {
              title: 'AI-Assisted Creation',
              desc: 'Bring Ideas to Life Faster',
            },
          },
          section4: { title: 'Swap Lasers. Create Without Limits.', body: '' },
          section5: {
            title: 'Switch Modules. Switch Possibilities',
            body: 'Move between 5W, 10W and 1.2W IR without tools',
            slides: [
              {
                name: '5W Diode | Fine Detail for Everyday Ideas',
                body: 'Crisp detail for everyday DIY',
              },
              {
                name: '10W Diode｜Fast Engraving, Light Cutting',
                body: 'A flexible balance of engraving speed and light cutting',
              },
              {
                name: '1.2W IR｜Fine Metal Engraving—and More',
                body: 'Engrave metal, acrylic, and plastic with fine detail',
              },
            ],
          },
          section6: {
            title: 'Precise Engraving on Various Materials',
            body: 'One machine, endless possibilities',
            tabs: [
              'Wood',
              'Leather',
              'Coated Metal',
              'Acrylic',
              'Slate',
              'Paper',
              'Fabric',
              'Glass',
            ],
          },
          section7: {
            title: 'Focused Light. Finer Detail',
            body: 'Precisely focused light brings lines and textures into clear view',
          },
          section8: {
            title:
              '<em class="blue">15,000 mm/min</em><sup class="fn">[5]</sup>. Speed Meets Detail',
            body: 'Engrave faster while retaining clean, refined detail',
          },
          section9: {
            title: 'See Clearly. Place Precisely',
            body: 'HD camera makes framing and positioning more intuitive',
          },
          section10: {
            title: 'True Auto Focus. Place and Focus',
            body: 'No manual focusing. Less setup before you create',
            labelT1: 'Falcon T1',
            labelOther: 'Other',
          },
          section11: {
            title: 'Smart Lifting for Different Heights',
            body: 'From flat sheets to dimensional pieces',
          },
          section12: {
            title:
              '<em class="blue">5.91 x 5.91 x 5.83 in</em><sup class="fn">[2]</sup> Creative Space',
            body: 'Compact outside, with room for more ways to create.<br />Flat｜Dimensional｜Rotary Expansion',
          },
          section13: {
            title: 'Easy to Move. Easy to Place',
            body: 'Compact enough to settle into different spaces with ease',
          },
          section14: {
            libraryTitle: 'Compact on Your Desktop',
            libraryBody:
              'Made for everyday creativityFits neatly beside your laptop, with room left for everyday essentials',
            wikiTitle: 'Create Beyond Home',
            wikiBody:
              'Move beyond home and keep creating wherever inspiration takes you',
          },
          section15: {
            title: 'Expand Your Setup. Create More',
            body: 'Rotary Kit, Flexible Fixture, Air Purifier, and Blade Bed expand A1C for more shapes, projects, and creative possibilities.',
          },
          section16: {
            title: 'One Machine, Endless Accessories',
            body: "From cylindrical tumblers to irregular shapes, there's an accessory for every project.",
            slides: [
              {
                name: 'Rotary Kit<sup class="fn">[7]</sup>',
                body: 'Create on Curved Surfaces',
              },
              {
                name: 'Flexible Fixture<sup class="fn">[7]</sup>',
                body: 'Secure Irregular Objects',
              },
              {
                name: 'Air Purifier<sup class="fn">[7]</sup>',
                body: 'Cleaner Air While Creating',
              },
              {
                name: 'Blade Bed<sup class="fn">[7]</sup>',
                body: 'Stable Material Support',
              },
            ],
          },
          section17: {
            title:
              'Class 1 Safety<sup class="fn">[3]</sup>, Layered Protection',
            items: [
              'Class 1',
              'Flame Detection',
              'Lid Detection',
              'Tilt Detection',
              'USB Safety Lock',
            ],
          },
          section18: {
            title: 'Everyday Moments. Made Personal',
            body: 'Home ｜ Gifts ｜ Holidays ｜ Events ｜ Apparel ｜ Pets',
            slides: [
              {
                name: 'Home Creators',
                body: 'DIY enthusiasts who personalize everyday items and bring creative ideas to life at home.',
              },
              {
                name: 'Gift Makers',
                body: 'Creative gift-givers who make personalized, meaningful gifts for every occasion.',
              },
              {
                name: 'PERSONALIZED DIY',
                body: 'Create one-of-a-kind pieces with your own hands.',
              },
              {
                name: 'EDUCATION & COMPANIONSHIP',
                body: 'Turn playtime into hands-on learning moments together.',
              },
              {
                name: 'SMALL BUSINESS',
                body: 'Turn custom orders into your next income stream.',
              },
              {
                name: 'Pet Lovers',
                body: 'Pet owners who create custom keepsakes and personalized accessories for their beloved pets.',
              },
            ],
          },
          section19: {
            title: 'See A1C Through the Eyes of Creators',
            body: 'From unboxing to finished projects, see how creators experience A1C',
            slides: [
              'https://www.youtube.com/watch?v=Z1ETFRwPzbA',
              'https://www.youtube.com/watch?v=u0mBpyJR3Fs',
              'https://www.youtube.com/watch?v=LyrXpwD-tfo',
              'https://www.youtube.com/watch?v=mBU3jakSCBk',
            ],
          },
          section20: {
            title:
              'AI Assistance<sup class="fn">[8]</sup>. Ideas Take Shape Faster',
            body: 'From image to finished piece, every step feels simpler',
            tabs: [
              'AI Contour Extraction',
              'AI Background Removal',
              'AI One-Tap Engraving',
              'AI Smart Fill & Layout',
            ],
          },
          section21: {
            title: "Questions? We're Here to Help You Create.",
            body: 'From getting started to troubleshooting, official guidance is always within reach.<br />Tutorials | Guides | Troubleshooting',
          },
          section22: {
            title: 'Creality Falcon A1C',
            subtitle: 'Bring Creativity into Everyday Life',
            features: [
              '3 Laser Modules in One',
              ' AI-Assisted Creation',
              'Compact by Design',
              '300+ Materials',
              'True Auto Focus',
              'Class 1 Safety',
            ],
            shopNow: 'Buy now',
            shopLink:
              'https://www.crealityfalcon.com/products/creality-falcon-a1c-laser-engraver-with-ai-camera?utm_source=official-website&utm_medium=product_page',
          },
          section23: {
            body: [
              '1. This page describes the 10W diode and 1.2W IR modules. Actual configurations, package contents, and regional availability may vary.',
              '2. The workspace measures 150 × 150 × 148 mm (5.91 × 5.91 × 5.83 in). Verify against the final specifications and applicable processing mode before publication.',
              '3. Class 1 applies only under the conditions stated in the final certification and user manual. Open-cover or other specific operating modes may have different safety classifications. Follow all safety instructions and use appropriate safeguards.',
              '4. Camera-based positioning and related features are available only on the grey version equipped with a camera. The white version does not include a camera. Features may vary by product and software version.',
              '5. 15,000 mm/min is the stated maximum speed. Actual speed varies with material, design complexity, laser module, processing mode, and settings. Confirm the test conditions with the product team before publication.',
              '6. "300+ popular materials" refers to material categories, not a guarantee that every composition, color, thickness, or finish is compatible. Results vary by material properties and settings; test before processing.',
              '7. Rotary Kit, Flexible Fixture, Air Purifier, Blade Bed, and other accessories are included only when specified in the selected bundle; some may be sold separately.',
              '8. AI feature availability may vary by software/app version, device configuration, region, and network conditions. Some features may require an account sign-in or internet connection.',
              '9. Asset counts, free availability, and access may change as the platform is updated. Project visuals are for illustration; actual processing results vary by material and settings.',
            ],
          },
        },
        D2 = {
          title: 'Creality Falcon A1C',
          description: 'Der perfekte erste Lasergravierer für dein Zuhause',
          stickyNav: {
            title: 'Creality Falcon A1C',
            shopNow: 'Jetzt kaufen',
            shopLink:
              'https://de.crealityfalcon.com/products/creality-falcon-a1c-lasergravierer-mit-ki-kamera',
          },
          section1: {
            title: 'Creality Falcon A1C',
            subtitle: 'Der perfekte erste Lasergravierer für dein Zuhause',
            shopNow: 'Jetzt kaufen',
            shopLink:
              'https://de.crealityfalcon.com/products/creality-falcon-a1c-lasergravierer-mit-ki-kamera',
          },
          section2: {
            body: 'Falcon A1C vereint drei austauschbare Lasermodule, Unterstützung für über 300 Materialien, echte Autofokussierung und eine intelligente Hubfunktion in einem kompakten Gerät. Die intuitive Steuerung über PC und App vereinfacht die Einrichtung, sodass auch Einsteiger mit einem guten Gefühl loslegen können. Dank der Sicherheitsklasse 1 und der kompakten Form fügt sich das laserbasierte Gestalten ganz natürlich in das Zuhause ein – vom täglichen Heimwerken bis hin zu dreidimensionalen Projekten.',
          },
          section3: {
            lasers: {
              title: '3 Lasermodule in einem<sup class="fn">[1]</sup>',
              desc: '5 W · 10 W · 1,2-W-IR',
            },
            toolFree: {
              title: 'Werkzeugloser Wechsel',
              desc: 'Einfaches Umschalten',
            },
            materials: {
              title: 'Über 300 Materialien<sup class="fn">[6]</sup>',
              desc: 'Mehr Oberflächen zum Gestalten',
            },
            chooseLaser: {
              title: 'Wähle deinen Laser',
              desc: 'Feine Details in Holz und Metall',
            },
            hdCamera: {
              title: 'HD-Kamera<sup class="fn">[4]</sup>',
              desc: 'Intuitive Platzierung von Designs',
            },
            autoFocus: {
              title: 'Echte Autofokussierung',
              desc: 'Keine manuelle Einstellung',
            },
            class1: {
              title: 'Sicherheitsklasse 1<sup class="fn">[3]</sup>',
              desc: 'Mehr Sorgenfreiheit zu Hause',
            },
            portable: {
              title: 'Kompakt und tragbar',
              desc: 'Gestalten, wohin du auch gingst',
            },
            ai: {
              title: 'KI-gestütztes Gestalten',
              desc: 'Ideen schneller zum Leben erwecken',
            },
          },
          section4: {
            title: 'Laser wechseln. Gestalten ohne Grenzen.',
            body: '',
          },
          section5: {
            title: 'Module wechseln. Neue Möglichkeiten entdecken.',
            body: 'Wechsele ohne Werkzeug zwischen 5 W, 10 W und 1,2-W-IR',
            slides: [
              {
                name: '5-W-Diode｜Feine Details für alltägliche Ideen',
                body: 'Scharfe Details für alltägliche DIY-Arbeiten',
              },
              {
                name: '10-W-Diode｜Schnelles Gravieren, leichtes Schneiden',
                body: 'Eine flexible Balance zwischen Gravurgeschwindigkeit und leichtem Schneiden',
              },
              {
                name: '1,2-W-IR-Laser｜Feine Metallgravur – und mehr',
                body: 'Graviere Metall, Acryl und Kunststoff mit feinen Details',
              },
            ],
          },
          section6: {
            title: 'Präzises Gravieren auf verschiedenen Materialien',
            body: 'Ein Gerät, endlose Möglichkeiten',
            tabs: [
              'Holz',
              'Leder',
              'Beschichtetes Metall',
              'Acryl',
              'Schiefer',
              'Papier',
              'Stoff',
              'Glas',
            ],
          },
          section7: {
            title: 'Fokussiertes Licht. Feinere Details',
            body: 'Präzise fokussiertes Licht bringt Linien und Strukturen klar zum Vorschein',
          },
          section8: {
            title:
              '<em class="blue">15.000 mm/min</em><sup class="fn">[5]</sup>. Geschwindigkeit trifft auf Detailgenauigkeit',
            body: 'Schneller gravieren und dabei saubere, feine Details bewahren',
          },
          section9: {
            title: 'Klar erkennen. Präzise platzieren',
            body: 'Die HD-Kamera macht den Bildausschnitt und die Positionierung intuitiver',
          },
          section10: {
            title: 'Echte Autofokussierung. Platzieren und fokussieren',
            body: 'Keine manuelle Fokussierung. Weniger Einrichtungsaufwand vor dem Gestalten',
            labelT1: 'Falcon T1',
            labelOther: 'Other',
          },
          section11: {
            title: 'Intelligente Hubfunktion für verschiedene Höhen',
            body: 'Von flachen Platten bis hin zu dreidimensionalen Werkstücken.',
          },
          section12: {
            title:
              '<em class="blue">5.91 x 5.91 x 5.83 in</em><sup class="fn">[2]</sup> großer Arbeitsbereich für Kreativität',
            body: 'Außen kompakt, mit Platz für vielfältige Gestaltungsmöglichkeiten.<br />Flach｜Dreidimensional｜Rotationsgravur',
          },
          section13: {
            title: 'Leicht zu transportieren. Leicht zu platzieren',
            body: 'Kompakt genug, um sich mühelos in verschiedene Räume einzufügen',
          },
          section14: {
            libraryTitle: 'Kompakt auf Ihrem Schreibtisch',
            libraryBody:
              'Für kreative Ideen im Alltag, passt perfekt neben Ihren Laptop und lässt noch Platz für deine Alltagsgegenstände',
            wikiTitle: 'Auch außerhalb der eigenen vier Wände kreativ sein',
            wikiBody:
              'Entfessele deine Kreativität überallhin mit und gestalten Sie weiter, wo immer die Inspiration Sie hinführt',
          },
          section15: {
            title: 'Erweitere deine Ausstattung. Gestalte mehr',
            body: 'Rotationskit, flexible Spannvorrichtung, Luftreiniger und Lamellenbett erweitern das A1C für mehr Formen, Projekte und kreative Möglichkeiten.',
          },
          section16: {
            title: 'Eine Maschine, unendlich viele Zubehörteile',
            body: 'Von zylindrischen Tumblern bis hin zu unregelmäßigen Formen – für jedes Projekt gibt es das passende Zubehör.',
            slides: [
              {
                name: 'Rotationskit<sup class="fn">[7]</sup>',
                body: 'Gestalte auf gekrümmten Oberflächen',
              },
              {
                name: 'Flexible Spannvorrichtung<sup class="fn">[7]</sup>',
                body: 'Unregelmäßig geformte Objekte sicher fixieren',
              },
              {
                name: 'Luftreiniger<sup class="fn">[7]</sup>',
                body: 'Sauberere Luft beim Gestalten',
              },
              {
                name: 'Lamellenbett<sup class="fn">[7]</sup>',
                body: 'Stabile Auflage für das Material',
              },
            ],
          },
          section17: {
            title:
              'Sicherheitsklasse 1<sup class="fn">[3]</sup>, mehrschichtiger Schutz',
            items: [
              'Sicherheitsklasse 1 ',
              'Flammenerkennung',
              'Deckelerkennung',
              'Kipperkennung',
              'USB-Sicherheitssperre',
            ],
          },
          section18: {
            title: 'Alltägliche Momente. Individuell gestaltet',
            body: 'Zuhause ｜ Geschenke ｜ Feiertage ｜ Veranstaltungen ｜ Bekleidung ｜ Haustiere',
            slides: [
              {
                name: 'Kreative für zu Hause',
                body: 'DIY-Begeisterte, die Alltagsgegenstände individuell gestalten und kreative Ideen zu Hause zum Leben erwecken.',
              },
              {
                name: 'Kreative Geschenkideen',
                body: 'Kreative, die zu jedem Anlass persönliche und bedeutungsvolle Geschenke gestalten.',
              },
              {
                name: 'INDIVIDUELLE DIY-PROJEKTE',
                body: 'Gestalte einzigartige Stücke mit Ihren eigenen Händen.',
              },
              {
                name: 'LERNEN UND GEMEINSAME ZEIT',
                body: 'Verwandele die Spielzeit gemeinsam in praktische Lernerlebnisse.',
              },
              {
                name: 'KLEINUNTERNEHMEN',
                body: 'Mache Sonderanfertigungen zu Ihrer nächsten Einnahmequelle.',
              },
              {
                name: 'Tierfreunde',
                body: 'Tierhalter, die individuelle Andenken und personalisiertes Zubehör für ihre geliebten Haustiere gestalten.',
              },
            ],
          },
          section19: {
            title: 'Erlebe A1C aus der Perspektive der Kreativen',
            body: 'Vom Auspacken bis zum fertigen Projekt – sehen Sie, wie Kreative A1C erleben',
            slides: [
              'https://www.youtube.com/watch?v=Z1ETFRwPzbA',
              'https://www.youtube.com/watch?v=u0mBpyJR3Fs',
              'https://www.youtube.com/watch?v=LyrXpwD-tfo',
              'https://www.youtube.com/watch?v=mBU3jakSCBk',
            ],
          },
          section20: {
            title:
              'KI-Unterstützung<sup class="fn">[8]</sup>.  Ideen nehmen schneller Gestalt an',
            body: 'Vom Bild bis zum fertigen Werk – jeder Schritt fühlt sich einfacher an',
            tabs: [
              'KI-Konturerkennung',
              'KI-Hintergrundentfernung',
              'KI-Gravur mit einem Fingertipp',
              'Intelligentes KI-Füllen und Layout',
            ],
          },
          section21: {
            title: 'Fragen? Wir sind hier, um dir beim Gestalten zu helfen.',
            body: 'Von den ersten Schritten bis zur Fehlerbehebung – offizielle Anleitungen sind immer griffbereit.<br />Tutorials ｜ Anleitungen ｜ Fehlerbehebung',
          },
          section22: {
            title: 'Creality Falcon A1C',
            subtitle: 'Bringe Kreativität in den Alltag',
            features: [
              '3 Laser in einem Gerät',
              'KI-gestütztes Gestalten',
              'Kompaktes Design',
              'Über 300 Materialien',
              'Echte Autofokussierung',
              'Sicherheitsklasse 1',
            ],
            shopNow: 'Jetzt kaufen',
            shopLink:
              'https://de.crealityfalcon.com/products/creality-falcon-a1c-lasergravierer-mit-ki-kamera',
          },
          section23: {
            body: [
              '1. Auf dieser Seite werden die 10-W-Dioden- und 1,2-W-IR-Module beschrieben. Die tatsächliche Ausstattung, der Lieferumfang und die Verfügbarkeit in deiner Region können abweichen.',
              '2. Der Arbeitsbereich beträgt 150 × 150 × 148 mm (5,91 × 5,91 × 5,83 Zoll). Prüfe vor der Veröffentlichung die endgültigen Spezifikationen und den passenden Bearbeitungsmodus.',
              '3. Die Laserklasse 1 gilt nur unter den Bedingungen aus der endgültigen Zertifizierung und dem Benutzerhandbuch. Wenn du das Gerät mit geöffneter Abdeckung oder in anderen speziellen Modi betreibst, kann eine andere Sicherheitsklasse gelten. Halte dich an alle Sicherheitshinweise und treffe geeignete Schutzmaßnahmen.',
              '4. Die kamerabasierte Positionierung und die dazugehörigen Funktionen gibt es nur bei der grauen Version mit Kamera. Die weiße Version hat keine Kamera. Die verfügbaren Funktionen können je nach Produkt und Softwareversion unterschiedlich sein.',
              '5. 15.000 mm/min ist die angegebene Höchstgeschwindigkeit. Die tatsächliche Geschwindigkeit hängt von Material, Motivkomplexität, Lasermodul, Bearbeitungsmodus und deinen Einstellungen ab. Kläre die Testbedingungen vor der Veröffentlichung mit dem Produktteam.',
              '6. „Über 300 gängige Materialien“ bezieht sich auf Materialgruppen. Es ist nicht garantiert, dass jede Zusammensetzung, Farbe, Dicke oder Oberfläche kompatibel ist. Das Ergebnis hängt von den Materialeigenschaften und deinen Einstellungen ab – mach vor der Bearbeitung immer einen Test.',
              '7. Rotationskit, flexible Spannvorrichtung, Luftreiniger, Lamellenbett und weiteres Zubehör sind nur im Lieferumfang enthalten, wenn das von dir gewählte Paket dies angibt. Einige Artikel musst du separat kaufen.',
              '8. Ob die KI-Funktionen nutzbar sind, hängt von der Software-/App-Version, Geräteausstattung, Region und Netzwerkverbindung ab. Für manche Funktionen musst du dich anmelden und eine Internetverbindung haben.',
              '9. Die Anzahl der Inhalte, kostenlose Nutzungsmöglichkeiten und der Zugriff können sich bei Plattform-Updates ändern. Die Projektbilder dienen nur zur Veranschaulichung. Das tatsächliche Bearbeitungsergebnis hängt von Material und deinen Einstellungen ab.',
            ],
          },
        },
        fp = {
          heroKV:
            'https://compress-file.creality.com/images/Agent/e94e7da5-6d4f-4a5d-a322-1dde03b90840.png',
          heroKVM:
            'https://compress-file.creality.com/images/Agent/c61f0c0a-ca0b-4faf-a280-aa5030d99c38.png',
          hlModule:
            'https://compress-file.creality.com/videos/Agent/cfa04fe8-1671-4578-afd5-f185936b4780.mp4',
          hlModuleM: '',
          hlPrecision:
            'https://cdn.creality.com/ow/a1c/4774b106-6617-4053-98be-1ba6b3650620.mp4',
          hlPrecisionM:
            'https://cdn.creality.com/ow/a1c/4774b106-6617-4053-98be-1ba6b3650620.mp4',
          hlGalvo:
            'https://compress-file.creality.com/images/Agent/b7330fd3-9495-433a-b7b9-cb41b27b7dae.png',
          hlGalvoM:
            'https://cdn.creality.com/ow/a1c/e085c784-be13-4888-884f-c9722c458d7c.png',
          hlDetail:
            'https://cdn.creality.com/ow/a1c/c846afc3-e6f3-4363-9f61-6f09ff56bf87.mp4',
          hlDetailM: '',
          hlAutoFocus:
            'https://compress-file.creality.com/videos/Agent/052a584e-cfed-4994-96dd-a6f81137b389.mp4',
          hlAutoFocusM:
            'https://compress-file.creality.com/videos/Agent/052a584e-cfed-4994-96dd-a6f81137b389.mp4',
          hlScreen:
            'https://cdn.creality.com/ow/a1c/e27dd03d-0129-4ed5-812f-9fcb6d43c1a9.png',
          hlScreenM:
            'https://cdn.creality.com/ow/a1c/c1b2de73-62c8-44d6-b202-6436027719d0.png',
          hlSafety:
            'https://compress-file.creality.com/videos/Agent/7603c5e6-794c-4cb4-9f9a-4d9c845f0868.mp4',
          hlSafetyM: '',
          hlConveyor:
            'https://compress-file.creality.com/images/Agent/56208f64-cd89-40f3-b35c-859730ef4979.png',
          hlConveyorM:
            'https://cdn.creality.com/ow/a1c/743b6e0f-ea25-4770-9280-e3ac8e483e61.png',
          hlAi: 'https://compress-file.creality.com/images/Agent/adddd0e1-a8a4-4078-a6eb-8febeeb7b1c1.png',
          hlAiM:
            'https://cdn.creality.com/ow/a1c/081b6ac2-8baf-4854-be32-9292c2bf39dd.png',
          section4Bg:
            'https://compress-file.creality.com/videos/Agent/c50d8122-a011-49e1-8134-b8070612a342.mp4',
          section4BgM:
            'https://compress-file.creality.com/videos/Agent/4e34a69f-ccb3-420e-81fe-25f6393f99c1.mp4',
          section5Slide1:
            'https://compress-file.creality.com/videos/Agent/09443fad-d957-4f11-bc66-785eb6c2b377.mp4',
          section5Slide1M: '',
          section5Slide2:
            'https://compress-file.creality.com/videos/Agent/482f15da-a648-45a3-9b61-de85bd40c23f.mp4',
          section5Slide2M: '',
          section5Slide3:
            'https://compress-file.creality.com/videos/Agent/43b42405-de49-4292-8450-c6ace8c48c96.mp4',
          section5Slide3M: '',
          section6Slide1:
            'https://compress-file.creality.com/images/Agent/8a6ba787-ff02-4143-8ae5-c5f5db2a9905.png',
          section6Slide1M:
            'https://compress-file.creality.com/images/Agent/4123c81e-0988-4edf-a7df-41af4976baeb.png',
          section6Slide2:
            'https://compress-file.creality.com/images/Agent/90489046-6700-493e-91ff-aea2a54fc1c3.png',
          section6Slide2M:
            'https://compress-file.creality.com/images/Agent/a109c615-2596-45b4-a0f1-06b24a7e7dfc.png',
          section6Slide3:
            'https://compress-file.creality.com/images/Agent/ad555bb0-7a71-4684-8ec4-d0b583ce2a63.png',
          section6Slide3M:
            'https://compress-file.creality.com/images/Agent/e9bef2c8-bc83-48c2-aaa5-f5fc33cae771.png',
          section6Slide4:
            'https://compress-file.creality.com/images/Agent/148d2d2b-ffe3-4af1-af85-46d5631cb29f.png',
          section6Slide4M:
            'https://compress-file.creality.com/images/Agent/9d29a8d9-6f8f-4d01-a8fa-0496a5035607.png',
          section6Slide5:
            'https://compress-file.creality.com/images/Agent/1a2321f7-5db4-41fa-9f9e-c40277ad3de8.png',
          section6Slide5M:
            'https://compress-file.creality.com/images/Agent/8ac2663c-8789-403f-9662-c4f0924c4665.png',
          section6Slide6:
            'https://compress-file.creality.com/images/Agent/9c3d0088-429c-4443-a287-4097587885d8.png',
          section6Slide6M:
            'https://compress-file.creality.com/images/Agent/0ba08fe8-b960-4814-9797-3ebfe8c2e49d.png',
          section6Slide7:
            'https://compress-file.creality.com/images/Agent/481693b6-c442-4a0f-9c24-6f972b8f6628.png',
          section6Slide7M:
            'https://compress-file.creality.com/images/Agent/e1312a4b-782b-44f1-bd08-78b9cc0f4af9.png',
          section6Slide8:
            'https://compress-file.creality.com/images/Agent/90c1947b-9260-4e99-b438-aba6b5c8e11c.png',
          section6Slide8M:
            'https://compress-file.creality.com/images/Agent/00e0eaee-57a0-4b11-9c2b-bcc63ac9ca72.png',
          section7Bg:
            'https://compress-file.creality.com/videos/Agent/e86b8515-c5cb-4cf7-a3ca-589a3f6d5713.mp4',
          section7BgM:
            'https://compress-file.creality.com/videos/Agent/2eab4e92-f1ef-4da1-bb4b-3d5342ef32ee.mp4',
          section8Media:
            'https://compress-file.creality.com/videos/Agent/2b7a7d84-7d9d-4eab-8027-f03e7d90e8e2.mp4',
          section8MediaM: '',
          section9Bg:
            'https://compress-file.creality.com/images/Agent/916a40e0-0cc2-4106-a5ad-3d0872795e71.png',
          section9BgM:
            'https://compress-file.creality.com/images/Agent/44d117bf-d2bb-402c-8524-187c461deb0f.png',
          section10Media:
            'https://compress-file.creality.com/videos/Agent/45dd98c2-0a59-433e-b363-95a6bc287b79.mp4',
          section10MediaM:
            'https://compress-file.creality.com/videos/Agent/a2f36580-055f-41b3-ab43-66762c11fa0d.mp4',
          section11Bg:
            'https://cdn.creality.com/ow/a1c/a8962228-992b-45f5-a26e-40f17a98dd3e.mp4',
          section11BgM: '',
          section12Bg:
            'https://compress-file.creality.com/videos/Agent/d39cfbe7-c374-4063-a2a1-2f970aafd111.mp4',
          section12BgM:
            'https://compress-file.creality.com/videos/Agent/ae89cb4f-ebc9-47c1-8582-064a87aa52d4.mp4',
          section13Bg:
            'https://compress-file.creality.com/images/Agent/4268d687-fb4c-4bf3-964e-cdc178082b30.png',
          section13BgM:
            'https://compress-file.creality.com/images/Agent/851ac058-a5c0-4021-90b5-a636ffc045b0.png',
          section14Library:
            'https://compress-file.creality.com/images/Agent/8efbc94b-b9f7-4387-bf3e-af886988bb74.png',
          section14LibraryM:
            'https://cdn.creality.com/ow/a1c/ff3df398-9af0-41c5-aeb1-ac44a42a5561.png',
          section14Wiki:
            'https://compress-file.creality.com/images/Agent/72840831-e166-4247-bd59-1783b47c9137.png',
          section14WikiM:
            'https://cdn.creality.com/ow/a1c/788dbf91-7291-4218-ab7c-e2920b5e2a0b.png',
          section15Bg:
            'https://compress-file.creality.com/images/Agent/ea9f29b3-fb2b-4c4d-a645-b861a6609465.png',
          section15BgM:
            'https://cdn.creality.com/ow/a1c/accd2ac2-09fc-4630-9817-7c6cb77c5d2b.png',
          section16Slide1:
            'https://compress-file.creality.com/videos/Agent/520cbcee-ff1e-4361-846c-19bf420cf961.mp4',
          section16Slide1M: '',
          section16Slide2:
            'https://compress-file.creality.com/videos/Agent/d232348e-7f66-4e23-9b89-2bc3b7f55fed.mp4',
          section16Slide2M: '',
          section16Slide3:
            'https://compress-file.creality.com/videos/Agent/4f2eae43-4570-4e7e-9111-e601600a7298.mp4',
          section16Slide3M: '',
          section16Slide4:
            'https://compress-file.creality.com/videos/Agent/206906d6-5c1f-4046-8041-c31399b9f96e.mp4',
          section16Slide4M: '',
          section17Bg:
            'https://compress-file.creality.com/images/Agent/e2e8f7ac-410f-48e9-80f1-93bed21628d9.png',
          section17BgM:
            'https://compress-file.creality.com/images/Agent/5fbde8ff-6cef-48f0-8b04-567ac712c4de.png',
          section17Icon1:
            'https://cdn.creality.com/ow/a1c/21d2d4f1-dde7-4c2a-a157-59390b38c32b.png',
          section17Icon1M: '',
          section17Icon2:
            'https://cdn.creality.com/ow/a1c/b311a57c-ebe9-4213-83b1-568006e57691.png',
          section17Icon2M: '',
          section17Icon3:
            'https://cdn.creality.com/ow/a1c/97b5a06f-d61e-481a-8a6d-60150299aab9.png',
          section17Icon3M: '',
          section17Icon4:
            'https://cdn.creality.com/ow/a1c/3034d383-28c8-47a0-9b98-d684f60d904d.png',
          section17Icon4M: '',
          section17Icon5:
            'https://cdn.creality.com/ow/a1c/ec62c925-6d7f-4244-8d60-346d57aefa5b.png',
          section17Icon5M: '',
          section18Slide1:
            'https://compress-file.creality.com/images/Agent/a844fcfb-0b72-42ce-9e0d-60e93e15f97e.png',
          section18Slide1M:
            'https://cdn.creality.com/ow/a1c/9ff9efc1-500e-4f57-b7d5-056282ea78e7.png',
          section18Slide2:
            'https://compress-file.creality.com/images/Agent/726563e4-e547-4e1b-a24f-20d1642f8cfa.png',
          section18Slide2M:
            'https://compress-file.creality.com/images/Agent/b808f4b0-6cba-4664-95bd-84360ca01c98.png',
          section18Slide3:
            'https://compress-file.creality.com/images/Agent/883a1dc8-179e-4daf-8e56-5f5789a6278b.png',
          section18Slide3M:
            'https://compress-file.creality.com/images/Agent/0c3061a5-dd35-40cb-a33e-a14b1d0114bc.png',
          section18Slide4:
            'https://compress-file.creality.com/images/Agent/1e1f627f-eae8-45a2-899e-33654a63953c.png',
          section18Slide4M:
            'https://cdn.creality.com/ow/a1c/098e7248-81f3-4d12-bfee-04e6a3df53e7.png',
          section18Slide5:
            'https://compress-file.creality.com/images/Agent/6ede3929-5937-4f28-88a1-a08083a1f072.png',
          section18Slide5M:
            'https://compress-file.creality.com/images/Agent/9ef31d86-de04-44ca-8e28-1fce82a14275.png',
          section18Slide6:
            'https://compress-file.creality.com/images/Agent/bab00659-46f0-47b0-9fd7-320316162f21.png',
          section18Slide6M:
            'https://compress-file.creality.com/images/Agent/85c314d8-d9bd-4858-8413-4bf263c67bbe.png',
          section20Slide1:
            'https://compress-file.creality.com/images/Agent/a5493e13-925d-4027-8154-686da79d3470.png',
          section20Slide1M:
            'https://cdn.creality.com/ow/a1c/a831c83f-8dfc-4816-8420-4ff344fd5f3d.png',
          section20Slide2:
            'https://cdn.creality.com/ow/a1c/40721785-261d-4913-8180-7e2e32a1eaf2.png',
          section20Slide2M:
            'https://cdn.creality.com/ow/a1c/2988b69e-b32c-4bdb-8c9a-3cf3ea0514d9.png',
          section20Slide3:
            'https://cdn.creality.com/ow/a1c/0b3684a9-ade6-45c2-8f8b-007a576e77ee.png',
          section20Slide3M:
            'https://cdn.creality.com/ow/a1c/add4f6a6-5ab5-46dd-8f5a-fb72f2937bef.png',
          section20Slide4:
            'https://compress-file.creality.com/images/Agent/7ecbdd6f-3509-4f49-af65-f81e6ddf6b54.png',
          section20Slide4M:
            'https://cdn.creality.com/ow/a1c/62c3af6d-76f6-4748-853f-8705bc67420d.png',
          section21Bg:
            'https://compress-file.creality.com/images/Agent/1e130b9f-2c7f-42e1-ba4f-e4ebac753e2e.png',
          section21BgM:
            'https://compress-file.creality.com/images/Agent/ca3bf998-e816-4454-b8f6-11ce5eca796f.png',
          section22Product:
            'https://cdn.creality.com/ow/a1c/c12d2b95-7394-4191-a44b-69d0f0348be3.png',
          section22ProductM:
            'https://cdn.creality.com/ow/a1c/5dda41c8-c98a-4622-9e2d-d7603204eaed.png',
        },
        L2 = {
          en: { translation: R2, imageUrl: fp },
          de: { translation: D2, imageUrl: fp },
        };
      Eu.use(Jv).init({
        resources: L2,
        lng: Sy(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      const j2 = document.getElementById('product-detail-a1c-page'),
        B2 = A.jsx(Wv, { i18n: Eu, children: A.jsx(C2, {}) });
      vv.createRoot(j2).render(B2);

})();